import PDFViewerImage1 from "../assets/PDFViewerImages/PDFViewerImage1.jpg";
import PDFViewerImage2 from "../assets/PDFViewerImages/PDFViewerImage2.jpg";
import PDFViewerImage3 from "../assets/PDFViewerImages/PDFViewerImage3.jpg";
import PDFViewerImage4 from "../assets/PDFViewerImages/PDFViewerImage4.jpg";
import PDFViewerImage5 from "../assets/PDFViewerImages/PDFViewerImage5.jpg";
import PDFViewerImage6 from "../assets/PDFViewerImages/PDFViewerImage6.jpg";
import PDFViewerImage7 from "../assets/PDFViewerImages/PDFViewerImage7.jpg";
import PDFViewerImage8 from "../assets/PDFViewerImages/PDFViewerImage8.jpg";
import PDFViewerImage9 from "../assets/PDFViewerImages/PDFViewerImage9.jpg";
import PDFViewerImage10 from "../assets/PDFViewerImages/PDFViewerImage10.jpg";
import PDFViewerImage11 from "../assets/PDFViewerImages/PDFViewerImage11.jpg";
import PDFViewerImage12 from "../assets/PDFViewerImages/PDFViewerImage12.jpg";
import PDFViewerImage13 from "../assets/PDFViewerImages/PDFViewerImage13.jpg";
import PDFViewerImage14 from "../assets/PDFViewerImages/PDFViewerImage14.jpg";
import PDFViewerImage15 from "../assets/PDFViewerImages/PDFViewerImage15.jpg";
import PDFViewerImage16 from "../assets/PDFViewerImages/PDFViewerImage16.jpg";
import PDFViewerImage17 from "../assets/PDFViewerImages/PDFViewerImage17.jpg";
import PDFViewerImage18 from "../assets/PDFViewerImages/PDFViewerImage18.jpg";
import PDFViewerImage19 from "../assets/PDFViewerImages/PDFViewerImage19.jpg";
import PDFViewerImage20 from "../assets/PDFViewerImages/PDFViewerImage20.jpg";
import PDFViewerImage21 from "../assets/PDFViewerImages/PDFViewerImage21.jpg";
import PDFViewerImage22 from "../assets/PDFViewerImages/PDFViewerImage22.jpg";
import PDFViewerImage23 from "../assets/PDFViewerImages/PDFViewerImage23.jpg";
import PDFViewerImage24 from "../assets/PDFViewerImages/PDFViewerImage24.jpg";
import PDFViewerImage25 from "../assets/PDFViewerImages/PDFViewerImage25.jpg";
import PDFViewerImage26 from "../assets/PDFViewerImages/PDFViewerImage26.jpg";
import PDFViewerImage27 from "../assets/PDFViewerImages/PDFViewerImage27.jpg";
import PDFViewerImage28 from "../assets/PDFViewerImages/PDFViewerImage28.jpg";
import PDFViewerImage29 from "../assets/PDFViewerImages/PDFViewerImage29.jpg";
import PDFViewerImage30 from "../assets/PDFViewerImages/PDFViewerImage30.jpg";
import PDFViewerImage31 from "../assets/PDFViewerImages/PDFViewerImage31.jpg";
import PDFViewerImage32 from "../assets/PDFViewerImages/PDFViewerImage32.jpg";
import PDFViewerImage33 from "../assets/PDFViewerImages/PDFViewerImage33.jpg";
import PDFViewerImage34 from "../assets/PDFViewerImages/PDFViewerImage34.jpg";
import PDFViewerImage35 from "../assets/PDFViewerImages/PDFViewerImage35.jpg";
import PDFViewerImage36 from "../assets/PDFViewerImages/PDFViewerImage36.jpg";
import PDFViewerImage37 from "../assets/PDFViewerImages/PDFViewerImage37.jpg";
import PDFViewerImage38 from "../assets/PDFViewerImages/PDFViewerImage38.jpg";
import PDFViewerImage39 from "../assets/PDFViewerImages/PDFViewerImage39.jpg";
import PDFViewerImage40 from "../assets/PDFViewerImages/PDFViewerImage40.jpg";
import PDFViewerImage41 from "../assets/PDFViewerImages/PDFViewerImage41.jpg";
import PDFViewerImage42 from "../assets/PDFViewerImages/PDFViewerImage42.jpg";
import PDFViewerImage43 from "../assets/PDFViewerImages/PDFViewerImage43.jpg";
import PDFViewerImage44 from "../assets/PDFViewerImages/PDFViewerImage44.jpg";
import PDFViewerImage45 from "../assets/PDFViewerImages/PDFViewerImage45.jpg";
import PDFViewerImage46 from "../assets/PDFViewerImages/PDFViewerImage46.jpg";
import PDFViewerImage47 from "../assets/PDFViewerImages/PDFViewerImage47.jpg";
import PDFViewerImage48 from "../assets/PDFViewerImages/PDFViewerImage48.jpg";
import PDFViewerImage49 from "../assets/PDFViewerImages/PDFViewerImage49.jpg";
import PDFViewerImage50 from "../assets/PDFViewerImages/PDFViewerImage50.jpg";
import PDFViewerImage51 from "../assets/PDFViewerImages/PDFViewerImage51.jpg";
import PDFViewerImage52 from "../assets/PDFViewerImages/PDFViewerImage52.jpg";
import PDFViewerImage53 from "../assets/PDFViewerImages/PDFViewerImage53.jpg";
import PDFViewerImage54 from "../assets/PDFViewerImages/PDFViewerImage54.jpg";
import PDFViewerImage55 from "../assets/PDFViewerImages/PDFViewerImage55.jpg";
import PDFViewerImage56 from "../assets/PDFViewerImages/PDFViewerImage56.jpg";
import PDFViewerImage57 from "../assets/PDFViewerImages/PDFViewerImage57.jpg";
import PDFViewerImage58 from "../assets/PDFViewerImages/PDFViewerImage58.jpg";
import PDFViewerImage59 from "../assets/PDFViewerImages/PDFViewerImage59.jpg";
import PDFViewerImage60 from "../assets/PDFViewerImages/PDFViewerImage60.jpg";
import PDFViewerImage61 from "../assets/PDFViewerImages/PDFViewerImage61.jpg";
import PDFViewerImage62 from "../assets/PDFViewerImages/PDFViewerImage62.jpg";
import PDFViewerImage63 from "../assets/PDFViewerImages/PDFViewerImage63.jpg";
import PDFViewerImage64 from "../assets/PDFViewerImages/PDFViewerImage64.jpg";
import PDFViewerImage65 from "../assets/PDFViewerImages/PDFViewerImage65.jpg";
import PDFViewerImage66 from "../assets/PDFViewerImages/PDFViewerImage66.jpg";
import PDFViewerImage67 from "../assets/PDFViewerImages/PDFViewerImage67.jpg";
import PDFViewerImage68 from "../assets/PDFViewerImages/PDFViewerImage68.jpg";
import PDFViewerImage69 from "../assets/PDFViewerImages/PDFViewerImage69.jpg";
import PDFViewerImage70 from "../assets/PDFViewerImages/PDFViewerImage70.jpg";
import PDFViewerImage71 from "../assets/PDFViewerImages/PDFViewerImage71.jpg";
import PDFViewerImage72 from "../assets/PDFViewerImages/PDFViewerImage72.jpg";
import PDFViewerImage73 from "../assets/PDFViewerImages/PDFViewerImage73.jpg";
import PDFViewerImage74 from "../assets/PDFViewerImages/PDFViewerImage74.jpg";
import PDFViewerImage75 from "../assets/PDFViewerImages/PDFViewerImage75.jpg";
import PDFViewerImage76 from "../assets/PDFViewerImages/PDFViewerImage76.jpg";
import PDFViewerImage77 from "../assets/PDFViewerImages/PDFViewerImage77.jpg";
import PDFViewerImage78 from "../assets/PDFViewerImages/PDFViewerImage78.jpg";
import PDFViewerImage79 from "../assets/PDFViewerImages/PDFViewerImage79.jpg";
import PDFViewerImage80 from "../assets/PDFViewerImages/PDFViewerImage80.jpg";
import PDFViewerImage81 from "../assets/PDFViewerImages/PDFViewerImage81.jpg";
import PDFViewerImage82 from "../assets/PDFViewerImages/PDFViewerImage82.jpg";
import PDFViewerImage83 from "../assets/PDFViewerImages/PDFViewerImage83.jpg";
import PDFViewerImage84 from "../assets/PDFViewerImages/PDFViewerImage84.jpg";
import PDFViewerImage85 from "../assets/PDFViewerImages/PDFViewerImage85.jpg";
import PDFViewerImage86 from "../assets/PDFViewerImages/PDFViewerImage86.jpg";
import PDFViewerImage87 from "../assets/PDFViewerImages/PDFViewerImage87.jpg";
import PDFViewerImage88 from "../assets/PDFViewerImages/PDFViewerImage88.jpg";
import PDFViewerImage89 from "../assets/PDFViewerImages/PDFViewerImage89.jpg";
import PDFViewerImage90 from "../assets/PDFViewerImages/PDFViewerImage90.jpg";
import PDFViewerImage91 from "../assets/PDFViewerImages/PDFViewerImage91.jpg";
import PDFViewerImage92 from "../assets/PDFViewerImages/PDFViewerImage92.jpg";
import PDFViewerImage93 from "../assets/PDFViewerImages/PDFViewerImage93.jpg";
import PDFViewerImage94 from "../assets/PDFViewerImages/PDFViewerImage94.jpg";
import PDFViewerImage95 from "../assets/PDFViewerImages/PDFViewerImage95.jpg";
import PDFViewerImage96 from "../assets/PDFViewerImages/PDFViewerImage96.jpg";
import PDFViewerImage97 from "../assets/PDFViewerImages/PDFViewerImage97.jpg";
import PDFViewerImage98 from "../assets/PDFViewerImages/PDFViewerImage98.jpg";
import PDFViewerImage99 from "../assets/PDFViewerImages/PDFViewerImage99.jpg";
import PDFViewerImage100 from "../assets/PDFViewerImages/PDFViewerImage100.jpg";
import PDFViewerImage101 from "../assets/PDFViewerImages/PDFViewerImage101.jpg";
import PDFViewerImage102 from "../assets/PDFViewerImages/PDFViewerImage102.jpg";
import PDFViewerImage103 from "../assets/PDFViewerImages/PDFViewerImage103.jpg";
import PDFViewerImage104 from "../assets/PDFViewerImages/PDFViewerImage104.jpg";
import PDFViewerImage105 from "../assets/PDFViewerImages/PDFViewerImage105.jpg";
import PDFViewerImage106 from "../assets/PDFViewerImages/PDFViewerImage106.jpg";
import PDFViewerImage107 from "../assets/PDFViewerImages/PDFViewerImage107.jpg";
import PDFViewerImage108 from "../assets/PDFViewerImages/PDFViewerImage108.jpg";
import PDFViewerImage109 from "../assets/PDFViewerImages/PDFViewerImage109.jpg";
import PDFViewerImage110 from "../assets/PDFViewerImages/PDFViewerImage110.jpg";
import PDFViewerImage111 from "../assets/PDFViewerImages/PDFViewerImage111.jpg";
import PDFViewerImage112 from "../assets/PDFViewerImages/PDFViewerImage112.jpg";
import PDFViewerImage113 from "../assets/PDFViewerImages/PDFViewerImage113.jpg";
import PDFViewerImage114 from "../assets/PDFViewerImages/PDFViewerImage114.jpg";
import PDFViewerImage115 from "../assets/PDFViewerImages/PDFViewerImage115.jpg";
import PDFViewerImage116 from "../assets/PDFViewerImages/PDFViewerImage116.jpg";
import PDFViewerImage117 from "../assets/PDFViewerImages/PDFViewerImage117.jpg";




export const SinhalaData = [
    {name: "",
        chapter1Title:  "1. රියදුරන් මගමරුවන් බවට පත් කරන සාධක",
        paragraph1: "රථයක් ධාවනය කරන තැනැත්තා අතින් අනතුරක් සිදුවීමට බලපාන සාධක රාශියකි.ඒ අතුරින් වඩාත්ම ප්‍රබලව බලපාන සාධක කිහිපය පහත පරිදි කෙටිකොට ගත හැක.",
        subheading1:  "1) මාර්ග නීතීන්ට අනුගත නොවීම",
        paragraph2:  "මේ කාරණාවේදී රිය පදවන්නන් මෙන්ම පදිකයන්ද එක හා සමානව වගකිව යුත්තෝ වෙති.එමෙන්ම සිදුවන රිය අනතුරු අතරින් අති බහුතරයකට හේතු වන්නේද කුමන හෝ පාර්ශවයක් විසින් මාර්ග නීති කඩ කිරීමයි. මාර්ගය භාවිතා කරන්නන්ට මාර්ග නීති පිළිබඳව නිසි අවබෝධයක් නොමැතිකම නිසා මෙන්ම නීතිය උවමනාවෙන්ම නොසලකා හැරීම නිසාද නිරන්තරයෙන් අනතුරු සිදුවේ.",
        paragraph3:"මාර්ගය භාවිතා කරන්නන්ට මාර්ග නීති පිළිබඳව නිසි අවබෝධයක් නොමැතිකම නිසා මෙනම් නීතිය උවමනා ලෙස නොසලකා හැරීම නිසාද නිරන්තරයෙන් අනතුරු සිදුවේ.",
        paragraph4:"නොයෙක් පරුෂ ආබාධයන්ගෙන් හෝ හීනමානයන්ගෙන් පෙළෙන ඇතැමුන්, තම පරුෂය ප්‍රදර්ශනය කිරීමේ මාර්ගයක් ලෙස මහමග ධාවනය වන වාහන යොදා ගනී.ප්‍රමාණයෙන් විශාල බස්, ලොරි වැනි වාහන පදවන රියදුරන් අන් සියලු වාහන විසින් තමන්ට ප්‍රමුඛතා ලබා දිය යුතුය යන හැඟීමෙන් රිය පැදවීමද මහමග සිදුවන අනතුරු වලට තවත් හේතුවකි.",
        subheading2:"2) ජංගම දුරකතන භාවිතය",
        paragraph5:"කුමන ආකාරයකින් ජංගම දුරකතනය භාවිත කළද (Handfree mode, Headset) එය සෑම විටම රියදුරාගේ අවධානය සැලකිය යුතු ලෙස ගිලිහී යයි. පර්යේෂණ අනුව මෙය අනතුරු ප්‍රවණතාවය වැඩි කරයි.",
        subheading3:"3) මත්ද්‍රව්‍ය භාවිතය",
        paragraph6:"රිය අනතුරු සිදුවීමට බලපාන තවත් ප්‍රධාන සාධකයක් වන්නේ මත්ද්‍රව්‍ය භාවිතයයි. මත්පැන්, ගංජා, හෙරොයින් වැනි මත්ද්‍රව්‍ය භාවිතය රියදුරාගේ අවධානය, තීරණ ගැනීමේ හැකියාව සහ ශාරීරික ක්‍රියාකාරිත්වය අඩු කරයි.",
        paragraph7:"රුධිරගත ඇල්කොහොල් සාන්ද්‍රණය 0.05g/dl ට වඩා වැඩි වූ විට,පුද්ගලයෙකුගේ ප්‍රතිචාර දැක්වීමේ කාර්යක්ෂමතාව දැඩි ලෙස පහළ යාමක් දක්වයි.",
        subheading4:"4) රියදුරු විඩාව",
        paragraph8:"අඛණ්ඩව දීර්ඝ කාලයක් රිය පැදවීමෙන් රියදුරු විඩාව ඇතිවිය හැක. එය ශාරීරික හා මානසික උදාසීනභාවයකින් ඇතිවන අවධානය අඩු වීමකි.",
        paragraph9:"විශේෂයෙන් දීර්ඝ ගමන් කරන බස් රථ, භාණ්ඩ ප්‍රවාහන රියදුරන් අතර රියදුරු විඩාවට ලක්වීමේ ඉඩ වැඩිය.",
        paragraph10:"රියදුරාගේ ක්‍රියාකාරීත්වය අඩු වීමත් සමඟ අනතුරු සිදුවීමේ හැකියාව ඉහළ යයි. එබැවින් රියදුරු විඩාව රිය අනතුරකට හිතමිතුරෙකි.",
        subheading5:" 5) අඩු පාඩු සහිත නිසි ප්‍රමිතියට නොමැති වාහන",
        paragraph11:"අඩුපාඩු සහිත හෝ නඩත්තු නොකළ වාහන මගින් අනතුරු සිදුවීමේ ඉඩක් පවතී.නිසි තත්ත්වයේ තිරිංග, ටයර්, ආලෝක පද්ධති නොමැති වාහන ධාවනය කිරීම තහනම්ය.",
        subheading6:" 6) අඩු පාඩු සහිත මාර්ග තත්ත්වය",
        paragraph12:"පිරිසිදු නොවූ මාර්ග, වකුටු, ජල ගැලීම්, හෝ ආලෝක නොමැති මාර්ග අනතුරු සිදුවීමට හේතු වේ. එබැවින් නිසි මාර්ග නඩත්තු කිරීම අත්‍යවශ්‍යය.",



        chapter2Title:  " 2. මහමග ත්‍රස්තවාදය මැඩලිය නොහැකිද? හැකි ය",
        chapter2Paragraph1:  "රිය අනතුරු වලින් 85%ටත් වඩා වැඩි ප්‍රමාණයක් වලක්වා ගත හැකි ඒවා ය.එනම් එම අනතුරු වලට හේතුව වී ඇත්තේ රියදුරාගේ, වාහනයේ, මගීන්ගේ හෝ එම පාර්ශව කිහිපයකගේ වරදකි.",
        chapter2Paragraph2:  "කෙසේ වුවද, රිය අනතුරු වලින් අතිශය බහුතරයකට හේතුවන්නේ රියදුරාගේ නොසැලකිලිමත්කමයි. නැතහොත් අදක්ෂ බවයි.",
        chapter2Paragraph3:  "තම රිය පැදවීමේ හැකියාව පිළිබඳවත්, තම වාහනය පිළිබඳවත් අතිශෝක්තිම ඉහළ තක්සේරුවකින් සිටින ඇතැමුන් ඒ නිසාම අකාලයේ රිය අනතුරු වලට මුහුණදෙති.",
        chapter2Paragraph4:  "බොහෝ ආධුනික රියදුරන් සිතා සිටිනුයේ කිනම් වේගයකින් ධාවනය කළද තිරිංග යෙදු සැණින් තම රථය නවතා ගත හැකිවනු ඇතැයි ය. කෙතරම් නවීන තාක්ෂණය යොදාගත් වාහනයක් වුවද සිතූ සැණින් නතර කර ගැනීමට හැකියාවක් නැත.",
        chapter2Paragraph5:  "ගමන් කරන වාහනයක් නතර වීමේදී සිදුවන්නේ වාහනයේ චාලක ශක්තිය ශූන්‍ය වීමයි. එසේ වන්නේ චාලක ශක්තිය විභව ශක්තිය, තාප ශක්තිය, ධ්වනි ශක්තිය බවට පරිවර්ථනය වීමෙනි.",
        chapter2Paragraph6:  "ගමන් කරන වාහනයක් තිරිංග යොදා නතර කිරීමේදී සම්පූර්ණයෙන්ම නිසල වීමට පෙර ගමන් කරන දුර ප්‍රමාණය පිළිබඳව අවබෝධයක් තිබිය යුතුය.",
        chapter2Image1:  PDFViewerImage1,
        chapter2Paragraph7:  "වර්තමානයේ මෝටර් වාහන නිෂ්පාදකයන්, වාහන සඳහා ආරක්ෂක උපක්‍රම රාශියක් යොදති. ABS තිරිංග, වායු බෑලුන්, නවීන ආසන පටි, වඩාත් ආරක්ෂාකාරී ආසන පද්ධති, ශක්තිමත් කරන ලද වාහන සැකිල්ල, රියදුරු ක්‍රියාකාරීත්වය විශ්ලේෂණය කරන පරිගණක වෙඩසටහන් ආදිය ඒ අතරයි.",
        chapter2Paragraph8:  "කෙතරම් තාක්ෂණික උපක්‍රම යෙදූවද සිදුවන අනතුරු සංඛ්‍යාවෙහි අඩුවක් දැක්වෙන්නේ නැත. වරද රිය පදවන ඔබ සතුය. මක් නිසාද යත්, ඔබේ වාහනය අජීවී වස්තුවකි; නමුත් ඔබ සජීවී ප්‍රාණියෙකි.",
        


        chapter3Title:  "  3. මහමග අනතුරු ගෙන එන නිරතුරු – “රියදුරු විඩාව”",
        chapter3Paragraph1: " රියදුරාගේ නිද්‍රාශීලී බව නිසා හෝ අක්‍රිය බව නිසා හෝ සිදුවන මාරක රිය අනතුරු දිනපතාම වාර්තා වේ. මෙසේ රියදුරෙකු රිය පදවන අතර අක්‍රිය වීම හෝ නිද්‍රාශීලී වීම හෝ අකාර්යක්ෂම වීම හඳන්වෙන්නේ “රියදුරු විඩාව” යනුවෙනි.",
        chapter3Paragraph2:"රිය පැදවීමට තිබිය යුතු කායික හා මානසික යෝග්‍යතාව පිළිබඳව නොසලකා හැරීම සහ රිය පැදවීමට සුදුසු කාල සීමාව පිළිබඳව නොසලකා හැරීම මෙයට ප්‍රධාන හේතුවකි.",
        chapter3Paragraph3: " ප්‍රමාණවත් නින්දක් හෝ විවේකයක් නොමැතිව දීර්ඝ කාලයක් පුරාවට රිය පැදවීම, රාත්‍රී කාලයේ රිය පැදවීම, ඒකාකාරී නීරස පරිසරයක දගින්දගටම රිය පැදවීම, මත්ද්‍රව්‍ය හෝ නිද්‍රාශීලී ඖෂධ භාවිතයෙන් රිය පැදවීම ආදිය නිසා රියදුරන් නිදා වැටී මාරක අනතුරු සිදුකර ගනී.”",
        chapter3Paragraph4:  " රියදුරෙකු රිය පදවන අතර නිදා වැටීම ක්ෂණිකව සිදුවන දෙයක් නොව, එය ක්‍රියාවලියක අවසන් ප්‍රතිඵලයයි. එනම් රියදුරු විඩාව අධියර කිහිපයකින් සමන්විත තත්ත්වයකි. තමන් විඩාවට පත්ව ඇති බව හඳුනාගත හැකි ලක්ෂණ පහල වූ වහාම හැකි ඉක්මනින් රිය පැදවීම නතර කර ප්‍රමාණවත් විවේකයක් ලබා ගැනීම රියදුරෙකුගේ ලක්ෂණයකි.”",        
        subheading7:" රියදුරු විඩාවේ ලක්ෂණ",
        subheading7List1: " ඈනුම් යෑම ",
        subheading7List2: " අලස බවක් දැනීම ",     
        subheading7List3: " මාර්ගයේ පසුකර පැමිණි අවසන් කිලෝමීටර් කිහිපය පිළිබඳව මතකයක් නොමැතිවීම ",     
        subheading7List4: " මාර්ග සංඥා පිළිබඳව ඇති අවධානය ගිලිහී යාම ",     
        subheading7List5: " දෑස් විවර කරගැනීමේ අපහසුතාවයක් දැනීම ",     
        subheading7List6: " වාහනය නිසි ධාවන පථයේ පවත්වා ගැනීම අසීරු වීම ", 
        subheading7List7: " ඉදිරි වීදුරුව අපහැදි බවක් දැනීම", 
        subheading7List8: " අවසන් වශයෙන් නිදා වැටීම",
        paragraph24: " ඉහත ලක්ෂණ අත්විඳමින් තවදුරටත් රිය පදවන්නේ නම්, ඔහු තමන්ගේ හා තවත් කිහිප දෙනෙකුගේ ජීවිත විනාශයට තැත් කරන මහා විනාශකාරයෙකි.",          
        subheading8:" රියදුරු විඩාව වලක්වා ගන්නා අයුරු",
        subheading8List1: " දිගු ගමනක් යාමට ඇත්නම් ඒ සඳහා හොඳින් සූදානම් වන්න. ",
        subheading8List2: " හොඳ නින්දක් ලබා ගන්න. ",     
        subheading8List3: " කිසිවිටක මත්ද්‍රව්‍ය හෝ නිද්‍රාකාරක ඖෂධ භාවිතයෙන් රිය පැදවීමෙන් වලකින්න. ",     
        subheading8List4: " දිගු ගමනකදී හැකි සෑම විටම රිය පැදවීමට සහයකයෙකුද එක්කර ගන්න. ",     
        subheading8List5: " හැකි සෑම විටම පෙරවරුවේ ගමන් ආරම්භ කරන්න. සන්ධ්‍යා හා රාත්‍රී කාලය විවේක සඳහා වෙන්විය යුතුය. ",     
        subheading8List6: "  අවම වශයෙන් පැය 3කට වරක්වත් රිය පැදවීම නවතා විවේකයක් ලබා ගන්න. වාහනයෙන් පිටතට පැමිණ මෙය කරන්න. ", 
        subheading8List7: " ධාවනය අතරතුර නිදමතක් දැනේ නම්, පසෙකට ගෙන වාහනය නතර කර කෙටි නින්දක් ගන්න (මිනිත්තු 30 ට වඩා නොවිය යුතුය).", 
        subheading8List8: " චොකලට්, කෝපි, තේ වැනි කැෆේන් පානයන් ප්‍රාණවත් වුවද, එය තාවකාලික විසඳුමක් පමණි.",



        chapter4Title:  "  4. මහපාරේ යකා නටන්නෝ හෙවත් ආක්‍රමණශීලී රියදුරන් – මාර්ග වියරුව (Road Rage)",
        chapter4Paragraph1:"මාර්ග නීති තුට්ටුවකට ගණන් ගන්නේ නැතිව, අන්‍යයන්ට බාධා කරමින් හෝ උවමනාවෙන්ම අනතුරු ඇතිකරමින් වාහන ධාවනය කරන ඇතැමුන් රියදුරන් ඔබ දැක ඇතුවාට සැක නැත.",
        chapter4Paragraph2:"මාර්ග ආලෝක සංඥා වල කොළ ආලෝකය දැල්වුණද නතරවී සිටීම, අධික වේගයෙන් හෝ ඉතා මඳින් ධාවනය කිරීම, වාහන හඹායාම, අනෙකුත් රියදුරන්ගේ සුළු වැටීද හෝ අතපසු වීමකදී තත්ක්ෂණිකව කෝපවීම ආදී ලක්ෂණ පෙන්නුම් කරන මොවුන් “ආක්‍රමණශීලී රියදුරන්” ය.",
        chapter4Paragraph3:"මෙවන් ආක්‍රමණශීලී රියදුරන් බිහිවීමට බලපාන ප්‍රධානතම සාධකය වන්නේ “මාර්ග වියරුව” යි. රියදුරෙකු මාර්ග වියරුවෙන් යුතු අයෙකු බවට පත්වන්නේ බොහෝ විට ඔහු තුළ පවත්නා සමාජීය හෝ මානසික දුර්වලතා හේතුවෙනි.",
        chapter4Paragraph4:"මෙවන් පුද්ගලයන් මහමග රිය පදවන විට හුදකලා වූත්, මානසික පීඩිත තත්ත්වයකට පත්වන බවත්, ඒ නිසා ඔවුන් අනෙකුත් රියදුරන් කෙරෙහි ආක්‍රමණශීලී බවක් පෙන්වන බවත් මනෝවිද්‍යාඥයන් පෙන්වා ඇත.",
        chapter4Paragraph5:"ආක්‍රමණශීලී රියදුරෙකු යනු නරක රියදුරෙකි. එවැනි පුද්ගලයෙකු ඔබේ පසුපස ධාවනය කරන්නේ නම්, ඔබේ වාහනයේ වේගය අඩුකර පසෙකට ගෙන ඔහුට ඔබව පසුකර යාමට ඉඩ සැලසීමයි හොඳම ක්‍රියාව.",
        chapter4Paragraph6:"සෑම විටම ඔබේත් ඔබේ වාහනයේත් ආරක්ෂාව පිළිබඳව සිතන්න. ආක්‍රමණිකයෙකුට පටුමනක් ලබා දීම හෝ පළිගැනීමේ චේතනාවකින් ක්‍රියා කිරීම නුවණැති ක්‍රියාවක් නොවේ.",
        chapter4Subheading1:" ආක්‍රමණශීලී රියදුරෙකු හඳුනාගන්නා අයුරු",
        chapter4List1:" අධික වේගයෙන් රිය පදවයි.",
        chapter4List2:" මාර්ග නීති කඩමින් අනෙකුත් රියදුරන්ට බාධා කරයි.",
        chapter4List3:" අනවශ්‍ය ලෙස හෝන් හඬවමින් රිය පදවයි.",
        chapter4List4:" වාහනයට හා අනෙකුත් රියදුරන්ට ඇති හානිය පිළිබඳ නොසිතා ධාවනය කරයි.",
        chapter4List5:" අවදානම් ලෙස ලංවලංව ධාවනය කරයි.",
        chapter4List6:" සුළු වැටීද හෝ අත්වැරදීම්වලදී අන් රියදුරන් හා පිදකයන් සමඟ කෝපවේ.",
        chapter4List7:" ආක්‍රමණශීලී, අසභ්‍ය හෝ තර්ජනාත්මක සංඥා පෙන්වයි.",
        chapter4List8:" අධික වේගයෙන් රිය පදවයි.",
        chapter4Subheading2:" මාර්ග වියරුව වලක්වාගන්නා අයුරු",
        chapter4List9:" සැහැල්ලු සිතින් යුතුව වාහනයට ගොඩවන්න.",
        chapter4List10:" වාහනය ඔබේ මානසික පීඩනය සමනය කරගැනීමට හෝ අනෙකුත් අය පීඩනයට පත් කිරීමට උපායයක් නොවන බව තේරුම් ගන්න.",
        chapter4List11:" කිසිවිටක මත්ද්‍රව්‍ය භාවිතා කර රිය පැදවීමෙන් වලකින්න.",
        chapter4List12:" වාහනයට හා අනෙකුත් රියදුරන්ට ඇති හානිය පිළිබඳ නොසිතා ධාවනය කරයි.",
        chapter4List13:" රථයේ වැඩි ශබ්දයෙන් සංගීතය বাজවීමෙන් ඔබේ මනස අවුල් විය හැක.",
        chapter4List14:" මාර්ගයේදී වැටීද නොකිරීමට තීරණය කරගන්න. අහම්බෙන් හෝ වරදක් සිදු වූවද එය නැවත සිදු නොවීමට වගබලා ගන්න.",
        chapter4List15:" අනෙකුත් රියදුරන් හෝ පිදකයන්ගේ වරදකදී ඉවසීම සහ සමාදන්වීම ආදර්ශයක් බව සිතන්න.",
        chapter4List16:" හඹායාමේ ආශාව ඇතිවූ විට ඔබේ ජීවිතයේ වටිනාකම පිළිබඳ සිතා විසිලිමත්ව රිය පදවන්න.",

        
        
        chapter5Title: "5. සොහොන් පිටියට පාර කියන යක්ෂයා – මත්ද්‍රව්‍ය",
        chapter5Paragraph1:"දෛනිකව වාර්තා වන රිය අනතුරු අතුරෙන් බොහෝමයකට හේතුව ලෙස අනාවරණය වී තිබෙන්නේ මත්ද්‍රව්‍යය – නැතහොත් මත්පැන්යයි.",
        chapter5Paragraph2:"ගමනක් පිටත්වීමට පෙර “පාරට එකක්” යැයි කියමින් මත්පැන් පානය කිරීමේ සිරිතක් ඇතැමුන් අතර පවතින බව දක්නට ලැබේ. ජීවිත විනාශ කරන මෙවන් සිරිතක් විදේශ රටවලින් අපට බෝ වූ විනාශයකි.",
        chapter5Paragraph3:"රියදුරෙකුට සෑම විටම හොඳ පෙනීමක්, මනා සිහියක්, නිවැරදි තීරණ ගැනීමේ හැකියාවක් ඇතිවීම අත්‍යවශ්‍යය. මත්ද්‍රව්‍ය වලට ඇත්තේ මෙම සියලු ගුණාංග ඉක්මනින් නැතිකර දැමීමේ හැකියාවයි.",
        chapter5Paragraph4:"අරක්කු, ගංජා හෝ හෙරොයින් වුවද – කුමක් භාවිත කළත් – ඉන් සිදුවන්නේ ශරීරයේ කාර්යක්ෂමතාව පහළ දැමීම සහ ප්‍රචණ්ඩභාවය හෝ අලසභාවය ඉහළ නැංවීම පමණි.",
        chapter5Paragraph5:"මත්පැන් පානය කර රිය පැදවීම රියදුරෙකු විසින් කරන බරපතල වරදකි. කිසියම් රියදුරෙකු මත්පැන් බී ඇතැයි සැකයක් තිබේ නම්, පොලිස් නිලධාරියෙකුට එය පරීක්ෂා කිරීමට බල ඇත.",
        chapter5Paragraph6:"පොලිස් නිලධාරියෙකුට සැකයක් ඇති විට, අදාළ පුද්ගලයාට නලයක් (බැලූන් පරීක්ෂාව) මඟින් පරීක්ෂා කිරීමට හැකිය. එම පරීක්ෂණය කිරීමට විරුද්ධ වන්නේ නම්, පනත මගින් ඔහු මත්පැන් බී සිටි බවට පූර්වනිගමනයක් කිරීමට අවසර ඇත.",
        chapter5Paragraph7:"දෙවන ක්‍රමය වන්නේ රජයේ වෛද්‍යවරයෙකු වෙත ඉදිරිපත්වීමයි. ඔහු විසින් රුධිරය පරීක්ෂා කර මිලි ලීටර 100 කට ඇල්කොහොල් ග්‍රෑම් 0.08 හෝ ඊට වඩා වැඩි ප්‍රමාණයක් ඇත්නම්, එවැනි පුද්ගලයෙකු රිය පැදවීමේදී මත්පැන් බී සිටි බවට නීතිමය වරදකරු කරනු ඇත.",
        chapter5Paragraph8:"එසේම වෛද්‍ය පරීක්ෂණ වලට ඉදිරිපත් වීම ප්‍රතිෂේධ කරන අයෙකු ද මත්පැන් බී සිටියැයි පූර්වනිගමනයට ලක්විය හැක. නමුත් පොලිසියට නිසි සාධක හෝ පරීක්ෂණයකින් තොරව චෝදනා කිරීමට නොහැක.",
        chapter5Paragraph9:"පොලිස් නිලධාරියෙකු ඔබ මත්පැන් බී රිය පැදවූ බවට චෝදනා කරයි නම්, එවැනි විට බැලූන් පරීක්ෂාවක් සිදුකරන ලෙස ඉල්ලා සිටීමට ඔබට අයිතිය ඇත.",


        
       
        chapter6Title:"6. නීත්‍යානුකූල රියදුරෙකු බවට පත්වීම හා රියදුරු බලපත්‍රය ලබා ගැනීම",
        chapter6Paragraph1:"වර්තමානයේ නිකුත් කරනු ලබන්නේ විද්‍යුත් චිපයක් සහිත “ස්මාර්ට් කාඩ්” බලපත්‍රයයි (Smartcard Driving License). ශ්‍රී ලංකාවේ රියදුරු බලපත්‍ර නිකුත් කිරීමේ පරම අයිතිය මෝටර් රථ ප්‍රවාහන කොමසාරිස්වරයාට හිමිවේ.",
        chapter6Paragraph2:"රියදුරු බලපත්‍ර නිකුත් කිරීමේ ප්‍රධාන ක්‍රම දෙකක් පවතී:\n1️⃣ වේරහැර ප්‍රධාන කාර්යාලය හා කුරුණෑගල දිස්ත්‍රික් කාර්යාලය.\n2️⃣ දිස්ත්‍රික් ලේකම් කාර්යාල හරහා.",
        chapter6Paragraph3:"අදාළ ක්‍රමවේදය අනුව පළමුව ලබා ගත හැක්කේ සැහැල්ලු වාහන බලපත්‍රයයි. බර වාහන බලපත්‍රය ලබා ගත හැක්කේ එම බලපත්‍රය ලබාගෙන වසර 2ක් ගතවීමෙන් පසුය.",
        chapter6Subheading1:"නව රියදුරු බලපත්‍රයක් ලබා ගැනීමේ මූලික අවශ්‍යතා",
        chapter6List11: "වයස අවුරුදු 18 සම්පූර්ණවීම.",
        chapter6List12:"ජාතික හැඳුනුම්පත සහ පිටපතක්.",
        chapter6List13:"උප්පැන්න සහතිකයේ මුල් පිටපත හෝ ප්‍රාදේශීය ලේකම් කාර්යාලයේ සහතික පිටපතක්.",
        chapter6List14:"කායික යෝග්‍යතාව සහතික කරන වෛද්‍ය සහතිකය සහ රුධිර වාර්තාව.",
        chapter6List15:"මෝටර් රථ ප්‍රවාහන කොමසාරිස් විසින් නිකුත් කරන ලද MA30 අයදුම්පත්‍රය.",
        chapter6List16:"රජයේ ගාස්තු ගෙවා ලබා ගත් රිසිට්පත.",
        chapter6List17:"පාස්පෝට් ප්‍රමාණයේ සුදු ඡායා රූප තුනක්.",
        chapter6Paragraph4:"වයස අවුරුදු 17 සම්පූර්ණ වූ විට අදාළ ලියකියවිලි ඉදිරිපත්කර ලියාපදිංචි වී ලිඛිත පරීක්ෂණයට පෙනී සමත්වී “පුහුණුවීමේ බලපත්‍රයක්” (Learner’s Permit) ලබා ගත හැක. වයස අවුරුදු 18 සම්පූර්ණ වූ පසු ප්‍රායෝගික පරීක්ෂණයට මුහුණදිය යුතුය.",
        chapter6Subheading2: "ලිඛිත පරීක්ෂණය",
        chapter6Paragraph5:"ලිඛිත පරීක්ෂණය මාර්ග නීති පිළිබඳව ඔබ සතු දැණුම පරීක්ෂා කිරීම සඳහා යොදා ගනී. බර වාහන බලපත්‍රය සඳහා අයදුම් කළ විට කාර්මික දැණුම පිළිබඳ ප්‍රශ්න ද ඇත. සියලුම ප්‍රශ්න බහු විකල්ප (multiple choice) ආකාරයේ වේ.",
        chapter6List2: [ "ලිඛිත පරීක්ෂණය සමත් වූ විට “L” පුවරු සහ පුහුණුවීමේ බලපත්‍රයක් ලබා දේ.","ප්‍රායෝගික පරීක්ෂණයට පෙර එම L පුවරු සහ බලපත්‍රය නැවත භාරදිය යුතුය."],
        chapter6Subheading3: "බර වාහන රියදුරු බලපත්‍රයක් ලබා ගැනීමේ අවශ්‍යතා",
        chapter6List31: "වයස අවුරුදු 21 සම්පූර්ණවීම.",
         chapter6List32:"සැහැල්ලු වාහන බලපත්‍රය ලබාගෙන වසර 2ක් ගතවීම.",
        chapter6List33:"ජාතික ප්‍රවාහන වෛද්‍ය ආයතනයෙන් හෝ ගමනාගමන මණ්ඩලයෙන් නිකුත් කරන වෛද්‍ය සහතිකය.",
        chapter6List34:"නිසි පරීදිය සම්පූර්ණ කළ MA34 අයදුම්පත්‍රය.",
        chapter6List35:"ජාතික හැඳුනුම්පත.",
        chapter6List36:"රජයේ ගාස්තු රිසිට්පත.",
       chapter6List37: "සැහැල්ලු වාහන බලපත්‍රය.",
        chapter6List38:"අධිකාරී රියදුරු පුහුණු පාසලකින් ලබාගත් ප්‍රවීණතා සහතිකය.", 
       chapter6Paragraph6: "බර වාහන රියදුරන් සඳහා අවම උස:\n• බස් හා ලොරි සඳහා — අඩි 5 ක්.\n• සැහැල්ලු බස් හා ලොරි සඳහා — අඩි 4 අඟල් 10ක්.",     
       chapter6Paragraph7: "පුහුණුවීමේ බලපත්‍රය ලබාගෙන මාස 3ක් ගත වූ විට ප්‍රායෝගික පරීක්ෂණයට පෙනී සිටිය හැක. සමත් වූ විට මාස 6ක් සඳහා වලංගු තාවකාලික බලපත්‍රයක් ලබා දේ. නියම බලපත්‍රය තැපැල් මගින් පසුකාලීනව ලැබේ.",
       
       chapter6Subheading4: "විදේශිකයන් සඳහා රියදුරු බලපත්‍ර ලබා ගැනීම",
       chapter6List44:"බර වාහන බලපත්‍ර ඇති අයෙකුට සැහැල්ලු වාහන බලපත්‍රය පමණක් ලබා දේ.",
       chapter6List45:"වලංගු විදේශ රියදුරු බලපත්‍රයක් අවශ්‍යය (තාවකාලික බලපත්‍ර වලංගු නොවේ).",
       chapter6List46:"අවම වශයෙන් මාසයක් සඳහා වලංගු වීසා බලපත්‍රයක් තිබිය යුතුය.",
       chapter6List47:"රියදුරු බලපත්‍රය විදෙශ භාෂාවක නම්, සත්‍යාපිත ඉංග්‍රීසි පරිවර්තනයක් ලබා දිය යුතුය.",
       chapter6List48:"ජාතික ප්‍රවාහන වෛද්‍ය ආයතනයෙන් මාස 6ක් ඇතුළත ලබාගත් යෝග්‍යතා සහතිකයක්.",
       chapter6List49:"විදේශ තනාපති කාර්යාලයක අයෙක් නම්, විදේශ කටයුතු අමාත්‍යාංශයෙන් සනාථ ලිපියක්.",
       chapter6List50: "ශ්‍රී ලාංකිකයෙකු හෝ ද්විත්ව පුරවැසියෙකු නම්, ජාතික හැඳුනුම්පත හා වලංගු ගමන් බලපත්‍රය ඉදිරිපත් කළ යුතුය.",

       chapter6Subheading5: "රියදුරු බලපත්‍රය අලුත් කිරීම",
       chapter6Paragraph8:"සැහැල්ලු වාහන බලපත්‍ර — වසර 8කට වරක්\nබර වාහන බලපත්‍ර — වසර 4කට වරක් අලුත් කළ යුතුය. මෙහිදී වෛද්‍ය වාර්තා ඉදිරිපත් කළ යුතු අතර, නැවත ප්‍රායෝගික පරීක්ෂණය අවශ්‍ය නොවේ.",
       chapter6Subheading6: "අනුපිටපතක් ලබා ගැනීම",
       chapter6List51: "පොලිස් පැමිණිල්ලේ පිටපතක්.",
       chapter6List52:"නිසි ලෙස සම්පූර්ණ කළ MA42 අයදුම්පත්‍රය.",
       chapter6List53:"රජයේ ගාස්තු ගෙවා ලබාගත් රිසිට්පත.",
       chapter6Subheading7: "තොරතුරු සංශෝධනය",
       chapter6List61:"දැනට ඇති රියදුරු බලපත්‍රය.",
        chapter6List62:"නම වෙනස් කිරීමට උප්පැන්න / විවාහ සහතිකය හෝ අනෙකුත් සත්‍යාපිත ලේඛන.",
       chapter6List63:"ලිපිනය වෙනස් කිරීමට ග්‍රාම නිලධාරිගේ සහතිකය." ,


      chapter6Subheading8: "නව බලපත්‍රයක් ලබා ගැනීම",
      chapter6List71:
       "දැනට ඇති රියදුරු බලපත්‍රය.",
       chapter6List72:"බර වාහන බලපත්‍රයක් නම්, මාස 6ක් ඇතුළත ලබාගත් යෝග්‍යතා වෛද්‍ය සහතිකයක්."
       ,

      chapter6Subheading9: "අත්ට්‍රැක්ටර් සඳහා බලපත්‍ර",

      chapter6Paragraph9:
      "ආබාධිත බලපත්‍රයක් ඇති අයෙකුට හැරවෙනත්, කිනම් හෝ වාහන කාණ්ඩයකට වලංගු බලපත්‍රයක් ඇති ඕනෑම අයෙකුට අධ්‍යක්ෂක ලෙස රිය පැදවීමේ අයිතිය ඇත.",

      chapter6Subheading10: "අභියාචන ඉදිරිපත් කිරීම",

      chapter6Paragraph10:
      "රියදුරු බලපත්‍ර පරීක්ෂණයකදී අසාධාරණයක් සිදුවූ බවක් ඇත්නම්, දින 7ක් ඇතුළත මෝටර් රථ ප්‍රවාහන කොමසාරිස්වරයාට හෝ දිස්ත්‍රික් ලේකම්වරයාට අභියාචනයක් ඉදිරිපත් කළ හැක.",

      chapter6Subheading11: "රියදුරු බලපත්‍රය අවලංගු කිරීම",

      chapter6Paragraph11:
      "අධිකරණ නියෝගයකින් හෝ වෛද්‍ය වාර්තාවකින් අනුව, මෝටර් රථ ප්‍රවාහන කොමසාරිස්වරයාට අවලංගු කිරීමේ බලය ඇත. මුළුමනින්ම අවලංගු කළ බලපත්‍රයක් නැවත ලබා ගැනීමට හැකියාවක් නොමැත.",

      chapter6Subheading12: "වාහන පන්ති",

      chapter6Image1: PDFViewerImage2,
      chapter6Image2: PDFViewerImage3,
      chapter6Image3: PDFViewerImage4,

        
      

     
      chapter7Title: "7. රියදුරු අභිවෘද්ධි ලකුණු",
      chapter7Subheading1: "පෙර- රියදුරු අකුශ්‍යතා ලකුණු",
      chapter7Paragraph1:
      "2011 ඔක්තෝම්බර් 05 වැනිදා ප්‍රකාශිත අංක 1726/12 දරන ගැසට් නියෝගයට අනුව රියදුරු අභිවෘද්ධි ලකුණු ලබාදීමේ නීතිය ක්‍රියාත්මක වේ. මෙය \"2011 අංක 03 දරන මෝටර් වාහන අභිවෘද්ධි ලකුණු නියෝග\" යනුවෙන් හැඳින්වේ.",

     chapter7Paragraph2:
      "රිය ධාවනයේදී රියැදුරන් කරන වැරදි වලට ලකුණු ලබාදී එම ලකුණු ප්‍රමාණය 24ක් වූ විට රියැදුරු බලපත්‍රය වසරකට අත්හිටු වීම මෙහිදී සිදුවේ.",

     chapter7List11:
    "මහා මාර්ගයකදී රිය අනතුරු වළක්වා ගැනීමට පියවර ගන්න අපොහොසත් වීම - ලකුණු 6ක්",
    chapter7List12:"මහා මාර්ගයක අපරික්ෂාකාව හෝ අන්තරාදායක ලෙස හෝ අන්තරාදායක වේගයෙන් මෝටර් වාහනයක් ධාවනය කිරීම ලකුණු 8ක්",
    chapter7List13:"මහා මාර්ගය භාවිතා කරන වෙනත් තැනැත්තන් කෙරෙහි නොසැලකිලිමත් ලෙස හෝ යුක්ති සහගත සැලකිල්ලක් නොමැතිව මහා මාර්ගයක මෝටර් වාහනයක් ධාවනය කිරීම ලකුණු 8ක්",
    chapter7List14:"මහා මාර්ගයක රිය අනතුරකින් පසුව වාහනය නතර කිරීම පැහැර හැරීම සහ අදාළ තොරතුරු සැපයීම පැහැර හැරීම - ලකුණු 10ක්.",
    chapter7List15:"අනතුරක් පිළිබඳව වහාම ළඟම පිහිටි පොලිස් ස්ථානයට දැනුම් දීම පැහැර හැරීම - ලකුණු 10ක්",

    chapter7Subheading2:
    "අපරික්ෂාකාරීව රිය පැදවීම සහ අනතුරු යන වරද යටතේ වූ වර්ගීකරණයේදී ලකුණු ලබාදෙන්නේ මෙසේය.",

    chapter7List21:
    "මාර්ග රීති යන වරද යටතේ මාර්ගයේ වම් පසට හෝ ආසන්න පැත්තට ගෙන රිය පැදවීම අපොහොසත් වීම ලකුණු 02ක්",
     chapter7List22:"මාර්ගයේද රිය පැහැදිලිව දර්ශනය කර ගැනීමෙන් තොරව වෙනත් වාහන පසුකර රිය පැදවීම ලකුණු 06ක්",
    chapter7List23:"වෙනත් වාහන පසුකර යනවිට ඒ වෙනත් වාහනවල දකුණු පැත්තෙන් දකුණට නැඹුරුව රිය පැදවීම පැහැර හැරීම ලකුණු 04ක්",
   chapter7List24: "දකුණු දෙසින් හෝ එම පැත්තට ඉහතින් පැමිණෙන වාහන සඳහා ඡේදනවලදී මාර්ගයේ ඉඩ ලබා නොදීම ලකුණු 04ක්",
    chapter7List25:"දීර්ඝ දුරක් මහාමාර්ගයක වාහනය පිටුපසට ධාවනය කිරීම හෝ පිටුපසට ධාවනය කිරීම සඳහා සාධාරණ හේතුවක් නොමැතිව අවසර දීම - ලකුණු 4ක්",
    chapter7List26:"තහනම්, සීමිත, අනිවාර්ය හෝ ප්‍රමුඛතා සංඥාවලට අනුකූලව ක්‍රියාකිරීම පැහැර හැරීම - ලකුණු 6ක්.",
    chapter7List27:"සංඥා කිරීම යන වරද යටතේ පොලිස් නිලධරයකුගේ වාහන නිරීක්ෂකයකු විසින් දෙන ලද වාචික විධාන හෝ හස්ත සංඥාවලට අනුකූලව ක්‍රියා කිරීම පැහැර හැරීම - ලකුණු 6ක්.",
    chapter7List28:"දුෂණය යන වරද යටතේ නියමිත ප්‍රමිතීන්ට වැඩි විමෝචන සහිත මෝටර් රථ වාහනයක් පැදවීම ලකුණු 6ක්.",
    chapter7List29:"නියමිත ප්‍රමිතීන් ඉක්මවන ශබ්ද මට්ටම් සහිතව වාහනයක ශබ්ද විකාශන උපකරණ භාවිත කිරීම හෝ භාවිත කිරීමට අවසර දීම ලකුණු 6ක්.",
    chapter7List30:"නියමිත ප්‍රමිතීන් ඉක්මවා එන්ජිම සහ නළාව ශබ්දය නිකුත් කරනු ලබන වාහනයක් පාවිච්චි කිරීම ලකුණු 6ක්.",
    chapter7List31:"මාර්ගයේ හෝ මාර්ගයට යාබද යම් තැනැත්තකුට දේපළකට හෝ වාහනයකට අනතුරක් හෝ හානිය ගෙන දෙන හෝ ඇති කිරීමට ඉඩ ඇති තත්ත්වයකින් යුත් වාහනයක් පැදවීම වාහන තැනීම හා පාවිච්චිය යන වරද යටතේ ලකුණු 10ක්",
     

     

    
    chapter8Title: "8. රිය අනතුරකදී ඔබේ වගකීම",
     chapter8Paragraph1:
    "රිය අනතුරක් ඒ බව ආසන්නතම පොලිස් ස්ථානයට දැනුම් දීම රියදුරන්ගේ වගකීමකි. සුළු අනතුරකදී නම් ඊට අදාල පාර්ශවයන්ගේ අනෝන්‍ය එකඟත්වය මත සමථයකට පත්විය හැක.",

     chapter8Paragraph2:
    "රථවාහන අනතුරු සම්බන්දව මහේස්ත්‍රාත් අධිකරණයේ නඩු විභාග වුව ද, රථ වාහන අනතුරක් සම්බන්දයෙන් වන්දි ලබා ගැනීමට හැකිවන්නේ දිසා අධිකරණයේ පවරනු ලබන නඩු කටයුත්තක් මගිනි.",

    chapter8Paragraph3:
    "රිය අනතුරකදී සිදුවන්නා වූ හානි පූර්ණය කිරීමට රක්ෂණ සමාගම් ඉදිරිපත් වන බව සැබෑවකි. එනමුත් ඔවුන් සෑම විටම ගිවිසුම් ගත රක්ෂණ වන්දි ඔප්පුවේ සීමා මායිම් වලට යටත්ව කටයුතු කරන බව අමතක නොකළ යුතුය.",

    chapter8Paragraph4:
    "ඇතැම් රක්ෂණ ආයතන පෙර සඳහන් නොකළ නීතීන් පවා ගෙන එමින් කටයුතු කරන බව විශේෂයෙන්ම මතක තබාගත යුතුය. එබැවින් තම රක්ෂණ සමාගම සමග ඇති කරගත් රක්ෂණ ඔප්පුවට අදාල වන්නා වූ සියලුම කොන්දේසි පිළිබඳව මනා අවබෝධයක් ඇති කර ගැනීම වාහන හිමිකරුවෙකු හෝ රියදුරෙකු වශයෙන් ඔබේ වගකීමයි.",

    chapter8Paragraph5:
    "රිය අනතුරකින් මරණයක් සිදුවුවහොත්, නීතියට අනූව රිය පැද වූ තැනැත්තා වැරදිකරු වේ නම්, ඔහුට මරණීය දණ්ඩනය නියම කිරීමට පවා නීතිමය ප්‍රතිපාදන තිබේ.",

    chapter8Subheading1: "මාරාන්තික අනතුරක් යනු",

    chapter8Paragraph6:
    "\"යම් තනි ගමනාගමන වාහනයක් හෝ කිහිපයක් ඇතුළත් වන යම් අනතුරකින්, එකී රිය අනතුර සිදුව දින 30ක් තුළ එක් තැනැත්තෙක් හෝ කිහිපදෙනෙක් මිය ගියා වූ අනතුරකි.\"",

 
    

   
  chapter9Title: "9. වාහන සිහිනය ජය ගන්න පහසු මගක් – ලීසිං (Leasing)",
  chapter9Paragraph1:
    "ලීසිං (Leasing) යනු වාහනයක් හෝ වෙනත් දේපලක් හෝ සේවාවක් මිලට ගැනීමට ඇති පහසු ක්‍රමයකි. වර්තමානයේ බොහෝ දෙනා වාහන මිලට ගන්නේ ලීසිං ක්‍රමයට ය. එනම් ලීසිං සමාගම් හරහාය.",
  chapter9Paragraph2:
    "මෙහිදී තමන් සතු යම් මුදලක් මූලික ගෙවීමක් වශයෙන් ලබාදී වාහනය මිලට ගැනීමේ පහසුකම ගැනුම්කරුට හිමි වේ.ලීසිං ගිවිසුමේ පරිදි නියමිත කාලයට අදාල වාරික සියල්ල ගෙවා නිමකළ විට වාහනයේ නියම හිමිකරු බවට පත්වීමටද ඔහුට හැකිවේ.",

  chapter9Paragraph3:
    "සරලව පැහෑදලි කලහොත් මෙහිදි සැබැවින්ම සිදුවන්නේ ලීසිං සමාගම විසින් සම්පූර්ණයෙන්ම මුදල් ගෙවා අදාළ වාහනය මිලට ගෙන, එහි පරම අයිතිය ලීසිං සමාගම සතුව තබාගෙන වාරික වශයෙන් වටිනාකම ගෙවීමේ කොන්දේසිය මත තවත් අයෙකුට එම වාහනය ලබාදීමයි.",

  chapter9Paragraph4:
    "එහිදී ඔහු අදාළ වාරික ගෙවා තම මූල්‍ය වැයකිරීම ලීසිං සමාගමට ලබාදුන් පසුව ඔවුන් පෙරකී වාහනයේ හිමිකරුට එහි පරම අයිතියද ලබාදෙයි.",

  chapter9Paragraph5:
    "තනි පුද්ගලයෙකුට වාහනයක් මිලට ගැනීමට ඇති පහසුම හා ඉක්මන් ක්‍රමයක් වීමත්, තම ආදායමට සරිලන පරිදි ලීසිං වාරික සකසා ගැනීමට ඇති ඉඩකඩත් නිසා, ලීසිං කිරීම වර්තමානයේ බෙහෙවින් ජනප්‍රිය වෙමින් පවතී.",

  chapter9Subheading1: "ලීසිං සමාගමක් සමඟ කටයුතු කිරීමේදී",

  chapter9List11:
    "ලීසිං සමාගම ශ්‍රී ලංකා මහ බැංකුවේ ලියාපදිංචි අනුමත ආයතනයක් වීම.",
    chapter9List12:"විශ්වාසනීය නාමයක් තිබීම.",
    chapter9List13:"ගනුදෙනුකරුවන්ට දක්වන විවෘතභාවය සහ සැලකිලිමත් බව.",

  chapter9Subheading2: "ලීසිං ගිවිසුමක් අත්සන් කිරීමට පෙර",

  chapter9List21:
    "ගිවිසුමේ අඩංගු කොන්දේසි හොඳින් කියවා තේරුම් ගන්න.තමන්ට තේරුම් ගත හැකි භාෂා පිටපතක් ඉල්ලා ගෙන කියවා ගිවිසුමේ කොන්දේසි පිළිබඳව සෑහීමකට පත්වන්න.",
    chapter9List22:"ගිවිසුම් කාලය තුළ වාරික ගෙවිය යුතු ආකාරය නිවැරදිව අවබෝධ කර ගන්න.නියමිත දින පසු වුවහොත් පොළිය අයවන ආකාරය පිළිබඳව ද දැනුවත් වන්න.",
    chapter9List23:"ගිවිසුම් ගත මුළු කාලයට පෙර ගිවිසුම අවලංගු කළහොත දඩ මුදලක් ගෙවීමට සිදුවේ ද හෝ ඒ හා සම්බන්ධ කොන්දේසීන් විමසා බලන්න.",
    chapter9List24:"ගිවිසුම අවලංගු කළහොත් දඩ මුදලක් ගෙවිය යුතුද යන්න විමසා බලන්න.",
    chapter9List25:"පොලී අනුපාත සහ දඩ පොලිය පිළිබඳව ද අනිවාර්යයෙන්ම ඔබ දැනුවත් විය යුතුය.",

  chapter9Subheading3: "ලීසිං වාහනයක් විකිණීම",

  chapter9Paragraph6:
    "ලීසිං ක්‍රමයට ලබාගත් වාහනයක් ලියාපදිංචියේදී අදාළ වන්නේ 1980 අංක 08 දරන මෝටර් රථ ප්‍රවාහන (සංශෝධිත) පනත යි. මෙහිදී වාහනය අයිතිකරුවන් දෙදෙනෙකු යටතේ ලියාපදිංචි වේ:",

  chapter9List3: ["පරම අයිතිකරු – Absolute Owner", "ලියාපදිංචි අයිතිකරු – Registered Owner"],

  chapter9Paragraph7:
    "මෙහිදී ලීසිං සමාගම පරම අයිතිකරු වන අතර, වාහනය මිලට ගත් තැනැත්තා ලියාපදිංචි අයිතිකරු බවට පත්වේ. ලියාපදිංචි අයිතිකරුට තම තනි කැමැත්ත මත වාහනය අන්සතු කළ නොහැක.ඒ සඳහා පරම අයිතිකරුගේ එකඟතාවය ද අවශ්‍ය වේ.",

  chapter9Paragraph8:
    "එමෙන්ම වාහනය නිසා සිදුවන අනතුරු හෝ අලාභ සඳහා පරම අයිතිකරු වගකිවයුතු නොවේ.",

  chapter9Subheading4: "ලීසිං වාහනයක් විකිණීමේදී",

  chapter9Paragraph9:
    "ලීසිං ගිවිසුම අවලංගු නොකොට වාහනය විකිණීමෙන් වළකින්න. ලීසිං සමාගම සමඟ පවතින මුල් ගිවිසුම අවලංගු කර වාහනය මිලට ගන්නා තැනැත්තාගේ නමින් නැවත ගිවිසුමක් ඇතිකර ගැනීමෙන් අනතුරුව වාහනය විකුණන්න.",
  chapter9Paragraph10:
    "වෙනත් අයෙකු වාහනයේ ලියාපදිංචි අයිතිකරු ලෙස සිටින ලීසිං වාහනයක් මිලට ගැනීමෙන් ඔබට වාහනයේ අයිතිය හිමි නොවේ.කල්බදු ගිවිසුම අවලංගු / වෙනස් කිරීමේදී යම් බදු මුදලක් ගෙවීමට සිදුවනු ඇත.",
  chapter9Subheading5: "ලීසිං වාරික නොගෙවූ වාහන රැගෙන යාම",
  chapter9Paragraph11:
    "මුල්‍ය හා කල්බදු පනත‍් අනුව කල්බදු යටතේ වාහනයක් මිල දී ගෙන ඇති පුද්ගලයෙකු අදාළ වාහනයේ වටිනාකමින් 50% කට වඩා ගෙවා නොමැති නම් හා එම කල්බදූලාභියා තව දුරටත් කල් බදු ගෙවීම පැහැර හරිනම් කල්බදු සමාගමට අදාළ වාහනය පවරා ගැනීමේ හැකියාව තිබේ.",

  chapter9Paragraph12:
    "එම වාහනය පවරා ගැනීමේදී කල්බදු සාමාගම පොලිසියේ පැමිණිල්ලක් කර පොලිසිය සමග අදාළ වහනය රැගෙන එමට යා යුතු අතර එහිදී වාහන හිමියා වාහනය ලබා දීම ප්‍රතික්ෂේප කරයි නම් උසාවියේ නඩු පවරා වාහනය ලබා ගත යුතුයි.කිසිම කාරයකින්”සීසර්” ලා (Seizure) ට තනිවම ගොස් වාහන ලබා ගත නොහැකියි.",

  chapter9Paragraph13:
    "නීතියේ මෙසේ සඳහන් වුවද සත්‍ය වශයෙන්ම ලීසිං කළ වාහනයක් නැවත ලබාගැනීම යනු අප්‍රසන්න ක්‍රියාවලියක් බවට පත්ව තිබේ. ලීසිං සමාගමෙන් පැමිණෙන \"සීසර්\"ලා (Seizure) බලහත්කාරයෙන් වාහනය රැගෙනයාම සිදු කරන්නේ වාහන හිමියා අන්ත අසරණ තත්වයට ඇඳ දමමිනි.",

  chapter9Subheading6: "සටහන",

  chapter9Paragraph14:
    "ලීසිං කර වාහනයක් මිලට ගත්විට, ලීසිං සමාගම වාහනයේ ලියාපදිංචි සහතිකය ( Certificate of registration) හෙවත් 'වාහනයේ පොත’ , රක්ෂණ ඔප්පුව (lnsurance policy) සහ වාහනයට ලැබෙන අමතර යතුර තමන් සතුව තබාගනී. ගනුදෙනුකරුට ආදායම් බලපත්‍රය හෝ රක්ෂණ සහතිකය හෝ ලබාගැනීමට අවශ්‍යවන විට ඒ වෙනුවෙන් ලීසිං සමාගමෙන් සහතික කළ ලිපියක් ලබාදෙනු ලැබේ.",


   



  
  chapter10Title: "10. අධිවේගී මාර්ගයේදී වැදගත් කරුණු",
  chapter10List11: 
    "අධිවේගී මාර්ගයේ ගමන් කිරීමට අවසර හිමි නොවන වාහන ත්‍රීරෝද රථ, යතුරු පැ, පා පැදි, ට්‍රැක්ටර් සහ අදාල යෝග්‍යතාවය සපුරාලීමට අපොහොසත් වන ඕනෑම වාහනයක්.",
    chapter10List12:"අධිවේගී මාර්ගය තුළ හෝ දෙපස හෝ පදිකයන්ට ගමන් කිරීම තහනම්ය."
  ,

  chapter10Subheading1: "අධිවේගී මාර්ගයේ ගමන් කිරීමට වාහනයක යෝග්‍යතා",
  chapter10List21: 
    "පැයට කි.මී. 100ක වේගයෙන් ගමන් කිරීමට හැකිවීම.",
    chapter10List22:"අධික බර පටවා නොමැතිවීම සහ ධාවනයේදී කලු දුම් පිට නොකිරීම.",
    chapter10List23:"මෝටර් රථ ආඥා පනතට අනුකූලව ප්‍රමිතිගත වාහනයක් වීම (උස, බර ආදිය).",
    chapter10List24:"උපාංග නිසි පරිදි ක්‍රියාත්මක වීම (ආලෝක සංඥා, ඩෑෂ්බෝර්ඩ් සංවේදක, තිරිංග, ආසන පටි ආදිය).",
    chapter10List25:"ටයර් සහ එන්ජිම සුදුසු තත්ත්වයේ පැවතීම.",
    chapter10List26:"ටයර් වල නිසි වායු පීඩනය පැවතීම."
  ,
  chapter10Subheading2: "අධිවේගී මාර්ගය ආරක්ෂාකාරීව භාවිතා කිරීමට උපදෙස්",
  chapter10List31: 
    "උපරිම වේගය පැයට කි.මී. 100කි.",
   chapter10List32: "සෑම විටම ඉදිරි වාහනය සමඟ ආරක්ෂාකාරී පරතරයක් පවත්වාගන්න. (අධිවේගි මාර්ගයේදී ඔබේ වාහනයේ හැසිරීම සාමාන්‍ය මාර්ගයකට වඩා බෙහෙවින් වෙනස් වනු ඇත)",
    chapter10List33:"සෑම විටම ආසන පටි පැළඳ ගන්න.අනතුරකදී ඔබේ ජීවිතය රැක ගැනීමට සුවිශාලතම සහයක් ලබා දෙන්නේ ඔබ විසින් බොහෝ විට නොතකා හරින මේ කුඩා ආසන පටිය මගිනි.",
    chapter10List34:"සෑම විටම පිටත මංතීරුවේ/වම් මංතීරුවේ ධාවනය කරන්න. ඇතුළත මංතීරුව, අන් වාහන පසුකර යාම සඳහා පමණක් වෙන්කර ඇත.",
    chapter10List35:"වාහනය ඉස්සර කිරීමට පෙර පැති කණ්ණාඩි පරීක්ෂාකර, ආරක්ෂාකාරී නම් සංඥා දමා ඉස්සර කර නැවතත් පෙර පරිද්දෙන්ම පරීක්ෂාකාරීව සංඥා දමා , පසුකළ වාහනයට අවහිරයක් ඇති නොවන ලෙස පරතරය තබාගෙන වම් ධාවන තීරුවට ඇතුළු වන්න.",
    chapter10List36:"අධිවේගී මාර්ගයට ඇතුළුවන සහ පිටවන මාර්ගයන්හි දී උපරිම වේගය පැයට කි.මී. 60 කි.",
   chapter10List37: "හදිසි නැවතුම් තීරුව යොදාගත හැක්කේ හදිසි අවස්ථාවකදී පමණි.",
    chapter10List38:"අවට සිරි නැරඹීම, ශාරීරික අවශ්‍යතා සඳහා හෝ විවේක ගැනීම සඳහා හෝ අධිවේගී මාර්ගය තුළදී ඔබගේ වාහනය නතර කිරීම හෝ වාහනයෙන් බැස ඇවිදීම සපුරා තහනම්ය.",
    chapter10List39:"ඔබේ සියලු අවශ්‍යතා විවේක ගැනීමේ ප්‍රදේශයේදී ඉටු කර ගැනීම ඔබේ වගකීමකි",
    chapter10List40:"ගමන අතරතුර මාර්ගයට කුණු කසළ බැහැර කිරීමෙන් වලකින්න.",
    chapter10List41:"අයහපත් කාළගුණ තත්ව වලදී, වාහනයේ වේගය අඩුකර,වඩාත් සුපරීක්ෂාකාරීව ධාවනය කරන්න.",
    chapter10List42:"හදිසි අනතුරක දී ඔබේ වාහනය හදිසි මංතීරුවට ගෙන නතර කරන්න. මෙම මංතීරුවේ පළල මීටර් 175ක් පමණක් නිසා, නතර කිරීමේ දීත් පිටතට පැමිණීමේදීත් බොහෝසෙයින් කල්පනාකාරී විය යුතුය.",
    chapter10List43:"හදිසි අවස්ථාවකදී හෝ ආපදාවකදී අධිවේගී මාර්ගයෙ හදිසි ඇමතුම් අංකය වන 1969 ට දැනුම් දී ආපදා සහන සේවා පැමිණෙන තුරු හැකි සෑම විටම වාහනය තුළට වී සිටීම වැදගත්ය.",
    chapter10List44:"අධිවේගී මාර්ගය තුළදී කිසිම විටක පිටුපසට ධාවනය තහනම් ක්‍රියාවකි. යම් හෙයකින් ඔබේ පිටවීමේ ස්ථානය මග හැරුනි නම්, කළයුත්තේ මීළඟ හුවමාරුව තෙක් ගමන් කොට එතැනින් පිටවීමයි.",
    chapter10List45:"අධිවේගී මාර්ගයේදී සැපයෙන ආපදා සේවාවන් සහ ඔබ අතින් මාර්ගයට හෝ දේපළ වලට සිදුවන හානි සඳහා ඉතා අධික සේවා ගාස්තු සහ දඩ මුදල් අයකිරීම සිදුවේ. එබැවින් ඔබේ වාහනය අධිවේගී මාර්ගයේ",
    chapter10List46:"ධාවනයට යෝග්‍ය නොමැති නම් ඒ වෙත ඇතුළු කිරීමෙන් වළකින්න. සෑම විටම හැකි උපරිම ආරක්ෂාකාරීව ධාවනය කරන්න.",
    chapter10List47:"අධිවේගී මාර්ගයේදී අදාල නීති රීතීන් අනුගමනය කර වඩාත් වේගවත්, ආරක්ෂාකාරී සහ සුවපහසු ගමනක් අත්විඳන්න."
  ,




  
  chapter11Title: "11. පදිකයන් සඳහා අදාළ මාර්ග නීති රීති",

  chapter11Paragraph1: "මහමග ගමන් කරන හැකි සෑම විටම මාර්ගය අයිනේ දකුණු පැත්තෙන් ගමන් කරන්න. එවිටද රියෙන් ඔබේ පැත්තෙන් එන වාහන ඔබට පෙනෙන අතර, පිටුපසින් එන වාහන ගමන් කරන්නේ ඔබට ඈතින් පිහිටි පැත්තෙනි.",
  chapter11Paragraph2: "පදික වේදකාවක් හෝ පදිකයන්ට වෙන්කළ පැති මාර්ගයක් හෝ ඇත්නම් සෑම විටම එය භාවිතා කරන්න.",
  chapter11Paragraph3: "මාර්ගයේ ගමන් කළ යුත්තේ තනිව හෝ උපරිම දෙදෙනෙක් පෙළට සිටින පරිදි ය. කිසිම විටක දෙදෙනෙකුට වඩා එක්ව පෙළට සිටින පරිදි ගමන් නොකළ යුතුය.",
  chapter11Paragraph4: "කුඩා ළමුන් රැගෙන යනවිට සෑම විටම ඔවුන්ගේ ආරක්ෂාව පිළිබඳව සැලකිලිමත් වන්න. සෑම විටම දරුවා මාර්ගය පැත්තට නොව,මාර්ගයෙන් පිටත පැත්තට සිටින ලෙසත් වැඩිහිටි ඔබ මාර්ගය පැත්තේ සිටින පරිදී ත් ගමන් කරන්න.",
  chapter11Paragraph5: "වංගුවකදී හෝ මංසන්ධියකදී, මාර්ගය දෙපස පටුවීමට ඉඩ ඇති නිසා වඩාත් සැලකිල්ලෙන් ගමන් කළ යුතුය.",
  chapter11Paragraph6: "රාත්‍රී කාලයේ ගමන් කරන විට හැකිනම් සුදු හෝ ළා පාට ඇඳුමක් ඇඳගෙන ගමන් කිරීම යෝග්‍ය වේ.එවිට රියදුරන්ට වඩාත් පහසුවෙන් ඔබව දිස්වනු ඇත",
  chapter11Paragraph7: "මාර්ගය හරහා ගමන් කිරීමට අවශ්‍ය වේ නම්, ආසන්නයේ පදික මාරුවක්, මාර්ගය යටින් දිවෙන උමගක් හෝ පදිකයන් සඳහාද ඉදි කළ පාලමක් තිබේ දැයි විමසිලිමත් වන්න. ඔබ සිටින ස්ථානයෙන් දෙපස මීටර් 50ක් ඇතුළත එවන් ස්ථානයක් තිබේ නම්, අනිවාර්යයෙන්ම එය භාවිතා කළ යුතුය.",
  chapter11Paragraph8: "පදික මාරුවක දී වුවද මාර්ගය හරහා යාමට පෙර දෙපසින් එන වාහන පිළිබඳව අවදානය යොමු කරන්න. රියදුරන්ට තම වේගය අඩුකර වාහනය නතර කරගැනීමට කාලයක් ලබා දී, ආරක්ෂාකාරීව මාර්ගය හරහා යන්න. පක මාරුවකදී ඔබ මාර්ගය හරහා යා යුත්තේ තිරස් කහ ඉරි මතින් මිස සීබ්‍රා ඉරි/ඇල ඉරි ඇති ප්‍රදේශයෙන් නොවේ.",
  chapter11Paragraph9: "පදික මාරුව අසල රිය හසුරුවන පොලිස් නිලධාරියෙකු සිටීනම් ඔහුගේ අණට තරයේ කීකරු වන්න.",
  chapter11Paragraph10: "පදික මාරුවක් නොමැති නම්, මාර්ගයේ වාහන අඩුවන තෙක් සිට දකුණු පැත්ත , වම් පැත්ත සහ නැවතත් දකුණු පැත්ත බලා ආරක්ෂාකාරී නම් ඉක්මනින් මාර්ගය හරහා යන්න.",
  chapter11Paragraph11: "නතර කර ඇති වාහන වලට මුවා වී එකවරම මාර්ගය හරහා ගමන් කිරීමෙන් වලකින්න.",
  chapter11Paragraph12: "පදික මාරුවක් සඳහා ආලෝක සංඥා පහසුකම ලබා දී ඇත්නම් එම ආලෝක සංඥා අනුගමනය කර මාර්ගය හරහා යන්න. මෙම ආලෝක සංඥා ස්වයංක්‍රීය හෝ යාන්ත්‍රික එනම් අතින් ක්‍රියාත්මක කළයුතු ඒවා විය හැක. අතින් ක්‍රියාත්මක කළ යුතු නම් ඒ සඳහා අදාල ස්විචය ආලෝක සංඥා කණුවේ පහතින් සවිකර තිබෙනු ඇත.",
  chapter11Paragraph13: "ආලෝක සංඥාවේ 'රතු පැහැති මිනිසා’ සංඥාව දැල්වෙයි නම් මාර්ගය හරහා ගමන් නොකළ යුතුය. දැන් ස්වයංක්‍රීයව දැල්වෙන තුරු සිට හෝ අදාළ ස්විචය ඔබා ’කොළ පැහැති මිනිසා’ සංඥාව දල්වා මාර්ගය හරහා යන්න.",
  chapter11Paragraph14: "නමුත් මෙවිට ද දෙපසින් පැමිණිය හැකි වාහන කෙරෙහි පරීක්ෂාකාරී විය යුතුය. මක්නිසාදයත්, ආලෝක සංඥා වලට අවනත වීමට රියදුරන්ට ද යම් කාලයක් ලබා දිය යුතු බැවිනි.",
  chapter11Paragraph15: "ස්වල්ප වේලාවකින් (බොහෝවිට කොළ සංඥාව දැල්වී තිබෙනුයේ මිනිත්තුවක් වැනි කාලයකි.) කොළ පාට මිනිසා සංඥාව චලනය වන්නට පටන් ගනු ඇතඉන් කියවෙන්නේ ඉතා ඉක්මනින් රතු පාට මිනිසා සංඥාව දැල්වෙනු ඇති බවයි.එබැවින් මෙවිට මාර්ගය හරහා ගමන් කිරීම ආරම්භ නොකළ යුතුය. එමෙන්ම ඔබ තවමත් මාර්ගය හරහා යමින් සිටින්නේ නම් ඉක්මනින් මාර්ගයේ අනිත් පැත්තය පැනිය යුතුය.",

  chapter11Image1: PDFViewerImage5,


  

  chapter12Title: "12. පා පැදිකරුවන් සඳහා වැදගත් නීති",
  chapter12Paragraph1: "මාර්ගයට පිවිසීමට පෙර ඔබගේ පාදය යෝග්‍ය තත්ත්වයේ පවතින්නේ දැයි පරීක්ෂා කර බලන්න.",
  chapter12Paragraph2: "වාර්ෂික බලපත්‍ර තහඩුව පැහැදලිව පෙනෙන පරිදි සවිකරන්න.",
  chapter12Paragraph3: "මාර්ගයේ වම් පසින් ධාවනය කරන්න.",
  chapter12Paragraph4: "පා පැදි ධාවන තීරුවක් ඇතිනම් සෑමවිටම එය භාවිතා කරන්න",
  chapter12Image1: PDFViewerImage6,
  chapter12Image2: PDFViewerImage7,
  chapter12Paragraph5: "වාහන පසුකර යන විට වඩාත් ප්‍රවේසම් වන්න.",
  chapter12Paragraph6: "සෑම විටම දෑත් බයිසිකල් හැඬලය මතම තබාගන්න",
  chapter12Paragraph7: "හස්ත සංඥා නිවැරදිව, කාර්යක්ෂමව සහ පැහැදලිව ලබා දෙන්න.",
  chapter12Paragraph8: "රාත්‍රී කාලයේ ධාවනය කරන්නේ නම් පාදයට ලාම්පුවක් (හෝ වෙනත් යෝග්‍ය ආලෝක ප්‍රභවයක්) සවිකර ගන්න.",
  chapter12Paragraph9: "ඉදිරිපස පැහැදලි ආලෝකයක් නිකුත් කරන ආලෝක ප්‍රභවයක් සහ පිටුපසින් රතු පැහැති ආලෝක පරාවර්තකයක් සවිකර තිබිය යුතුය.",
  chapter12Paragraph10: "එම පරාවර්තකයේ විෂ්කම්භය 03.75cm විය යුතු අතර, පිටුපස රෝදයේ මඩ ආවරණයේ පහළ කෙළවරේ සිට ඉහළට 23.00cm උසට සුදු වර්ණය ආලේප කර, එම සුදු පැහැති කොටසේ පරාවර්තකය සවිකර තිබිය යුතුය.",
  chapter12Image3: PDFViewerImage8,
  chapter12Image4: PDFViewerImage9,
  chapter12Image5: PDFViewerImage10,
  chapter12Image6: PDFViewerImage11,



  chapter13Title: "13. මෝටර් වාහන පදවන්නන් සඳහා වැදගත් කරුණු",
  chapter13Paragraph1: "ඔබ රිය පැදවීමට යෝග්‍ය තත්වයක සිටින්නේ නම් මිසෙක ගමනක් ආරම්භ කිරීමෙන් වළකින්න. ඔබ මත්ද්‍රව්‍ය (හෝ මත්ගතිය ඇතිවන ඖෂධ) භාවිතා කර මත්පැන් ගෙන විඩාවට පත්ව දැඩි චිත්තවේගයට ගොදුරුව සිටින්නේ නම් රිය පැදවීමෙන් වළකින්න.",
  chapter13Paragraph2: "රිය පදවන අතරතුර දුරකථනය භාවිතා කිරීමෙන්, ආහාර ගැනීමෙන් වළකින්න. එසේම සෙරෙප්පු පැළඳ රිය පදවන්න එපා.",
  chapter13Paragraph3: "වාහනයේ යාන්ත්‍රික තත්වය යහපත් බව තහවුරු කරගන්න. සුක්කානම, තිරිංග, ටයර්, ලාම්පු, නළාව, ආලෝක සංඥා, වයිපර් පිළිබඳව අවදානය යොමු කරන්න.",
  chapter13Subheading1: "මහාමාර්ගයක රිය පැදවීමට පහත අවශ්‍යතා සම්පූර්ණ විය යුතුය.",
  chapter13List11: 
    "1. රියදුරා නිසි කායික හා මානසික යෝග්‍යතාවයකින් යුක්ත වීම.",
    chapter13List12: "2. වාහනය මාර්ග ධාවනය සඳහා සුදුසු තත්ත්වයේ පැවතීම.",
    chapter13List13: "3. වාහනය සඳහා වලංගු රක්ෂණ සහතිකයක් තිබීම.",
    chapter13List14: "4. වාහනයට වලංගු ආදායම් බලපත්‍රයක් තිබීම.",
    chapter13List15: "5. රියදුරාට අදාල වාහන පන්තිය සඳහා වලංගු රියදුරු බලපත්‍රයක් තිබීම.",
   chapter13List16:  "6. වාහනයට වලංගු වායු විමෝචන සහතිකයක් තිබීම."
  ,
  chapter13Paragraph4: "රිය පදවන සෑම විටම රියදුරු බලපත්‍රය, වාහනයේ ආදායම් බලපත්‍රය,රක්ෂණ සහතිකය සහ වායු විමෝචන සහතිකය වාහනය තුළ ම තබාගත යුතුය.",
  chapter13Paragraph5: "ඔබ රිය පැදවීම පුහුණු වන්නේ නම්, එම වාහන පන්තියට අදාල වලංගු රියදුරු බලපත්‍රයක් හිමි, වයස අවුරුදු 21 ට වැඩි අයෙක් වාහනයේ ඔබගේ පසෙකින් අසුන්ගෙන සිටිය යුතුය.(මෙම නියමය යතුරු පැදි සහ ට්‍රැක්ටර් සඳහා අදාළ නැත)",
  chapter13Paragraph6: "වාහනයේ අංක තහඩුවේ අංක මෙන් දෙගුණයක ප්‍රමාණයෙන් යුතු රතු පැහැති L පුවරුවක්, අංක තහඩුවට උඩින් පැහදලිව පෙනෙන පරිදි සවිකර තිබිය යුතුය.",
  chapter13Paragraph7: "රියදුරු අසුනේ වාඩි වී එය ඔබට ගැලපෙන පරිදි සකස් කර ගන්න. පැති කණ්ණාඩිද ඔබට ගැලපෙන පරිදි සකසා ගන්න. ආසන පටි ඇත්නම් ඒවා නිවැරදිව පළදින්න.",
  chapter13Paragraph8: "කුඩා දරුවෙක් රැගෙන යන්නේ නම් හැකි සෑම විටකම පිටුපස අසුනේ රැගෙන යන්න. ළමුන් වෙනුවෙන් සකසා ඇති ආරක්ෂක අසුනක් භාවිතා කරන්නේ නම් එය වඩාත් යෝග්‍ය වේ.",
  chapter13Paragraph9: "පැති කණ්ණාඩියෙන් පිටුපස බලන්න. අවශ්‍ය නම් දකුණු උරහිසට ඉහළින් පිටුපස බලා මාර්ගය ආරක්ෂිතදැයි තහවුරු කරගන්න. දැන් සංඥා දමා පසුපසින් එන වාහන සඳහා බාධාවක් නොවන පරිදි ගමන ආරම්භ කරන්න.",
  chapter13Image1: PDFViewerImage12,
  chapter13Paragraph10: "සෑම විටම වේග සීමාවන්ට අනුකූලව රිය පදවන්න. රිය පදවන විට හැකි සෑම අවස්ථාවකම ඔබේ දෑත සුක්කානම මත තබා ගන්න. ගියර් දැමීම වැනි අත්‍යාවශ්‍ය කාර්යක් වුව කළ යුත්තේ එක් අතක් සුක්කානම මත තබාගෙනය.",
  chapter13Paragraph11: "හස්ත සංඥා හෝ ආලෝක සංඥා කල්වේලා ඇතිව ලබා දිය යුතුය. විශේෂයෙන්ම හස්ත සංඥා පැහැදලිව ලබා දිය යුතුය. එමෙන්ම අදාළ කාර්ය ඉටු කරගත් පසු එම ආලෝක සංඥා අක්‍රිය කළ යුතුය.",
  chapter13Paragraph12: "නළාව හඬවමින් නළාවේ බලයෙන් රිය පැදවීමෙන් වළකින්න.",
  chapter13Subheading2: "වාහන අතර පරතරය සහ වේගය",
  chapter13Paragraph13: "සෑම විටම ඉදිරියේ ඇති වාහනය සමඟ ආරක්ෂාකාරී පරතරයක් පවත්වා ගන්න. ඉදිරියේ යන වාහනය හදිස්සියේ නතර කළහොත් ගැටීමකින් තොරව ඔබට ඔබේ වාහනය නතර කරගැනීමට හැකි විය යුතුය.",
  chapter13Paragraph14: "වේගය වැඩි වනවිට ඒකීය කාලයකදී ගමන් කරන දුර වැඩිවන නිසා, වාහනය නතර කර ගැනීමට ගතවන කාලයද වැඩි වේ.",
  chapter13Subheading3: "නැවතීමේ දුර - සිතීමේ දුර + තිරිංග යෙදීමේ දුර",
  chapter13Paragraph15: "ගමන් කරන වාහනයක් තිරිංග යොදා නතර කිරීමේදී, සම්පූර්ණයෙන්ම නිසල වීමට පෙර ගමන් කරන දුර ප්‍රමාණය පිලිබඳව පහත සටහනෙන් අවබෝධයක් ලබාගත හැක.",
  chapter13Image2: PDFViewerImage13,
  chapter13Subheading4: "ආලෝක සංඥා",
  chapter13Paragraph16: "වේගයෙන් ගමන්කරන වාහන වලට ඔබව පසුකර යාමට ඉඩ දෙන්න.සෙමින් ගමන් කරන බර වාහන, වේගයෙන් ගමන් කරන වාහන සඳහා මාර්ග ඉඩ දිය යුතුය. මාර්ග ඉඩදීමට සුදුසු අවස්ථාවක් ලැබුණු විගස වාහනය පසෙකට ගෙන හෝ නතර කර වේගයෙන් යන අනෙක් වාහන සඳහ ඉඩදීම බර වාහන රියදුරන් සතු වගකීමකි.",
  chapter13Paragraph17: "ආලෝක සංඥා මගින් බලාපොරොත්තු වන්නේ තමන් අනුගමනය කිරීමට යන යම් ධාවන වෙනසක් අන්‍යයන්ට දැනුම් දීමයි.අවදානම් හැඟවීමේ සංඥා(Park Lights) භාවිතා කළ යුත්තේ වාහනය අවදානම් තත්ත්වයක හෝ අබලන් තත්වයක පවත්නා බව දැනුම් දීමට පමණි. එමෙන්ම අවදානම් හැඟවීමේ සංඥා භාවිතා කළයුත්තේ වාහනය ඇදගෙන යන විටකදී හෝ නවත්වා ඇති විටකදී පමණි.",
  chapter13Paragraph18: "නිවෙන දැල්වෙන(ජ්වලනය වන) ප්‍රධාන ලාම්පු වලින් ඔබට ප්‍රමුඛත්වයක් නොලැබේ ඉන් පැවසෙන්නේ ඔබ ඉදිරියට පැමිණෙන බව පමණි.",
  chapter13Paragraph19: "ඔබ පසුකර යාමට අදහස් නොකරන විට ඉදිරි වාහනයට ආසන්නව ගමන් කරන විට ඔබේ ප්‍රධාන ලාම්පු අවපාතනය (dim) කරන්න.මාර්ගය ආලෝකමත්ව පවත්නා අවස්ථාවන් වලදී, ප්‍රධාන ලාම්පු (Head Lights) අනවශ්‍ය අන්දමින් භාවිතා කිරීමෙන් වළකින්න.ඔබ පසුකර යාමට අදහස් නොකරන වාහනයක් පසුපස ඊට ආසන්නව ගමන් කරනවිට , ඔබේ වාහනයේ ප්‍රධාන ලාම්පු අවපාතනය කරන්න.(Dim)",
  chapter13Paragraph20: "(ඔබේ ප්‍රධාන ලාම්පු ක්‍රියාකාරී වනවිට ඉදිරි වාහනයේ පැති කණ්ණාඩි හරහා එම ආලෝකය සෘජුවම එහි රියදුරාගේ දෑස වෙත යොමු වන ප්‍රධාන ලාම්පු එළිය අවපාතනය කළවිට හෝ නිවා දැමූ විට වඩාත් සුපරික්ෂාකාරීව රිය පදවන්න.)",

  

  chapter14Title: "14. ධාවන තීරු පිළිබඳ නීති",
  chapter14Paragraph1: "ධාවන තීරු පිළිබඳ වූ නීති රීතීන් හැකි සෑම විටම පිළිපදින්න. එමගින් අනවශ්‍ය වාහන තදබද වීම් වළක්වා ගැනීමටත් ධන ආදී සම්පත්, සහ මානව කාලය මහමගට නාස්තිවීමත් අවම කර ගැනීමටත්, රිය අනතුරු වළක්වා ගැනීමටත් පහසුවෙන් ඉඩ සැලසෙනු ඇත.",
  chapter14Paragraph2: "මාර්ගය මධ්‍යයේ ඇඳ ඇති තනි සුදු ඉර කැපී යන පරිදි ඒ හරහා ධාවනය කිරීමට අවසර ඇත්තේ දකුණට හැරවීම සඳහා සහ හදිසි අනතුරක් වලක්වා ගැනීම සඳහා පමණි.",
  chapter14Subheading1: "ද්විත්ව සුදු ඉරි",
  chapter14Image1: PDFViewerImage14,
  chapter14Subheading2: "තනි සුදු ඉර",
   chapter14Paragraph30: "මාර්ගය මධ්‍යයේ ඇඳ ඇති තනි සුදු ඉර කැපී යන පරිදි ඒ හරහා ධාවනය කිරීමට අවසර ඇත්තේ දකුණට හැරවීම සඳහා සහ හදිසි අනතුරක් වලක්වා ගැනීම සඳහා පමණි.",
   chapter14Image2: PDFViewerImage15,
   chapter14Subheading3: "මාර්ගයේ මධ්‍ය රේඛාව",

   chapter14Paragraph3: "සමාන පරතරයක් සහිත සුදු කඩ ඉරි හෝ විදුලි බුබුළු (හෝ ආලෝක පරාවර්තක) සහිත සුදු කඩ ඉරි මගින් මාර්ගයේ මධ්‍ය රේඛාව හෙවත් එකිනෙකට ප්‍රතිවිරුද්ධ දිශාවන්ට වාහන ගමන් කරන ධාවන තීරු වෙන් කරනු ලැබේ.",
  chapter14Paragraph4: "ඉදිරියෙන් පැමිණෙන වාහන වලට බාධාවක් නොවන්නේනම් පමණක් මෙම රේඛා වලින් කුමන හෝ එකක් කැපීයන පරිද්දෙන් ධාවනය කිරීමට ඉස්සර කිරීමට අවසර තිබේ.",
   chapter14Image3: PDFViewerImage16,
   chapter14Subheading4: "ධාවන තීරු සළකුණ",
    chapter14Paragraph5: "දිගු පරතරයක් සහිත කෙටි කහ ඉරි මගින් මාර්ගයේ ධාවන තීරු වෙන් කෙරේ. මෙසේ ධාවන තීරු වෙන් කර ඇති මාර්ගයක ගමන් කරන විට හැකි සෑම විටම අදාළ ධාවන තීරුව තුළ වාහනය පවත්වාගත යුතුය.",
  chapter14Paragraph6: "ධාවන තීරු අතර අනවශ්‍ය පරිදි මාරු නොවිය යුතුය. කෙසේ වුවද, අනෙක් වාහන වල ධාවනයට බාධාවක් නොවන පරිදි, තමන්ට අවශ්‍ය මං තීරුවට මාරු වීමට හෝ ඉදිරි වාහන පසුකර යාමට අවසර තිබේ. මේ සෑම අවස්ථාවකදීම අලෝක සංඥා නිවැරිදව ලබාදී ආරක්ෂාකාරීව ධාවන තීරු අතර මාරු විය යුතුය.",
    chapter14Image4:PDFViewerImage17,
     chapter14Subheading5: "ධාවන තීරු තුනක් සහිත මාර්ගයකදී,",
     chapter14Paragraph7: "මාර්ගයේ වම් පැත්තේ ඇති ධාවන තීරුව හෙවත් වම් ධාවන තීරුව සෙමින් ගමන් කරන වාහන සහ වමට හරවන වාහන සඳහා වෙන්වේ. [රූපයේ 1 ධාවන තීරුව]",
  chapter14Paragraph8: "මධ්‍යම ධාවන තීරුව කෙළින්ම ඉදිරියට යන වාහන සඳහා වෙන් වේ. [රූපයේ 2 ධාවන තීරුව]",
  chapter14Paragraph9: "මාර්ගයේ මධ්‍ය රේඛාව පැත්තේ ඇති ධාවන තීරුව [රූපයේ 3 තීරුව] දකුණට හැරවීමට බලාපොරොත්තු වන වාහන සහ අන් වාහන පසුකර යන වාහන සඳහා වෙන් වේ.",
  chapter14Image5: PDFViewerImage18,
  chapter14Paragraph10: "මාර්ගයෙන් පිටවීමට ආසන්න වන විට සුදුසු කාලයකට පෙර අලෝක සංඥා යොදන්න. ඉන් පසු පසුබැලුම් කණ්ණාඩියෙන් මාර්ගයේ පිටුපස නිරීක්ෂණය කර ආරක්ෂාකාරීව වම් හෝ දකුණු ධාවන තීරුවට පිවිසෙන්න.ඉන් පසු පෙර පරිදිම ආරක්ෂාකාරීව මාර්ගයෙන් බැහැර වන්න.",
  chapter14Paragraph11: "මාර්ගයේ තදබදයක් පවතින විට හැකිතාක් තම ධාවන තීරුව තුළම වාහනය පවත්වා ගන්න. එමගින් තවදුරටත් අනවශ්‍ය තදබදයක් ඇතිවීම අවම වේ.කෙටි පරතරයක් සහිත දිගු සුදු ඉරි මගින් මාර්ගයේ අවදානම් කලාපයක් ඇති බවට සංඥා කෙරේ. මෙවිට වඩාත් පක්ෂාකාරීව රිය පැදවිය යුතුය",
   chapter14Image6: PDFViewerImage19,
  chapter14Image7: PDFViewerImage20,
  chapter14Image8: PDFViewerImage21,

  
  chapter14Subheading6: "පහත සඳහන් සංඥා ඇතිවිට වඩාත් ආරක්ෂාකාරීව හා සුපරික්ෂාකාරීව වේගය අඩුකර රිය පැදවිය යුතුය.",
  chapter14List11: 
    "පා පැදිකරුවන් මාරුවන ස්ථානද ඉදිරියෙනි.",
    chapter14List12:"ගවයන් හෝ වෙනත් සතුන් මාර්ගය හරහා ගමන් කිරීම ඉඩ ඇති ස්ථානද ඉදිරියෙනි.",
    chapter14List13:"පදිකයන් මාරුවන ස්ථානය ඉදිරියෙනි.",
    chapter14List14:"ළමුන් මාර්ගය හරහා ගමන් කිරීමටඉඩ ඇති ස්ථානය ද ඉරියෙනි.",
    chapter14List15:"පාසල ඉදිරියෙනි.",
   chapter14List16: "මිනිසුන් වැඩෙහි යෙදෙන ස්ථානද ඉදිරියෙනි."
  ,
  chapter14Paragraph25: "පදික මාරුවකදී (කහඉර) පදකයෙකු සිටීනම්, පදික මාරුව දක්වන සංඥා ඉදිරියේ හෝ පදික මාරුවේ ඇති මාර්ග ඉඩදෙනු රේඛාව ඉදිරියේ වාහනය නතර කළ යුතුය. වාහනය නතර කර ගත යුත්තේ මාර්ග ඉඩදෙනු රේඛාව මත හෝ එය පසුකර නොවේ. එම රේඛාවට ඉරියෙනි.",
  chapter14Image9: PDFViewerImage22,

  chapter14Paragraph13: "පදික මාරුව මත දී (සීබ්‍රා ඉරි මගින් පාලනය වන ප්‍රදේශයේදී) වාහන නතර කිරීම, වාහන ඉස්සර කිරීම, නළා හැඬවීම තහනම් ය.",

  chapter14Subheading7: "වාහන පසුකර යාම.",
  chapter14Paragraph14: "තමාට ආරක්ෂාකාරීව ඉදිරි වාහනය පසු කිරීමට හැකි බවටත්, පසුකරන වාහනයටත් ඉදිරියෙන් පැමිණෙන වාහන වලටත් ධාවනයේ අපහසුතාවයක් ඇති නොවන බවටත් සහතික නම් මිසෙක වාහන පසු කිරීමෙන් වළකින්න. මන්ද, අපරික්ෂාකාරී ඉස්සර කිරීම යනු, මාර්ගයකදී ජීවිත ගණනාවකට හානිකර ක්‍රියාවක් වීමේ ඉඩකඩ බොහෝ නිසාය.",
  chapter14Paragraph15: "රාත්‍රී කාලයේ, මීදුම ඇතිවිට, වර්ෂාව සහිතව මාර්ගය තෙත්ව පවත්නා විට සහ හුරුපුරුදු නොවූ මාර්ගයක ධාවනය කරන විට අන් වාහන පසු කිරීමේදී වඩාත් ආරක්ෂාකාරී විය යුතුය.",
  chapter14Paragraph16: "අන්වාහනයක් පසු කිරීමට අවශ්‍ය විට පළමුව ඉදිරි මාර්ගය පැහැදලි බවටත් , එම පෙනෙන මාර්ග ප්‍රදේශය තුළදී එම වාහනය පසුකර යාමට හැකි බවටත් නිසැකව දැන ගන්න. දැන් පසුපස මාර්ගය කණ්ණාඩිය මගින් නිරීක්ෂණය කර දකුණට හැරවීමේ ආලෝක සංඥා දමන්න.",
  chapter14Paragraph17: "දැන් වාහනයට වැඩි වේගයක් ලබාදී (3, 4 වැනි ගියරයක) ධාවනය කර පසුකර යන්න.",
  chapter14Paragraph18: "වාහනයක් පසුකළ පසු, නැවතත් එයට ඉදිරියෙන් එක්වරම ධාවන තීරුවට එක්වීමෙන් පසුකළ වාහනයේ ධාවනයට බාධාවක් ඇතිවේ. එබැවින් මද දුරක් දකුණු ධාවන තීරුවේ ගමන් කර ආරක්ෂාකාරී පරතරයක් සහිතව, ආලෝක සංඥා යොදා පළමු ධාවන තීරුවට ඇතුළුවන්න.",
  chapter14Paragraph19: "ඉදිරියෙන් ගමන් ගන්නා වාහනය දකුණට හැරවීමට සංඥා ලබා දී ඇතිවිට සහ වම් පැත්තෙන් ඉස්සර කිරීම ආරක්ෂා සහිත යැයි හොඳින්ම තහවුරු වන්නේ නම් පමණක්, වම් පැත්තෙන් ඉස්සර කිරීමට අවසර තිබේ. එනමුත් අනෙක් සෑම අවස්ථාවක ඉස්සර කළ යුත්තේ දකුණු පැත්තෙනි. නිවෙන දැල්වෙන (වලනය වන) ප්‍රධාන ලාම්පු වලින් හැඟවෙන්නේ ඔබ ඉදරියට පැමිණෙන බව පමණි. ඉන් ඔබට ප්‍රමුඛතාවක් නොලැබේ.",
  chapter14Paragraph20: "වෙනත් වාහනයක් විසින් ඔබව පසුකර යනවිට, ඔබේ වාහනයේ වේගය අඩුකර වම්පසට ගෙන්ඉඩ දෙන්න. පසුකර යන්නා ඉඩ නොදී තරඟයට මෙන් ධාවනය කිරීම යනු ඔබේ අශීලාචාර බව අන්‍යයන්ට ප්‍රදර්ශනය කිරීමකි.",
  chapter14Paragraph21: "අඩු වේගයකින් ධාවනය වන වාහන විසින් වේගයෙන් ගමන් කරන අනෙක් වාහන සඳහා පසුකර යාමට ඉඩ ලබා දිය යුතුය.",

   chapter14Subheading8: "පසුකර යාම සිදු නොකළයුතු ස්ථාන.",
  chapter14List21: 
    "1. පදිකයන් මාරුවන ස්ථානයක්",
    chapter14List22:"2. වංගුවක්.",
    chapter14List23:"3. මංසන්ධියක්.",
    chapter14List24:"4. කඳු මුදුනක් හෝ ආරුක්කු හැඩැති පාළමක්.",
    chapter14List25:"5. තනි හෝ ද්විත්ව සුදු ඉරි මගින් පාලනය වන මාර්ග ප්‍රදේශයක්.",
   chapter14List26: "6. ඉස්සර කිරීම තහනම් කර ඇති ප්‍රදේශයක්.",

  chapter14Subheading9: "පසුපසට පැදවීම",
  chapter14Paragraph22: "පසුපසට පැදවීමේදී ඉතා සුපරීක්ෂාකාරී විය යුතුය.",
  chapter14Paragraph23: "අතුරු මාර්ගයක සිට ප්‍රධාන මාර්ගයට පසුපසට පැදවීමෙන් වළකින්න. පසුපසට පැදවීමේදී සෙමෙන් ධාවනය කරන්න.",
  chapter14Paragraph24: "අනවශ්‍ය ලෙස පසුපසට පැදවීමෙන් වළකින්න.",



  
  chapter15Title: "15. මංසන්ධි හරහා ධාවනය කිරීම",
  chapter15Paragraph1: "මංසන්ධියකදී වෙනත් මාර්ගයකින් හෝ කිහිපයකින් වාහන එකතුවන නිසාත්, වෙනත් මාර්ගවලට වාහන පිටව යන නිසාත් ඉතා පරික්ෂාකාරීව ධාවනය කළයුතුය.",
  chapter15Paragraph2: "ධාවනපථ එකිනෙක කැපීයන පරීද වාහන ධාවනය වන නිසා මෙවන් ස්ථානයකදී වාහන එකිනෙක ගැටීමේ හැකියාව ඉතා වැඩිය. මංසන්ධියකට ළඟාවීමට පෙර, ඔබ ගමන් කළයුතු මාර්ගය තීරණය කර ගන්න.",
  chapter15Paragraph3: "මංසන්ධියක වාහනය නතර කරගෙන, යායුතු මාර්ගය විමසීම, නැවත පසුපසට පැදවීම, හෝ Uහැඩයට හැරවීම කිසිසේත්ම නොකළ යුතුය. එසේ කිරීමෙන් තවත් විශාල පිරිසකගේ ධාවන පථයන් අවහිර වනු ඇත. මංසන්ධියකට ළඟා වනවිට පසුබැලුම් කණ්ණාඩිය බලා, අවශ්‍ය ආලෝක සංඥා යොදා නිවැරදි ධාවන තීරුවට වාහනය ගන්න.",
  chapter15Image1: PDFViewerImage23,
  chapter15Paragraph4: "වමට හරවන්නේ නම් හෝ කෙළින්ම ඉදිරියට යන්නේනම්, වම් ධාවන තීරුවේ රැඳීඉන්න. දකුණට හරවන්නේ නම් පමණක් දකුණු ධාවන තීරුවේ ගමන් කර දකුණට හරවන්න.",
  chapter15Subheading1: "ධාවන තීරු තුනකින් යුතු මාර්ගයකදී,",
  chapter15List11: 
    "වම් පැත්තට හැරවීමට අවශ්‍ය නම් වම් ධාවන තීරුවේ ධාවනය කරන්න.",
    chapter15List12:"දකුණට හැරවීමට අවශ්‍ය නම දකුණු ධාවන තීරුවේ ගමන් කරන්න",
    chapter15List13:"කෙළින්ම ඉදිරියට යන්නේ නම් මැද ධාවන තීරුවේ ගමන් කරන්න.",
  chapter15Paragraph5: "මංසන්ධියකදී දකුණට හෝ වමට හරවන වාහන විසින් කෙළින්ම ඉදිරියට යන වාහන වලට ඉඩ ලබාදිය යුතුය",
  chapter15Image2: PDFViewerImage24,
  chapter15Subheading2: "ත්‍රිත්ව ධාවන තිරු සහිත හතරමංසන්ධියක්",
  chapter15List21:
    "1 - පැති කණ්ණාඩිය බලන්න.",
     chapter15List22:"2 - සංඥා දමන්න.",
     chapter15List23:"3 - අදාල ධාවන තීරුවට පිවිසෙන්න.",
  chapter15Image3: PDFViewerImage25,





  chapter16Title: "16. ආලෝක සංඥා",
  chapter16Paragraph1: "මෙම සංඥාව මගින් ආලෝක සංඥා මගින් රථවාහන ගමනාගමනය පාලනය කෙරෙන මංසන්ධියකට ඔබ ළඟාවෙමින් සිටින බව හැඟවේ.",
  chapter16Image1: PDFViewerImage26,
  chapter16Paragraph2: "ආලෝක සංඥා වලට සියලුම රියදුරන් තරයේම අවනත විය යුතුය. අලෝක සංඥා මගින් වාහන ගමන් කිරීම නවත්වා ඇති විට( රතු වර්ණයෙන්), මාර්ගය මත පිහිටුවා ඇති නැවතුම් රේඛාවට මෙපිටින් වාහනය නතර කරගත යුතුය.",
  chapter16Image2: PDFViewerImage27,
  chapter16Paragraph3: "එම නැවතුම් රේඛාව නොමැතිනම්, ආලෝක සංඥාඉදිරිපිට හෝ මාර්ගය බෙදීයන ස්ථානයට ඇතුළුවීමට පෙර වාහනය නතර කරගත යුතුය.",
  chapter16Image3: PDFViewerImage28,
  chapter16Image4: PDFViewerImage29,
  chapter16Image5: PDFViewerImage30,
  chapter16Image6: PDFViewerImage31,
  chapter16Paragraph4: "කෙතරම් නිවැරදිව සහ පරීක්ෂාකාරිව සකස් කර ඇති මෙම සංඥා වුවද, කලාතුරකින් හෝ වැරදි ආකාරයට ක්‍රියාත්මක වීමට ඉඩ ඇත. එමෙන්ම ආලෝක සංඥා වලට අවනත නොවී රිය පදවන්න නීති කඩන්නන්ද සිටිය හැක. මේ නිසා ආලෝක සංඥා ඇති විටක වුවද මාර්ගය කෙරෙහි ඔබේ සුපුරුදු අවදානය පවත්වා ගැනීමට කටයුතු කළ යුතුය.",
  chapter16Paragraph5: "අතැම් අවස්ථාවල ආලෝක සංඥා තාවකාලිකව අක්‍රිය කර පොලිස් නිලධාරියෙකු විසින් වාහන හසුරවන අවස්ථා තිබිය හැක. එවිට පොලිස් හස්ත සංඥා වලට තරයේම කීකරු විය යුතුය.",



  chapter17Title: "17. පොලිස් හස්ත සංඥා",
  chapter17Paragraph1: "පොලිස් නිලධාරියෙකු විසින් , රථ වාහන පාලනය කරන විට හස්ත සංඥා වලට ඔබ තරයේම අවනත විය යුතුය.",
  chapter17Image1: PDFViewerImage32,
  chapter17Paragraph2: "මෙවිට, මාර්ගය මත පිහිටුවා ඇති නැවතුම් රේඛාවෙන් මෙපිට දී වාහනය නතර කරගත යුතුය. එම රේඛාව පිහිටුවා නොමැති නම්, මාර්ගය බෙදී යන ස්ථානයට ඇතුලු වීමට පෙර වාහනය නතර කරගත යුතුය.",



  chapter18Title: "18. වටරවුමකදී ධාවනය",
  chapter18Paragraph1: "පහත සංඥාව මගින් ඉදිරියේ වටරවුමක් ඇති බව කියැවේ.",
  chapter18Image1: PDFViewerImage33,
  chapter18Paragraph2: "අනිවාර්යය වටරවුමක් නම්, ඔබ ඒ හරහා ධාවනය කළ යුතුම වේ.",
  chapter18Image2: PDFViewerImage34,
  chapter18Subheading1: "වටරවුමේ නීතිය [ දකුණේ නීතිය]",
  chapter18Paragraph3: "වටරවුමකදී දකුණු පැත්තෙන් ආසන්නයෙන් එන වාහන වලටඉඩදී ධාවනය කළ යුතුය. දකුණෙන් එන වාහනවලට ඉඩදී ම සඳහා වට රවුමේ මාර්ගය මත පිහිටුවන, \"මාර්ගඉඩදෙනු \" කඩඉර අසලදී ඔබේ වාහනය නතර කරගත යුතුය.",
  chapter18Image3: PDFViewerImage35,



  chapter19Title: "19. මංසන්ධි කොටුව",
  chapter19Image1: PDFViewerImage36,
  chapter19Paragraph1: "මංසන්ධියක මාර්ගය මත කහ පැහැයෙන් මංසන්ධි කොටු සළකුණු කර තිබිය හැක. ඔබගේ පිටවීමේ මාර්ගය පැහැදලිව ඇත්නම් මිසෙක එම සළකුණ මතට ඇතුළු නොවිය යුතුය.",
  chapter19Paragraph2: "කෙසේ වුවද, ඔබට මංසන්ධිකොටුව මත රැඳීමට අවසර ඇත්තේ දකුණට හැරවීමට අදහස් කරන්නේ නම් ඉදිරියෙන් එන වාහන වලින් හා දකුණට හැරවීමට ඇති අනෙක් වාහන වලින් ඔබේ ධාවනයට බාධාවී ඇත්නම් පමණි.",
  chapter19Paragraph3: "වෙනත් කිසිම විටක මංසන්ධි කොටුව මත රැඳී සිටීම තහනම්ය.",



  chapter20Title: "20. වාහන නතර කිරීම",
  chapter20Paragraph1: "හැකි සෑම විටකම, වාහන නැවතුම්පොළක් භාවිතා කරන්න.මාර්ගය අයිනේ නවත්වන්නේ නම්, එම මාර්ගය වාහන ගමන් කරන දිශාවට මුහුණලා වම් පැත්තේ හැකිතාක් මාර්ගය පසෙකට ගෙන මාර්ගයට සමාන්තරව සිටින සේ නතර කළ යුතුය.",
  chapter20Image1: PDFViewerImage37,
  chapter20Paragraph2: "එන්ජිම නතර කර, නිසි පරිදි නවතා තැබීමේ තිරිංග (අත් තිරිංග /Hand Break) යොදන්න. විශේෂයෙන් මාර්ගය පැත්තේ දොර විවර කිරීමේ දී පිටුපසින් එන වාහන පිළිබඳව පරීක්ෂාකාරී වන්න.",
  chapter20Paragraph3: "වාහන නැවතුම් පොළකදී, කෝණාකාරව හෝ වෙනත් ආකාරයකට වාහන නතර කිරීමට නියම කර ඇත්නම් එය අනුගමනය කරන්න. නිසි සැලැස්මක් නොමැතිව හිතුමතේ තැන තැන වාහන නතර කිරීමෙන් අන්‍යයන්ගේ වටිනා කාලය මෙන්ම ඔබේ කාලයද නිකරුනේ අපතේ යයි. එමෙන්ම මාර්ගය අවහිර වන පරිදි තැන තැන වාහන නතර කිරීම නිසා සිදුවන ධන හානියද, ඇතිවන මාර්ග තදබදයද සුළුපටු නොවේ. එබැවින් වාහන නැවතුම්පොළක හෝ මාර්ගය අයිනේ හෝ නිසි පරිදි වාහන නතර කිරීම ඉතා වැදගත් ය.",
  chapter20Subheading1: "වාහන නතර කර තැබීමේ පිළිගත් ප්‍රධාන ආකාර දෙකකි.",
  chapter20List11: 
    "1) සමාන්තර ක්‍රමය - Parallel parking",
    chapter20List12:"2)කෝණික ක්‍රමය - Angle parking"
  ,

  chapter20Subheading2: "සමාන්තර ක්‍රමය",
  chapter20Paragraph4: "පළමුව ඔබේ වාහනය නතර කිරීමට ප්‍රමාණවත් ඉඩක් සොයා ගන්න. ආරක්ෂාකාරීව වාහනය නතර කිරීමට නම් අවම වශයෙන් වාහනයේ දිගට වඩා මීටර් 02කින් වත් වැඩි ඉඩක් තිබිය යුතුය. දැන් නිසි පරිදි සංඥා දමා වාහනය හසුරුවන්න.",
  chapter20Paragraph5: "මෙහිදී වාහනය හැසිරවීමට සම්මත නීතියක් නැතත්, පහත දක්වා ඇත්තේ බහුතරයක් රියදුරන් අනුගමනය කරන්නාවූ ද, වඩාත් පහසු හා ආරක්ෂාකාරී වූ ද ක්‍රමයයි. එනමුත් ඔබේ හුරුව හා පහසුව අනූව ස්වකීය ඕනෑම ක්‍රමයක් අනුගමනය කළ හැක. වඩාත් වැදගත් වන්නේ අනෙක් වාහන වලට හානි නොවන පරිදිත්, ධාවන පථ අවහිර නොවන පරිදිත් වාහනය නතර කිරීම පමණි.",
  chapter20Paragraph6: "වාහනය ගාල් කරන ස්ථානයට ඉදිරියෙන් ඇති වාහනයට සමාන්තරව, මීටර් 5ක පමණ පරතරයක් පවත්වා ගනිමින් ඔබේ වාහනය ඉදිරියට ගන්න.",
  
  chapter20Image2: PDFViewerImage38,
  chapter20Paragraph7: "සෙමින් පිටුපසට පැදවීම අරඹන අතරම සුක්කානම ක්‍රමානුකූලව හැරවීම අරඹන්න. අංශක 45ක් දක්වා සුක්කානම හැරවෙන තෙක් පසුපසට එන්න.",
  chapter20Image3: PDFViewerImage39,
  chapter20Paragraph8: "ඉන් පසු රෝද කෙළින් කරගෙන තව දුරටත් පිටුපසට යන්න.",
  chapter20Image4: PDFViewerImage40,
  chapter20Paragraph9: "දැන් නැවත අනෙක් පසට සුක්කානම හරවමින් පසුපසට ගන්න",
  chapter20Image5: PDFViewerImage41,
  chapter20Paragraph10: "ඉන් පසුව, නිසි පරතරයක් ඇතිවන පරිදි පිහිටීම සකසා ගන්න.",
  chapter20Image6: PDFViewerImage42,
  chapter20Subheading3: "කෝණික ක්‍රමය",
  chapter20Paragraph11: "බොහෝවිට වාහන ගාල් කිර්ම සඳහා භාවිතා වන්නේ මෙම ක්‍රමයයි. මෙහිද වාහනය දෙපසින් තවත් වාහන දෙකක් පවතිනු ඇත.",
  chapter20Paragraph12: "මෙවිට ඉදිරි තිරස සමග අංශක 90ක කෝණයක් පවතිනු ඇත.",
  chapter20Image7: PDFViewerImage43,

  chapter20Paragraph13: "අංශක 60 ක කෝණයක් පවත්වාගනිමින් වාහන ගාල් කිරීම",
  chapter20Paragraph14: "මේ අකාරයට වාහන ගාල් කිරීම තනි අතට ගමන් කරන මාර්ගයක් අයිනේදී සිදුවේ. එමෙන්ඉඩකඩ සීමිත නැවතුම් ස්ථාන වලදීද මේ ක්‍රමය අනුගමනය කෙරේ.",
  chapter20Image8: PDFViewerImage44,

  chapter20Paragraph15: "වාහන නැවතුම්පොළකදී වාහනය තුළ කිසිවෙකු නොසිටින්නේ නම් හෝ වාහනය පිළිබඳව වගකියන පාර්ශවයක් නොසිටින්නේ නම්, අනිවාර්යයෙන්ම වාහනය අගුළු දමා යා යුතුය.",
  chapter20Paragraph16: "රාත්‍රී කාලයේ වාහන ගමන් ගන්නා මාර්ගයක නවතා තබන විට, නැවතුම් පහන් දල්වා තබන්න.",

  chapter20List2: [
    "වාහනය නතර කරන්නේද රියට බෑවුම ඇති ස්ථානයක දී නම්, රිවස් ගියරයට දමා, මාර්ගයෙන් ඉවතට රෝද යොමු වන පරිදි උපරිමයෙන් සුක්කානම කපා, අත් තිරිංග ඇද නතර කළ යුතුය."
  ],
  chapter20Image9: PDFViewerImage45,

  chapter20List3: [
    "පසුපසට බෑවුම ඇති ස්ථානයක(කන්දක) නතර කරන්නේ නම්, පළමු ගියරයේ තිබියදී අත් තිරිංග ඇද නතර කළ යුතුය. එමෙන්ම මාර්ගය අයිනේ ගැටියක් සහිත නම් රෝද මාර්ගය දෙසට යොමුවන පරිදිීත්, එවන් ගැටියක් නොමැති නම් රෝද මාර්ගයෙන් ඉවතට යොමු වන පරිදිත් සුක්කානම සකසා නතර කළ යුතුය."
  ],
  chapter20Image10: PDFViewerImage46,



 


  chapter21Title: "21. වාහන නතර කර තැබීම තහනම් ස්ථාන",
  chapter21List11: 
    "මංසන්ධියක සිට මීටර් 25 ක් ඇතුළත.",
    chapter21List12:"බස් නැවතුමක සිට මීටර් 30 ක් ඇතුළත.",
    chapter21List13:"පදික මාරුවක සිට මීටර් 15ක ප්‍රදේශයක් ඇතුළත.",
    chapter21List14:"ගිනි නිවන ජල නළයක සිට මීටර් 15ක් ඇතුළත.",
    chapter21List15:"පදික වේදකාව මත.",
   chapter21List16: "පාලමක් මත.",
    chapter21List17:"කඳු මුදුනක.",
    chapter21List18:"මාර්ගයේ වංගු සහිත ස්ථානයක.",
    chapter21List19:"මාර්ගය පටු ස්ථානයකදී.",
    chapter21List20:"තනි හෝ ද්විත්ව සුදු ඉරි සහිත මාර්ග ප්‍රදේශයක දී",
    chapter21List21:"බස් රථ හෝ පා පැදි ධාවන තීරුවක් මත.",
    chapter21List22:"අධිවේගී ධාවන තීරුවක.",
    chapter21List23:"කුළී රථ නැවතුම්පොළක.",
    chapter21List24:"පාලන සංඥා මගින් නතර කිරීම තහනම් කළ ස්ථානයක.",
    chapter21List25:"යම් ස්ථානයක පිවිසුම් දොරටුවක් අවහිර වන පරිදි"
  ,



   chapter22Title: "22. මාර්ග සංඥා",
  chapter22Paragraph1: "මාර්ග සංඥා ප්‍රධාන වශයෙන් කාණ්ඩ දෙකකට වෙන්කර දැක්විය හැක.",
  chapter22List11: 
    "1) පුවරු සංඥා",
     chapter22List12:"2) මාර්ගය මත පිහිටුවන සංඥා"
  ,

  chapter22Subheading1: "පුවරු වශයෙන් ඇති සංඥා කාණ්ඩ කිහිපයකි",
  chapter22List21: 
    "අනතුරු හැඟවීමේ සංඥා",
    chapter22List22: "පාලන සංඥා",
     chapter22List23:"තොරතුරු සංඥා",
       chapter22List231:"a මගපෙන්වීමේ පූර්ව සංඥා.",
       chapter22List232:"b මග පෙන්වීමේ සංඥා.",
       chapter22List233:"c ස්ථාන හැඳන්වීමේ සංඥා.",



     chapter22List24:"අනෙකුත් සංඥා"
  ,

  chapter22Subheading2: "පාලන සංඥා වර්ග",
  chapter22List31: 
    "a) තහනම් සංඥා",
    chapter22List32:"b) සීමාකාරී සංඥා",
    chapter22List33:"c) විධාන සංඥා",
    chapter22List34:"d) ප්‍රමුඛතා සංඥා"
  ,
chapter22Subheading21: "2) පාලන සංඥා",
  chapter22Subheading3: "අනතුරු හැඟවීමේ සංඥා",
  chapter22Image1: PDFViewerImage47,
chapter22Image2: PDFViewerImage48,
chapter22Image3: PDFViewerImage49,
chapter22Image4: PDFViewerImage50,
chapter22Image5: PDFViewerImage51,
chapter22Image6: PDFViewerImage52,

  chapter22Subheading4: "තහනම් සංඥා",
  chapter22Image7: PDFViewerImage53,
  chapter22Image8: PDFViewerImage54,
  chapter22Image9: PDFViewerImage55,
  chapter22Paragraph2: "මෙම මාර්ගයට ඇතුළුවීම මෙන්ම (අනෙක් අන්තයෙන් ඇතුළු වීමද) තහනම් ය.",
  chapter22Image10: PDFViewerImage56,
  chapter22Paragraph3: "මෙම මාර්ගයට ඇතුළුවීම තහනම් වුවද, මාර්ගයේ පැමිණෙන අනෙක් අන්තයේ සිට වාහන වලට මෙතුනින් පිටවීමට අවසර ඇත.",
  chapter22Paragraph4: "මෙම සංඥාව මගින් පාලනය වන සීමාව තුළ 'වාහන නවතා තැබීම' තහනම් වුවද හදිසි නොකර වාහනය අවස්ථාවක එන්ජිම නතර නැවැත්වීමට අවසර ඇත.",
  chapter22Paragraph5: "කිසිම ආකාරයකට වාහන නැවැත්වීම සහ නවත්වා තැබීම තහනම්ය.",
  chapter22Image11: PDFViewerImage57,
  chapter22Image12: PDFViewerImage58,

  chapter22Subheading5: "අතිරේක පුවරු",
  chapter22Paragraph6: "මෙම පුවරු මගින් පාලන සංඥා බලපැවැත්වෙන දිශාව හා දුර ප්‍රමාණය දැක්වීම සිදුවේ. අදාල පාලන සංඥාවට පහළින් මෙම අතිරේක පුවරු සවි කරනු ලැබේ. බොහෝවිට වාහන නතර කිරීම සම්බඳව යෙදෙන පාලන සංඥා වලදී අතිරේක පුවරු යොදා ගැනේ.",
  chapter22Image13: PDFViewerImage59,

  chapter22Subheading6: "සීමාකාරී සංඥා",
  chapter22Image14: PDFViewerImage60,

  chapter22Subheading7: "විධාන සංඥා",
  chapter22Image15: PDFViewerImage61,

  chapter22Subheading8: "ප්‍රමුඛතා සංඥා",
  chapter22Paragraph7: "අතුරු මාර්ගයක ගමන් ගන්නා වාහන විසින් ප්‍රධාන මාර්ගයේ ගමන් කරන වාහන වලට ඉඩ දිය යුතු බව දනුම් දීමට යොදා ගැනේ.",
  chapter22Image16: PDFViewerImage62,
  chapter22Paragraph8: "අතුරු මාර්ගයක සිට ප්‍රධාන මාර්ගයට ඇතුළුවන වාහන අනිවාර්යයෙන්ම නතර කර ප්‍රධාන මාර්ගයේ වාහන වලට ඉඩ දිය යුතු බව මෙම සංඥාවෙන් දක්වේ.",
  chapter22Image17: PDFViewerImage63,
  chapter22Paragraph9: "අතුරු මාර්ගවල සිට ප්‍රධාන මාර්ගයට ඇතුළුවන වාහන විසින් ප්‍රධාන මාර්ගයේ ගමන් කරන වාහන වලට ප්‍රමුඛත්වය ලබාදෙන බව, ප්‍රධාන මාර්ගයේ වාහන වලට දැන්වීම මෙම සංඥාවෙන් සිදුවේ.",
  chapter22Image18: PDFViewerImage64,
  chapter22Paragraph10: "අතුරු මාර්ගවල සිට ප්‍රධාන මාර්ගයට ඇතුළුවන වාහන විසින් ප්‍රධාන මාර්ගයේ ගමන් කරන වාහන වලට ලබාදෙන ප්‍රමුඛත්වය අවසන් බව, ප්‍රධාන මාර්ගයේ වාහන වලට දැන්වීම මෙම සංඥාවෙන් සිදුවේ.",
  chapter22Image19: PDFViewerImage65,
  chapter22Image20: PDFViewerImage66,

  chapter22Subheading9: "තොරතුරු සංඥා",
  chapter22List41: 
    "a) මග පෙන්වීමේ පූර්ව සංඥා",
    
    chapter22List43: "c) ස්ථාන හැඳන්වීමේ සංඥා"
  ,
  chapter22Image21: PDFViewerImage67,

chapter22Subheading12:" මාර්ගය වෙනස්ව ඇති විට එම දිශාව දැනුම් දීමට යොදා ගැනේ.",
  chapter22Image22: PDFViewerImage68,
  
  chapter22Subheading11:"මාර්ගයේ ඇති බාධකයක් දක්වීමට යොදා ගැනේ.",
  chapter22Image23: PDFViewerImage69,
  chapter22Image24: PDFViewerImage70,

  chapter22List42: "b) මග පෙන්වීමේ සංඥා",
  chapter22Image25: PDFViewerImage71,

  chapter22Subheading10: "අනෙකුත් සංඥා",
  chapter22Image26: PDFViewerImage72,
  chapter22Image27: PDFViewerImage73,


  

  chapter23Title: "23. මාර්ගය මත පිහිටුවන සංඥා",
  chapter23Subheading1: "පදික මාරුවක දී මාර්ගය මත පිහිටුවන සළකුණු",
  chapter23Image1: PDFViewerImage74,
  chapter23Image2: PDFViewerImage75,
  chapter23Paragraph1: "නවතිනු සංඥාවේ දී මාර්ගය මත පිහිටුවන නැවතුම් අතුරු මාර්ගයක සිට ප්‍රධාන මාර්ගයකට ඇතුළු වන ස්ථානයක මෙම රේඛාව පිහිටුවා ඇති විට, අනිවාර්යයෙන්ම වාහනය නවතා දෙපසින් එන වාහන වලට ප්‍රමුඛත්වය ලබා දිය යුතුය.",
  chapter23List11:
    '"මාර්ගඉඩදෙනු රේඛාව" ප්‍රධාන මාර්ගයකට ඇතුළුවීමේදී අතුරු මාර්ගයේ වාහන සඳහා මෙම සළකුණ පිහිටුවනු දැකිය හැක',
     chapter23Image3: PDFViewerImage76,

     chapter23List12:"මංසන්ධියක හෝ එවැනි මාර්ගය බෙදී යන ස්ථානයක පිහිටුවන නැවතුම් රේඛාව",
     chapter23Image4: PDFViewerImage77,

     chapter23List13:"වටරවුමකදී පිහිටුවන මාර්ග ඉඩදෙනු රේඛාව",
     chapter23Image5: PDFViewerImage78,



    chapter23List14: "මාර්ගයේ අයින දැක්වෙන ආයත රේඛාව",
    chapter23Image6: PDFViewerImage79,

    chapter23List15: "වාහන නතර කිරීම තහනම් හෝ සීමා කර ඇති බව දක්වීමට මාර්ගය අයිනේ පිහිටුවන ආයත රේඛාව",
    chapter23Image7: PDFViewerImage80,
chapter23Image8: PDFViewerImage81,
chapter23Image9: PDFViewerImage82,


    chapter23List16: "තනි සුදු ඉර මගින් පාලනය වන මාර්ග ප්‍රදේශයක්: ඉර පරිදි දකුණට රවීමට අවසර තිබුණද, ඉර කැපීයන පරිදි ධාවනය කිරීම, සහ දෙපස වාහන නතරකර තැබීම තහනම් ය.",
     chapter23Image10: PDFViewerImage83,

    chapter23List17:"ද්විත්ව සුදු ඉරි මගින් පාලනය වන මාර්ග ප්‍රදේශයක්: ඉරි කැපීයන පරිදි ධාවනය කිරීම ඉස්සර කිරීම, සහ දෙපස වාහන නතරකර තැබීම තහනම් ය. දකුණට රවීමද තහනම් ය.",
     chapter23Image11: PDFViewerImage84,


    chapter23List18:"අවදානම් ප්‍රදේශය: මෙම සළකුණ දෙපසින්, එකිනෙකට ප්‍රතිවිරුද්ධ දිශාවට වාහන ධාවනය කරනවිට, ආරක්ෂා සහිත යැයි හොඳින්ම තහවුරු නම් මිසෙක, මේ හරහා දකුණට හැරවිය නොහැක.",
    chapter23Image12: PDFViewerImage85,
    
    chapter23List19:"අවදානම් ප්‍රදේශය: මෙම හරස් විකර්ණ රේඛා මගින් දෙපැත්තේම එකම දිශාවට වාහන ගමන් කරන විට, වඩා ආරක්ෂාකාරීව ධාවනය කළ යුතු ප්‍රදේශය පෙන්වා දෙනු ලැබේ.",
    chapter23Image13: PDFViewerImage86,

    chapter23List20: "ධාවන තීරු වෙන්කර දැක්වීමට යොදා ඇති සළකුණු",
    chapter23Image14: PDFViewerImage87,


    chapter23List21b: "අනිවාර්යයෙන්ම වමට හැරවිය යුතු බව දැක්වෙන සළකුණ",
    chapter23Image15: PDFViewerImage88,

    chapter23List22b: "අනිවාර්යයෙන්ම දකුණට හැරවිය යුතු බව දැක්වෙන සළකුණ",
    chapter23Image16: PDFViewerImage89,

    chapter23List23b: "අනිවාර්යයෙන්ම කෙළින්ම ඉදිරියට ගමන් කළයුතු බව දැක්වෙන සළකුණ",
    chapter23Image17: PDFViewerImage90,

    chapter23List24b: "'නවතිනු' සංඥාව ඇති ස්ථානයක මාර්ගය මත පිහිටුවන සළකුණ",
    chapter23Image18: PDFViewerImage91,

    chapter23List25: "ඉදිරියේ අවදානමක් ඇති අවස්ථාවක සෙමින් ධාවනය කරන ලෙස දැනුම් දෙන සංඥාව",
    chapter23Image19: PDFViewerImage92,


     chapter23List26:"බස් රථ ධාවන තීරුව",
     chapter23Image20: PDFViewerImage93,


    chapter23List27: "පා පැදි ධාවන තීරුව",
    chapter23Image21: PDFViewerImage94,


    chapter23List28: "මාර්ගයේ අවදානමක් ඇති බවට අනතුරු හැඟවීමේ රේඛාව",
    chapter23Image22: PDFViewerImage95,


    chapter23List29: "බස් හෝ පාද ධාවන තීරුවක් බෙදා දැක්වෙන රේඛාව",
    chapter23Image23: PDFViewerImage96,
  





  chapter23Subheading2: "අමතර දැනුමට",
  
chapter23Image24: PDFViewerImage97,

  chapter23Paragraph2: "රූපයේ දැක්වෙන මංසන්ධියේදී,",
  chapter23List21: 
    "මෝටර් කාරය අනිවාර්යයෙන්ම ඉදරියට යා යුතුය. ✓",
    chapter23List22:  "ත්‍රී රෝද රථයට කෙළින්ම ඉදිරියට යා හැක. X",
    chapter23List23:  "ත්‍රී රෝද රථයට දකුණට හැරවීමට හෝ කෙළින්ම ඉදිරියට යා හැක. X",
     chapter23List24: "ත්‍මෝටර් කාරයට කෙළින් ඉදිරියට යාමට හෝ දකුණට හැරවීමට හැක. X"
  ,

  chapter23List31:
    "මාර්ග සලකුණ කුමක්ද? මාර්ගය හරහා යෑම තහනම් කෙරෙන ආයත රේඛාව.",

    chapter23Image25: PDFViewerImage98,


   chapter23List32: "මෙම මාර්ග සලකුණ කුමක්ද? වටරවුමක පිහිටුවන මාර්ග ඉඩදෙනු රේඛාව",
   chapter23Image26: PDFViewerImage99,


    chapter23List33:"මෙම මාර්ග සලකුණ කුමක්ද? නවතිනු සංඥාවේ පිහිටුවන නැවතුම් රේඛාව.",
    chapter23Image27: PDFViewerImage100,
  

  chapter23List41: "T හැඩැති මංසන්ධියකට ඇතුළුවන විට, අනිවාර්යයෙන් නතර කොට ධාවනය කළයුතුය.",
chapter23List42: "මාර්ග නීති සංග්‍රහයේ 'අනතුරු හැඟවීමේ සංඥා' දැක්වෙන්නේ? කහ පසුබිමේ කලු වර්ණයෙනි.",
chapter23List43: "වටරවුමක මූලික නීතිය වන්නේ? දකුණෙන් පැමිණෙන රථවාහන වලට ඉඩදී ධාවනය කළයුතුය.",
chapter23List44: "මංතීරු තුනක් සහිත මාර්ගයක ඉදිරියටම ගමන් කරන්නේ නම්, මාර්ගයේ මැද මංතීරුව භාවිතා කළ යුතුය.",
chapter23List45: "'අවදානම හැඟවීමේ ලාම්පු (Hazard Lamps) භාවිතා කළ යුත්තේ, වාහනය අබලන් තත්වයකට පත්ව ස්ථිරව නතර කර ඇති අවස්ථාවක පමණි.",
chapter23List46: "රාත්‍රී කාලයේ වාහනය නතර කළ යුත්තේ, රථ වාහන ගමනා ගමනය සිදුවන දිශාවට මුහුණලාය.",
chapter23List47: "වාහනයක් නතර කිරීමේදී 'නැවැත්වීමේ දුර' යනු? සිතීමේ දුර සහ තිරිංග යෙදීමේ දුර යන දෙකේ එකතුවයි.",
chapter23List48: "ඉදිරියේ පදික මාරුවක් ඇති බවට සංඥාවක් දුටු විට, වාහනය නතර කර ගැනීමට සූදානමින් වේගය පාලනය කරගෙන ධාවනය කළ යුතුය.",
chapter23List49: "ඉදිරියේදී දකුණට හැරවිය යුතුනම් ඔබ ධාවනය කළ යුතු වන්නේ, මාර්ගයේ දකුණුපස ධාවන තීරුවේය.",
chapter23List50: "අතුරු මාර්ගයකින් ප්‍රධාන මාර්ගයකට පිවිසෙන විට, මාර්ගයේ දෙපසම හොඳින් නිරීක්ෂණය කිරීමෙන් අනතුරුව පිවිසිය යුතුය.",
chapter23List51: "බෑවුම් මාර්ගයක ධාවනය කරනවිට, අඩු ගියරයක (බර ගියරයක) ධාවනය කළ යුතුය.",
chapter23List52: "මෝටර් වාහනයක ඉන්ධන පුරවන විට, එන්ජිම නතර කර තැබිය යුතුය.",
chapter23List53: "නව අංක තහඩු ක්‍රමය යටතේ ලබාදෙන 'වාහනයේ අනන්‍යතා පත්‍රය' (VIC) සෑම විටම වාහනය තුළ තබාගත යුතුය.",
chapter23List54: "වාහනය ඉස්සර කිරීමේදී 3, 4 වැනි වැඩි ගියරයක් තෝරා වැඩි වේගයක් ලබාදී ධාවනය කළ යුතුය.",
chapter23List55: "මෝටර් වාහනයක බෆරය මත ලෝහමය ආරක්ෂක වැටක් සවි කිරීම නීත්‍යානුකූල නොවේ.",
chapter23List56: "රථවාහන නීති පිළිපිදන විට ප්‍රමුඛත්වය දිය යුතු පිළිවෙල: පොලිස් සංඥා, ආලෝක සංඥා, මාර්ග සංඥා, මාර්ගය මත පිහිටුවන සංඥා.",
chapter23List57: "මාර්ගයේ ඇති සංඥා ප්‍රධාන වර්ග දෙකකි: පුවරු සංඥා සහ මාර්ගය මත පිහිටවූ සංඥා.",
chapter23List58: "රියදුරෙකු සංඥා දැමීමෙන් බලාපොරොත්තු වන්නේ තමන්ගේ ක්‍රියාව අන්‍යයන්ට දැනුම් දීමයි.",
chapter23List59: "වාහනයක ඉදිරි වීදුරුව (Windscreen) අඳුරු කළ නොහැක. දෙපස වීදුරු වලින් 1/5ක් පමණක් අඳුරු කළ හැක.",
chapter23List60: "නොපෙනෙන ශීග්‍ර වංගුවකදී, නළාව ශබ්ද කර අඩු වේගයකින් ධාවනය කළ යුතුය.",
chapter23List61: "ප්‍රධාන ලම්පුවේ ආලෝකය ආකාර දෙකකි: ප්‍රධාන එළිය (Head) සහ අවපාත / අඩවන් එළිය (Dim).",
chapter23List62: "බෑවුමක ධාවනය කරන විට අඩු / බර ගියරයක ධාවනය කළ යුතුය.",
chapter23List63: "ලිස්සායන අවස්ථාවක තිරිංග භාවිතා නොකළ යුතුය. ඇස්ලේටරය අතහැර ලිස්සා යන දිශාවට සුක්කානම හරවන්න.",
chapter23List64: "මාර්ග තදබදයක ධාවනය කරන විට, පාදය ක්ලච් පැඩලයේ සහ දකුණු පාදය තිරිංග පැඩලය මත යාන්තමින් තිබිය යුතුය.",
chapter23List65: "තැනිතලා මාර්ගයක නිදහසේ ධාවනය කරන විට, වම් පාදය නිදහසේ සහ දකුණු පාදය ඇස්ලේටර් පැඩලය මත තිබිය යුතුය.",
chapter23List66: "පහලට බෑවුමක ධාවනය වනවිට, වම් පාදය ක්ලච් පැඩලයේ සහ දකුණු පාදය තිරිංග පැඩලයේ තිබිය යුතුය.",
chapter23List67: "පදික මාරුවක් භාවිතා නොකර මාර්ගය හරහා යන පදිකයෙකුට රු.1000.00 සිට 2000.00 දක්වා දඩ මුදලක් නියම කළ හැක.",
chapter23List68: "මාරාන්තික අනතුරක් යනු, අනතුර සිදුව දින 30ක් ඇතුළත එක් තැනැත්තෙක් හෝ කිහිපදෙනෙකු මියගිය අනතුරකි.",
chapter23List69: "පරීක්ෂාකාරීව ධාවනය කළයුතු ස්ථාන: පාසල් අසල, දුම්රිය හරස් මාර්ග, පදික මාරු, මංසන්ධි, ජනාකීර්ණ මාර්ග ආදිය.",
chapter23List70: "අතුරු මාර්ගයක සිට ප්‍රධාන මාර්ගයකට ඇතුළුවන විට, ප්‍රධාන මාර්ගයේ වාහන වලට ඉඩදී ධාවනය කළ යුතුය.",


  chapter23Paragraph3: "T හැඩයේ මංසන්ධියකදී නම්, ඔබේ වාහනය මාර්ගඉඩදෙනු රේඛාවට මෙපිටින් නතර කර ප්‍රධාන මාර්ගයේ දෙපසින්ම ආසන්නයෙන් එන වාහන වලට ඉඩ දී ගමන් කළ යුතුය.",
  




   chapter24Title: "24. අනතුරකදී හෝ ආපදා අවස්ථාවකදී ගත යුතු පියවර",
  chapter24Paragraph1: "වාහනය හදිසි අනතුරකට හෝ ආපදාවකට ලක්වූ විට හැකි ඉක්මණින් එය මාර්ගයෙන් ඉවතට ගෙන, මාර්ගයේ ගමනා ගමනයට ඇතිවන බාධාව ඉවත් කළ යුතුය. කෙසේ වුවද, හදිසි අනතුරකදී වාහනයේ පිහිටීම වෙනස් කිරීමට පෙර පොලීසිය, රක්ෂණ නියෝජිතයා සහ අනතුරට පත්වූ අනෙක් පාර්ශවය සමඟ සාකච්ඡා කර තීරණයක් ගත යුතුය.",
  chapter24Paragraph2: "එසේම අනතුරකදී, වාහනයේ පිහිටීම වෙනස් කිරීමට පෙර, එහි පිහිටීම හුණු කැබැල්ලකින් මාර්ගය මත සළකුණු කිරීම, ඡායාරූපගත කිරීම ආදිය වඩාත් උචිත වේ.",
  chapter24Paragraph3: "අනතුරට ලක්වූ වාහනය මාර්ගයෙන් ඉවත් කළ නොහැකි නම්, වාහනයේ අවදානම් හැඟවීමේ ළාම්පු දල්වා තබන්න. වාහනය පිහිටා ඇති තැන සිට මීටර් 50ක් පමණ දුරින්, වාහනය පිහිටි පැත්තට එන අනෙක් වාහන වලට මුහුණලා අවදානම් හැඟවීමේ රතු පැහැති පරාවර්තන ත්‍රිකෝණයක් තබන්න. පටු මාර්ගයකදී නම් වාහනයට මීටර් 50ක් පමණ ඉදිරිපසින්ද එවැනිම අවදානම් හැඟවීමේ උපාංගයක් තබන්න.",
  chapter24Paragraph4: "ඔබේ වාහනය හදිසි අනතුරකට මුහුණ දුන්හොත්,",
  chapter24List11: 
    "වාහනය නතර කරන්න.",
   chapter24List12: "තුවාලකරුවන් ප්‍රවාහනයේදී ඇතිවිය හැකි ප්‍රමාදයන් හැර හැකි ඉක්මණින් පොලීසියට අනතුර දැනුම් දෙන්න. (රිය අනතුරක් සිදුවී පැය 24ක් ඇතුළත එය පොලීසියට වාර්ථා කළ යුතුය.)",
    chapter24List13:"පොලිස් නිලධාරියෙකු, ග්‍රාම නිලධාර්වරයෙක්, තුවාල ලැබූ පුද්ගලයෙකු, හෝ තුවාල ලැබූ පුද්ගලයෙක්, සතත්වයෙක් භාරව සිටින යම් තැනැත්තෙක් භාර ඉල්ලා සිටියහොත් පහත තොරතුරු ලබාදය යුතුය." ,
  chapter24SubList11: 
    "රියදුරුගේ නම",
    chapter24SubList12:"ලිපිනය",
    chapter24SubList13:"වාහනය අයිතිකරුගේ නම",
    chapter24SubList14:"වාහනයේ අංකය",
  chapter24Paragraph5: "එසේම, ඔබ අනතුර සිදුවන මොහොතේ වාහනයේ ගමන් කළ මගියෙකු වුවද ඉහත සඳහන් තොරතුරු ලබාදීමටත්, ඔබේ නම, ලිපිනය හා අදාල අවස්ථාවේ වාහනයේ ගමන් කරමින් සිටි බවත් පොලීසියට දැනුම් දීමට බැඳී සිටී.",
  chapter24Paragraph6: "තුවාල ලැබූ අය සිටිය හොත් හෝ තුවාල ලැබූ අයෙක් සිහිසුන්ව සිටීනම් හෝ එකී තුවාල හේතුවෙන් යමෙකුගේ ජීවිතයට අනතුරක් වේ යැයි හැඟීයන්නේ නම් හෝ නොපමාව එම තුවාලකරුවන් ළඟම ඇති රෝහලකට රැගෙන යන්න.",
  chapter24Paragraph7: "පොලිස් නිලධාරියෙකු හෝ ග්‍රාමනිලධාරිවරයා හෝ තුවාල ලැබූ අයෙක් හෝ තුවාල ලැබූ අයෙක් වෙනුවෙන් ක්‍රියාකරන පුද්ගලයෙකු ඉල්ලා සිටියහොත් රක්ෂණ සහතිකය ඉදිරිපත් කරන්න. එම අවස්ථාවේ එය ඉදිරිපත් කිරීමට නොහැකි වුවහොත් හැකි ඉක්මණින් එය අදාල පොලිස් ස්ථානයනට ඉදිරිපත් කරන්න.",
  chapter24Paragraph8: "අනතුරක් වළක්වා ගැනීමට හෝ වාහනය පාලනය කරගත නොහැකි අවස්ථාවකදී හෝ පමණක් මාර්ග නීති කඩකිරීම වරදක් ලෙස සළකනු නොලැබේ.",






  chapter25Title: "25. රියදුරන් සඳහා වැදගත් සාමාන්‍ය කාර්මික දැනුම",

  chapter25Paragraph1: "එන්ජිම යනු ඕනෑම මෝටර වාහනයක හදවත බඳු වටිනාම කොටසයි. ඉන්ධන යොදා ගෙන බලය උත්පාදනය කරනු ලබන්නේ එන්ජිම මගිනි. මේවා පොදුවේ අභ්‍යන්තර දහන එන්ජිම් (Internal Combustion Engine) ලෙස හැඳින්වේ. සිව් පහර එන්ජින් (4 Stroke Engine) සහ දෙපහර එන්ජින් (2 Stroke Engine) ලෙස එන්ජින් දෙවර්ගයක් පැවතියද, වර්ථමානය වනවිට සියලුම ඩීසල් හා පෙට්‍රල් වාහන සඳහා යොදාගැනෙන්නේ සිව්පහර එන්ජිම් ය.",

  chapter25Paragraph2: "සිව්පහර අභ්‍යන්තර දහන එන්ජිමක් ක්‍රියාත්මකවීමේදී සිදුවන ක්‍රියාවලීය අනුපිළිවෙලින් පහත පරිදි දැක්විය හැක.",

  chapter25List11: 
    "වාතය සමඟ මිශ්‍ර ඉන්ධන සිලින්ඩරය තුළට පැමිණීම.",
    chapter25List12: "ඉන්ධන + වාත මිශ්‍රණය සම්පීඩනය වීම.",
    chapter25List13: "විද්‍යුත් පිළිඟුවක් මගින් සම්පීඩිත ඉන්ධන වාත මිශ්‍රණය දහනය වීම.",
    chapter25List14: "එවිට නිපදවෙන තාපය නිසා සිලින්ඩරය තුළ වාතය ප්‍රසාරණය වී පිස්ටනය පහළට තල්ලු වීම.",
   chapter25List15:  "එම චලිතය ක්‍රෑන්ක්ෂාෆ්ටයක් (Crankshaft) හරහා භ්‍රමණ චලිතයක් බවට පත්කර රෝද වෙත සම්ප්‍රේෂණය කිරීම."
  ,

  chapter25Paragraph3: "සිව්පහර එන්ජිම යනුවෙන් හෑඳින්වෙන්නේ එම එන්ජිමේ එක් වටයක් සඳහා පියවර 04ක් සම්පූර්ණවන බැවිනි.",

 chapter25List21: "චූෂණ පහර - Intake",
chapter25List22: "සම්පීඩන පහර - Compression Stroke",
chapter25List23: "බල පහර - Power Stroke",
chapter25List24: "පිටාර පහර - Exhaust Stroke",


  chapter25Image1: PDFViewerImage101,
  chapter25Image2: PDFViewerImage102,

  chapter25Subheading1: "චුෂණ පහර",
  chapter25Paragraph4: "පිස්ටන ඉහළ සිට පහළට යන විට සිලින්ඩරය තුළ ඇතිවන රික්තකය හේතුවෙන්, ඇතුළු වෑල්වය හරහා වාතය සමඟ මිශ්‍ර වූ ඉන්ධන සිලින්ඩරය තුළට ඇදී ඒමෙන් රික්තය පුරවනු ලැබේ.",

  chapter25Subheading2: "සම්පීඩන පහර",
  chapter25Paragraph5: "පහළට ගිය පිස්ටන ඉහළට එන අතර සිලින්ඩරයේ ඉහළ කපාට වැසී, ඉන්ධන වාත මිශ්‍රණය අධිකව සම්පීඩනය වේ. චූෂණ පහරේදී පිස්ටනය පහළට පැමිණි විට සිලින්ඩරය තුළ ඇතිවන හිස් පරිමාවත්, සම්පීඩන පහරේදී පිස්ටන ඉහළ ගිය විට ඇතිවන හිස් පරිමාවත් අතර අනුපාතය 'සම්පීඩන අනුපාතය' (Compression Rate) ලෙස හඳන්වේ.",

  chapter25Subheading3: "බල පහර",
  chapter25Paragraph6: "සම්පීඩනය අවසානයේ සිලින්ඩරය තුළ ඇති පුළිඟු ජේනුව (Spark Plug) මගින් පුළිඟුවක් නිකුත් කර සම්පීඩිත ඉන්ධන + වාත මිශ්‍රණය දහනය කරයි. එවිට විශාල තාප ශක්තියක් ජනනය වන අතර වාතය ප්‍රසාරණය වී පිස්ටනය පහලට තල්ලු වෙයි. මෙවිට ක්‍රෑන්ක්ෂාෆ්ටයට චලනයක් ලැබේ.",

  chapter25Subheading4: "පිටාර පහර",
  chapter25Paragraph7: "මේ වනවිට බල පහරේදී කැරකැවුණු ක්‍රෑන්ක්ෂාෆ්ටය මගින් නැවත පිස්ටනය ඉහළට තල්ලු කෙරෙන අතර, ඒ අවස්ථාවේදී පිටාර කපාටය (Outlet valve) විවර වී දහනය වූ වාතය පිටතට යොමු කරනු ලැබේ. මෙම පිටාර පහරෙන් පසුව නැවතත් චූෂණ පහර සිදුවේ. මෙම ක්‍රියාවලීය චක්‍රයක් ලෙස වේගයෙන් දිගින් දිගටම සිදුවෙමින්, රෝද චලනය වීම සඳහා අවශ්‍ය බලය සපයනු ලැබේ. පිස්ටනය ඉහළට හෝ පහලට ගමන් කරන එක් දුරක් 'පහරක්' (Stroke) ලෙස හඳුන්වනු ලබන අතර, රෝද චලනය කිරීමට අවශ්‍ය බලය ලබා දීමට එනම් බල පහරක් සිදුවීම සඳහා, පිස්ටනය සිව්වර ඉහල පහළ යන නිසා මෙම එන්ජිම 'සිව්පහර එන්ජින්' ලෙස හඳන්වේ.",
  
  chapter25Paragraph8b: "මෙම පිටාර පහරෙන් පසුව නැවතත් චූෂන පහර සිදුවේ. මෙම ක්‍රියාවලීය චක්‍රයක් ලෙස වේගයෙන් දිගින් දිගටම සිදුවෙමින්, රෝද චලනය වීම සඳහා අවශ්‍ය බලය සපයනු ලැබේ.",
  chapter25Paragraph9b: "පිස්ටනය ඉහළට හෝ පහලට ගමන් කරන එක් දුරක්-පහරක් (Stroke)- ලෙස හඳුන්වනු ලබන අතර, රෝද චලනය කිරීමට අවශ්‍ය බලය ලබා දීමට එනම් බල පහරක් සිදුවීම සඳහා පිස්ටනය සිව්වර ඉහල පහළ යන නිසා මෙම එන්ජිම-සිව්පහර එන්ජින්-ලෙස හඳන්වේ.",


  chapter25List31: "එන්ජිමකට එන්ජින් ඔයිල් යොදන්නේ - එන්ජිමේ කොටස් අතර ඝර්ෂණය අවම කර කොටස් ගෙවීයාම වළක්වා ගැනීමට",
  chapter25List32: "එන්ජින් ඔයිල් මට්ටම පරීක්ෂා කරන්නේ - තෙල් මට්ටම මනින කුරෙනි (Dipstick)",
  chapter25List33: "එන්ජිම පණගැන්වීමට නොහැකිවන්නේ - බැටරිය බැසීම",
  chapter25List34: "ක්‍රියාරම්භක මෝටරය (Starter motor) අක්‍රියවීම - එන්ජිම හිරවීම",
  chapter25List35: "පණගන්වන විට එන්ජිම මන්දගාමීව (ඇද ඇද) ක්‍රියාතමක වන්නේ - බැටරිය දුර්වල වීම, ස්ටාටර් මෝටරය දෝෂ සහිත වීම",
  chapter25List36: "එන්ජිම අධිකව රත්වන්නේ - රේඩියේටර් ෆෑන් බෙල්ට් එක බුරුල් වීම, රේඩියේටර් ෆෑන් එක දෝෂ සහිත වීම, රේඩියේටරයේ වතුර අඩු වීම, කාන්දු වීම හෝ ජල පොම්පය දෝෂ සහිත වීම",
  chapter25List37: "එන්ජින් ඔයිල් අඩුවීමට හේතුව - තෙල් අධිකව පිච්චීම හෝ කාන්දු වීම",
  chapter25List38: "එන්ජින් බලය අඩුවීම (Under compression) - එන්ජින් ඔයිල් මූඩියෙන් තෙල් පිටවීම, සයිලන්සරයෙන් නිල් දුම් පිටවීම, බ්ලීදර් එකෙන් දුම් පිටවීම",


  chapter25Subheading5: "ඉග්නිෂන් නොක්වීම",
  chapter25Paragraph8: "සිව්පහර එන්ජිමක ඉන්ධන වායු මිශ්‍රණය අනවශ්‍ය ලෙස අධිකව සම්පීඩනය වූ විට, එම වායු මිශ්‍රණය දහනයේදී සිලින්ඩරය තුළ පිපිරීමක් ඇතිවේ. මෙවිට එන්ජිමෙන් තද කම්පනයක් සමඟ දෙදෙරා යන ශබ්දයක් නැගේ. මෙම තත්වය 'ඉග්නිෂන් නොක්වීම' යනුවෙන් හැඳන්වේ.",

  chapter25List41: "ඉග්නිෂන් නොක්වීමට හේතු - සිලින්ඩර තුළට ඇදගන්නා වාත ප්‍රමාණය වැඩි වීම",
chapter25List42: "ඉග්නිෂන් නොක්වන අවස්ථා - වැඩි බලයක් ඇති ගියරයක (1, 2, 3 වැනි) වැඩි වේගයකින් යන විට, බර පටවා කන්දක ධාවනය කරන විට",
chapter25List43: "ඉග්නිෂන් නොක්වීම වළක්වා ගැනීම - ගියර මාරු කර වැඩි වේගයක් සහිත ගියරයක ධාවනය කිරීම",


  chapter25Subheading6: "එන්ජින් ඔයිල් මට්ටම පරීක්ෂා කිරීම",
  chapter25Paragraph9: "වාහනය සමතලා මතුපිටක නතර කරන්න.",
  chapter25Paragraph10: "එන්ජිම නතර කර සිසිල් වීමට ඉඩ දෙන්න. අවම වශයෙන් පැය 1/2ක් වත් සිසිල් විය යුතුය. රාත්‍රී කාලයේ නතර කර තිබූ රථයක් නම් උදෑසන තෙල් මට්ටම පරීක්ෂා කිරීම වඩාත් යෝග්‍ය වේ.",
  chapter25Paragraph11: "පළමුව තෙල් මට්ටම මනින කූර (dipstick) පිටතට ගෙන හොඳින් පිසදා ගන්න. නැවත වරක් එසේ කරන්න.",
  chapter25Paragraph12: "ඉන් පසුව තෙල් මට්ටම පරීක්ෂා කරන්න.",





  chapter26Title: "26. සිසිලන පද්ධතිය",
  chapter26Image1: PDFViewerImage103,
  chapter26Paragraph1: "වාහනය පදවන අතරේ රියදුරාගේ ඇස නිරන්තරව යොමුවන, ඩෑෂ් බෝඩ් එකේ ඇති සංඥාවක් වන්නේ 'එන්ජිමේ උෂ්ණත්වය’ දැක්වෙන සංවේදකයයි.",
  chapter26Paragraph2: "මෝටර් රථ එන්ජිමක් තුළ සිදුවන ක්‍රියාවලී ඉතා අධික තාපයක් ජනනය කරනු ලබන ක්‍රියාවලීයකි. මෙසේ ජනනය වන තාපය වේගයෙන් ඉවත් නොකළ හොත් එය එන්ජිමට හානි දායක වන නිසා එන්ජිම සඳහා සිසිලන පද්ධතියක් එකතු කර තිබේ.",

  chapter26Paragraph3: "එන්ජිමෙන් නිපදවෙන අධික තාපයෙන් 45% පමණ පිටාර වායුව සමඟ සයිලන්සරයෙන් ඉවත් වේ. තවදුරටත් රැඳී ඇති වාතය ඉවත් වන්නේ පෙර කී සිසිලන පද්ධතිය හරහා ය. එන්ජිම අධිකව රත්වුවහොත්",

  chapter26List11: 
    "එන්ජිමේ කොටස් අනවශ්‍ය ලෙස ප්‍රසාරණය වී එන්ජිම අවහිරවීම",
    chapter26List12: "සිලින්ඩර් හෙඩ්, ගෑස්කැ ආදිය විනාශවීම",
    chapter26List13: "එන්ජින් ඔයිල් අනවශ්‍ය ලෙස පිච්චීම ආදී තත්ත්වයන් ඇතිවිය හැක"
  ,

  chapter26Paragraph4: "මෝටර් රථ එන්ජින් සිසිලනය කිරීම ප්‍රධාන ආකාර 03 කට සිදුවේ.",

  chapter26List21: 
    "වාතයෙන් සිසිල් කිරීම",
   chapter26List22:  "ජලයෙන් සිසිල් කිරීම",
    chapter26List23: "ඔයිල් මගින් සිසිල් කිරීම"
  ,

  chapter26Paragraph5: "වාතය යොදාගෙන එන්ජිම සිසිල් කරන විට, බ්ලෝවරයක් මගින් විශාල වායු ධාරාවක් එන්ජිම වටා ගමන් කිරීම ඉඩ සලස්වයි. ජලය භාවිතයෙන් සිසිල් කිරීමේදී, රේඩියේටරයක් හරහා එන්ජිමේ සිලින්ඩර වටා ජල ධාරාවක් ගමන් කරවමින් සිසිලනය සිදු කරනු ලැබේ. එන්ජිම තුළින් ගමන් කරන ඔයිල් මගින් තාපය අවශෝෂණය කරගෙන එන්ජිම සිසිල් කිරිම ඔයිල් මගින් ක්‍රියාත්මක සිසිලන පද්ධති වලදී සිදුවේ.",

  chapter26List31: 
    "එන්ජිමේ සිසිලන පද්ධතිය තුළ ජලය සංසරණය සිදුකරනු ලබන්නේ ජල පොම්පය මගිනි",
    chapter26List32: "එන්ජිමක් අනවශ්‍ය ලෙස සිසිලනය වීමෙන් ඇතිවන අවාසි - එන්ජින් බලය අඩුවේ, ඉන්ධන වැයවීම වැඩිවේ, පිටාර වායුව සමඟ පිටවෙන නොදැවුණු වායු ප්‍රමාණ ඉහළ යයි, ධාවන වේගය අඩුවේ",
    chapter26List33: "එන්ජිම අනවශ්‍ය පරිද හීට් වීමට හේතු - රේඩියේටර් ෆෑන් එක බුරුල් වීම, රේඩියේටරයේ අවශ්‍ය තරම් වතුර නැතිවීම",
    chapter26List34: "එන්ජිම ඕවර්හීට් වී ඇති බව දැනගන්නේ - ඕවර්හීට් වන බව දැක්වෙන සංවේදකයෙන්, රේඩියේටරයේ වතුර නැටීමෙන්"
  ,

  chapter26Subheading1: "ඕවර්හීට් සංවේදකය/සංඥාව (Overheat Indicator)",

  chapter26Image2: PDFViewerImage104,

  chapter26Paragraph6: "එන්ජිම ඕවර්හීට් වන විට මෙය දැල්වේ. එමෙන්ම ආරම්භයේ ඉග්නිෂන් යතුර ක්‍රියාත්මක කළ විටද මෙය එක්වරක් දැල්වී නිවී යනු ඇත.",

  chapter26Subheading2: "ඕවර්හීට් වන විට",

  chapter26Paragraph7: "ඕවර්හීට් සංඥාව දැල්වුනු විගස වාහනයේ වායුසමීකරණ ක්‍රියාත්මකව ඇත්නම් ඒවා අක්‍රිය කරන්න. වහාම වාහනය අයින් කර නවත්වන්න. වාහනය නතර කළ සැනින් රේඩියේටරයේ ජල මට්ටම පරීක්ෂා කිරීමට යෑම කිසිසේත්ම නොකළ යුතුය.",

  chapter26Paragraph8: "එසේ ඉක්මන් වී රේඩියේටර් මූඩිය විවර කළහොත් ජල වාෂ්ප වළාවකට මෙන්ම නටන ජල දහරාවකටද මුහුණ දීමට සිදුවනු ඇත.",

  chapter26Paragraph9: "එබැවින් රේඩියේටරයේ ජලය නිමෙන තුරු මද කාලයක් ගතකර අනතුරුව, පොලිතින් කොලයක් වැනි ආවරණයක් යොදාගෙන රේඩියේටර් විවෘත කිරීම වඩාත්ම ආරක්ෂාකාරීය. සාමාන්‍යයෙන් රේඩියේටරයක මූඩිය විවර වන්නේ කට්ට දෙකකටය. ඒ ආරක්ෂක පියවරක් වශයෙනි. පළමු කට්ටය විවර කළ විට රේඩියේටරයේ වාෂ්ප තිබේ නම් ඒවා පිටව යනු ඇත. ඒ නිසා සෑම විටම රේඩියේටර් පියන විවර කළ යුත්තේ කට්ට දෙකකට ය.",

  chapter26Subheading3: "ඕවර්හීට් වී නතරවුණු වාහනයකට ජලය පිරවීම",

  chapter26Paragraph10: "ඕවර්හීට් සඳහා ස්වල්පය බැගින් ජලය පිරවිය යුතුය. එමෙන්ම ජලය පුරවන විට වාහනයේ එන්ජිම පණගන්වා තිබිය යුතුය.",

  chapter26Subheading4: "රේඩියේටර් සඳහා 'කුලන්ට්' (Coolant) යෙදීම",

  chapter26Paragraph11: "රේඩියේටර් කූලන්ට් මගින් ජලයේ හිමාංකය පහත දැමීම සහ තාපාංක ඉහළ දැමීම සිදුවේ. ඊට අමතරව රේඩියේටරයේ නළ මාර්ග වල මල බැඳී අවහිර වීම ආදියද වැළැක්වෙයි. මේ නිසා ඕනෑම දේශගුණික තත්ත්වයක් යටතේ වුවද වාහනයකට නිසි ප්‍රමිතියෙන් යුතු කුලන්ට් යෙදීම අත්‍යාවශ්‍ය මෙන්ම වැදගත් පියවරකි.",

  chapter26List41: 
    "ක්ලචයේ ප්‍රයෝජනය - එන්ජිම හා ගියර් පෙට්ටිය අවශ්‍ය විට එක් කිරීම සහ වෙන් කිරීම",
    chapter26List42: "හොඳ තත්ත්වයේ ඇති ක්ලචයක ගුණාංග - එන්ජිම හා ගියර් පෙට්ටිය සම්බන්ධ කිරීමේදී හා විසන්ධි කිරීමේදී දෙදරීම්, ලිස්සායෑම් හෝ ශබ්ද ඇති නොවීම, සමබර වීම සහ පහසුවෙන් ක්‍රියා කිරීම",
   chapter26List43:  "ක්ලචය ලිස්සීමේ ලක්ෂණ - ගියර් දමා ක්ලචය අතහරින විට අධිකව රේස් වෙමින් ගමන් ආරම්භ කිරීමට නොහැකි වීම, එන්ජිමේ ශබ්දයේ තරමට වාහනය ගමන් නොකිරීම",
   chapter26List44:  "ක්ලචය ලිස්සීමට හේතු - ප්ලේට් ගේවීයාම, ක්ලචයට තෙල් කාන්දු වීම, ක්ලචයේ පීඩන තැටියේ පීඩනය අඩුවීම",
    chapter26List45: "ක්ලචය ලිස්සන බව පරීක්ෂා කිරීම - අත් තිරිංග ඇද වාහනය පණගන්වා පළමු ගියරයට දමා, ක්‍රමානුකූලව ක්ලචය නිදහස් කරන්න. මෙවිට එක් අවස්ථාවකිද එන්ජිම නතරවෙයි නම් ක්ලචයේ ලිස්සායාමක් නැත"
  ,


  





  chapter27Title: "27. ගියර් පෙට්ටිය",
  chapter27Paragraph1: "වාහනයක් සෑමවිටම තැනිතලා මාර්ගයක ගමන් කරන්නේ නැත. එබැවින් මාර්ගයේ පවත්නා විෂමතාවන් අනූව එන්ජිමේ බලය අඩු වැඩි වෙමින් රෝද වෙත ලබාදය යුතුය.",
  chapter27Paragraph2: "නවතා ඇති වාහනයක් ගමන් ඇරඹීම, කඳු නැගීම ආදී අවස්ථාවන් වලදී වැඩි බලයක් අවැසි වන අතර තැනිතලා මාර්ගයක ගමන් කිරීමේදී හෝ පල්ලමක දී අවැසි වන්නේ අඩු එන්ජින් බලයකි.",
  chapter27Paragraph3: "මේ ආකාරයට එන්ජිමේ බලය අඩු හෝ වැඩි කර වෙනස් ප්‍රබලතාවයන්ගෙන් රෝදවල කැරකැවීමේ ආයාසයන්(ව්‍යාවර්ථයන්) ඇති කිරිමට යොදාගන්නා යාන්ත්‍රික උපාංගය \"ගියර් පෙට්ටිය\" නම්වේ.",
  chapter27Image1: PDFViewerImage105,
  chapter27Paragraph4: "සාමාන්‍යයෙන් වාහනයක ඉදිරි ගියර 4ක් හෝ 5ක් හෝ ඇත. 123 ගියර වැඩි ව්‍යාවර්ථයක් (එන්ජින් බලයක්) සහිත ගියරයන් වන අතර, ඒවායේ දී වාහනයට ලැබෙන රෝද කරකැවීමේ බලය වැඩි වුවද, වේගය අඩුය. 4 සහ 5 ගියර අඩු ව්‍යාවර්ථයක් සහිත වුවද ඒවායින් ලැබෙන වේගය වැඩිය. මින් 5 වැනි ගියරය Top gear ලෙස හඳන්වෙන අතර, නවීන වාහන වල Top gear එකටද ඉහළින් Over drive යනුවෙන් ගියරයක් දැකගත හැක.",
  chapter27Paragraph5: "ඊට අමතරව පිහිටන Reverse gear එකද වැඩි ව්‍යාවර්ථයක් සහ අඩු වේගයක් සහිත ගියරයකි.",
  chapter27Paragraph6: "වාහනයක් අරඹන සෑම විටකම පළමු ගියරයෙන් ගමන් ඇරඹිය යුතුය. සෙමෙන් ධාවනය වන විට හෝ බර ගෙනයන විට ඉහළ ගියරයන්ගේ ධාවනය කළ නොහැක්කාක් මෙන්ම පහළ ගියරයන්ගේ දිගු දුරක් ධාවනය කිරීමද එන්ජිමට අතිශයින්ම හානිදායක වනු ඇත.",
  chapter27List11: 
    "Sliding mesh",
    chapter27List12:"Constant mesh",
    chapter27List13:"Syncromesh",
    chapter27List14:"Epycyclic, යනුවෙන් ගියර් පෙට්ටි ප්‍රධාන මාදිලි 04ක් දැකගත හැක"
  ,

  chapter27Paragraph7: "Sliding mesh ගියර පෙට්ටි පැරණි මාදිලියේ ඒවා වන අතර ඒවායේදී ගියරයක් මාරු කරන විට දෙවරක් ක්ලචය පෑගිය යුතුය. Constant mesh ගියර් පෙට්ටි බර වාහන සඳහා යොදාගැනෙන අතර Syncromesh සහ Epycyclic මාදිලි මගී ප්‍රවාහන රථ සඳහා බහුලව යොදා ගැනේ.",
  chapter27List2: [
    "ගියර් පෙට්ටියක් පැවතීමේ අවශ්‍යතාව",
  ],

  chapter27List31: 
    "වාහනයේ වේගය වෙනස් කිරීමට",
    chapter27List32:"වාහනය ඉදිරියට හා පසුපසට ධාවනය කිරීමට",
  


  chapter27List4: [
     "ගියර යෙදීමට අපහසු වන්නේ",
  ],

  chapter27List51: 
     "ක්ලචයේ දෝෂයක්",
     chapter27List52:"ගියර් පෙට්ටිය හිරවීමක්",
     chapter27List53:"ක්ලච් ඔයිල් නැතිවීම"
  ,






  chapter28Title: "28. රෝධක හෙවත් තිරිංග",
  chapter28Paragraph1:
    "ධාවනය වන වාහනයක් ක්ෂණිකව නවත්වා ගැනීමට සහ වේගය පාලනය කර ගැනීමට තිරිංග ප්‍රයෝජනවත් වේ.",
  chapter28Paragraph2: "තිරිංග පද්ධති වර්ග.",
  chapter28List11:
    "යාන්ත්‍රික රෝධක පද්ධති.",
    chapter28List12:"ද්‍රව රෝධක පද්ධති.",
    chapter28List13:"වාත රෝධක පද්ධති."
  ,

  chapter28Subheading1: "හොඳ තිරිංග පද්ධතියක ලක්ෂණ.",
  chapter28Paragraph3:
    "කෙටි කාලයක් තුළදී කෙටි දුරක් ඇතුළත වාහනය නතර කර ගැනීමට හැකිවීම.",
  chapter28Paragraph4:
    "පහසුවෙන් හා ක්ෂණිකව ක්‍රියාත්මක වීම.ඕනෑම මාර්ග තත්වයකදී සහ ඕනෑම දේශගුණික තත්වයකදී ක්‍රියාත්මක වීම.",
  chapter28List2: [
    "තිරිංග පැඩලයේ නිදහස් චලනය,සෙ.මී. 01 ක් විය යුතුය."
  ],

  chapter28Subheading2: "තිරිංග ක්‍රියාත්මක නොවීමට හේතු",

  chapter28List31: 
    "තිරිංග තැටි ගෙවීම.",
     chapter28List32:"තිරිංග අවහිර වීම.",
     chapter28List33:"ද්‍රව තිරිංග පද්ධතියක නම් බ්‍රේක් ඔයිල් නැතිවීම.",
     chapter28List34:"තිරිංග තෙල් කාන්දු වීම."
  ,

  chapter28Paragraph5:
    "තිරිංග තෙල් කාන්දුවන විට,තිරිංග යෙදූ විට කාන්දුව ඇති රෝධයට විරුද්ධ පැත්තට වාහනය ඇදී යයි.",

  chapter28Subheading3: "තිරිංග තෙල් අඩුවීමට හේතු",

  chapter28List41: 
    "කාන්දු වීම.",
    chapter28List42:"බ්‍රේක් වොෂර් ගෙවීයාම.",
    chapter28List43:"සිලින්ඩර් ගෙවීම."
  ,

  chapter28Subheading4: "තිරිංග යෙදූවිට වාහනය පැත්තකට ඇදී යාමට හේතු.",

  chapter28List51: 
    "රෝදයක තිරිංග තෙල් කාන්දුවක් තිබීම.",
    chapter28List52:"තිරිංග නිසි පරීද සීරු මාරුවී නොතිබීම.",
    chapter28List53:"ටයරයක් අධිකව ගෙවීගොස් තිබීම.",
    chapter28List54:"ටයරයක් හුළං අඩු හෝ වැඩි වීම.",
    chapter28List55:"රෝදයක තිරිංග හිරවී තිබීම."
  ,

  chapter28Paragraph6:
    "ධාවනය වන විට එක්වරම තිරිංග අක්‍රියවුවහෝත්, තිරිංග පැඩලය කිහිප වරක් පාගමින් නිදහස් කරන්න. 1, 2 වැනි බර ගියරයකට දමන්න.අත් තිරිංග අදන්න.",

  chapter28Paragraph7:
    "වාහන ඉක්මනින් නතර කරගැනීමට,බ්‍රේක් පැඩලය වේගයෙන් කඩින් කඩ කිහිපවරක් පාගමින් නිදහස් කරන්න.",

  chapter28Subheading5: "ABS Brake යනු කුමක්ද?",

  chapter28Paragraph8:
    "Anti-Locking Brake System.ABS තිරිංග පද්ධතියකදී තිරිංග යෙදූවිට රෝද හිරවන්නේ නැත.",

  chapter28Paragraph9:
    "වාහනය ලිස්සා යන විට,තිරිංග අතහැර ලිස්සායන පැත්තටම සුක්කානම කපන්න.",





  
  chapter29Title: "29. සුක්කානම",
  chapter29Subheading1: "සුක්කානම හැසිරවීම.",
  chapter29Paragraph1:
    "ගියර් දමන විට හැර අන් සෑම අවස්ථාවකම දෑත් තිබිය යුත්තේ සුක්කානම මතයි.",
  chapter29Paragraph2:
    "සෑමවිටම ඇදීමේ හා තල්ලු කිරීමේ ක්‍රමයට සුක්කානම හැසිරවිය යුතුය. කිසිම විටක කතිරයක ආකාරයට දෑත එකෙනෙක හරහා යන පරිදි තබානොගත යුතුය.",
  chapter29Paragraph3:
    "බර වාහනයක් පදවන විට, සුක්කනම මත දෑත් තිබිය යුත්තේ ඔරලෝසුවේ කටු මගින් 9.15 දැක්වෙන ආකාරයටය.",
  chapter29Paragraph4:
    "සැහැල්ලු වාහනයක් පදවන විට නම් 10.10 ආකාරයට දෑත් තිබිය යුතුය.",
  chapter29Paragraph5:
    "නමුත් ඔබ පදවන වාහනයේ හදිසි අනතුරකදී ක්‍රියාත්මක වන එයා බෑග් (Air Bags) තිබේ නම් අනිවාර්යයෙන්ම ඔබ සුක්කානම මත දෑත් තබා ගත යුත්තේ ඔරලෝසුවේ කටු මගින් 8.20 දැක්වෙන ආකාරයටයි.නැතිනම් හදිසියකදී එයාර් බෑග් ක්‍රියාත්මක වුවහොත් පළමුවෙන්ම හානි වන්නේ ඔබේ අත් දෙකටයි",
  

  


  chapter30Title: "30. බැටරිය",
  chapter30List1Title: "බැටරිය පැවතීමේ වැදගත්කම.",
  chapter30List1: [
    "එන්ජිම පණගැන්වීමට සහ ළාම්පු නළා ආය ක්‍රියාත්මක කිරීමට."
  ],

  chapter30List2Title: "බැටරිය ඕවර් චාජ් වන්නේ,",
  chapter30List2: [
    "බැටරියට වැඩිපුර විදුලිය ලැබීම හේතුවෙනි."
  ],

  chapter30List3Title: "බැටරිය ආරෝපණය නොවන විට,",
  chapter30List31: 
    "බැටරියේ සම්බන්ධක වයර් පරීක්ෂා කරන්න.",
    chapter30List32:"බැටරි වතුර පරීක්ෂා කරන්න.",
    chapter30List33:"ඕල්ටනේටරය පරීක්ෂා කරන්න.",
    chapter30List34:"ෆෑන් බෙල්ට් එක පරීක්ෂා කරන්න."
  ,

  chapter30List4Title:
    "ප්‍රධාන ළාම්පු,නළාව,සංඥා ආදී සියල්ලම ක්‍රියාත්මක නොවෙයි නම්,",
  chapter30List4: [
    "බැටරිය බැස යාම හෝ සම්බන්ධක වයර් බුරුල් වීම."
  ],

  chapter30List5Title: "ඉහත එක් උපාංගයක් පමණක් අක්‍රිය වී ඇත්නම්,",
  chapter30List5: [
    "එම උපාංගය දැවී ගොස් තිබීම හෝ ඊට අදාල විලායක (ෆියුස්) දැවී යාම."
  ],

  chapter30List6Title:
    "වාහනයේ විදුලි කාන්දුවක් (ෂෝට් වීමක්) සිදුවන බව දැනගත් වහාම,",
  chapter30List6: [
    "ඉක්මණින් වාහනය නතර කර එන්ජිම නිවා දමා, බැටරියේ සම්බන්ධක වයර් (ටර්මින්ල වයර්) ගලවන්න."
  ],

  chapter30List7Title: "බැටරියේ ආරෝපණ තත්ත්වය,",
  chapter30List7: [
    "ඉග්නිෂන් යතුර දැමූවිට දැල්වී නිවී යන රතු පාට බල්බය මගින් බැටරිය නිසි ආරෝපණ තත්ත්වයේ ඇති බව දැක්වේ."
  ],




  chapter31Title: "31. එළවුම් ක්‍රම",
  chapter31Paragraph1:
    "බැලූ බැල්මට වාහනයක් ධාවනය වනවිට එහි රෝද හතරම එන්ජින් බලයෙන් කැරකෙන බව පෙනුනද, එසේ රෝද හතරම එන්ජින් බලය ලබාගෙන කැරකැවෙන්නේ \"සිව් රෝද එළවුම\" (Fourwheel Drive - 4x4) ඇති වාහනවල පමණි.",
  chapter31Paragraph2:
    "අනෙක් සෑම වාහනයකම එන්ජින් බලයෙන් කැරකැවෙන්නේ රෝද යුගලයක් පමණි. එසේ එන්ජිමේ ව්‍යාවර්ථී බලයන් ඉදිරියට හෝ පිටුපසට චලනය වන රෝද \"එළවුම් රෝද\" නම්වේ. එවිට අනෙක් රෝද යුගලය \"එළවෙන රෝද\" යුගලය යි.",
  chapter31Paragraph3:
    "මෙසේ එන්ජින් බලය මගින් කැරකෙන එළවුම් රෝද පිහිටා ඇති ආකාරය අනූව ප්‍රධාන වශයෙන් වාහන මාදිලි 03 කි.",
  chapter31ListTitle: "වාහන එළවුම් ක්‍රම වර්ග",
  chapter31List1: 
    "ඉදිරි එළවුම – Front wheel drive",
    chapter31List2:"පසු එළවුම – Rear wheel drive",
    chapter31List3:"සිව් රෝද එළවුම – Four wheel drive (4×4)"
  ,





  
  chapter32Title: "32. ටයර්",
  chapter32Paragraph1:
    "ටයර් මිලට ගැනීමේදී සැලකිලිමත් විය යුතු කරුණු.",

  chapter32ListTitle1: "ටයර් මිලට ගැනීමේදී සැලකිලිමත් විය යුතු කරුණු",
  chapter32List11: 
    "ටයරයේ සන්නාමය (Brand).",
    chapter32List12:"ටයරයේ ගුණාත්මකභාවය."
  ,

  chapter32Paragraph2:
    "ටයරයේ කට්ට රටාව සමානව පැතිරී ඇතිනම් එය ‘සමමිතික’ කට්ට රටාවක් සහිත ටයරයකි. කට්ට රටාව ටයරයේ දෙපැත්තේ එකිනෙකට වෙනස්ව පැතිර ඇත්නම්, එය ‘අසමමිතික’ කට්ට රටාවක් සහිත ටයරයකි. මෙවන් අසමමිතික ටයරයක් සවි කිරීමේදී Inside ලෙස සඳහන් පැත්ත ඇතුළටත් Outside ලෙස සඳහන් පැත්ත පිටතටත් යොමු වන පරිදි සවි කළ යුතුය.",

  chapter32Title2: "3). ලිස්සුම් අගය – Traction Rate",
  chapter32Paragraph3:
    "තෙත මතුපිටකදී නතර කර ගැනීමේ හැකියාව මෙමගින් දැක්වේ. ට්‍රැක්ෂන් අගය වැඩි නම් කෙටි දුරකදී වාහනය නතර කළ හැක. ට්‍රැක්ෂන් අගය AA, A, B, C ලෙස වර්ග කර ඇත. AA යනු ඉහළම අගය වන අතර C යනු අඩුම අගයයි. ශ්‍රී ලංකාවේ මාර්ග සඳහා AA හෝ A අගයේ ටයර් වඩාත් යෝග්‍ය වේ.",

  chapter32ThreadWearTitle: "4). Thread Wear Rate",
  chapter32ThreadWearParagraph:
    "කට්ටවල කල්පැවැත්ම පිළිබඳව මෙමගින් සඳහන් වේ. මෙම අගය වැඩිවන විට කට්ටවල කල්පැවැත්ම වැඩි වේ.",

  chapter32TemperatureTitle: "5). උෂ්ණත්ව ප්‍රතිරෝධීතාවය",
  chapter32TemperatureParagraph:
    "මෙම අගය A, B, C ලෙස වර්ග කර ඇත.",
  chapter32TemperatureList11: "A – උෂ්ණාධික ප්‍රදේශ සඳහා",
    chapter32TemperatureList12:"B – සාමාන්‍ය දේශගුණික ප්‍රදේශ සඳහා",
    chapter32TemperatureList13:"C – ශීත දේශගුණික ප්‍රදේශ සඳහා",
  
  chapter32TemperatureNote:
    "අප රටට වඩාත් ගැළපෙන්නේ B අගයේ ටයර් වේ.",

  chapter32LoadSpeedTitle: "6). Max Load Capacity & Speed Index",
  chapter32LoadSpeedList1: 
    "Max Load Capacity – ටයරයට දරාගත හැකි උපරිම බර.",
     chapter32LoadSpeedList2:"Speed Index – එම උපරිම බර දරාගෙන ගමන් කළ හැකි උපරිම වේගය."
  ,

  chapter32LoadParagraph:
    "Max Load Capacity අගය ටයරයේ සටහන් වන සංකේත සහ ඒවාට අදාල බර පහත වගු වල දැක්වේ.",

  chapter32LoadImages: [
    PDFViewerImage106,
    PDFViewerImage107,
    PDFViewerImage108,
    PDFViewerImage109,
  ],

  chapter32SpeedParagraph:
    "Load Index අගය ටයරයේ සටහන් වන සංකේත සහ ඒවාට අදාල වේගය පහත වගු වල දැක්වේ.",

  chapter32SpeedImages: [
    PDFViewerImage110,
    PDFViewerImage111,
    PDFViewerImage112,
  ],

  chapter32ManufactureTitle: "7). නිෂ්පාදිත දිනය",
  chapter32ManufactureParagraph1:
    "සාමාන්‍යයෙන් ටයරයක් නිෂ්පාදිත දිනයෙන් වසර 04ක් ගත වූ පසු කල් ඉකුත් වේ.",
  chapter32ManufactureParagraph2:
    "වර්තමාන වෙළඳපොළේ ‘කට්ට කැපූ ටයර්’ සහ ‘නැවත පිරවූ ටයර්’ බහුලව ඇත. නැවත පිරවූ ටයර් භාවිතා කළ හැකි නමුත් ඉතා අඩු මිලට ඇති කට්ට කැපූ ටයර් කිසිදු අවස්ථාවක භාවිතා නොකළ යුතුය.",
  chapter32ManufactureParagraph3:
    "ටයරයේ සියළු දත්ත නොමැකෙන ලෙස සටහන් කර ඇත. නිෂ්පාදකයා සහ රට අනුව එම දත්ත වෙනස් විය හැකි බැවින් ඒවා නිවැරදිව කියවා තේරුම්ගත යුතුය.",

  chapter32DateCodeParagraph:
    "නිෂ්පාදිත දිනය ඉලක්කම් 04කින් සමන්විත අංකයකින් සටහන් වේ. උදාහරණයක් ලෙස 3705 යනු 2005 වර්ෂයේ 37 වැනි සතියයි.",

  chapter32DateImages: [
    PDFViewerImage113],

    chapter32DateCodeParagraph2:
    "3705 – 2005 වර්ෂයේ 37 වැනි සතියේදී නිෂ්පාදනය කෙරුණු ටයරයකි.",
    chapter32DateCodeParagraph3:
    "පහත ආකාරයේ දිගු අංකයක්ද ටයර් මත සටහන්ව පවතී..",

    chapter32DateImages2:[PDFViewerImage114],

     chapter32DateCodeParagraph4:
    "පහත ආකාරයේ දිගු අංකයක්ද ටයර් මත සටහන්ව පවතී..",
    chapter32DateImages3:[PDFViewerImage115],
  

  chapter32AirPressureTitle: "වායු පීඩනය පරීක්ෂා කිරීම",
  chapter32AirPressureParagraph:
    "සාමාන්‍යයෙන් දෙසතියකට වරක්වත් රෝදවල වායු පීඩනය පරීක්ෂා කළ යුතුය.",
  chapter32AirPressureList1: 
    "වායු පීඩනය වැඩි වීම",
    chapter32AirPressureList2:"වායු පීඩනය අඩු වීම",
    chapter32AirPressureList3:"වීල් එලයින්මන්ට් වෙනස් වීම",
   chapter32AirPressureList4: "ෂොක් ඇබ්සෝබර්, දුනු, ස්ප්‍රින් දුර්වල වීම",
    chapter32AirPressureList5:"අඩු වායු පීඩනයෙන් ධාවනය කිරීම",
    chapter32AirPressureList6:"වීල් එලයින්මන්ට් නැති වීමෙන් ටයර් වේගයෙන් ගෙවී යාම",
   chapter32AirPressureList7: "දෙසතියකට වරක්වත් අවම වශයෙන් ටයර් පරීක්ෂා කළ යුතුය"
  ,

  chapter32RotationTitle: "ටයර්වල ස්ථාන මාරු කිරීම",
  chapter32RotationParagraph:
    "සාමාන්‍යයෙන් සෑම කිලෝමීටර් 8000කට වරක් ටයර්වල ස්ථාන මාරු කළ යුතුය. මෙහිදී සියළු ටයර් එකම මට්ටමේ භාවිතා කළ ඒවා විය යුතුය.",
  chapter32RotationImage: PDFViewerImage116,



  


  chapter33Title: "33. ඩෑෂ් බෝඩ් සංඥා",
  chapter33Paragraph1:
    "ඩැෂ් බෝඩයේ දක්නට ලැබෙන ප්‍රධාන සංඥා කිහිපයක් පහත දක්වා ඇත.",
  chapter33Image: PDFViewerImage117,
  chapter33ListTitle: "ඩෑෂ් බෝඩ් සහ වාහන සම්බන්ධ වැදගත් කරුණු",
  chapter33List11: 
    "4×4 වාහන යනු ? එන්ජිමේ ව්‍යාවර්ථය රෝද හතරටම ලැබෙන වාහන.",
    chapter33List12: "ඩීසල් වාහනයක ඩීසල් අවසන් වී පොම්පයට හුළං ඇල්ලූ විට ? ඩීසල් පුරවා, පොම්පයේ හුළං ඉවත් කර ධාවනය කළ යුතුය.",
    chapter33List13: "ඩිපරන්සලයේ කාර්යය ? වංගුවකදී දෙපැත්තේ රෝද දෙකේ වේගයන් අඩු වැඩිවීම සමබරව පවත්වා ගැනීම.",
    chapter33List14: "පැති කණ්ණාඩි දෙක සහ ඇතුළත ඇති කණ්ණාඩිය නිවැරදිව සකස් කළ විට, ඉදිරි වීදුරුවෙන් පෙනෙන පරාසයද ඇතුළත්ව දල වශයෙන් අංශක 360ක පරාසයක් රියදුරාට දැකගත හැක.",
    chapter33List15: "අනතුරකදී ක්‍රියාත්මකවන වායු මළු (Air bags) අඩංගු වාහනයක ගමන් කරන විට වුවද, අනිවාර්යයෙන්ම ආසන පටි පැළඳිය යුතුය.",
    chapter33List16: "වායු මළු (Air bags) තුළ අඩංගු වන්නේ නයිට්‍රජන් (N2) වායුවයි.",
    chapter33List17: "වාහනය ගිනි ගන්නා බවක් දැනුනු වහාම.",
    chapter33List18: "වාහනයක පිටුපස වීදුරුව ස්ටිකර්, තිර රෙදි මගින් ආවරණය කිරීම නීති විරෝධීය.",
    chapter33List19: "වාහනයක ඉදිරියේ ආරක්ෂක වැටවල් සවිකිරීම නීති විරෝධීය.",
    chapter33List10: "අන්ධ පුද්ගලයෙක් හඳුනාගන්නේ, සුදු සැරයටියක් භාවිතා කිරීමෙන් හෝ මගපෙන්වන සුනඛයෙක් සමග ගමන් කිරීමෙනි.",
   chapter33List111:  "වටරවුමක මූලික නීතිය ? දකුණේ නීතිය – දකුණෙන් ආසන්නයේ එන වාහන වලට ඉඩදී ධාවනය කළ යුතුය.",
    chapter33List121: "ධාවනය කරන අතරතුර මීටර් පුවරුවේ / ඩෑෂ් බෝඩයේ රතු පැහැති බල්බයක් දැල්වුණහොත්, වාහනය නතර කර දෝෂය කුමක්දැයි තහවුරු කරගත යුතුය.",
    chapter33List1311: "වාහනය ඉන්ධන පුරවන විට, එන්ජිම නතර කර තැබිය යුතුය.",
   chapter33List141:  "වාහනයේ විදුලි පරිපථයේ දෝෂයක් නිසා වයර් පිලිස්සෙන ගඳක් දැනුන හොත්, බැටරියේ සම්බන්ධක වයර් ගැළවිය යුතුය.",
   chapter33List151:  "වායු විමෝචන වාර්ථාව හෙවත් දුම් සහතිකය, සෑම විටම වාහනයේ තබාගත යුතුය.",
    chapter33List161: "ගිලන් රථයක, ගිනි නිවන රථයක, පොලිස් හෝ හමුදා වාහනයක හැර වෙනත් කිසිම වාහනයක විවිධ නාද රටා නිකුත් කරන නළාවක්, අමිහිරි, කර්කෂ, ගෝෂාකාරී හෝ බිය උපදවන ශබ්ද නිකුත් කරන උපකරණ සවිකළ නොහැක.",
    chapter33List171: "දුම්, හුමාලය, වැලිකැට, ගිනිපුපුරු, අලු, දැලි අඟුරු, ග්‍රීස් හෝ තෙල් සහිත ද්‍රව්‍ය පිටකරන වාහන පැදවීම වරදකි.",
    chapter33List181: "වාහනයක සවිකර ඇති ශබ්ධ විකාශන යන්ත්‍රවල (රේඩියෝ) ශබ්දය වාහනය තුළට වීමා විය යුතුය."
  ,




  chapter34Title: "34. රියදුරන් රඳවා ගැනීම",
  chapter34ListTitle: "පොලිස් නිලධාරියෙකුට රියදුරෙකු රඳවා ගැනීමට හේතු වන අවස්ථා",
  chapter34List11: 
    "තම නම සහ ලිපිනය ඉල්ලූ විට ලබා නොදෙන හෝ ලබාදුන් තොරතුර අසත්‍ය යැයි පොලිස් නිලධාරියා විසින් සාධාරණ ලෙස සැකකරන.",
   chapter34List12:  "වායු පීඩනය වැඩි විට.",
    chapter34List13: "මරණයක් හෝ බරපතළ තුවාල සිදු වූ අනතුරකට සම්බන්ධ වීම.",
   chapter34List14:  "මත්පැන් හෝ මත්ද්‍රව්‍ය පානයකර ඇති හෝ එසේ බවට පොලිස් නිලධාරියා විසින් සාධාරණ ලෙස සැක කරන අවස්ථාවක.",
    chapter34List15: "පොලිස් නිලධාරියාගේ මතය අනුව ව්‍යාජ හෝ කූට ලේඛන හෝ ව්‍යාජ අංක තහඩු තමන් සන්තකයේ ඇති බව.",
   chapter34List16:  "පොලිස් නිලධාරියාගේ මතය අනුව කූට ලෙස වෙනස් කරන ලද හෝ සුලු වශයෙන් වෙනස් කරන ලද චැසි අංක, එන්ජින් අංක සහිත මෝටර් වාහනයක් තමන් සතුව ඇති බව.",
   chapter34List17:  "සොරකම් කරන ලද වාහනයක් තම සන්තකයේ ඇති බවට පොලිස් නිලධාරියා විසින් සාධාරණ ලෙස සැක කරන අවස්ථාව."
  ,

  chapter34Paragraph1:
    "මෝටර් වාහනයක රියදුරෙක් පරීක්ෂණයක් හෝ විමර්ශනයක් සඳහා සාධාරණ කාලසීමාවක් පොලිස් ස්ථානයේ රඳවාගැනීමට පොලිස් නිලධාරියෙකුට බලය ඇත.",







  chapter35Title: "35. රථවාහන නඩත්තුව",
  chapter35Paragraph1: 
    "වාහනයක් පදවන පුද්ගලයෙක් සෑම විටම මෝටර් කාර්මිකයෙක් නොවන නිසා ඔහු තම වාහනය පිළිබඳව 100% ක් දැනුවත්ව සිටිය යුතු නොවේ. හදිසි ආපදාවකදී කටයුතු කළයුතු ආකාරය හා වාහනය නිවැරදිව නඩත්තු කරන ආකාරය පිළිබඳව දැනුවත්ව සිටීම ප්‍රමාණවත්ය.",

   chapter35Paragraph2: "වාහනය සමඟ අත්පොතක් (Manual) ලැබී ඇත්නම් එය කියවා තේරුම් ගන්න.",

    chapter35Paragraph3:"අවම වශයෙන් සතියකට වරක්වත් පහත පරීක්ෂාවන් කරන්න."
  ,
  chapter35SubTitle1: "සතියකට වරක් කළ යුතු මූලික පරීක්ෂාවන් (P O W E R)",
  chapter35List11: 
    "P – Fuel (ඉන්ධන)",
    chapter35List12:"O – Oil (තෙල්)",
    chapter35List13:"W – Water (වතුර)",
    chapter35List14:"E – Electricity (විදුලිය – බැටරිය)",
    chapter35List15:"R – Rubber (ටයර්)"
  ,

  chapter35Paragraph41: 
    "වාහනය සේවා කිරීමට හෝ අලුත්වැඩියාවකට යොමුකරන සෑම විටම ඒ පිළිබඳ තොරතුරු වාහනය වෙනුවෙන් වෙන්කළ සටහන් පොතක සටහන් කරගන්න.",
     chapter35Paragraph42:"සේවා කිරීමේදී සෑම විටම නියම ප්‍රමිතියේ, වාහනයේ නිෂ්පාදකයා විසින් අනුමත කරන ලද තෙල් වර්ග සහ අමතර කොටස් යොදාගන්න.",
     chapter35Paragraph43:"නවීන වාහනවල එන්ජිමේ වතුර ගමන් කිරීමෙන් හානිවිය හැකි කොටස් තිබේ. සේවා කිරීමේදී ඒ පිළිබඳව සැලකිලිමත්වන්න. වාහනය සේවා කිරීමට හෝ අලුත්වැඩියාවකට රැගෙන යනවිට හැකි සෑම අවස්ථාවකම බලයලත් නියෝජිත ආයතනයක් වෙත යන්න.හැකි සෑම විටම අදාල කාර්යය නිමවෙන තුරු වාහනය සමඟ රැඳෙන්න.",
  

  chapter35Paragraph5:
    "මෙහි අගයන් දල වශයෙන් දැක්වේ. වාහන මාදිලිය අනුව වෙනස් විය හැක.",

  chapter35List51: 
    "Engine oil – සෑම Km 5,000 ට වරක්",
     chapter35List52: "Engine oil filter – සෑම Km 10,000 ට වරක්",
    chapter35List53:  "Fuel filter – වාහන මාදිලිය අනුව",
     chapter35List54: "Air cleaner – සෑම Km 40,000 ට වරක්",
     chapter35List55: "Gear box oil – සෑම Km 40,000 ට වරක්",
     chapter35List56: "Brake oil – සෑම Km 40,000 ට වරක්"
  ,

  chapter35Paragraph6:
    "නිසි පරිදි නඩත්තු කරන වාහනය, ඔබේ කාලය මෙන්ම මුදල්ද ඉතිරි කර දෙයි.",


  
  

  

  


  }
]; 

export const EnglishData = [
    {name: "",
       chapter1Title: "1. Factors That Turn Drivers into Road Offenders",
paragraph1: "There are many factors that can cause a person driving a vehicle to be involved in an accident. Among them, several major factors can be briefly summarized as follows.",
subheading1: "1) Failure to Follow Road Rules",
paragraph2: "In this matter, both drivers and pedestrians are equally responsible. Furthermore, a majority of road accidents occur because one party violates traffic rules. Accidents happen constantly due to road users lacking proper understanding of the rules or intentionally ignoring them.",
paragraph3: "Accidents happen constantly due to road users lacking proper understanding of the rules or intentionally ignoring them.",
paragraph4: "Some people suffering from aggressive disorders or complexes use vehicles on the road as a way to display their aggression. Drivers of large vehicles such as buses and lorries often drive with the feeling that all other vehicles must give them priority, which is another cause of road accidents on main roads.",
subheading2: "2) Mobile Phone Use",
paragraph5: "Regardless of how a mobile phone is used (Handfree mode, Headset), it always significantly distracts the driver. Research shows that it increases accident risk.",
subheading3: "3) Substance Use",
paragraph6: "Another major factor contributing to accidents is substance use. Alcohol, cannabis, heroin, and other substances reduce the driver’s attention, decision-making ability, and physical performance.",
paragraph7: "When blood alcohol concentration exceeds 0.05g/dl, a person’s reaction efficiency decreases sharply.",
subheading4: "4) Driver Fatigue",
paragraph8: "Driving continuously for long periods can cause driver fatigue, which is a decrease in attention due to physical and mental tiredness.",
paragraph9: "Long-distance bus and freight transport drivers are especially more likely to experience driver fatigue.",
paragraph10: "As the driver’s performance decreases, the likelihood of accidents increases. Therefore, driver fatigue is a major contributor to accidents.",
subheading5: "5) Vehicles Without Proper Standards or Defects",
paragraph11: "Defective or poorly maintained vehicles increase the risk of accidents. Driving vehicles without proper brakes, tires, or lighting systems is prohibited.",
subheading6: "6) Poor Road Conditions",
paragraph12: "Dirty roads, potholes, water accumulation, or roads without lighting cause accidents. Therefore, proper road maintenance is essential.",




  
  chapter2Title: "2. Can Highway Terror Be Prevented? – Yes, It Can",

  chapter2Paragraph1:
    "More than 85% of road accidents can actually be prevented. This is because, in most cases, accidents occur due to the mistakes of one or more parties involved—whether it is the driver, vehicle, passengers, or a combination of these factors.",

  chapter2Paragraph2:
    "However, the main cause behind the majority of road accidents is the driver’s carelessness or incompetence.",

  chapter2Paragraph3:
    "Some drivers overestimate their driving skills and the capabilities of their vehicles, and as a result, they face accidents unexpectedly.",

  chapter2Paragraph4:
    "Many inexperienced or overconfident drivers believe that a vehicle can be stopped immediately just by applying the brakes, regardless of the speed at which they are traveling.",

  chapter2Paragraph5:
    "In reality, even the most technologically advanced vehicle cannot stop instantly the moment the driver decides to brake.",

  chapter2Paragraph6:
    "When stopping a moving vehicle, what actually happens is that the vehicle’s kinetic energy must reduce to zero. This energy is transformed into: Potential energy, Heat energy, Sound energy.",
  
  
chapter2Image1:  PDFViewerImage1,
  chapter2Paragraph7:
    "Only after this conversion does the vehicle come to a complete stop.",

  chapter2Paragraph8:
    "The following table (mentioned in the handbook) explains the distance a vehicle travels before stopping once the brakes are applied, helping drivers understand the physics behind stopping distances.",

  chapter2Paragraph9:
    "Modern motor vehicle manufacturers equip their vehicles with a wide range of advanced safety features. These include ABS braking systems, airbags, modern seat belts, improved seat restraint systems, reinforced vehicle structures, and computer programs designed to analyse driver behaviour.",

  chapter2Paragraph10:
    "However, despite all these technological developments, there has been no significant reduction in the number of accidents. The responsibility still lies with the driver. No matter how many safety systems are installed, your vehicle is only an inanimate object—it cannot think or react on its own.",

  chapter2Paragraph11:
    "You, the driver, are the living being in control, and therefore the safety of every journey depends primarily on your actions, decisions, and discipline."
,


  
  chapter3Title: "3. The Hidden Danger on the Highway – Driver Fatigue",

  chapter3paragraph1:
    "Fatal road accidents caused by driver drowsiness or inactivity are reported daily. When a driver becomes inactive, sleepy, or mentally unresponsive while driving, this condition is known as “driver fatigue.” The main reasons for driver fatigue are the failure to recognize one’s own physical and mental fitness for driving and the disregard for the appropriate duration one should spend behind the wheel.",

  chapter3paragraph2:
    "Driving for long periods without proper sleep or rest, driving at night, travelling for hours in a monotonous environment, or driving after consuming alcohol, drugs, or sedative medication can easily lead to dangerous levels of fatigue. As a result, many drivers fall asleep at the wheel and cause fatal accidents.",

  chapter3paragraph3:
    "Driver fatigue does not occur suddenly. It is the final stage of a process consisting of several warning signals. A responsible driver must recognize these signs and stop driving immediately to take sufficient rest.",
chapter3paragraph4:
    " ",

  subheading7: "Signs of Driver Fatigue",

  subheading7List1:
    "Frequent yawning",

  subheading7List2:
    "A feeling of tiredness or heaviness",

  subheading7List3:
    "Inability to remember the last few kilometres travelled",

  subheading7List4:
    "Reduced focus on road signs and surroundings",

  subheading7List5:
    "Difficulty keeping eyes open",

  subheading7List6:
    "Trouble maintaining the vehicle within its lane",

  subheading7List7:
    "Blurred vision through the windscreen",

  subheading7List8:
    "Eventually falling asleep",

  paragraph24:
    "A driver who continues to drive despite experiencing these symptoms becomes a serious threat not only to their own life but also to the lives of many others on the road.",

  subheading8: "How to Prevent Driver Fatigue",

  subheading8List1:
    "Prepare well before starting a long journey.",

  subheading8List2:
    "Ensure you get enough sleep before driving.",

  subheading8List3:
    "Never drive after consuming alcohol or taking sedative drugs.",

  subheading8List4:
    "Whenever possible, take a companion to assist with driving during long trips.",

  subheading8List5:
    "Begin long journeys in the morning; evening and night hours are naturally meant for rest.",

  subheading8List6:
    "Take a break at least every three hours, and whenever possible, step out of the vehicle during your rest period.",

 subheading8List7:
    "If you feel sleepy while driving, pull over safely and take a short nap—not longer than 30 minutes.",

  subheading8List8:
    "Drinks containing caffeine (such as tea, coffee, or chocolate) may provide temporary alertness, but they are not a long-term solution."
,







  chapter4Title: "4. Aggressive Drivers on the Road – Understanding Road Rage",

   chapter4Paragraph1:
    "It is not uncommon to see certain drivers on the road who ignore traffic rules, inconvenience others, or deliberately create risky situations. These drivers often behave irresponsibly—such as stopping even when the traffic light is yellow, driving at extremely high or unusually low speeds, tailgating other vehicles, or reacting angrily to minor mistakes made by others. Such individuals are known as aggressive drivers.",

   chapter4Paragraph2:
    "The primary reason behind the rise of aggressive drivers is a psychological condition known as road rage. According to psychologists, drivers who suffer from road rage often experience underlying social or emotional weaknesses. When they are behind the wheel, they feel isolated, mentally pressured, and stressed, which leads them to direct their frustration toward other road users.",

   chapter4paragraph3:
    "An aggressive driver is always a dangerous driver. If you sense that such a driver is coming behind you, the safest action is to slow down and allow them to pass. Always think first about your safety and the safety of your vehicle. Trying to “teach them a lesson” is never a wise decision.",
chapter4Paragraph4:
    " ",
    chapter4Paragraph5:
    " ",
    chapter4Paragraph6:
    " ",

  chapter4Subheading1: "How to Identify an Aggressive Driver",

  chapter4List1:
    "Drives at excessively high speeds",

   chapter4List2:
    "Violates road rules and disrupts other drivers",

   chapter4List3:
    "Uses the horn unnecessarily or repeatedly",

   chapter4List4:
    "Drives without concern for damage or safety",

   chapter4List5:
    "Follows other vehicles too closely (tailgating)",

   chapter4List6:
    "Gets angry over minor delays or mistakes made by other drivers or pedestrians",

   chapter4List7:
    "Displays rude, aggressive, or threatening gestures",
    chapter4List8:
    " Drives at high speed. ",

  chapter4Subheading2: "How to Prevent Road Rage",

  chapter4List9:
    "Get into your vehicle with a calm and clear mind.",

  chapter4List10:
    "Understand that a vehicle is not a tool to release stress or to intimidate others.",

  chapter4List11:
    "Never drive under the influence of alcohol or drugs. Loud, disturbing music can also cloud your judgment.",

  chapter4List12:
    "Make a firm decision not to violate road rules. Even if a mistake happens unintentionally, ensure it does not happen again.",

  chapter4List13:
    "Be patient when other drivers or pedestrians make errors or cause delays. Forgiveness is a noble skill.",

 chapter4List14:
    "When you feel the urge to chase or punish another driver, remind yourself of the value of your own life and drive with patience.",
chapter4List15:
    " Consider patience and tolerance in the mistakes of other drivers or pedestrians as an example. ",
    chapter4List16:
    " When feeling rushed, drive carefully, keeping in mind the value of your life. ",

    



  

  chapter5Title: "5. The Silent Killer on the Road – Alcohol and Drugs",

  chapter5Paragraph1:
    "A large number of daily road accidents are caused by the influence of alcohol or other intoxicating drugs. Many drivers follow the dangerous practice of drinking “just one for the road” before beginning a journey. This deadly habit—borrowed from foreign cultures—destroys countless lives. A driver must always maintain clear vision, sharp memory, sound judgment, and quick decision-making ability. Alcohol and drugs have the power to rapidly destroy all these essential qualities needed for safe driving.",

  chapter5Paragraph2:
    "Whether it is arrack, cannabis, heroin, or any other substance, the result is the same: the body’s performance decreases rapidly, and aggressive or lethargic behaviour increases. Driving under the influence of alcohol is one of the most serious offences a driver can commit. Once it is confirmed that a driver has consumed alcohol, legal action is immediately taken against them. There are two accepted methods for such confirmation.",

  chapter5Paragraph3:
    "The first method is the breathalyzer test. If a police officer suspects that a driver is under the influence, the individual can be taken into custody and asked to blow into a testing device. The law states that refusing this test allows authorities to presume that the driver has consumed alcohol.",

  chapter5Paragraph4:
    "The second method is a medical examination conducted by a government medical officer. If a blood test shows an alcohol concentration of 0.08 grams or more per 100 millilitres of blood, the driver can be legally charged with driving under the influence. Refusing to undergo this examination also allows the authorities to conclude that the driver has consumed alcohol.",

  chapter5Paragraph5:
    "However, police officers cannot accuse a driver of drunk driving without reasonable grounds. If a police officer claims you have been driving under the influence, you have the full legal right to request an immediate breathalyzer test to prove your innocence."
,
chapter5Paragraph6:
    " "
,
chapter5Paragraph7:
    " "
,

chapter5Paragraph8:
    " "
,

chapter5Paragraph9:
    " "
,








   chapter6Title: "6. Becoming a Legal Driver – Obtaining a Driving Licence",

  chapter6Paragraph1:
    "Sri Lanka currently issues a Smart Card Driving Licence, which contains an electronic chip. The exclusive authority for issuing driving licences in Sri Lanka rests with the Commissioner General of Motor Traffic.",

  chapter6Paragraph2:
    "There are two main methods through which a driving licence can be obtained: through the Head Office or the Kurunegala District Office, or through the District Secretariat Office.",

  chapter6Paragraph3:
    "According to the present procedure, a person must first obtain a Light Vehicle Driving Licence. A licence for heavy vehicles can only be obtained after holding a light vehicle licence for two years.",

  chapter6Subheading1: "Basic Requirements for Obtaining a New Driving Licence",

  chapter6List11: "Completion of 18 years of age",
chapter6List12: "National Identity Card and a photocopy",
chapter6List13: "Original Birth Certificate or a certified copy issued by the Divisional Secretariat",
chapter6List14: "Medical certificate confirming physical fitness and a blood report indicating blood group",
chapter6List15: "Duly completed MA30 application form issued by the Department of Motor Traffic",
chapter6List16: "Official receipt for payment of government fees",
chapter6List17: "Three passport-size black-and-white photographs",

  chapter6Paragraph4:
    "Although you must be 18 years old to obtain the driving licence itself, you may register and sit for the written examination at the age of 17. If you pass, you will receive a Learner’s Permit. After turning 18, you must appear for the practical examination.",

  chapter6Subheading2: "Written Examination",

  chapter6Paragraph5:
    "The written examination tests your knowledge of road rules. Those applying for heavy vehicle licences will also receive questions related to mechanical and technical knowledge. All questions are multiple-choice.",

  chapter6List2: [
    "Candidates who pass the written exam receive a Learner’s Permit and an L-board.",
    "These must be returned when appearing for the practical test."
  ],

  chapter6Subheading3: "Requirements for Obtaining a Heavy Vehicle Driving Licence",

  chapter6List31: "Completion of 21 years of age",
chapter6List32: "Possession of a light vehicle licence for at least two years",
chapter6List33: "Medical certificate from the National Transport Medical Institute or a medical officer of the Sri Lanka Transport Board",
chapter6List34: "Duly completed MA34 application form issued by the Department of Motor Traffic",
chapter6List35: "National Identity Card",
chapter6List36: "Official receipt confirming payment of government fees",
chapter6List37: "Valid light vehicle licence",
chapter6List38: "Competency certificate from an A-grade driving school",

  chapter6Paragraph6:
    "For heavy vehicle drivers, minimum height requirements are:\n• Buses and lorries — 5 feet\n• Light buses and light lorries — 4 feet 10 inches.",

  chapter6Paragraph7:
    "After holding the Learner’s Permit for three months, you may appear for the practical examination. If you pass, a temporary driving licence valid for six months will be issued. The permanent licence will be mailed to you afterwards.",

  chapter6Subheading4: "Driving Licences for Foreign Nationals",

 chapter6List44: "Foreign nationals are eligible to obtain only a light vehicle driving licence, even if they possess a heavy vehicle licence in their home country.",
chapter6List45: "A valid foreign driving licence is required (temporary licences or learner permits are not accepted).",
chapter6List46: "A valid visa for a minimum period of one month",
chapter6List47: "If the driving licence is not in English, an official English translation is required.",
chapter6List48: "A medical fitness certificate issued within the last six months by the National Transport Medical Institute",
chapter6List49: "If the applicant is part of a foreign diplomatic mission, a verification letter from the Ministry of Foreign Affairs",
chapter6List50: "Sri Lankan citizens or dual citizens must present their National Identity Card and a valid travel document",

  chapter6Subheading5: "Renewing a Driving Licence",

  chapter6Paragraph8:
    "Light vehicle licences must be renewed every 8 years, while heavy vehicle licences must be renewed every 4 years. Medical reports must be submitted during renewal, but the practical examination is not required.",

  chapter6Subheading6: "Obtaining a Duplicate Licence",

 chapter6List51: "A copy of the police complaint",
chapter6List52: "Duly completed MA42 application form",
chapter6List53: "Official receipt for payment of government fees"
,
  chapter6Subheading7: "Correcting Information on the Licence",

  chapter6List61: "Currently issued driving licence",
chapter6List62: "For name changes: birth certificate, marriage certificate, or other verified documents",
chapter6List63: "For address changes: residency certificate issued by the Grama Niladhari",
  chapter6Subheading8: "Obtaining a New Licence in Place of an Old One",

  chapter6List71: "Existing driving licence",
chapter6List72: "For heavy vehicle licence holders: a medical certificate issued within the last six months",

  chapter6Subheading9: "Driving Licence for Hand Tractors",

  chapter6Paragraph9:
    "Any individual with a valid driving licence for any vehicle category—except restricted or disability-specific licences—has the legal right to operate a hand tractor.",

  chapter6Subheading10: "Submitting Appeals",

  chapter6Paragraph10:
    "If a candidate feels that they were treated unfairly during a driving licence examination, they may submit an appeal to the Commissioner General of Motor Traffic or the relevant District Secretary within seven days.",

  chapter6Subheading11: "Cancellation of a Driving Licence",

  chapter6Paragraph11:
    "The Commissioner General of Motor Traffic has the authority to temporarily or permanently cancel a driving licence based on a court order, medical report, or other valid reasons. A licence that has been permanently cancelled cannot be reissued.",

  chapter6Subheading12: "Driving Classes",

  chapter6Image1: PDFViewerImage2,
  chapter6Image2: PDFViewerImage3,
  chapter6Image3: PDFViewerImage4
,




  chapter7Title: "7. Driver Development Points (Demerit Points System)",
chapter7Paragraph1:
    "According to Gazette Notification No. 1726/12, issued on 05 October 2011, the Driver Development Points System is now in force. This is officially referred to as the Motor Vehicle (Demerit Points) Regulations, No. 03 of 2011.",

   chapter7Paragraph2:
    "Under this system, points are assigned for offences committed while driving. When a driver accumulates 24 demerit points, their driving licence will be suspended for one year.",

   chapter7Subheading1: "Demerit Points for Major Highway Offences",

  chapter7List11:
    "Failure to take action to prevent an accident on a highway – 6 points",

  chapter7List12:
    "Driving carelessly, dangerously, or at a dangerous speed on a highway – 8 points",

  chapter7List13:
    "Driving without reasonable consideration for other road users – 8 points",

  chapter7List14:
    "Failure to stop after a highway accident and failure to provide required information – 10 points",

  chapter7List15:
    "Failure to report the accident immediately to the nearest police station – 10 points",

  chapter7List16:
    "Driving above the prescribed speed limit – 6 points",

  chapter7Subheading2: "Demerit Points for Major Highway Offences Demerit Points for Careless Driving and Accident-Related Offences",

  chapter7List21:
    "Failure to keep the vehicle to the left side or near the left edge of the road – 2 points",

  chapter7List22:
    "Overtaking another vehicle without clear visibility – 6 points",

  chapter7List23:
    "Failure to overtake from the right side of the vehicle ahead – 4 points",

  chapter7List24:
    "Failure to give way to oncoming vehicles at intersections or crossings – 4 points",

  chapter7List25:
    "Reversing the vehicle for a long distance on a major road without a valid reason – 4 points",

  chapter7List26:
    "Failure to comply with prohibition, restriction, mandatory, or priority signs – 6 points",

 chapter7List27:
    "Failure to obey verbal orders or hand signals given by a police officer or traffic inspector – 6 points",

  chapter7List28:
    "Driving a vehicle that emits pollutants above the permitted limits – 6 points",

  chapter7List29:
    "Using audio equipment that produces sound levels exceeding the legal limits – 6 points",

  chapter7List30:
    "Using a vehicle that emits excessive noise from its engine or exhaust – 6 points",

 chapter7List31:
    "Driving a vehicle that is in a condition likely to cause injury or damage to a person, property, or another vehicle – 10 points"
,




  chapter8Title: "8. Your Responsibilities in the Event of a Road Accident",

  chapter8Paragraph1:
    "It is the responsibility of every driver to inform the nearest police station immediately when a road accident occurs. In the case of a minor accident, the parties involved may settle the matter mutually, provided that both sides agree.",

  chapter8Paragraph2:
    "Although cases related to road accidents may be heard before a Magistrate’s Court, compensation claims for damages arising from a road accident must be submitted to the District Court.",

  chapter8Paragraph3:
    "Insurance companies generally assist in covering the damages caused by accidents. However, it is important to remember that they operate strictly within the limits and conditions specified in the insurance policy agreement. Some companies may even introduce additional terms that were not explained beforehand. Therefore, as a vehicle owner or driver, it is your responsibility to have a clear understanding of all conditions in your insurance policy.",

  chapter8Paragraph4:
    "If a road accident results in a fatality, and if the driver is found guilty according to the law, legal provisions allow the court to impose capital punishment or the highest applicable penalties.",

  chapter8Paragraph5:
    "A “fatal accident” is defined as an accident involving one or more vehicles in which one or more persons die within 30 days following the incident."
,
chapter8Subheading1: " ",
chapter8Paragraph6: " ",





  chapter9Title: "9. Leasing – The Easy Path to Owning Your Dream Vehicle",

  chapter9Paragraph1:
    "Leasing is a convenient method for purchasing a vehicle, property, or service. Today, many people buy vehicles through leasing companies. In this process, the buyer pays a certain amount as a down payment, and the leasing company pays the full price of the vehicle. The vehicle is then given to the buyer under the condition that they pay monthly instalments as agreed in the leasing contract. When all instalments are fully paid, the buyer becomes the legal owner of the vehicle.",

  chapter9Paragraph2:
    "In simple terms, the leasing company becomes the actual purchaser of the vehicle and keeps the ultimate ownership until the instalments are completed. The person who uses the vehicle pays instalments each month, and once the amount spent by the leasing company is recovered, the company transfers full ownership to the customer. Because leasing allows people to purchase a vehicle quickly and arrange instalments according to their income level, it has become extremely popular today.",

  chapter9Paragraph3:
    "When dealing with a leasing company, the following points require close attention:",

  chapter9Paragraph4:
    "The leasing company must be an institution registered and approved by the Central Bank of Sri Lanka.",

  chapter9Paragraph5:
    "The company should be trustworthy and reputable.",

  chapter9Subheading1:
    "The company must be transparent and customer-friendly.",

  chapter9Subheading2: "Before Signing a Leasing Agreement",

chapter9List21:
    "Always read and understand all terms and conditions clearly. Request a copy of the agreement in a language you understand.",

  chapter9List22:
    "Make sure you understand how the monthly instalments must be paid throughout the period.",

  chapter9List23:
    "Know the penalty fees if payments are delayed.",

  chapter9List24:
    "Check whether a penalty is charged if you want to terminate the lease agreement before the contract period ends.",

  chapter9List25:
    "Be aware of the interest rate and any additional penalty interest.",

  chapter9Subheading3:"Selling a Vehicle Purchased on Leasing",

   chapter9Paragraph6:
    "According to the Motor Traffic Act (Amended) No. 8 of 1980, a vehicle obtained through leasing is registered under two types of ownership:",

 chapter9List3:
    "Absolute Owner – the leasing company",

  chapter9Paragraph7:
    "Registered Owner – the person using the vehicle",

 chapter9Paragraph8:
    "The registered owner cannot sell the vehicle based solely on personal preference. Selling the vehicle requires the approval of the absolute owner (the leasing company). Also, the leasing company is not responsible for any accidents or losses caused by the vehicle.",

  chapter9Subheading4: "When Selling a Leased Vehicle",

  chapter9Paragraph9:
    "Do not sell the vehicle without cancelling the original leasing agreement. First, terminate the existing agreement with the leasing company and transfer the lease to the new buyer under a new agreement.",

  chapter9Paragraph10:
    "If you buy a leased vehicle registered under someone else’s name, you do not gain legal ownership. When a lease is cancelled or changed, certain charges or fees may apply.",

  chapter9Subheading5: "Repossessing a Vehicle due to Non-Payment",

  chapter9Paragraph11:
    "According to finance and leasing laws, if a person has paid less than 50% of the vehicle’s value and fails to continue paying instalments, the leasing company has the right to take back the vehicle.",

   chapter9Paragraph12:
    "To repossess a vehicle legally, the leasing company must:",

  chapter9Paragraph13:
    "Make a complaint to the police,",

  chapter9Subheading6:
    "Go with the police to collect the vehicle, and",

   chapter9Paragraph14:
    "If the owner refuses to hand it over, file a case in court and obtain legal authority.",

  chapter9Paragraph23:
    "A leasing company cannot send “seizure officers” to forcibly take a vehicle without following legal procedures. However, in reality, many seizure officers act aggressively, causing hardship to vehicle users.",







  chapter10Title: "10. Important Points When Using the Expressway",

  chapter10List11: 
    "The following vehicles are not allowed to travel on the expressway: three-wheelers, motorcycles, bicycles, tractors, and any other vehicle that does not meet the required standards. Pedestrians are strictly prohibited from walking on or near the expressway.",
 
  chapter10List12: " Walking on or alongside the expressway is prohibited. ",
 chapter10Subheading1: "Vehicle Requirements for Expressway Use",
  chapter10List21: 
    "A vehicle must meet the following conditions to enter the expressway:",

  chapter10List22:
    "It must be able to travel at 100 km/h.",

  chapter10List23:
    "It must not carry excessive loads and must not emit black smoke while travelling.",

  chapter10List24:
    "It must comply with the standards of the Motor Traffic Act (height, weight, etc.).",

  chapter10List25:
    "All components such as lights, indicators, dashboard sensors, brakes, and seat belts must function properly.",

  chapter10List26:
    "The engine and tyres must be in good condition, with the correct tyre pressure maintained.",

   chapter10Subheading2: "Guidelines for Safe Expressway Use",

  chapter10List31: 
    "The maximum speed limit is 100 km/h.",

  chapter10List32:
    "Always maintain a safe distance from the vehicle in front. Vehicle behaviour is very different on an expressway compared to normal roads.",

  chapter10List33:
    "Always wear your seat belt. This small belt provides life-saving protection in an accident.",

  chapter10List34:
    "Always drive in the left/outer lane. The inner/right lane is only for overtaking.",

  chapter10List35:
    "Before overtaking, check your mirrors, and if safe, signal and overtake. After overtaking, signal again and return safely to the left lane without obstructing other vehicles.",

  chapter10List36:
    "The speed limit at expressway entry and exit points is 60 km/h.",

   

  chapter10List37:
    "The emergency lane may be used only in emergency situations.",

  chapter10List38:
    "Stopping your vehicle on the expressway for sightseeing, resting, or personal needs is strictly prohibited. All such activities must be done at designated rest areas.",

  chapter10List39:
    "Do not throw garbage onto the road at any time.",

  chapter10List40:
    "During bad weather, reduce your speed and drive more carefully.",

 

  chapter10List41:
    "If an emergency or accident occurs, move your vehicle to the emergency lane and stop.",

  chapter10List42:
    "Since the lane is only about 1.75 meters wide, be extremely cautious when stopping or stepping out.",

  chapter10List43:
    "Call the expressway emergency hotline 1969, and stay inside your vehicle until emergency services arrive.",

  chapter10List44:
    "Reversing on the expressway is strictly prohibited. If you miss your exit, continue to the next interchange and exit there.",

  chapter10List45:
    "Expressway emergency services and property damage repairs involve very high service charges and fines. Therefore, if your vehicle is not suitable for expressway travel, do not enter the expressway.",

  chapter10List46:
    "Always drive with maximum safety and follow the rules to enjoy a fast, safe, and comfortable journey.",


  chapter10List47:
    " Follow the relevant rules on the expressway to experience a faster, safer, and more comfortable journey",







  chapter11Title: "11. Road Rules for Pedestrians",

  cchapter11Paragraph1:
    "Whenever possible, pedestrians should walk on the right side of the road. This allows you to clearly see the vehicles coming towards you, while vehicles coming from behind will be on the far side of the road.",

  chapter11Paragraph2:
    "Always use the pedestrian footpath or any designated walkway if one is available.",

  chapter11Paragraph3:
    "Pedestrians should walk alone or in pairs, side by side. At no time should more than two people walk side by side on the road.",

  chapter11Paragraph4:
    "When walking with small children, always pay special attention to their safety. The child should walk on the outer side, away from the road, while the adult walks on the side closer to the road.",

 chapter11Paragraph5:
    "When walking near bends or junctions, be extra cautious because vehicles may appear suddenly from either direction.",

  chapter11Paragraph6:
    "When walking at night, it is advisable to wear white or light-coloured clothing. This makes it easier for drivers to see you.",

 chapter11Paragraph7:
    "If you need to cross the road, first check whether there is a pedestrian crossing, an underpass, or an overhead bridge within 50 meters of where you are standing. If such a facility exists, you must use it.",

 chapter11Paragraph8:
    "Even at a pedestrian crossing, always look carefully in both directions before crossing. Allow drivers enough time to slow down or stop safely, and then cross the road.",

  chapter11Paragraph9:
    "At a pelican crossing (signal-controlled pedestrian crossing), cross only along the straight yellow lines, not on areas with zebra stripes unless indicated for use.",

  chapter11Paragraph10:
    "If a police officer is controlling traffic near a pedestrian crossing, always obey his instructions.",

  chapter11Paragraph11:
    "If there is no pedestrian crossing, wait until the traffic is light. Then look right, left, and right again, and if it is safe, cross the road quickly.",

  chapter11Paragraph12:
    "Never cross the road by suddenly stepping out from behind parked vehicles, as this prevents drivers from seeing you.",

  chapter11Paragraph13:
    "If the pedestrian crossing has traffic lights, follow the signals. These lights may be automatic or manually activated. If manually activated, the switch will be found on the signal pole.",

  chapter11Paragraph14:
    "When the red man signal is on, do not cross the road. Wait until it automatically turns green or press the switch to activate the green man signal.",

  chapter11Paragraph15:
    "Even when the green man lights up, still be careful and check for vehicles because drivers may need a moment to react to the signal change.",

  chapter11Paragraph16:
    "The green man usually stays lit for a very short time (often about 10 seconds). After this, the green man begins to blink, warning that the light will soon turn red. Do not start crossing at this time. If you are already crossing, reach the other side quickly and safely.",







  chapter12Title: "12. Important Rules for Cyclists",

   chapter12Paragraph1: 
    "Before entering the road, always check whether your bicycle is in proper working condition. Make sure the brakes, lights, tyres, and overall body are safe for use.",

   chapter12Paragraph2: 
    "Ensure that the annual licence sticker of the bicycle is fixed properly and clearly visible.",

   chapter12Paragraph3: 
    "When riding, always travel on the left side of the road, following the correct lane discipline.",

   chapter12Paragraph4: 
    "If there is a dedicated cycling lane, you must use it at all times for your safety and the safety of others.",

  chapter12Paragraph5: 
    "standard signal is a green X indicating a lane is open, and a red X meaning it is closed and cannot be entered",

   chapter12Paragraph6: 
    "End of bicycle-only lane",
   chapter12Paragraph7: 
    "This type of road sign warns drivers of a designated area where cyclists may be crossing the road or where a shared path is in use.",

   chapter12Paragraph8: 
    "Be extra careful when overtaking other vehicles. Always keep both hands on the bicycle handlebar. Give hand signals correctly, efficiently, and clearly so that other road users can understand your movements.",

   chapter12Paragraph9: 
    "If you are riding at night, make sure to use a lamp (or another suitable light source) on your bicycle. Your bicycle must have a bright white light at the front and a red reflector at the back. The diameter of the rear red reflector should be 3.75 cm. Also, the lower edge of the mudguard above the back wheel must have a 23 cm high white-painted strip, and the reflector should be fixed onto that white strip.",

  

    chapter12Paragraph10: 
    "a solid white line indicates a mandatory lane that vehicles should not cross, while a broken white line marks an advisory lane that vehicles may enter with caution when necessary"
,






  chapter13Title: "13. Important Rules for Motor Vehicle Drivers",

  chapter13Paragraph1:
    "Do not start a journey unless you are fit to drive. Avoid driving if you have taken drugs (or medication that causes drowsiness), consumed alcohol, are overly tired, or are in an unstable emotional condition.",

  chapter13Paragraph2:
    "While driving, avoid using a mobile phone or eating food. Also, never drive wearing slippers.",

  chapter13Paragraph3:
    "Make sure your vehicle is in good mechanical condition. Pay attention to the steering system, brakes, tyres, lights, horn, indicators, and wipers.",

  chapter13Subheading1:
    "Requirements for Driving on a Main Road",

  chapter13List11:
    "1. The driver must be physically and mentally fit.",

  chapter13List12:
    "2. The vehicle must be in proper running condition.",

  chapter13List13:
    "3. The vehicle must have a valid insurance certificate.",

  chapter13List14:
    "4. The vehicle must have a valid revenue licence.",

  chapter13List15:
    "5. The driver must have a valid driving licence for that vehicle category.",

  chapter13List16:
    "6. The vehicle must have a valid emission test certificate.",

  chapter13Paragraph4:
    "When driving, you must always keep the driving licence, revenue licence, insurance certificate, and emission test certificate inside the vehicle.",

  chapter13Paragraph5:
    "If you are learning to drive, a qualified person above 21 years of age who holds a valid licence for that vehicle category must sit beside you. (This rule does not apply to motorcycles or tractors.)",

  chapter13Paragraph6:
    "A red L board, which is double the size of the number plate letters, must be displayed clearly above the number plate.",

  chapter13Paragraph7:
    "Before driving, adjust the driver’s seat so it fits you comfortably. Also adjust the side mirrors properly. If seatbelts are available, wear them correctly.",

  chapter13Paragraph8:
    "When travelling with a small child, always keep the child in the back seat. Using a child safety seat is even more appropriate.",

  chapter13Paragraph9:
    "Before starting to move, check the rear using the side mirror. If needed, look over your right shoulder to ensure the road behind is safe. Then give the proper signal and begin your journey without obstructing any approaching vehicles.",

  chapter13Image1: PDFViewerImage12,

  chapter13Paragraph10:
    "When driving, keep both hands on the steering wheel whenever possible. Even when performing essential tasks such as changing gears, at least one hand must always remain on the steering wheel.",

  chapter13Paragraph11:
    "Hand signals or light indicators must be given clearly and well in advance. Hand signals, especially, should be shown in a clear and visible manner. After completing the maneuver, remember to switch off the signal lights.",

  chapter13Paragraph12:
    "Avoid using the horn unnecessarily or driving aggressively by relying on the horn.",

  chapter13Subheading2:
    "Distance Between Vehicles and Speed",

  chapter13Paragraph13:
    "Always maintain a safe distance from the vehicle in front of you. If the vehicle ahead stops suddenly, you should be able to stop your own vehicle without a collision.",

  chapter13Paragraph14:
    "As your speed increases, the distance your vehicle travels each second also increases. Therefore, the time required to stop the vehicle becomes longer.",

  chapter13Subheading3:
    "Stopping Distance = Thinking Distance + Braking Distance",

  chapter13Paragraph15:
    "The table below shows the approximate distance a moving vehicle travels—from the moment the driver decides to stop until the vehicle comes to a complete halt—after applying brakes.",

  chapter13Image2: PDFViewerImage13,

  chapter13Subheading4:
    "Use of Light Signals",

  chapter13Paragraph16:
    "Always allow faster vehicles to overtake you safely. Slow-moving heavy vehicles must give way to vehicles traveling at higher speeds.",

  chapter13Paragraph17:
    "Whenever a suitable opportunity arises, heavy vehicle drivers should move their vehicle to the side or stop temporarily to allow faster vehicles to pass. This is an important responsibility of heavy vehicle drivers to ensure smooth and safe traffic flow.",

  chapter13Paragraph18:
    "Light signals are used to inform other road users about the driving actions you are about to perform.",

  chapter13Paragraph19:
    "Hazard lights (park lights) should be used only to indicate that your vehicle is in a dangerous or disabled condition.",

  chapter13Paragraph20:
    "Headlights do not provide priority or right-of-way. They simply indicate your presence to oncoming traffic, especially at night."
,





  chapter14Title: "14. Lane Discipline Rules",

  chapter14Paragraph1:
    "Always follow the rules and regulations related to lane discipline.",

  chapter14Paragraph2:
    "Maintaining proper lane discipline helps:\n- Prevent unnecessary traffic congestion\n- Reduce the wastage of fuel, time, and other resources\n- Minimize road accidents\n- Improve overall traffic flow and safety",

  chapter14Subheading1: "Double White Lines",

  chapter14Paragraph3:
    "You must never cross or cut over double white lines marked in the middle of the road, except in the following very limited situations:",

  chapter14Paragraph4:
    "When you must avoid an uncontrollable situation, or",

  chapter14Paragraph5:
    "To prevent a sudden and unavoidable accident",

  chapter14Paragraph6:
    "Apart from these exceptional circumstances, crossing double white lines is strictly prohibited.",

  chapter14Paragraph7:
    "Additionally:\n- Stopping vehicles on either side of a road section controlled by double white lines is prohibited.\n- Overtaking on a road section marked with double white lines is also strictly forbidden.",

  chapter14Image1: PDFViewerImage14,

  chapter14Subheading2: "Single White Line",

  chapter14Paragraph30:
    "A single white line drawn in the middle of the road must not be crossed or cut except under the following conditions:",

  chapter14Image2: PDFViewerImage15,

  chapter14Subheading3: "Center Line of the Road",

  chapter14Paragraph8:
    "When you are turning right, or",

  chapter14Paragraph9:
    "When avoiding a sudden or unavoidable danger",

  chapter14Paragraph10:
    "Crossing the single white line for any other reason is prohibited.",

  chapter14Paragraph11:
    "In addition:\n- Stopping vehicles on either side of a road section controlled by a single white line is prohibited.\n- Overtaking in areas marked with a single white line is also strictly forbidden.",

  chapter14Image3: PDFViewerImage16,

  chapter14Subheading4: "Lane Markings",

  chapter14Paragraph12:
    "The center line of a road is marked using white broken lines or white broken lines with reflective studs (cat’s eyes). These markings separate the lanes used by vehicles traveling in opposite directions.",

  chapter14Paragraph13b:
    "You may cross or overtake across these lines only if it is safe to do so—meaning it must not obstruct or endanger oncoming traffic.",

  chapter14Paragraph14b:
    "Long gaps with short yellow lines are used to separate the driving lanes on the road. When travelling on a road where lanes are marked in this way, you must keep your vehicle within your designated lane at all times.",

  chapter14Paragraph15b:
    "You should not change lanes unnecessarily. However, you may change lanes to move into the lane you need or to overtake another vehicle, as long as it does not obstruct other vehicles. In every such situation, you must give the correct light signals and change lanes safely.",

  chapter14Image4: PDFViewerImage17,

  chapter14Subheading5: "Driving on a Three-Lane Road",

  chapter14Paragraph16b:
    "On a roadway with three lanes:\n- The left lane is reserved for slow-moving vehicles and for vehicles that intend to turn left. (Shown as Lane 1 in the diagram.)\n- The middle lane is reserved for vehicles that are travelling straight ahead. (Shown as Lane 2 in the diagram.)\n- The lane next to the centre line (Lane 3 in the diagram) is reserved for vehicles that intend to turn right and for vehicles that need to overtake other vehicles.",

  chapter14Image5: PDFViewerImage18,

  chapter14Paragraph17b:
    "When you are approaching a point where you need to turn off the road, signal early using your indicator lights. Then check the rear-view mirrors to observe the traffic behind you, and safely move into the left or right lane, as required.",

  chapter14Paragraph18b:
    "After that, exit the road carefully and safely, just as you would normally do.",

  chapter14Paragraph19b:
    "When there is heavy traffic on the road, try to keep your vehicle within your own lane as much as possible. This will help prevent additional unnecessary congestion.",

  chapter14Paragraph20b:
    "Long white lines with short gaps indicate a danger zone on the road. When you see these markings, you must drive with extra caution and care.",

  chapter14Image6: PDFViewerImage19,
  chapter14Image7: PDFViewerImage20,
  chapter14Image8: PDFViewerImage21,

  chapter14Subheading6:
    "Road Signs and Caution Zones",

  chapter14List11:
    "A pedestrian crossing ahead.",

  chapter14List12:
    "A location where cattle or other animals may cross the road ahead.",

  chapter14List13:
    "A pedestrian crossing point directly ahead.",

  chapter14List14:
    "A place where children may cross the road ahead.",

  chapter14List15:
    "A school zone ahead.",

  chapter14List16:
    "An area where people may be engaged in roadwork or other activities ahead.",

  chapter14Paragraph25:
    "At a pedestrian crossing with a yellow line, if a pedestrian is waiting to cross, you must stop your vehicle before the pedestrian crossing sign or before the give-way line marked on the road.",

  chapter14Image9: PDFViewerImage22,

  chapter14Paragraph13:
    "You must never stop on top of the give-way line or past it. Your vehicle should be stopped just before the line, allowing pedestrians to cross safely.",

  chapter14Subheading7: "Overtaking Vehicles",

  chapter14Paragraph14:
    "Do not overtake unless you are completely certain that it is safe to pass the vehicle in front of you. You must ensure that overtaking will not cause danger or inconvenience to either the vehicle you are passing or any oncoming vehicles. Unsafe overtaking is extremely dangerous and can easily lead to fatal accidents.",

  chapter14Paragraph15:
    "At night, during fog, when the road is wet due to rain, or when travelling on an unfamiliar road, you must be especially cautious when overtaking.",

  chapter14Paragraph16:
    "Before overtaking another vehicle, first make sure the road ahead is clearly visible and that you can complete the overtaking within that visible distance. Then check your rear-view mirrors to ensure the road behind is clear, and turn on your right-turn signal.",

  chapter14Paragraph17:
    "Increase your speed (preferably using 3rd or 4th gear) and safely overtake the vehicle.",

  chapter14Paragraph18:
    "After passing the vehicle, do not immediately return to your original lane, as you may cut off the other vehicle’s path. Instead, continue for a short distance in the right lane, ensure a safe gap, use your indicator signal, and then return to your lane safely.",

  chapter14Paragraph19:
    "If the vehicle in front is signalling a right turn and it is completely safe to pass on the left side, only then may you overtake on the left. In all other situations, overtaking must be done from the right side only.",

  chapter14Paragraph20:
    "The flashing of headlights by an approaching vehicle simply indicates its presence. It does not give you priority.",

  chapter14Paragraph21:
    "When another vehicle attempts to overtake you, reduce your speed slightly and keep to the left to allow them to pass. Increasing your speed to prevent another driver from overtaking is reckless and discourteous behavior.",

  chapter14Subheading8:
    "Places Where Overtaking is Prohibited",

  chapter14List21:
    "At a pedestrian crossing.",

  chapter14List22:
    "On a bend or curve.",

  chapter14List23:
    "At a junction or intersection.",

  chapter14List24:
    "At the crest of a hill or on a humpback bridge.",

  chapter14List25:
    "On road sections controlled by single or double solid white lines.",

  chapter14List26:
    "In any area where overtaking is specifically prohibited by signs.",

  chapter14Subheading9: "Reversing a Vehicle",

  chapter14Paragraph22:
    "Reversing must always be done slowly and with extreme caution.",

  chapter14Paragraph23:
    "Never reverse from a side road onto a main road.",

  chapter14Paragraph24:
    "While reversing, proceed slowly and continuously check all surroundings."
,





  chapter15Title: "15. Driving Through Intersections",

  chapter15Paragraph1:
    "Intersections must be approached with extreme caution because vehicles enter from other roads or exit onto different roads. Since traffic paths cross at intersections, the risk of collisions is very high.",

  chapter15Paragraph2:
    "Before approaching an intersection, decide exactly which direction you need to go.",

  chapter15Paragraph3:
    "You should never stop your vehicle at the intersection to ask for directions, reverse the vehicle, or make a U-turn. Such actions will obstruct the traffic flow on multiple roads and can easily cause congestion or accidents.",

  chapter15Paragraph4:
    "As you approach the intersection, check your mirrors, apply the required indicator signals, and move your vehicle into the correct lane well in advance.",

  chapter15Image1: PDFViewerImage23,

  chapter15Subheading1:
    "On a Two-Lane Road",

  chapter15List11:
    "If you are turning left or going straight ahead, stay in the left lane.",

  chapter15List12:
    "Use the right lane only when you need to turn right, and complete your right turn from that lane.",

  chapter15List13:
    "If you are going straight ahead, you should travel in the middle lane.",

  chapter15Paragraph5:
    "At an intersection, vehicles that are turning left or right must give way to vehicles going straight ahead.",

  chapter15Image2: PDFViewerImage24,

  chapter15Subheading2:
    "On a Three-Lane Road",

  chapter15List21:
    "If you need to turn left, you must use the left lane.",

  chapter15List22:
    "If you need to turn right, you must use the right lane.",

  chapter15List23:
    "If you are going straight ahead, you should travel in the middle lane.",

  chapter15Image3: PDFViewerImage25,







 chapter16Title: "16. Traffic Lights",

  chapter16Paragraph1:
    "This sign indicates that you are approaching an intersection where vehicle movement is controlled by traffic light signals.",

  chapter16Image1: PDFViewerImage26,

  chapter16Paragraph2:
    "All drivers must strictly obey traffic light signals. When the red light is displayed, it indicates that vehicle movement has been stopped. In such situations, the driver must bring the vehicle to a complete stop before the stop line marked on the road, without crossing it.",

  chapter16Image2: PDFViewerImage27,

  chapter16Paragraph3:
    "If a stop line is not marked on the road, the vehicle must be brought to a complete stop before reaching the traffic lights or before entering the point where the road divides. The driver must ensure the vehicle is stopped safely without obstructing other road users.",

  chapter16Image3: PDFViewerImage28,
  chapter16Image4: PDFViewerImage29,
  chapter16Image5: PDFViewerImage30,
  chapter16Image6: PDFViewerImage31,

  chapter16Paragraph4:
    "Even though these signals are designed to operate accurately and reliably, there may occasionally be times when they malfunction or do not operate correctly. There may also be drivers who disobey traffic light signals. For this reason, you must always maintain your full attention on the road, even when traffic lights are present.",

  chapter16Paragraph5:
    "In certain situations, traffic lights may be temporarily deactivated, and a police officer may be directing traffic instead. In such cases, you must strictly follow the hand signals given by the police officer, as they take priority over the traffic lights."
,



 chapter17Title: "17. Police Hand Signals",

  chapter17Paragraph1:
    "When a police officer is controlling traffic, you must strictly obey their hand signals.",

  chapter17Image1: PDFViewerImage32,

  chapter17Paragraph2:
    "In such situations, you must stop your vehicle before the stop line that is marked on the road.If there is no stop line, you must stop the vehicle before entering the junction or the point where the road divides.",

  
chapter18Title: "18. Driving at Roundabouts",
chapter18Paragraph1: "The following sign indicates that there is a roundabout ahead.",
chapter18Image1: PDFViewerImage33,
chapter18Paragraph2: "If it is a mandatory roundabout, you must drive through it.",
chapter18Image2: PDFViewerImage34,
chapter18Subheading1: "Roundabout Rule [Keep Right Rule]",
chapter18Paragraph3: "At a roundabout, you should give way to vehicles approaching from the right. To give way to vehicles coming from the right, stop your vehicle near the 'Give Way' line marked on the roundabout road.",
chapter18Image3: PDFViewerImage35,



  chapter19Title: "19. The Yellow Box Junction",

  chapter19Image1: PDFViewerImage36,

  chapter19Paragraph1:
    "At some intersections, a yellow box may be marked on the road surface.\n\nYou must not enter the yellow box unless your exit lane is clear and you can pass through without stopping inside the box.",

  chapter19Paragraph2:
    "However, you are allowed to wait inside the yellow box only if you intend to turn right (or left in some countries) and your movement is blocked by oncoming traffic or by other vehicles also waiting to turn.",

  chapter19Paragraph3:
    "At all other times, stopping inside a yellow box junction is prohibited."
,






  chapter20Title: "20. Parking the Vehicle",

  chapter20Paragraph1:
    "Whenever possible, use a designated parking area to stop your vehicle. If you must stop at the side of the road, position your vehicle facing the same direction as the traffic flow and move it as far left as possible. The vehicle should be stopped parallel to the road while remaining safely off the main traffic lane.",

  chapter20Image1: PDFViewerImage37,

  chapter20Paragraph2:
    "Turn off the engine and apply the parking brake (hand brake) properly. When opening the door—especially on the roadside—always check for vehicles approaching from behind.",

  chapter20Paragraph3:
    "If you are parking in a designated parking area, follow the specific parking instructions given, whether it requires angled parking, parallel parking, or any other method. Parking randomly without proper arrangement wastes both your time and others’ valuable time. Improperly parked vehicles can obstruct the road, cause traffic congestion, and lead to unnecessary damage. Therefore, it is very important to park your vehicle properly, either in a parking area or at the roadside.",

  chapter20Subheading1: "Stopping and Parking the Vehicle",

  chapter20List11: ["Parallel Parking", "Angle Parking"],

  chapter20Subheading2: "Parallel Parking",

  chapter20Paragraph4:
    "First, find a space that is large enough for your vehicle. To park safely, the available space should be at least 2 meters longer than the length of your vehicle. After locating the space, signal correctly and begin maneuvering.",

  chapter20Paragraph5:
    "Although there is no single 'standard rule' for maneuvering the vehicle into the space, the method given below is the one followed by most drivers because it is safe, easy, and widely practiced. However, depending on your skill and comfort, you may use any method you prefer. The most important thing is to ensure that you park the vehicle without causing damage to other vehicles and without obstructing the traffic lane.",

  chapter20Paragraph6:
    "Drive your vehicle forward until it is parallel to the vehicle parked in front of the space where you intend to park. Maintain a distance of about 5 meters (or a safe gap) between your vehicle and the vehicle ahead.",

  chapter20Image2: PDFViewerImage38,

  chapter20Paragraph7:
    "Slowly begin reversing the vehicle while gradually turning the steering wheel. Continue reversing until the steering wheel has been turned to about 45 degrees.",

  chapter20Image3: PDFViewerImage39,

  chapter20Paragraph8:
    "After that, straighten the wheels and continue reversing further into the parking space.",

  chapter20Image4: PDFViewerImage40,

  chapter20Paragraph9:
    "Now turn the steering wheel in the opposite direction and continue reversing into the parking space.",

  chapter20Image5: PDFViewerImage41,

  chapter20Paragraph10:
    "After that, adjust the position of your vehicle so that there is a proper and safe gap on all sides.",

  chapter20Image6: PDFViewerImage42,

  chapter20Subheading3: "Angle Parking",

  chapter20Paragraph11:
    "This method is commonly used for parking vehicles. In this method, there will usually be two other vehicles parked on either side of your vehicle.",

  chapter20Paragraph12:
    "In angle parking, the vehicle is positioned at a 90-degree angle to the front boundary line.",

  chapter20Image7: PDFViewerImage43,

  chapter20Paragraph13:
    "Parking at a 60-degree angle is commonly used on one-way roads.",

  chapter20Paragraph14:
    "This method is also followed in areas where parking space is limited.",

  chapter20Image8: PDFViewerImage44,

  chapter20Paragraph15:
    "If no one is inside the parked vehicle or if no responsible person is present, the vehicle must always be locked before leaving.",

  chapter20Paragraph16:
    "When parking at night on a road used by vehicles, switch on the parking lights to alert other drivers.",

  chapter20List2: [
    "If you are parking on a slope or incline, engage the reverse gear, turn the steering wheel towards the side away from the road as much as possible, and apply the handbrake firmly."
  ],

  chapter20Image9: PDFViewerImage45,

  chapter20List3: [
    "If stopping on a downward slope, keep the vehicle in first gear and apply the handbrake firmly. If there is a curb, turn the wheels towards the curb so that the vehicle will roll into it if it moves. If there is no curb, turn the wheels away from the road to prevent the vehicle from rolling into traffic."
  ],

  chapter20Image10: PDFViewerImage46
,



  chapter21Title: "21. Places Where Parking Is Prohibited",

  chapter21List11: 
    "Parking a vehicle is strictly prohibited in the following locations:",

  chapter21List12: "Within 30 meters of a bus stop.",
chapter21List13: "Within 15 meters of a pedestrian crossing.",
chapter21List14: "Within 15 meters of a fire hydrant.",
chapter21List15: "On a pedestrian walkway.",
chapter21List16: "On a bridge.",
chapter21List17: "On the crest of a hill.",
chapter21List18: "At a bend or curve on the road.",
chapter21List19: "At narrow sections of the road.",
chapter21List20: "On road areas marked with single or double solid white lines.",
chapter21List21: "On bus lanes or bicycle lanes.",
chapter21List22: "On high-speed lanes.",
chapter21List23: "In taxi-only parking zones.",
chapter21List24: "In any location where traffic signs prohibit parking.",
chapter21List25: "In a way that blocks or obstructs an entrance or gateway."
,

chapter22Title: "22. Road Signs",
chapter22Paragraph1: "Road signs can mainly be categorized into two types.",
chapter22List11: 
  "1) Board signs",
chapter22List12: 
  "2) Signs placed on the road",

chapter22Subheading1: "Categories of Board Signs",
chapter22List21: 
  "Warning signs",
chapter22List22: 
  "Regulatory signs",
chapter22List23: 
  "Information signs",
chapter22List231: 
  "a) Advance direction signs",
chapter22List232: 
  "b) Direction signs",
chapter22List233: 
  "c) Place identification signs",
chapter22List24: 
  "Other signs",

chapter22Subheading2: "Types of Regulatory Signs",
chapter22List31: 
  "a) Prohibition signs",
chapter22List32: 
  "b) Restrictive signs",
chapter22List33: 
  "c) Instruction signs",
chapter22List34: 
  "d) Priority signs",

chapter22Subheading21: "2) Regulatory Signs",
chapter22Subheading3: "Warning Signs",
chapter22Image1: PDFViewerImage47,
chapter22Image2: PDFViewerImage48,
chapter22Image3: PDFViewerImage49,
chapter22Image4: PDFViewerImage50,
chapter22Image5: PDFViewerImage51,
chapter22Image6: PDFViewerImage52,

chapter22Subheading4: "Prohibition Signs",
chapter22Image7: PDFViewerImage53,
chapter22Image8: PDFViewerImage54,
chapter22Image9: PDFViewerImage55,
chapter22Paragraph2: "Entering this road (including from the opposite end) is prohibited.",
chapter22Image10: PDFViewerImage56,
chapter22Paragraph3: "Even though entry onto this road is prohibited, vehicles may exit from the other end of the road.",
chapter22Paragraph4: "Within the area regulated by this sign, stopping vehicles is prohibited, but temporarily stopping the engine without emergency is allowed.",
chapter22Paragraph5: "Stopping or parking vehicles in any manner is prohibited.",
chapter22Image11: PDFViewerImage57,
chapter22Image12: PDFViewerImage58,

chapter22Subheading5: "Additional Boards",
chapter22Paragraph6: "These boards indicate the direction and distance for which a regulatory sign is effective. They are installed below the relevant regulatory sign. Additional boards are often used with regulatory signs related to vehicle stopping.",
chapter22Image13: PDFViewerImage59,

chapter22Subheading6: "Restrictive Signs",
chapter22Image14: PDFViewerImage60,

chapter22Subheading7: "Instruction Signs",
chapter22Image15: PDFViewerImage61,

chapter22Subheading8: "Priority Signs",
chapter22Paragraph7: "These signs indicate that vehicles entering from a side road must give way to vehicles on the main road.",
chapter22Image16: PDFViewerImage62,
chapter22Paragraph8: "This sign shows that vehicles entering the main road from a side road must stop and give way to vehicles on the main road.",
chapter22Image17: PDFViewerImage63,
chapter22Paragraph9: "This sign indicates that vehicles entering the main road from a side road must yield priority to vehicles traveling on the main road.",
chapter22Image18: PDFViewerImage64,
chapter22Paragraph10: "This sign indicates the end of the priority for vehicles entering the main road from a side road.",
chapter22Image19: PDFViewerImage65,
chapter22Image20: PDFViewerImage66,

chapter22Subheading9: "Information Signs",
chapter22List41: 
  "a) Advance direction signs",
chapter22List43: 
  "c) Place identification signs",
chapter22Image21: PDFViewerImage67,

chapter22Subheading12: "Used to inform when the road changes direction.",
chapter22Image22: PDFViewerImage68,

chapter22Subheading11: "Used to indicate an obstacle on the road.",
chapter22Image23: PDFViewerImage69,
chapter22Image24: PDFViewerImage70,

chapter22List42: "b) Direction signs",
chapter22Image25: PDFViewerImage71,

chapter22Subheading10: "Other Signs",
chapter22Image26: PDFViewerImage72,
chapter22Image27: PDFViewerImage73,





chapter23Title: "23. Road Markings on the Road",
chapter23Subheading1: "Road markings at pedestrian crossings",
chapter23Image1: PDFViewerImage74,
chapter23Image2: PDFViewerImage75,
chapter23Paragraph1: "At a stop line, when this line is placed at the point where a side road meets the main road, vehicles must stop and give way to vehicles coming from both directions on the main road.",

chapter23List11: 
  '"Give Way Line" – This marking can be seen for vehicles on a side road entering the main road.',
chapter23Image3: PDFViewerImage76,

chapter23List12: "Stop line placed at an intersection or where the road splits",
chapter23Image4: PDFViewerImage77,

chapter23List13: "Give way line placed at a roundabout",
chapter23Image5: PDFViewerImage78,

chapter23List14: "Centerline marking on the road",
chapter23Image6: PDFViewerImage79,

chapter23List15: "Markings on the road indicating that stopping or parking is prohibited or restricted",
chapter23Image7: PDFViewerImage80,
chapter23Image8: PDFViewerImage81,
chapter23Image9: PDFViewerImage82,

chapter23List16: "Single white line controlled area: Vehicles may turn right along the line, but overtaking and stopping vehicles on both sides are prohibited.",
chapter23Image10: PDFViewerImage83,

chapter23List17: "Double white line controlled area: Overtaking along the lines is prohibited, stopping vehicles on both sides is prohibited, and right turns are also prohibited.",
chapter23Image11: PDFViewerImage84,

chapter23List18: "Danger area: When vehicles move in opposite directions on both sides of this marking, it is safe only if verified. Turning right through it is prohibited.",
chapter23Image12: PDFViewerImage85,

chapter23List19: "Danger area: These transverse diagonal lines indicate a safer area for vehicles when traffic moves in the same direction on both sides.",
chapter23Image13: PDFViewerImage86,

chapter23List20: "Markings used to separate traffic lanes",
chapter23Image14: PDFViewerImage87,

chapter23List21b: "Mandatory left turn marking",
chapter23Image15: PDFViewerImage88,

chapter23List22b: "Mandatory right turn marking",
chapter23Image16: PDFViewerImage89,

chapter23List23b: "Mandatory straight ahead marking",
chapter23Image17: PDFViewerImage90,

chapter23List24b: "Marking placed at locations with a 'Stop' signal",
chapter23Image18: PDFViewerImage91,

chapter23List25: "Marking indicating to drive slowly when there is a hazard ahead",
chapter23Image19: PDFViewerImage92,

chapter23List26: "Bus lane marking",
chapter23Image20: PDFViewerImage93,

chapter23List27: "Bicycle lane marking",
chapter23Image21: PDFViewerImage94,

chapter23List28: "Warning line indicating a road hazard",
chapter23Image22: PDFViewerImage95,

chapter23List29: "Markings separating bus and pedestrian lanes",
chapter23Image23: PDFViewerImage96,

chapter23Subheading2: "Additional Information",
chapter23Image24: PDFViewerImage97,
chapter23Paragraph2: "In the intersection shown in the image:",

chapter23List21: "Motorcycles must go straight. ✓",
chapter23List22: "Three-wheeled vehicles can go straight. X",
chapter23List23: "Three-wheeled vehicles can turn right or go straight. X",
chapter23List24: "Motorcycles can go straight or turn right. X",

chapter23List31: "What is this road marking? Centerline marking prohibiting passage across the road.",
chapter23Image25: PDFViewerImage98,

chapter23List32: "What is this road marking? Give way line at a roundabout",
chapter23Image26: PDFViewerImage99,

chapter23List33: "What is this road marking? Stop line at a stop signal.",
chapter23Image27: PDFViewerImage100,

chapter23List41: "At a T-junction, vehicles must stop before proceeding.",
chapter23List42: "In the Road Traffic Rules, 'Warning Signs' have a yellow background with black markings.",
chapter23List43: "The basic rule at a roundabout: Give way to vehicles coming from the right.",
chapter23List44: "On a three-lane road, the center lane should be used when moving straight ahead.",
chapter23List45: "Hazard lamps should be used only when the vehicle is immobilized and stationary.",
chapter23List46: "When stopping a vehicle at night, it should face the direction of traffic.",
chapter23List47: "'Stopping distance' refers to the sum of thinking distance and braking distance.",
chapter23List48: "When approaching a pedestrian crossing, slow down and be ready to stop.",
chapter23List49: "If you need to turn right ahead, drive in the right-hand lane.",
chapter23List50: "When entering a main road from a side road, check both directions carefully before proceeding.",
chapter23List51: "When driving on a hilly road, use a low or heavy gear.",
chapter23List52: "Refueling a motor vehicle requires turning off the engine.",
chapter23List53: "Under the new registration system, the Vehicle Identity Card (VIC) must always be kept in the vehicle.",
chapter23List54: "When overtaking, select 3rd or 4th gear to accelerate appropriately.",
chapter23List55: "Installing a metallic guard on the bumper of a motor vehicle is illegal.",
chapter23List56: "Priority of following traffic rules: Police signals, traffic lights, road signs, road markings.",
chapter23List57: "The two main types of road signs are: Board signs and Road markings.",
chapter23List58: "A driver uses signals to inform others of their intended actions.",
chapter23List59: "The windscreen of a vehicle cannot be tinted. Only 1/5 of side windows can be tinted.",
chapter23List60: "At an unseen sharp bend, sound the horn and drive slowly.",
chapter23List61: "The main headlight has two modes: High beam (Head) and Low beam (Dim).",
chapter23List62: "On a hilly road, drive in low or heavy gear.",
chapter23List63: "Do not use indicators when skidding; release the accelerator and steer in the direction of the skid.",
chapter23List64: "In heavy traffic, keep your left foot on the clutch and right foot on the brake pedal.",
chapter23List65: "On open roads, left foot free and right foot on the accelerator.",
chapter23List66: "When going downhill, left foot on clutch and right foot on brake.",
chapter23List67: "Crossing pedestrians outside a designated crossing can result in a fine of Rs. 1,000–2,000.",
chapter23List68: "A fatal accident is one in which one or more persons die within 30 days of the incident.",
chapter23List69: "Areas requiring careful driving: near schools, railway crossings, pedestrian crossings, intersections, busy roads.",
chapter23List70: "When entering a main road from a side road, give way to vehicles on the main road.",

chapter23Paragraph3: "At a T-junction, your vehicle must stop at the Give Way line and allow vehicles approaching from both sides of the main road to pass before proceeding.",






chapter24Title: "24. Steps to Be Taken in the Event of an Accident or Emergency",
chapter24Paragraph1: "When a vehicle is involved in a sudden accident or emergency, it should be moved off the road as quickly as possible to remove any obstruction to traffic. However, before changing the position of the vehicle after an accident, a decision should be taken after consulting the police, the insurance representative, and the other party involved in the accident.",

chapter24Paragraph2: "In addition, before changing the position of the vehicle after an accident, it is advisable to mark its position on the road using chalk, take photographs, or record other evidence.",

chapter24Paragraph3: "If the vehicle involved in the accident cannot be removed from the road, switch on the vehicle’s hazard warning lamps. Place a red reflective warning triangle approximately 50 meters away from the vehicle, facing oncoming traffic from the side where vehicles approach. On a narrow road, place a similar warning device about 50 meters in front of the vehicle as well.",

chapter24Paragraph4: "If your vehicle is involved in an accident:",

chapter24List11: "Stop the vehicle.",
chapter24List12: "Except for unavoidable delays caused by transporting injured persons, inform the police of the accident as soon as possible. (A road accident must be reported to the police within 24 hours.)",
chapter24List13: "If requested by a police officer, a Grama Niladhari officer, an injured person, or a person responsible for an injured person or animal, the following information must be provided:",

chapter24SubList11: "Name of the driver",
chapter24SubList12: "Address",
chapter24SubList13: "Name of the vehicle owner",
chapter24SubList14: "Vehicle registration number",

chapter24Paragraph5: "Furthermore, even if you were a passenger traveling in the vehicle at the time of the accident, you are obliged to provide the above information and to inform the police of your name, address, and that you were traveling in the vehicle at the relevant time.",

chapter24Paragraph6: "If there are injured persons, if an injured person is unconscious, or if it appears that someone’s life may be in danger due to the injuries, immediately transport the injured persons to the nearest hospital.",

chapter24Paragraph7: "If requested by a police officer, Grama Niladhari officer, an injured person, or a person acting on behalf of an injured person, present the insurance certificate. If it cannot be produced at that moment, it must be presented at the relevant police station as soon as possible.",

chapter24Paragraph8: "Violating traffic laws is not considered an offense only in situations where it is done to prevent an accident or when the vehicle cannot be properly controlled.",






chapter25Title: "25. Important General Mechanical Knowledge for Drivers",
chapter25Paragraph1: "The engine is the most valuable and vital part of any motor vehicle, similar to the heart of the vehicle. Power is generated by the engine using fuel. These are generally known as Internal Combustion Engines. Although there are two types of engines—Four Stroke Engines and Two Stroke Engines—at present, all diesel and petrol vehicles use four-stroke engines.",
chapter25Paragraph2: "The sequence of operations that take place during the operation of a four-stroke internal combustion engine can be explained as follows:",

chapter25List11: "Fuel mixed with air enters the cylinder.",
chapter25List12: "The fuel–air mixture is compressed.",
chapter25List13: "The compressed fuel–air mixture is ignited by an electric spark.",
chapter25List14: "Due to the heat generated, the air inside the cylinder expands and pushes the piston downward.",
chapter25List15: "This motion is converted into rotary motion through the crankshaft and transmitted to the wheels.",

chapter25Paragraph3: "The term four-stroke engine is used because four steps are completed for one complete cycle of the engine.",

chapter25List21: "Intake Stroke",
chapter25List22: "Compression Stroke",
chapter25List23: "Power Stroke",
chapter25List24: "Exhaust Stroke",

chapter25Image1: PDFViewerImage101,
chapter25Image2: PDFViewerImage102,

chapter25Subheading1: "Intake Stroke",
chapter25Paragraph4: "As the piston moves downward from top to bottom, a vacuum is created inside the cylinder. Due to this vacuum, the fuel mixed with air is drawn into the cylinder through the inlet valve.",

chapter25Subheading2: "Compression Stroke",
chapter25Paragraph5: "As the piston moves upward after reaching the bottom, the upper valves close and the fuel–air mixture is highly compressed. The ratio between the empty volume inside the cylinder when the piston is at the bottom during the intake stroke and the empty volume when the piston reaches the top during the compression stroke is known as the Compression Ratio.",

chapter25Subheading3: "Power Stroke",
chapter25Paragraph6: "At the end of compression, the spark plug inside the cylinder produces a spark, igniting the compressed fuel–air mixture. This generates a large amount of thermal energy, causing the air to expand and push the piston downward. This action drives the crankshaft.",

chapter25Subheading4: "Exhaust Stroke",
chapter25Paragraph7: "At this stage, the crankshaft rotated during the power stroke pushes the piston upward again. At the same time, the exhaust valve opens and the burnt gases are expelled out of the cylinder. After the exhaust stroke, the intake stroke occurs again. This process continues rapidly in cycles, providing the power required to move the wheels. One movement of the piston either upward or downward is called a stroke. Since the piston moves up and down four times to produce one power stroke, this engine is called a four-stroke engine.",

chapter25Paragraph8: "After the exhaust stroke, the intake stroke occurs again. This cycle continues repeatedly and rapidly, supplying the power required to move the wheels.",

chapter25Paragraph9: "One movement of the piston either upward or downward is called a stroke. Since the piston must move up and down four times to generate the power needed to drive the wheels, this engine is known as a four-stroke engine.",

chapter25List31: "Engine oil is used to reduce friction between engine parts and prevent wear.",
chapter25List32: "The engine oil level is checked using the oil level gauge (dipstick).",
chapter25List33: "Failure to start the engine is caused by a discharged battery.",
chapter25List34: "Failure of the starter motor results in the engine not cranking.",
chapter25List35: "If the engine cranks slowly when starting, the causes may be a weak battery or a faulty starter motor.",
chapter25List36: "Engine overheating can occur due to a loose radiator fan belt, a faulty radiator fan, low coolant level, coolant leakage, or a faulty water pump.",
chapter25List37: "Reduction in engine oil level is caused by excessive oil burning or oil leakage.",
chapter25List38: "Reduced engine power (under-compression) is indicated by oil escaping from the oil cap, blue smoke from the silencer, or smoke from the breather.",

chapter25Subheading5: "Ignition Knocking",
chapter25Paragraph10: "When the fuel–air mixture in a four-stroke engine is excessively compressed unnecessarily, an explosion occurs inside the cylinder during combustion. This produces a loud knocking sound accompanied by strong vibrations from the engine. This condition is known as ignition knocking.",

chapter25List41: "Causes of ignition knocking: Excessive amount of air drawn into the cylinder.",
chapter25List42: "Situations where ignition knocking occurs: Driving at high speed in a low-power gear (1st, 2nd, or 3rd gear) or driving uphill with a heavy load.",
chapter25List43: "Prevention of ignition knocking: Shift to a higher gear suitable for higher speeds.",

chapter25Subheading6: "Checking the Engine Oil Level",
chapter25Paragraph11: "Park the vehicle on a level surface.",
chapter25Paragraph12: "Switch off the engine and allow it to cool. It should be cooled for at least half an hour. If the vehicle was parked overnight, checking the oil level in the morning is most suitable.",
chapter25Paragraph13: "First, pull out the dipstick and wipe it clean thoroughly. Then reinsert it and remove it again.",
chapter25Paragraph14: "After that, check the oil level.",





chapter26Title: "26. Cooling System",

chapter26Image1: PDFViewerImage103,

chapter26Paragraph1: "One of the dashboard indicators that a driver constantly observes while driving is the engine temperature gauge.",

chapter26Paragraph2: "The processes that take place inside a motor vehicle engine generate a very high amount of heat. If this heat is not removed quickly, it can cause damage to the engine. Therefore, a cooling system is incorporated into the engine.",

chapter26Paragraph3: "About 45% of the excessive heat generated by the engine is expelled through the silencer along with exhaust gases. The remaining heat is removed through the cooling system mentioned above. If the engine overheats:",

chapter26List11: "Unnecessary expansion of engine parts causing engine seizure",
chapter26List12: "Damage to the cylinder head, gasket, etc.",
chapter26List13: "Excessive burning of engine oil and similar conditions may occur",

chapter26Paragraph4: "Motor vehicle engines are cooled mainly in three ways.",

chapter26List21: "Air cooling",
chapter26List22: "Water cooling",
chapter26List23: "Oil cooling",

chapter26Paragraph5: "In air cooling, a large flow of air is directed around the engine using a blower. In water cooling, cooling is achieved by circulating water around the engine cylinders through a radiator. In oil cooling systems, the oil flowing through the engine absorbs heat and cools the engine.",

chapter26List31: "Water circulation within the engine cooling system is carried out by the water pump",
chapter26List32: "Disadvantages of excessive engine cooling: Reduced engine power, increased fuel consumption, increased emission of unburnt gases through exhaust, reduced driving speed",
chapter26List33: "Causes of engine overheating: Loose radiator fan belt, insufficient water in the radiator",
chapter26List34: "How to identify engine overheating: Overheat warning indicator, boiling water in the radiator",

chapter26Subheading1: "Overheat Indicator / Warning (Overheat Indicator)",

chapter26Image2: PDFViewerImage104,

chapter26Paragraph6: "This indicator lights up when the engine overheats. It also lights up briefly and turns off when the ignition key is turned on initially.",

chapter26Subheading2: "When the Engine Overheats",

chapter26Paragraph7: "As soon as the overheat warning light comes on, switch off the air conditioning system if it is operating. Immediately pull over and stop the vehicle. Do not attempt to check the radiator water level immediately after stopping the vehicle.",

chapter26Paragraph8: "If the radiator cap is opened hastily, you may be exposed to hot steam and boiling water spray.",

chapter26Paragraph9: "Therefore, wait for a short period until the radiator cools down, and then open it using a protective covering such as a polythene sheet. Generally, a radiator cap opens in two stages as a safety feature. When the first stage is opened, any trapped steam will escape. Hence, the radiator cap should always be opened gradually to the second stage.",

chapter26Subheading3: "Filling Water into an Overheated and Stopped Vehicle",

chapter26Paragraph10: "When refilling water due to overheating, water should be added little by little. Additionally, the engine should be running while refilling the water.",

chapter26Subheading4: "Using Coolant in the Radiator",

chapter26Paragraph11: "Radiator coolant lowers the freezing point of water and raises its boiling point. In addition, it prevents rusting and blockage of radiator pipes. Therefore, using a properly specified coolant is an essential and important step for vehicles under any climatic condition.",

chapter26List41: "Purpose of the clutch: To engage and disengage the engine and gearbox when required",
chapter26List42: "Characteristics of a good clutch: Smooth engagement and disengagement without vibration, slipping, or noise; balanced and easy operation",
chapter26List43: "Symptoms of clutch slipping: Excessive engine revving when releasing the clutch in gear without the vehicle moving properly; vehicle speed not matching engine sound",
chapter26List44: "Causes of clutch slipping: Worn clutch plates, oil leakage onto the clutch, reduced pressure on the clutch pressure plate",
chapter26List45: "Testing for clutch slipping: Apply the handbrake, start the vehicle, engage first gear, and gradually release the clutch. If the engine stalls at some point, the clutch is not slipping",






chapter27Title: "27. Gear Box",

chapter27Paragraph1: "A vehicle does not always travel on flat roads. Therefore, depending on the uneven conditions of the road, engine power must be increased or decreased and delivered to the wheels accordingly.",

chapter27Paragraph2: "Greater power is required when starting a stationary vehicle or climbing hills, while less engine power is needed when traveling on flat roads or downhill.",

chapter27Paragraph3: "The mechanical device used to vary engine power and create different torque levels to rotate the wheels as required is called the 'gear box'.",

chapter27Image1: PDFViewerImage105,

chapter27Paragraph4: "Generally, a vehicle has four or five forward gears. Gears 1, 2, and 3 are high-torque (high engine power) gears, where wheel turning force is high but speed is low. Gears 4 and 5 provide lower torque but higher speed. The 5th gear is known as the top gear, and in modern vehicles, an additional gear above the top gear known as overdrive may also be available.",

chapter27Paragraph5: "In addition, the reverse gear is also a gear with high torque and low speed.",

chapter27Paragraph6: "A vehicle should always start moving in first gear. It is not possible to drive in higher gears at low speeds or when carrying heavy loads. Similarly, driving long distances in lower gears can cause severe damage to the engine.",

chapter27List11: "Sliding mesh",
chapter27List12: "Constant mesh",
chapter27List13: "Synchromesh",
chapter27List14: "Epicyclic – These are the four main types of gear boxes",

chapter27Paragraph7: "Sliding mesh gear boxes are older designs and require the clutch to be pressed twice when changing gears. Constant mesh gear boxes are used in heavy vehicles, while synchromesh and epicyclic types are commonly used in passenger vehicles.",

chapter27List2:
  - "Importance of having a gear box",

chapter27List31: "To change the speed of the vehicle",
chapter27List32: "To drive the vehicle forward and backward",

chapter27List4:
  - "Reasons why engaging gears becomes difficult",

chapter27List51: "Fault in the clutch",
chapter27List52: "Gear box seizure or jamming",
chapter27List53: "Lack of clutch oil",





chapter28Title: "28. Brakes",
chapter28Paragraph1: "Brakes are used to stop a moving vehicle quickly and to control its speed.",
chapter28Paragraph2: "Types of brake systems.",
chapter28List11: "Mechanical brake systems",
chapter28List12: "Hydraulic brake systems",
chapter28List13: "Pneumatic brake systems",
chapter28Subheading1: "Characteristics of a good braking system",
chapter28Paragraph3: "The ability to stop the vehicle within a short distance in a short time.",
chapter28Paragraph4: "Smooth and instant operation. Effective performance under all road conditions and all weather conditions.",

chapter28List2:
  - "Free movement of the brake pedal should be approximately 1 cm.",

chapter28Subheading2: "Reasons for brake failure",

chapter28List31: "Wear of brake pads or discs",
chapter28List32: "Brake binding or seizure",
chapter28List33: "Loss of brake oil in a hydraulic brake system",
chapter28List34: "Brake fluid leakage",

chapter28Paragraph5: "When brake fluid leaks, applying the brakes causes the vehicle to pull toward the opposite side of the leaking brake.",

chapter28Subheading3: "Reasons for reduction of brake fluid",

chapter28List41: "Leakage",
chapter28List42: "Worn brake washers",
chapter28List43: "Worn brake cylinders",

chapter28Subheading4: "Reasons for the vehicle pulling to one side when brakes are applied",

chapter28List51: "Brake fluid leakage in one wheel",
chapter28List52: "Improper brake adjustment",
chapter28List53: "Excessive wear of a tyre",
chapter28List54: "Incorrect tyre pressure (too low or too high)",
chapter28List55: "Brake seizure in one wheel",

chapter28Paragraph6: "If the brakes suddenly fail while driving, repeatedly press and release the brake pedal several times. Shift to a low gear such as first or second. Apply the handbrake.",

chapter28Paragraph7: "To stop the vehicle quickly, press and release the brake pedal rapidly and intermittently.",

chapter28Subheading5: "What is ABS Braking?",

chapter28Paragraph8: "Anti-Locking Brake System (ABS). In an ABS braking system, the wheels do not lock when brakes are applied.",

chapter28Paragraph9: "If the vehicle starts skidding, release the brakes and turn the steering wheel toward the direction of the skid.",





chapter29Title: "29. Steering Wheel",
chapter29Subheading1: "Handling the steering wheel",
chapter29Paragraph1: "Except when changing gears, the driver’s hands should remain on the steering wheel at all times.",
chapter29Paragraph2: "The steering wheel should always be handled using the push-and-pull method. The hands should never cross over each other in a crisscross manner.",
chapter29Paragraph3: "When driving a heavy vehicle, the hands should be placed on the steering wheel at the 9:15 position, as indicated on a clock.",
chapter29Paragraph4: "When driving a light vehicle, the hands should be positioned at the 10:10 position.",
chapter29Paragraph5: "However, if the vehicle is equipped with airbags that deploy during an emergency, the hands must be placed on the steering wheel at the 8:20 position. Otherwise, if the airbag deploys suddenly, the hands will be the first to be injured.",





chapter30Title: "30. Battery",

chapter30List1Title: "Importance of the battery",
chapter30List1: "To start the engine and to operate lights, horn, and other electrical components.",

chapter30List2Title: "The battery becomes overcharged when",
chapter30List2:
  "Excessive electrical current is supplied to the battery.",

chapter30List3Title: "When the battery does not charge",
chapter30List31: "Check the battery connecting wires",
chapter30List32: "Check the battery water (electrolyte) level",
chapter30List33: "Check the alternator",
chapter30List34: "Check the fan belt",

chapter30List4Title: "If the main lights, horn, indicators, and all electrical components do not function",
chapter30List4:
  "The battery may be discharged or the connecting wires may be loose.",

chapter30List5Title: "If only one of the above components is not working",
chapter30List5:
  "That component may be burnt out or the relevant fuse may have blown.",

chapter30List6Title: "If an electrical leakage (short circuit) is detected in the vehicle",
chapter30List6:
  "Immediately stop the vehicle, switch off the engine, and disconnect the battery terminal wires.",

chapter30List7Title: "Battery charging condition",
chapter30List7:
  "When the ignition key is turned on, the red warning light that illuminates and then goes off indicates that the battery is in proper charging condition.",




 
  
chapter31Title: "31. Drive Systems",
chapter31Paragraph1: "At first glance, when a vehicle is in motion, it may appear that all four wheels are rotating using engine power. However, only vehicles equipped with four-wheel drive (4WD – 4×4) have all four wheels driven by the engine.",
chapter31Paragraph2: "In all other vehicles, only one pair of wheels is driven by engine power. The wheels that receive engine torque and provide motion are known as the driven wheels. The other pair is referred to as the non-driven wheels.",
chapter31Paragraph3: "Based on the position of the driven wheels powered by the engine, vehicles are mainly classified into three types.",
chapter31ListTitle: "Types of vehicle drive systems",
chapter31List1: "Front-wheel drive",
chapter31List2: "Rear-wheel drive",
chapter31List3: "Four-wheel drive (4×4)",




chapter32Title: "32. Tyres",
chapter32Paragraph1: "Factors to be considered when purchasing tyres.",
chapter32ListTitle1: "Factors to consider when purchasing tyres",
chapter32List11: "Tyre brand",
chapter32List12: "Tyre quality",
chapter32Paragraph2: "If the tread pattern is evenly distributed across the tyre, it is called a symmetrical tread pattern. If the tread pattern differs on each side of the tyre, it is called an asymmetrical tread pattern. When fitting an asymmetrical tyre, the side marked 'Inside' must face inward and the side marked 'Outside' must face outward.",
chapter32Title2: "3). Traction Rate",
chapter32Paragraph3: "This indicates the stopping ability on wet surfaces. A higher traction rating allows the vehicle to stop within a shorter distance. Traction ratings are classified as AA, A, B, and C. AA is the highest rating and C is the lowest. For Sri Lankan road conditions, tyres rated AA or A are most suitable.",

chapter32ThreadWearTitle: "4). Tread Wear Rate",
chapter32ThreadWearParagraph: "This indicates the durability of the tread grooves. A higher value means longer tread life.",

chapter32TemperatureTitle: "5). Temperature Resistance",
chapter32TemperatureParagraph: "This rating is classified as A, B, and C.",
chapter32TemperatureList11: "A – Suitable for high-temperature regions",
chapter32TemperatureList12: "B – Suitable for moderate climatic regions",
chapter32TemperatureList13: "C – Suitable for cold climatic regions",

chapter32TemperatureNote: "For our country, tyres with a B rating are the most suitable.",

chapter32LoadSpeedTitle: "6). Max Load Capacity & Speed Index",
chapter32LoadSpeedList1: "Max Load Capacity – The maximum load a tyre can carry",
chapter32LoadSpeedList2: "Speed Index – The maximum speed at which the tyre can carry the specified maximum load",

chapter32LoadParagraph: "The symbols marked on the tyre indicating the maximum load capacity and their corresponding load values are shown in the tables below.",

chapter32LoadImages:[
  - PDFViewerImage106,
  - PDFViewerImage107,
  - PDFViewerImage108,
  - PDFViewerImage109
],
chapter32SpeedParagraph: "The symbols marked on the tyre indicating the speed index and their corresponding speeds are shown in the tables below.",

chapter32SpeedImages:[
  - PDFViewerImage110,
  - PDFViewerImage111,
  - PDFViewerImage112,
],

chapter32ManufactureTitle: "7). Date of Manufacture",
chapter32ManufactureParagraph1: "Generally, a tyre expires four years after the date of manufacture.",
chapter32ManufactureParagraph2: "In the current market, 'regrooved tyres' and 'retreaded tyres' are commonly available. Retreaded tyres may be used, but very cheap regrooved tyres should never be used under any circumstances.",
chapter32ManufactureParagraph3: "All tyre data is permanently marked on the tyre. Since these markings may vary depending on the manufacturer and country, they should be read and understood carefully.",

chapter32DateCodeParagraph: "The date of manufacture is indicated by a four-digit number. For example, 3705 indicates the 37th week of the year 2005.",

chapter32DateImages:
  - PDFViewerImage113,

chapter32DateCodeParagraph2: "3705 – A tyre manufactured in the 37th week of the year 2005.",
chapter32DateCodeParagraph3: "A longer serial number is also marked on the tyre as shown below.",

chapter32DateImages2:
  - PDFViewerImage114,

chapter32DateCodeParagraph4: "Another example of a long serial number marked on a tyre is shown below.",

chapter32DateImages3:
  - PDFViewerImage115,

chapter32AirPressureTitle: "Checking Air Pressure",
chapter32AirPressureParagraph: "Generally, tyre air pressure should be checked at least once every two weeks.",

chapter32AirPressureList1: "Excessive air pressure",
chapter32AirPressureList2: "Low air pressure",
chapter32AirPressureList3: "Incorrect wheel alignment",
chapter32AirPressureList4: "Weak shock absorbers, leaf springs, or coil springs",
chapter32AirPressureList5: "Driving with low air pressure",
chapter32AirPressureList6: "Rapid tyre wear due to incorrect wheel alignment",
chapter32AirPressureList7: "Tyres should be inspected at least once every two weeks",

chapter32RotationTitle: "Tyre Rotation",
chapter32RotationParagraph: "Generally, tyres should be rotated every 8,000 kilometers. All tyres used for rotation should be of the same type and wear level.",
chapter32RotationImage: PDFViewerImage116,





chapter33Title: "33. Dashboard Indicators",

chapter33Paragraph1: "The main indicators visible on the dashboard are listed below.",

chapter33Image: PDFViewerImage117,

chapter33ListTitle: "Important Points Related to Dashboard and Vehicle",

chapter33List11: "What is a 4×4 vehicle? A vehicle in which engine power is delivered to all four wheels.",
chapter33List12: "In a diesel vehicle, if the diesel runs out and air enters the pump? Refill diesel, remove air from the pump, and then drive.",
chapter33List13: "Function of the differential? To maintain balanced speed between two wheels on a turn.",
chapter33List14: "When both side mirrors and the inner mirror are properly adjusted, the driver can view the entire 360-degree range around the vehicle, including the front.",
chapter33List15: "Even in vehicles equipped with airbags, seat belts must be worn at all times.",
chapter33List16: "Airbags contain Nitrogen (N2) gas.",
chapter33List17: "If the vehicle catches fire, take immediate action.",
chapter33List18: "Covering rear windows with stickers or curtains is illegal.",
chapter33List19: "Installing protective bars on the front of the vehicle is illegal.",
chapter33List10: "A blind person can be identified by a white cane or by being accompanied by a guide dog.",
chapter33List111: "Basic rule at a roundabout? Right-hand rule – give way to vehicles coming from the right.",
chapter33List121: "If a red bulb lights up on the meter panel/dashboard while driving, stop the vehicle and identify the fault.",
chapter33List1311: "When refueling the vehicle, the engine must be switched off.",
chapter33List141: "If a burning smell occurs due to an electrical fault, disconnect the battery wires.",
chapter33List151: "The air release certificate or smoke certificate must always be kept in the vehicle.",
chapter33List161: "On ambulances, fire engines, police or military vehicles only, sirens may be used; no other vehicle may be fitted with devices emitting harsh, frightening, or excessive sounds.",
chapter33List171: "Driving vehicles that emit smoke, fumes, waste, fire, ash, cinders, grease, or oil-containing substances is prohibited.",
chapter33List181: "The sound from installed audio devices (radio) must not leak outside the vehicle."
,




chapter34Title: "34. Detaining Drivers",
chapter34SubTitle: "Situations where a police officer may detain a driver",
chapter34List11: "When the driver does not provide their name and address when asked or the information provided is reasonably suspected by the police officer to be false.",
chapter34List12: "When the air pressure is high.",
chapter34List13: "Being involved in an accident causing death or serious injury.",
chapter34List14: "When the driver has consumed alcohol or drugs or is reasonably suspected by the police officer to have done so.",
chapter34List15: "According to the opinion of the police officer, possessing forged or counterfeit documents or fake number plates.",
chapter34List16: "According to the opinion of the police officer, possessing a motor vehicle with a chassis number or engine number that has been tampered with or slightly altered.",
chapter34List17: "When the police officer reasonably suspects that the driver possesses a stolen vehicle.",
chapter34Paragraph1: "A police officer has the authority to detain a driver at a police station for a reasonable period for an inspection or investigation of a motor vehicle.",




chapter35Title: "35. Vehicle Maintenance",
chapter35Paragraph1: "A person driving a vehicle is not always a motor mechanic, so they do not need to be 100% aware of their vehicle. It is sufficient to be aware of how to act in an emergency and how to properly maintain the vehicle.",
chapter35Paragraph2: "If the vehicle comes with a manual, read and understand it.",
chapter35Paragraph3: "At a minimum, perform the following checks at least once a week.",
chapter35SubTitle1: "Basic weekly checks (P O W E R)",

chapter35List11: "P – Fuel ",
chapter35List12: "O – Oil ",
chapter35List13: "W – Water ",
chapter35List14: "E – Electricity ",
chapter35List15: "R – Rubber",

chapter35Paragraph41: "Whenever the vehicle is sent for service or repair, record the details in a logbook reserved for the vehicle.",

chapter35Paragraph42: "Always use the specified grade of oil and approved spare parts recommended by the vehicle manufacturer during servicing.",

chapter35Paragraph43: "Modern vehicles have parts that can be damaged if water enters the engine. Be careful when servicing. Whenever possible, take the vehicle to an authorized service center and stay with the vehicle until the work is completed.",

chapter35Paragraph5: "The values listed here are indicative. They may vary depending on the vehicle model.",

chapter35List51: "Engine oil – every 5,000 Km",
chapter35List52: "Engine oil filter – every 10,000 Km",
chapter35List53: "Fuel filter – according to vehicle model",
chapter35List54: "Air cleaner – every 40,000 Km",
chapter35List55: "Gear box oil – every 40,000 Km",
chapter35List56: "Brake oil – every 40,000 Km",

chapter35Paragraph6: "A properly maintained vehicle will save both your time and money.",



    }
]; 
export const TamilData = [
    {name: "",
        chapter1Title: "1. ஓட்டுநர்களை சாலை குற்றவாளிகளாக மாற்றும் காரணிகள்",

paragraph1:
  "ஒரு வாகனத்தை இயக்கும் நபரால் விபத்து ஏற்பட பல காரணிகள் உள்ளன. அவற்றில் முக்கியமாக தாக்கம் செலுத்தும் சில காரணிகளை கீழ்வருமாறு சுருக்கமாக குறிப்பிடலாம்.",

subheading1:
  "1) சாலை விதிகளை பின்பற்றாதது",

paragraph2:
  "இந்த விடயத்தில் ஓட்டுநர்களும் பாதசாரிகளும் சமமாக பொறுப்புடையவர்களாக உள்ளனர். நடைபெறும் சாலை விபத்துகளில் பெரும்பாலானவை, எந்தவொரு தரப்பினராலும் சாலை விதிகள் மீறப்படுவதாலேயே ஏற்படுகின்றன. சாலைப் பயனாளர்களுக்கு சாலை விதிகள் பற்றிய போதிய அறிவு இல்லாமையும், சட்டத்தை விருப்பத்துடன் புறக்கணிப்பதும் காரணமாக அடிக்கடி விபத்துகள் ஏற்படுகின்றன.",

paragraph3:
  "சாலைப் பயனாளர்களுக்கு சாலை விதிகள் பற்றிய போதிய அறிவு இல்லாமையும், சட்டத்தை வேண்டுமென்றே புறக்கணிப்பதாலும் அடிக்கடி விபத்துகள் ஏற்படுகின்றன.",

paragraph4:
  "பல்வேறு மனநிலை குறைபாடுகள் அல்லது தாழ்வு மனப்பான்மை கொண்ட சிலர், தங்களது அகந்தையை வெளிப்படுத்தும் வழியாக சாலையில் வாகனங்களை ஓட்டுகின்றனர். அளவில் பெரிய பேருந்துகள், லாரிகள் போன்ற வாகனங்களை இயக்கும் ஓட்டுநர்கள், மற்ற அனைத்து வாகனங்களும் தங்களுக்கு முன்னுரிமை வழங்க வேண்டும் என்ற எண்ணத்துடன் ஓட்டுவதும் சாலை விபத்துகளுக்கான இன்னொரு காரணமாகும்.",

subheading2:
  "2) கைபேசி பயன்பாடு",

paragraph5:
  "எந்த விதமான முறையிலே கைபேசியைப் பயன்படுத்தினாலும் (Handfree mode, Headset), அது எப்போதும் ஓட்டுநரின் கவனத்தை குறிப்பிடத்தக்க அளவில் சிதறடிக்கிறது. ஆய்வுகளின் படி, இது விபத்து அபாயத்தை அதிகரிக்கிறது.",

subheading3:
  "3) மயக்கப் பொருட்கள் பயன்பாடு",

paragraph6:
  "சாலை விபத்துகள் ஏற்படுவதற்கான மற்றொரு முக்கிய காரணியாக மயக்கப் பொருட்கள் பயன்பாடு உள்ளது. மதுபானம், கஞ்சா, ஹெரோயின் போன்ற மயக்கப் பொருட்கள், ஓட்டுநரின் கவனம், தீர்மானம் எடுக்கும் திறன் மற்றும் உடல் செயல்பாடுகளை குறைக்கின்றன.",

paragraph7:
  "இரத்தத்தில் உள்ள ஆல்கஹால் அளவு 0.05g/dl ஐ விட அதிகமாக இருக்கும் போது, ஒருவரின் எதிர்வினை செயல்திறன் கடுமையாக குறைகிறது.",

subheading4:
  "4) ஓட்டுநர் சோர்வு",

paragraph8:
  "தொடர்ச்சியாக நீண்ட நேரம் வாகனம் ஓட்டுவதால் ஓட்டுநர் சோர்வு ஏற்படலாம். இது உடல் மற்றும் மன சோர்வால் ஏற்படும் கவனக் குறைவாகும்.",

paragraph9:
  "குறிப்பாக நீண்ட தூரம் பயணிக்கும் பேருந்து மற்றும் சரக்கு வாகன ஓட்டுநர்கள், ஓட்டுநர் சோர்வுக்கு அதிகமாக உள்ளாகும் வாய்ப்பு உள்ளது.",

paragraph10:
  "ஓட்டுநரின் செயல்திறன் குறைவடையும் போது, விபத்து ஏற்படும் சாத்தியம் அதிகரிக்கிறது. எனவே, ஓட்டுநர் சோர்வு சாலை விபத்துகளுக்கான நெருங்கிய தோழனாகும்.",

subheading5:
  "5) குறைபாடுகள் உள்ள மற்றும் தரநிலைக்கு உட்படாத வாகனங்கள்",

paragraph11:
  "குறைபாடுகள் உள்ள அல்லது சரியாக பராமரிக்கப்படாத வாகனங்களால் விபத்துகள் ஏற்படும் வாய்ப்பு உள்ளது. சரியான நிலையில் இல்லாத பிரேக், டயர், விளக்கு அமைப்புகள் கொண்ட வாகனங்களை இயக்குவது தடை செய்யப்பட்டுள்ளது.",

subheading6:
  "6) குறைபாடுகள் உள்ள சாலை நிலை",

paragraph12:
  "சுத்தமாக இல்லாத சாலைகள், குழிகள், நீர் தேக்கம் அல்லது வெளிச்சம் இல்லாத சாலைகள் விபத்துகள் ஏற்பட காரணமாகின்றன. எனவே, சரியான சாலை பராமரிப்பு அவசியமாகும்.",




chapter2Title:
  "2. சாலைத் தீவிரவாதத்தை கட்டுப்படுத்த முடியாதா? முடியும்",

chapter2Paragraph1:
  "சாலை விபத்துகளில் 85%க்கும் அதிகமானவை தவிர்க்கக்கூடியவையாகும். அதாவது, அந்த விபத்துகளுக்குக் காரணமாக இருப்பது ஓட்டுநரின், வாகனத்தின், பயணிகளின் அல்லது அந்தப் பக்கங்களின் ஒன்றுக்கும் மேற்பட்ட தவறுகளாகும்.",

chapter2Paragraph2:
  "எவ்வாறாயினும், சாலை விபத்துகளில் பெரும்பாலானவை ஓட்டுநரின் கவனக்குறைவினாலேயே ஏற்படுகின்றன. அல்லது அனுபவமின்மையினாலேயே.",

chapter2Paragraph3:
  "தமது ஓட்டும் திறன் குறித்தும், தமது வாகனம் குறித்தும் அளவுக்கு மீறிய உயர்ந்த மதிப்பீட்டில் இருக்கும் சிலர், அதனால் திடீரென சாலை விபத்துகளை சந்திக்கின்றனர்.",

chapter2Paragraph4:
  "பல புதிய ஓட்டுநர்கள் எவ்வளவு வேகத்தில் சென்றாலும் பிரேக் பயன்படுத்திய உடனே வாகனத்தை நிறுத்த முடியும் என்று நினைக்கின்றனர். எவ்வளவு நவீன தொழில்நுட்பம் கொண்ட வாகனமாக இருந்தாலும், நினைத்த உடனே அதை நிறுத்த முடியாது.",

chapter2Paragraph5:
  "இயங்கிக்கொண்டிருக்கும் ஒரு வாகனம் நிறுத்தப்படும்போது, அதில் உள்ள இயக்க சக்தி பூஜ்ஜியமாக மாறுகிறது. அது இயக்க சக்தி, நிலை சக்தி, வெப்ப சக்தி மற்றும் ஒலி சக்தியாக மாற்றப்படுவதால் ஆகும்.",

chapter2Paragraph6:
  "இயங்கிக்கொண்டிருக்கும் வாகனத்தை பிரேக் பயன்படுத்தி நிறுத்தும்போது, அது முழுமையாக நிலைபெறும் முன் பயணிக்கும் தூரம் குறித்து தெளிவான புரிதல் இருக்க வேண்டும்.",

chapter2Image1:
  PDFViewerImage1,

chapter2Paragraph7:
  "தற்போது மோட்டார் வாகன உற்பத்தியாளர்கள், வாகனங்களில் பல பாதுகாப்பு அமைப்புகளை இணைக்கின்றனர். ABS பிரேக் அமைப்பு, காற்று பைகள், நவீன சீட் பெல்ட்கள், அதிக பாதுகாப்பு கொண்ட இருக்கை அமைப்புகள், பலப்படுத்தப்பட்ட வாகன கட்டமைப்பு, ஓட்டுநர் செயல்திறனை பகுப்பாய்வு செய்யும் கணினி மென்பொருட்கள் போன்றவை அதில் அடங்கும்.",

chapter2Paragraph8:
  "எவ்வளவு தொழில்நுட்ப பாதுகாப்பு முறைகள் பயன்படுத்தப்பட்டாலும், விபத்துகளின் எண்ணிக்கையில் குறைவு காணப்படவில்லை. தவறு வாகனம் ஓட்டும் உங்களிடமே உள்ளது. ஏனெனில், உங்கள் வாகனம் உயிரற்ற பொருள்; ஆனால் நீங்கள் உயிருள்ள உயிரினமாக இருக்கிறீர்கள்.",





chapter3Title:
  "3. சாலை விபத்துகளை ஏற்படுத்தும் நிரந்தர அபாயம் – “ஓட்டுநர் சோர்வு”",

chapter3Paragraph1:
  "ஓட்டுநரின் நித்திரை நிலை காரணமாகவோ அல்லது செயலற்ற தன்மை காரணமாகவோ ஏற்படும் மரணகரமான சாலை விபத்துகள் தினந்தோறும் பதிவாகுகின்றன. இவ்வாறு ஓட்டுநர் வாகனம் ஓட்டும் போது செயலற்ற நிலையில் இருப்பது, நித்திரை அடைவது அல்லது செயல்திறன் குறைவது என்பதே “ஓட்டுநர் சோர்வு” என அழைக்கப்படுகிறது.",

chapter3Paragraph2:
  "வாகனம் ஓட்டுவதற்கு தேவையான உடல் மற்றும் மன தகுதி குறித்து கவனம் செலுத்தாததும், வாகனம் ஓட்டுவதற்கு ஏற்ற கால எல்லையை புறக்கணிப்பதும் இதற்கான முக்கிய காரணங்களாகும்.",

chapter3Paragraph3:
  "போதிய உறக்கம் அல்லது ஓய்வு இல்லாமல் நீண்ட நேரம் தொடர்ந்து வாகனம் ஓட்டுதல், இரவு நேரங்களில் வாகனம் ஓட்டுதல், ஒரே மாதிரியான சலிப்பூட்டும் சூழலில் தொடர்ச்சியாக வாகனம் ஓட்டுதல், மது அல்லது நித்திரை ஏற்படுத்தும் மருந்துகளை பயன்படுத்தி வாகனம் ஓட்டுதல் போன்ற காரணங்களால் ஓட்டுநர்கள் தூங்கிவிழுந்து உயிர்க்கொல்லி விபத்துகளை ஏற்படுத்துகின்றனர்.",

chapter3Paragraph4:
  "ஒரு ஓட்டுநர் வாகனம் ஓட்டும் போது தூங்கிவிழுவது திடீரென நடைபெறும் செயல் அல்ல; அது ஒரு செயல்முறையின் இறுதி விளைவாகும். அதாவது, ஓட்டுநர் சோர்வு பல கட்டங்களைக் கொண்ட நிலையாகும். தாம் சோர்வடைந்துள்ளோம் என்பதை உணர்த்தும் அறிகுறிகள் தோன்றும் உடனே, விரைவாக வாகனம் ஓட்டுவதை நிறுத்தி போதிய ஓய்வு எடுப்பது ஓட்டுநரின் பொறுப்பாகும்.",

subheading7:
  "ஓட்டுநர் சோர்வின் அறிகுறிகள்",

subheading7List1:
  "ஆவல் விடுதல்",

subheading7List2:
  "சோர்வாக உணர்வு ஏற்படுதல்",

subheading7List3:
  "சாலையில் கடந்த சில கிலோமீட்டர்கள் குறித்து நினைவில்லாமை",

subheading7List4:
  "சாலை குறியீடுகளின் மீது உள்ள கவனம் குறைவது",

subheading7List5:
  "கண்களை திறந்து வைத்திருக்க சிரமம் ஏற்படுதல்",

subheading7List6:
  "வாகனத்தை சரியான ஓட்டுப்பாதையில் வைத்திருக்க முடியாத நிலை",

subheading7List7:
  "முன்பக்க கண்ணாடி தெளிவில்லாமல் தோன்றுதல்",

subheading7List8:
  "இறுதியில் தூங்கிவிழுதல்",

paragraph24:
  "மேலே குறிப்பிடப்பட்ட அறிகுறிகளை அனுபவித்தும் தொடர்ந்து வாகனம் ஓட்டினால், அவர் தமது மற்றும் பிற பலரின் உயிர்களை அழிக்கும் பெரும் ஆபத்தாளராக மாறுகிறார்.",

subheading8:
  "ஓட்டுநர் சோர்வைத் தடுக்கும் வழிகள்",

subheading8List1:
  "நீண்ட பயணம் மேற்கொள்ள வேண்டுமெனில் அதற்காக முறையாக முன்தயாரிப்பு செய்யுங்கள்.",

subheading8List2:
  "போதிய உறக்கம் பெறுங்கள்.",

subheading8List3:
  "எந்த சூழலிலும் மது அல்லது நித்திரை ஏற்படுத்தும் மருந்துகளை பயன்படுத்தி வாகனம் ஓட்டுவதை தவிர்க்குங்கள்.",

subheading8List4:
  "நீண்ட பயணங்களில் இயன்றால் ஓட்டுநருக்கு உதவியாளரையும் சேர்த்துக் கொள்ளுங்கள்.",

subheading8List5:
  "இயன்றவரை காலை நேரத்தில் பயணத்தை தொடங்குங்கள். மாலை மற்றும் இரவு நேரங்கள் ஓய்விற்காக ஒதுக்கப்பட வேண்டும்.",

subheading8List6:
  "குறைந்தது மூன்று மணி நேரத்திற்கு ஒருமுறை라도 வாகனம் ஓட்டுவதை நிறுத்தி ஓய்வு எடுங்கள். வாகனத்திலிருந்து வெளியே வந்து இதை செய்யுங்கள்.",

subheading8List7:
  "ஓட்டும் போது நித்திரை உணர்வு ஏற்பட்டால், பக்கமாக நிறுத்தி வாகனத்தை நிறுத்தி குறுகிய தூக்கம் எடுங்கள் (30 நிமிடங்களுக்கு மேல் அல்ல).",

subheading8List8:
  "சாக்லேட், காபி, தேநீர் போன்ற கஃபைன் பானங்கள் தற்காலிகமாக உற்சாகம் அளித்தாலும், அது ஒரு தற்காலிக தீர்வாக மட்டுமே இருக்கும்.",





chapter4Title:
  "4. சாலையில் ஆவேசம் காட்டும் ஓட்டுநர்கள் – சாலை ஆவேசம் (Road Rage)",

chapter4Paragraph1:
  "சாலை விதிகளை சிறிதும் மதிக்காமல், பிறருக்கு இடையூறு ஏற்படுத்தியும் அல்லது திட்டமிட்டு விபத்துகளை ஏற்படுத்தியும் வாகனங்களை ஓட்டும் சில ஓட்டுநர்களை நீங்கள் கண்டிருப்பீர்கள் என்பதில் சந்தேகமில்லை.",

chapter4Paragraph2:
  "சாலை போக்குவரத்து விளக்கில் பச்சை விளக்கு எரிந்தும் நின்றுகொள்வது, மிக அதிக வேகத்தில் அல்லது மிக மந்தமாக வாகனம் ஓட்டுதல், வாகனங்களை துரத்திச் செல்வது, பிற ஓட்டுநர்களின் சிறிய தவறு அல்லது கவனக்குறைவுகளுக்கே உடனடியாக கோபம் காட்டுதல் போன்ற அறிகுறிகளை வெளிப்படுத்துவோரை “ஆவேசமான ஓட்டுநர்கள்” என அழைக்கப்படுகின்றனர்.",

chapter4Paragraph3:
  "இவ்வாறு ஆவேசமான ஓட்டுநர்கள் உருவாகுவதற்கான முக்கிய காரணம் “சாலை ஆவேசம்” ஆகும். ஒரு ஓட்டுநர் சாலை ஆவேசம் கொண்ட நபராக மாறுவது பெரும்பாலும் அவருக்குள் இருக்கும் சமூக அல்லது மனநல பலவீனங்களின் காரணமாகும்.",

chapter4Paragraph4:
  "இத்தகைய நபர்கள் சாலையில் வாகனம் ஓட்டும் போது தனிமையடைந்தவர்களாகவும், மன அழுத்தத்தில் உள்ளவர்களாகவும் மாறுவதாகவும், அதனால் அவர்கள் பிற ஓட்டுநர்களிடம் ஆவேசமான நடத்தை காட்டுவதாகவும் உளவியலாளர்கள் கூறுகின்றனர்.",

chapter4Paragraph5:
  "ஒரு ஆவேசமான ஓட்டுநர் என்பது ஒரு மோசமான ஓட்டுநரே. அத்தகைய ஒருவர் உங்கள் பின்னால் வாகனம் ஓட்டினால், உங்கள் வாகனத்தின் வேகத்தை குறைத்து பக்கமாக நகர்ந்து அவரை உங்களை முந்திச் செல்ல அனுமதிப்பதே சிறந்த நடவடிக்கையாகும்.",

chapter4Paragraph6:
  "எப்போதும் உங்கள் மற்றும் உங்கள் வாகனத்தின் பாதுகாப்பைப் பற்றி சிந்தியுங்கள். ஒரு ஆவேசமான நபருக்கு சவால் விடுவது அல்லது பழிவாங்கும் எண்ணத்துடன் செயல்படுவது புத்திசாலித்தனமான செயல் அல்ல.",

chapter4Subheading1:
  "ஒரு ஆவேசமான ஓட்டுநரை அடையாளம் காணும் விதம்",

chapter4List1:
  "மிக அதிக வேகத்தில் வாகனம் ஓட்டுவார்.",

chapter4List2:
  "சாலை விதிகளை மீறி பிற ஓட்டுநர்களுக்கு இடையூறு ஏற்படுத்துவார்.",

chapter4List3:
  "தேவையில்லாமல் ஹார்ன் அடித்து வாகனம் ஓட்டுவார்.",

chapter4List4:
  "வாகனத்திற்கும் பிற ஓட்டுநர்களுக்கும் ஏற்படும் சேதத்தைப் பற்றி சிந்திக்காமல் வாகனம் ஓட்டுவார்.",

chapter4List5:
  "அபாயகரமான முறையில் மிக அருகில் வாகனம் ஓட்டுவார்.",

chapter4List6:
  "சிறிய தவறுகள் அல்லது கவனக்குறைவுகளின் போது பிற ஓட்டுநர்களுடனும் பாதசாரிகளுடனும் கோபப்படுவார்.",

chapter4List7:
  "ஆவேசமான, அசிங்கமான அல்லது மிரட்டும் சைகைகளை காட்டுவார்.",

chapter4List8:
  "மிக அதிக வேகத்தில் வாகனம் ஓட்டுவார்.",

chapter4Subheading2:
  "சாலை ஆவேசத்தைத் தடுக்கும் வழிகள்",

chapter4List9:
  "மன அமைதியுடன் வாகனத்தில் ஏறுங்கள்.",

chapter4List10:
  "வாகனம் உங்கள் மன அழுத்தத்தை குறைக்கவோ அல்லது பிறரை மன அழுத்தத்திற்கு உள்ளாக்கவோ பயன்படும் கருவி அல்ல என்பதை புரிந்துகொள்ளுங்கள்.",

chapter4List11:
  "எந்த சூழலிலும் மது அல்லது போதைப்பொருள் பயன்படுத்தி வாகனம் ஓட்டுவதை தவிர்க்குங்கள்.",

chapter4List12:
  "வாகனத்திற்கும் பிற ஓட்டுநர்களுக்கும் ஏற்படும் சேதத்தைப் பற்றி சிந்திக்காமல் ஓட்ட வேண்டாம்.",

chapter4List13:
  "வாகனத்தில் மிக அதிக சத்தத்தில் இசை ஒலிக்கச் செய்வது உங்கள் மனதை குழப்பக்கூடும்.",

chapter4List14:
  "சாலையில் கோபப்பட வேண்டாம் என முடிவு செய்யுங்கள். தவறுதலாக ஏதாவது நடந்தாலும் அது மீண்டும் நடக்காதவாறு கவனியுங்கள்.",

chapter4List15:
  "பிற ஓட்டுநர்கள் அல்லது பாதசாரிகளின் தவறுகளின் போது பொறுமையும் சகிப்புத்தன்மையும் ஒரு நல்ல முன்னுதாரணம் என்பதை நினைவில் கொள்ளுங்கள்.",

chapter4List16:
  "துரத்த வேண்டும் என்ற எண்ணம் தோன்றும் போது, உங்கள் வாழ்க்கையின் மதிப்பை நினைத்து அமைதியாக வாகனம் ஓட்டுங்கள்.",




  chapter5Title:
  "5. கல்லறைக்கு வழி காட்டும் பேய் – போதைப்பொருட்கள்",

chapter5Paragraph1:
  "தினசரி பதிவாகும் சாலை விபத்துகளில் பெரும்பாலானவற்றிற்கான காரணமாக கண்டறியப்பட்டுள்ளதே போதைப்பொருட்கள் – அல்லது மது அருந்துதலாகும்.",

chapter5Paragraph2:
  "பயணம் தொடங்குவதற்கு முன் “சாலைக்காக ஒன்று” என்று கூறி மது அருந்தும் பழக்கம் சிலரிடையே காணப்படுகிறது. உயிர்களை அழிக்கும் இத்தகைய பழக்கம் வெளிநாடுகளிலிருந்து நமக்கு பரவிய ஒரு அழிவாகும்.",

chapter5Paragraph3:
  "ஒரு ஓட்டுநருக்கு எப்போதும் தெளிவான பார்வை, நல்ல நினைவாற்றல், சரியான முடிவெடுக்கும் திறன் அவசியமாகும். போதைப்பொருட்கள் இந்த அனைத்து பண்புகளையும் மிக விரைவில் அழிக்கும் சக்தி கொண்டவை.",

chapter5Paragraph4:
  "அரக்கு, கஞ்சா அல்லது ஹெரோயின் என எதனை பயன்படுத்தினாலும் – அதன் விளைவு ஒன்றே: உடலின் செயல்திறன் குறைவதோடு, ஆவேசம் அல்லது சோம்பல் தன்மை அதிகரிப்பதாகும்.",

chapter5Paragraph5:
  "மது அருந்தி வாகனம் ஓட்டுவது ஒரு ஓட்டுநர் செய்யக்கூடிய மிகக் கடுமையான குற்றமாகும். ஒரு ஓட்டுநர் மது அருந்தியிருக்கலாம் என்ற சந்தேகம் ஏற்பட்டால், அதைச் சரிபார்க்க காவல் அதிகாரிக்கு அதிகாரம் உள்ளது.",

chapter5Paragraph6:
  "காவல் அதிகாரிக்கு சந்தேகம் ஏற்பட்டால், அந்த நபரை ஒரு கருவி மூலம் (பாலூன் பரிசோதனை) சோதனை செய்யலாம். அந்த சோதனையை செய்ய மறுத்தால், அந்த நபர் மது அருந்தியுள்ளார் என்று சட்டப்படி முன்கணிப்பு செய்ய அனுமதி வழங்கப்பட்டுள்ளது.",

chapter5Paragraph7:
  "இரண்டாவது முறை அரசாங்க மருத்துவ அதிகாரியின் பரிசோதனை ஆகும். அவர் இரத்த பரிசோதனை செய்து, 100 மில்லிலிட்டர் இரத்தத்தில் 0.08 கிராம் அல்லது அதற்கு மேற்பட்ட ஆல்கஹால் இருப்பதாக கண்டறிந்தால், அந்த நபர் மது அருந்தி வாகனம் ஓட்டியதாக சட்டப்படி குற்றவாளியாகக் கருதப்படுவார்.",

chapter5Paragraph8:
  "மேலும், மருத்துவ பரிசோதனையை மறுக்கும் நபரும் மது அருந்தியதாக முன்கணிப்புக்கு உட்படுத்தப்படலாம். எனினும், போதுமான ஆதாரம் அல்லது சரியான பரிசோதனை இல்லாமல் காவல்துறையினர் குற்றம் சாட்ட முடியாது.",

chapter5Paragraph9:
  "ஒரு காவல் அதிகாரி நீங்கள் மது அருந்தி வாகனம் ஓட்டியதாக குற்றம் சாட்டினால், அந்த நேரத்தில் பாலூன் பரிசோதனை செய்யுமாறு கோருவதற்கு உங்களுக்கு முழு உரிமை உள்ளது.",





 chapter6Title:"6. சட்டப்படி ஓட்டுநராக மாறுதல் மற்றும் ஓட்டுநர் உரிமம் பெறுதல்",

chapter6Paragraph1:"தற்போது வழங்கப்படுவது மின்சார சிப் உடைய “ஸ்மார்ட் கார்ட்” உரிமம் (Smartcard Driving License) ஆகும். இலங்கையில் ஓட்டுநர் உரிமங்களை வழங்கும் முழு அதிகாரமும் மோட்டார் வாகன போக்குவரத்து ஆணையருக்கு உட்பட்டதாகும்.",

chapter6Paragraph2:"ஓட்டுநர் உரிமம் வழங்கப்படும் இரண்டு முக்கிய முறைகள் உள்ளன:\n1️⃣ வெரஹெர பிரதான அலுவலகம் மற்றும் குருநாகல் மாவட்ட அலுவலகம்.\n2️⃣ மாவட்ட செயலாளர் அலுவலகங்கள் மூலம்.",

chapter6Paragraph3:"தகுந்த நடைமுறையின் படி முதலில் பெறக்கூடியது இலகு வாகன உரிமம் ஆகும். கனரக வாகன உரிமத்தை பெற இலகு வாகன உரிமம் பெற்ற பின் 2 ஆண்டுகள் கடந்திருக்க வேண்டும்.",

chapter6Subheading1:"புதிய ஓட்டுநர் உரிமம் பெறுவதற்கான அடிப்படை தேவைகள்",

chapter6List11:"வயது 18 ஆண்டுகள் நிறைவடைந்திருக்க வேண்டும்.",

chapter6List12:"தேசிய அடையாள அட்டை மற்றும் அதன் நகல்.",

chapter6List13:"பிறப்புச் சான்றிதழின் அசல் அல்லது பிரதேச செயலாளர் அலுவலகத்தின் சான்றளிக்கப்பட்ட நகல்.",

chapter6List14:"உடல் தகுதியை உறுதிப்படுத்தும் மருத்துவச் சான்றிதழ் மற்றும் இரத்த அறிக்கை.",

chapter6List15:"மோட்டார் வாகன போக்குவரத்து ஆணையரால் வழங்கப்பட்ட MA30 விண்ணப்பப் படிவம்.",

chapter6List16:"அரசு கட்டணம் செலுத்தி பெற்ற ரசீது.",

chapter6List17:"பாஸ்போர்ட் அளவிலான வெள்ளை பின்னணியுடைய மூன்று புகைப்படங்கள்.",

chapter6Paragraph4:"வயது 17 ஆண்டுகள் நிறைவடைந்தபோது தேவையான ஆவணங்களை சமர்ப்பித்து பதிவு செய்து எழுத்துத் தேர்வில் தேர்ச்சி பெற்றால் “பயிற்சி உரிமம்” (Learner’s Permit) பெறலாம். வயது 18 ஆண்டுகள் நிறைவடைந்த பின் நடைமுறைத் தேர்வில் தோன்ற வேண்டும்.",

chapter6Subheading2:"எழுத்துத் தேர்வு",

chapter6Paragraph5:"எழுத்துத் தேர்வு உங்கள் சாலை விதிகள் தொடர்பான அறிவை பரிசோதிப்பதற்காக நடத்தப்படுகிறது. கனரக வாகன உரிமத்திற்கு விண்ணப்பிக்கும் போது தொழில்நுட்ப அறிவு தொடர்பான கேள்விகளும் இடம்பெறும். அனைத்து கேள்விகளும் பல்தேர்வு (multiple choice) முறையில் உள்ளன.",

chapter6List2:[
  "எழுத்துத் தேர்வில் தேர்ச்சி பெற்றால் “L” பலகைகள் மற்றும் பயிற்சி உரிமம் வழங்கப்படும்.",
  "நடைமுறைத் தேர்விற்கு முன் அந்த L பலகைகள் மற்றும் உரிமம் மீண்டும் ஒப்படைக்க வேண்டும்."
],

chapter6Subheading3:"கனரக வாகன ஓட்டுநர் உரிமம் பெறுவதற்கான தேவைகள்",

chapter6List31:"வயது 21 ஆண்டுகள் நிறைவடைந்திருக்க வேண்டும்.",

chapter6List32:"இலகு வாகன உரிமம் பெற்ற பின் 2 ஆண்டுகள் கடந்திருக்க வேண்டும்.",

chapter6List33:"தேசிய போக்குவரத்து மருத்துவ நிறுவனத்திலிருந்து அல்லது போக்குவரத்து சபையிலிருந்து வழங்கப்பட்ட மருத்துவச் சான்றிதழ்.",

chapter6List34:"முறையாக பூர்த்தி செய்யப்பட்ட MA34 விண்ணப்பப் படிவம்.",

chapter6List35:"தேசிய அடையாள அட்டை.",

chapter6List36:"அரசு கட்டண ரசீது.",

chapter6List37:"இலகு வாகன உரிமம்.",

chapter6List38:"அங்கீகாரம் பெற்ற ஓட்டுநர் பயிற்சி நிலையத்திலிருந்து பெறப்பட்ட திறன் சான்றிதழ்.",

chapter6Paragraph6:"கனரக வாகன ஓட்டுநர்களுக்கான குறைந்தபட்ச உயரம்:\n• பேருந்து மற்றும் லாரிகளுக்கு — 5 அடி.\n• இலகு பேருந்து மற்றும் லாரிகளுக்கு — 4 அடி 10 அங்குலம்.",

chapter6Paragraph7:"பயிற்சி உரிமம் பெற்ற பின் 3 மாதங்கள் கடந்தால் நடைமுறைத் தேர்வில் தோன்றலாம். தேர்ச்சி பெற்றால் 6 மாதங்களுக்கு செல்லுபடியாகும் தற்காலிக உரிமம் வழங்கப்படும். நிரந்தர உரிமம் பின்னர் தபால் மூலம் வழங்கப்படும்.",

chapter6Subheading4:"வெளிநாட்டவர்களுக்கு ஓட்டுநர் உரிமம் பெறுதல்",

chapter6List44:"கனரக வாகன உரிமம் கொண்டவர்களுக்கு இலகு வாகன உரிமம் மட்டுமே வழங்கப்படும்.",

chapter6List45:"செல்லுபடியாகும் வெளிநாட்டு ஓட்டுநர் உரிமம் அவசியம் (தற்காலிக உரிமங்கள் செல்லாது).",

chapter6List46:"குறைந்தது ஒரு மாதத்திற்கு செல்லுபடியாகும் வீசா இருக்க வேண்டும்.",

chapter6List47:"ஓட்டுநர் உரிமம் வெளிநாட்டு மொழியில் இருந்தால், சான்றளிக்கப்பட்ட ஆங்கில மொழிபெயர்ப்பு வழங்க வேண்டும்.",

chapter6List48:"தேசிய போக்குவரத்து மருத்துவ நிறுவனத்திலிருந்து 6 மாதங்களுக்குள் பெறப்பட்ட தகுதி சான்றிதழ்.",

chapter6List49:"வெளிநாட்டு தூதரக ஊழியர் என்றால், வெளிநாட்டு விவகார அமைச்சின் உறுதிப்பத்திரம்.",

chapter6List50:"இலங்கை குடிமகன் அல்லது இரட்டை குடியுரிமையாளர் என்றால், தேசிய அடையாள அட்டை மற்றும் செல்லுபடியாகும் பாஸ்போர்ட் சமர்ப்பிக்க வேண்டும்.",

chapter6Subheading5:"ஓட்டுநர் உரிமம் புதுப்பித்தல்",

chapter6Paragraph8:"இலகு வாகன உரிமம் — 8 ஆண்டுக்கு ஒருமுறை\nகனரக வாகன உரிமம் — 4 ஆண்டுக்கு ஒருமுறை புதுப்பிக்க வேண்டும். இதற்காக மருத்துவ அறிக்கைகள் சமர்ப்பிக்க வேண்டும்; மீண்டும் நடைமுறைத் தேர்வு தேவையில்லை.",

chapter6Subheading6:"நகல் பெறுதல்",

chapter6List51:"போலீஸ் புகாரின் நகல்.",

chapter6List52:"முறையாக பூர்த்தி செய்யப்பட்ட MA42 விண்ணப்பப் படிவம்.",

chapter6List53:"அரசு கட்டணம் செலுத்தி பெற்ற ரசீது.",

chapter6Subheading7:"தகவல் திருத்தம்",

chapter6List61:"தற்போதைய ஓட்டுநர் உரிமம்.",

chapter6List62:"பெயர் மாற்றத்திற்கு பிறப்புச் சான்றிதழ் / திருமணச் சான்றிதழ் அல்லது பிற சான்றளிக்கப்பட்ட ஆவணங்கள்.",

chapter6List63:"முகவரி மாற்றத்திற்கு கிராம அதிகாரியின் சான்றிதழ்.",

chapter6Subheading8:"புதிய உரிமம் பெறுதல்",

chapter6List71:"தற்போதைய ஓட்டுநர் உரிமம்.",

chapter6List72:"கனரக வாகன உரிமம் என்றால், 6 மாதங்களுக்குள் பெறப்பட்ட தகுதி மருத்துவச் சான்றிதழ்.",

chapter6Subheading9:"டிராக்டர் ஓட்ட உரிமம்",

chapter6Paragraph9:"ஊனமுற்றோர் உரிமம் கொண்டவரை தவிர, ஏதேனும் வாகன வகைக்கு செல்லுபடியாகும் உரிமம் கொண்ட எந்த நபருக்கும் பயிற்றுவிப்பாளராக ஓட்டும் உரிமை உள்ளது.",

chapter6Subheading10:"மேன்முறையீடு சமர்ப்பித்தல்",

chapter6Paragraph10:"ஓட்டுநர் உரிமத் தேர்வில் அநியாயம் நடந்ததாக இருந்தால், 7 நாட்களுக்குள் மோட்டார் வாகன போக்குவரத்து ஆணையருக்கு அல்லது மாவட்ட செயலாளருக்கு மேன்முறையீடு சமர்ப்பிக்கலாம்.",

chapter6Subheading11:"ஓட்டுநர் உரிமம் ரத்து செய்தல்",

chapter6Paragraph11:"நீதிமன்ற உத்தரவு அல்லது மருத்துவ அறிக்கையின் அடிப்படையில், மோட்டார் வாகன போக்குவரத்து ஆணையருக்கு உரிமத்தை ரத்து செய்ய அதிகாரம் உள்ளது. முழுமையாக ரத்து செய்யப்பட்ட உரிமத்தை மீண்டும் பெற முடியாது.",

chapter6Subheading12:"வாகன வகைகள்",

chapter6Image1: PDFViewerImage2,
chapter6Image2: PDFViewerImage3,
chapter6Image3: PDFViewerImage4,
 



chapter7Title: "7. ஓட்டுநர் அபிவிருத்தி புள்ளிகள்",

chapter7Subheading1: "முன்- ஓட்டுநர் தகுதியின்மை புள்ளிகள்",

chapter7Paragraph1:
"2011 அக்டோபர் 05 அன்று வெளியிடப்பட்ட 1726/12 இலக்க வர்த்தமானி அறிவிப்பின் படி ஓட்டுநர் அபிவிருத்தி புள்ளிகள் வழங்கும் சட்டம் அமல்படுத்தப்பட்டுள்ளது. இது \"2011 இலக்கம் 03 கொண்ட மோட்டார் வாகன அபிவிருத்தி புள்ளிகள் விதிமுறை\" என அழைக்கப்படுகிறது.",

chapter7Paragraph2:
"வாகனம் ஓட்டும் போது ஓட்டுநர்கள் செய்யும் தவறுகளுக்கு புள்ளிகள் வழங்கப்பட்டு, அந்த புள்ளிகளின் மொத்தம் 24 ஆகும் போது ஓட்டுநர் உரிமம் ஒரு வருடத்திற்கு இடைநிறுத்தப்படும்.",

chapter7List11:
"பெரும் நெடுஞ்சாலையில் வாகன விபத்துகளைத் தவிர்க்க தேவையான நடவடிக்கைகள் எடுக்கத் தவறுதல் - புள்ளிகள் 6",

chapter7List12:
"பெரும் நெடுஞ்சாலையில் கவனக்குறைவாக அல்லது ஆபத்தான முறையில் அல்லது ஆபத்தான வேகத்தில் மோட்டார் வாகனம் ஓட்டுதல் - புள்ளிகள் 8",

chapter7List13:
"பெரும் நெடுஞ்சாலையை பயன்படுத்தும் பிற நபர்களைப் பொருட்படுத்தாமல் அல்லது நியாயமான கவனம் இன்றி பெரும் நெடுஞ்சாலையில் மோட்டார் வாகனம் ஓட்டுதல் - புள்ளிகள் 8",

chapter7List14:
"பெரும் நெடுஞ்சாலையில் ஏற்பட்ட வாகன விபத்திற்குப் பிறகு வாகனத்தை நிறுத்தத் தவறுதல் மற்றும் தொடர்புடைய தகவல்களை வழங்கத் தவறுதல் - புள்ளிகள் 10.",

chapter7List15:
"விபத்து தொடர்பாக உடனடியாக அருகிலுள்ள காவல் நிலையத்திற்கு அறிவிக்கத் தவறுதல் - புள்ளிகள் 10",

chapter7Subheading2:
"கவனக்குறைவாக வாகனம் ஓட்டுதல் மற்றும் விபத்துகள் என்ற குற்றத்தின் கீழ் வகைப்படுத்தலில் புள்ளிகள் வழங்கப்படுவது பின்வருமாறு.",

chapter7List21:
"சாலை விதிகள் என்ற குற்றத்தின் கீழ் சாலையின் இடது பக்கம் அல்லது அருகிலுள்ள பக்கத்தில் வைத்து வாகனம் ஓட்டத் தவறுதல் - புள்ளிகள் 02",

chapter7List22:
"சாலையில் தெளிவான பார்வை இன்றி பிற வாகனங்களை முந்திச் சென்று வாகனம் ஓட்டுதல் - புள்ளிகள் 06",

chapter7List23:
"பிற வாகனங்களை முந்திச் செல்லும் போது, அந்த வாகனங்களின் வலது பக்கத்தில் இருந்து வலதுபுறமாக சாய்ந்து வாகனம் ஓட்டத் தவறுதல் - புள்ளிகள் 04",

chapter7List24:
"வலது பக்கம் அல்லது அந்த பக்கத்திலிருந்து மேலாக வரும் வாகனங்களுக்கு சந்திப்புகளில் சாலையில் இடம் வழங்கத் தவறுதல் - புள்ளிகள் 04",

chapter7List25:
"நீண்ட தூரம் பெரும் நெடுஞ்சாலையில் வாகனத்தை பின்செலுத்துதல் அல்லது பின்செலுத்துவதற்கு நியாயமான காரணம் இன்றி அனுமதி வழங்குதல் - புள்ளிகள் 4",

chapter7List26:
"தடைசெய்யப்பட்ட, கட்டுப்படுத்தப்பட்ட, கட்டாய அல்லது முன்னுரிமை சைகைகளுக்கு இணங்க செயல்படத் தவறுதல் - புள்ளிகள் 6.",

chapter7List27:
"சைகை வழங்குதல் என்ற குற்றத்தின் கீழ் காவல் அதிகாரி அல்லது வாகன பரிசோதகரால் வழங்கப்பட்ட வாய்மொழி உத்தரவுகள் அல்லது கைச் சைகைகளுக்கு இணங்க செயல்படத் தவறுதல் - புள்ளிகள் 6.",

chapter7List28:
"மாசுபாடு என்ற குற்றத்தின் கீழ் நிர்ணயிக்கப்பட்ட அளவுகளை மீறிய வெளியேற்றங்களுடன் கூடிய மோட்டார் வாகனம் ஓட்டுதல் - புள்ளிகள் 6.",

chapter7List29:
"நிர்ணயிக்கப்பட்ட அளவுகளை மீறும் ஒலி மட்டங்களுடன் வாகனத்தில் ஒலி பெருக்கி சாதனங்களை பயன்படுத்துதல் அல்லது பயன்படுத்த அனுமதித்தல் - புள்ளிகள் 6.",

chapter7List30:
"நிர்ணயிக்கப்பட்ட அளவுகளை மீறி எஞ்சின் மற்றும் ஹார்ன் ஒலியை வெளியிடும் வாகனத்தை பயன்படுத்துதல் - புள்ளிகள் 6.",

chapter7List31:
"சாலையில் அல்லது சாலைக்கு அருகிலுள்ள எந்த நபருக்கும், சொத்திற்கும் அல்லது வாகனத்திற்கும் விபத்து அல்லது சேதம் ஏற்படுத்தக்கூடிய அல்லது ஏற்பட வாய்ப்புள்ள நிலையிலான வாகனத்தை ஓட்டுதல், வாகன தயாரிப்பு மற்றும் பயன்பாடு என்ற குற்றத்தின் கீழ் - புள்ளிகள் 10",



chapter8Title: "8. வாகன விபத்தில் உங்கள் பொறுப்பு",

chapter8Paragraph1:
"வாகன விபத்து ஏற்பட்டால் அதனை அருகிலுள்ள காவல் நிலையத்திற்கு அறிவிப்பது ஓட்டுநர்களின் பொறுப்பாகும். சிறிய விபத்து ஏற்பட்டால், அதில் தொடர்புடைய தரப்புகளின் பரஸ்பர சம்மதத்தின் அடிப்படையில் சமரசம் செய்து கொள்ள முடியும்.",

chapter8Paragraph2:
"வாகன விபத்துகள் தொடர்பான வழக்குகள் மஜிஸ்திரேட் நீதிமன்றத்தில் விசாரிக்கப்படினும், வாகன விபத்திற்கான இழப்பீட்டை பெறுவது மாவட்ட நீதிமன்றத்தில் தாக்கல் செய்யப்படும் வழக்கின் மூலமே சாத்தியமாகும்.",

chapter8Paragraph3:
"வாகன விபத்தில் ஏற்பட்ட சேதங்களை ஈடு செய்ய காப்பீட்டு நிறுவனங்கள் முன்வருகின்றன என்பது உண்மையே. ஆனால் அவர்கள் எப்போதும் காப்பீட்டு ஒப்பந்தத்தில் குறிப்பிடப்பட்ட வரம்புகளுக்கு உட்பட்டே செயல்படுகின்றனர் என்பதை மறக்கக்கூடாது.",

chapter8Paragraph4:
"சில காப்பீட்டு நிறுவனங்கள் முன்கூட்டியே குறிப்பிடப்படாத விதிகளையும் கொண்டு செயல்படுகின்றன என்பதை குறிப்பாக நினைவில் கொள்ள வேண்டும். ஆகவே, உங்கள் காப்பீட்டு நிறுவனத்துடன் மேற்கொண்ட காப்பீட்டு பத்திரத்திற்கு உட்பட்ட அனைத்து விதிமுறைகளையும் பற்றி முழுமையான புரிதலை பெற்றுக்கொள்வது வாகன உரிமையாளர் அல்லது ஓட்டுநராக உங்கள் பொறுப்பாகும்.",

chapter8Paragraph5:
"வாகன விபத்தினால் மரணம் ஏற்பட்டால், சட்டத்தின் படி வாகனம் ஓட்டிய நபர் குற்றவாளி என நிரூபிக்கப்பட்டால், அவருக்கு மரண தண்டனை விதிப்பதற்கும் சட்டப்பூர்வ ஏற்பாடுகள் உள்ளன.",

chapter8Subheading1: "மாரக விபத்து என்றால்",

chapter8Paragraph6:
"\"ஒரு தனிப்பட்ட போக்குவரத்து வாகனம் அல்லது பல வாகனங்கள் தொடர்புடைய விபத்தில், அந்த வாகன விபத்து ஏற்பட்ட நாளிலிருந்து 30 நாட்களுக்குள் ஒருவரோ அல்லது பலரோ உயிரிழந்த விபத்து ஆகும்.\"",







chapter9Title: "9. வாகன கனவைக் கைப்பற்றும் எளிய வழி – லீசிங் (Leasing)",

chapter9Paragraph1:
"லீசிங் (Leasing) என்பது ஒரு வாகனம் அல்லது பிற சொத்துகள் அல்லது சேவைகளை வாங்குவதற்கான எளிய முறையாகும். இன்றைய காலத்தில் பெரும்பாலானோர் வாகனங்களை லீசிங் முறையில் வாங்குகின்றனர். அதாவது லீசிங் நிறுவனங்கள் மூலமாக.",

chapter9Paragraph2:
"இதில், தங்களிடம் உள்ள ஒரு தொகையை முன்பணம் ஆக செலுத்தி வாகனத்தை வாங்கும் வசதி வாங்குபவருக்கு கிடைக்கிறது. லீசிங் ஒப்பந்தத்தின் படி நிர்ணயிக்கப்பட்ட காலத்திற்கான அனைத்து தவணைகளையும் செலுத்தி முடித்த பின், வாகனத்தின் சட்டப்பூர்வ உரிமையாளர் ஆகவும் அவருக்கு வாய்ப்பு உண்டு.",

chapter9Paragraph3:
"எளிமையாக விளக்கினால், இங்கு உண்மையில் நடப்பது என்னவென்றால், லீசிங் நிறுவனம் முழுமையாக பணம் செலுத்தி சம்பந்தப்பட்ட வாகனத்தை வாங்கி, அதன் முழு உரிமையையும் தன்னிடமே வைத்துக்கொண்டு, தவணை முறையில் மதிப்பை செலுத்தும் நிபந்தனையின் அடிப்படையில் அந்த வாகனத்தை மற்றொரு நபருக்கு வழங்குவதாகும்.",

chapter9Paragraph4:
"அதில், அவர் சம்பந்தப்பட்ட தவணைகளை செலுத்தி தனது நிதி பொறுப்பை லீசிங் நிறுவனத்திற்கு நிறைவேற்றிய பின்னர், அவர்கள் அந்த வாகனத்தின் முழு உரிமையையும் அவருக்கு வழங்குவார்கள்.",

chapter9Paragraph5:
"ஒரு தனிநபருக்கு வாகனம் வாங்குவதற்கான மிக எளியதும் விரைவானதும் ஆன வழியாகவும், தனது வருமானத்திற்கு ஏற்ப லீசிங் தவணைகளை அமைத்துக்கொள்ளும் வசதி இருப்பதாலும், இன்றைய காலத்தில் லீசிங் மிகவும் பிரபலமாகி வருகிறது.",

chapter9Subheading1: "லீசிங் நிறுவனத்துடன் பணியாற்றும் போது",

chapter9List11:
"லீசிங் நிறுவனம் இலங்கை மத்திய வங்கியில் பதிவு செய்யப்பட்ட அங்கீகாரம் பெற்ற நிறுவனம் ஆக இருப்பது.",
chapter9List12:
"நம்பகமான பெயர் இருப்பது.",
chapter9List13:
"வாடிக்கையாளர்களிடம் வெளிப்படைத்தன்மையும் கவனத்தையும் காட்டுவது.",

chapter9Subheading2: "லீசிங் ஒப்பந்தத்தில் கையெழுத்திடுவதற்கு முன்",

chapter9List21:
"ஒப்பந்தத்தில் உள்ள விதிமுறைகளை நன்கு வாசித்து புரிந்துகொள்ளுங்கள். உங்களுக்கு புரியும் மொழியில் உள்ள பிரதியை கோரி வாசித்து, ஒப்பந்த விதிமுறைகள் குறித்து திருப்தி அடையுங்கள்.",
chapter9List22:
"ஒப்பந்த காலத்தில் தவணைகளை எவ்வாறு செலுத்த வேண்டும் என்பதை தெளிவாக புரிந்துகொள்ளுங்கள். நிர்ணயிக்கப்பட்ட தேதியை கடந்தால் வட்டி விதிக்கப்படும் விதம் பற்றியும் அறிந்து கொள்ளுங்கள்.",
chapter9List23:
"ஒப்பந்த காலம் முடிவதற்கு முன் ஒப்பந்தத்தை ரத்து செய்தால் அபராதம் செலுத்த வேண்டுமா அல்லது அதனுடன் தொடர்புடைய நிபந்தனைகள் என்ன என்பதை விசாரிக்கவும்.",
chapter9List24:
"ஒப்பந்தத்தை ரத்து செய்தால் அபராதம் செலுத்த வேண்டுமா என்பதை உறுதி செய்து கொள்ளுங்கள்.",
chapter9List25:
"வட்டி விகிதங்கள் மற்றும் அபராத வட்டி பற்றியும் நீங்கள் கட்டாயமாக அறிந்திருக்க வேண்டும்.",

chapter9Subheading3: "லீசிங் வாகனத்தை விற்பனை செய்வது",

chapter9Paragraph6:
"லீசிங் முறையில் பெறப்பட்ட வாகனம் பதிவு செய்யப்படும் போது, 1980 ஆம் ஆண்டு இலக்கம் 08 உடைய மோட்டார் வாகன போக்குவரத்து (திருத்தப்பட்ட) சட்டம் பொருந்தும். இதில் வாகனம் இரண்டு உரிமையாளர்களின் கீழ் பதிவு செய்யப்படுகிறது:",

chapter9List3: ["முழு உரிமையாளர் – Absolute Owner", "பதிவுசெய்யப்பட்ட உரிமையாளர் – Registered Owner"],

chapter9Paragraph7:
"இங்கு லீசிங் நிறுவனம் முழு உரிமையாளராக இருக்கும் போது, வாகனத்தை வாங்கிய நபர் பதிவுசெய்யப்பட்ட உரிமையாளராகிறார். பதிவுசெய்யப்பட்ட உரிமையாளருக்கு தனிப்பட்ட விருப்பத்தின் அடிப்படையில் வாகனத்தை மாற்றிக்கொடுக்க முடியாது. அதற்காக முழு உரிமையாளரின் ஒப்புதலும் அவசியமாகும்.",

chapter9Paragraph8:
"மேலும் வாகனத்தினால் ஏற்படும் விபத்துகள் அல்லது சேதங்களுக்கு முழு உரிமையாளர் பொறுப்பாளி அல்ல.",

chapter9Subheading4: "லீசிங் வாகனத்தை விற்பனை செய்யும் போது",

chapter9Paragraph9:
"லீசிங் ஒப்பந்தத்தை ரத்து செய்யாமல் வாகனத்தை விற்பனை செய்வதை தவிர்க்கவும். லீசிங் நிறுவனத்துடன் உள்ள முதற்கட்ட ஒப்பந்தத்தை ரத்து செய்து, வாகனத்தை வாங்கும் நபரின் பெயரில் புதிய ஒப்பந்தத்தை உருவாக்கிய பின்னரே வாகனத்தை விற்க வேண்டும்.",

chapter9Paragraph10:
"வேறு ஒருவர் வாகனத்தின் பதிவுசெய்யப்பட்ட உரிமையாளராக இருக்கும் லீசிங் வாகனத்தை வாங்குவதன் மூலம் உங்களுக்கு அந்த வாகனத்தின் உரிமை கிடைக்காது. குத்தகை ஒப்பந்தத்தை ரத்து / மாற்றம் செய்யும் போது சில வரிகள் அல்லது கட்டணங்கள் செலுத்த வேண்டி வரும்.",

chapter9Subheading5: "லீசிங் தவணை செலுத்தப்படாத வாகனங்களை கைப்பற்றுதல்",

chapter9Paragraph11:
"நிதி மற்றும் குத்தகைச் சட்டத்தின் படி, குத்தகையின் கீழ் வாகனம் வாங்கிய நபர் அந்த வாகனத்தின் மதிப்பில் 50% க்கும் அதிகமாக செலுத்தவில்லை என்றாலும், மேலும் அந்த குத்தகையாளர் தவணை செலுத்துவதை தொடர்ந்தும் தவிர்த்தால், குத்தகை நிறுவனத்திற்கு அந்த வாகனத்தை கைப்பற்றும் உரிமை உள்ளது.",

chapter9Paragraph12:
"அந்த வாகனத்தை கைப்பற்றும் போது, குத்தகை நிறுவனம் காவல் நிலையத்தில் புகார் அளித்து காவல்துறையுடன் இணைந்து வாகனத்தை எடுத்துச் செல்ல வேண்டும். அந்த நேரத்தில் வாகன உரிமையாளர் வாகனத்தை வழங்க மறுத்தால், நீதிமன்றத்தில் வழக்கு தாக்கல் செய்து வாகனத்தை பெற்றுக்கொள்ள வேண்டும். எந்த நிலையிலும் “சீசர்” (Seizure) நபர்கள் தனிப்பட்ட முறையில் சென்று வாகனங்களை கைப்பற்ற முடியாது.",

chapter9Paragraph13:
"சட்டத்தில் இவ்வாறு குறிப்பிடப்பட்டிருந்தாலும், நடைமுறையில் லீசிங் செய்யப்பட்ட வாகனத்தை மீட்டெடுப்பது ஒரு மிகவும் அசௌகரியமான செயல்முறையாக மாறியுள்ளது. லீசிங் நிறுவனத்திலிருந்து வரும் \"சீசர்\" (Seizure) நபர்கள் பலவந்தமாக வாகனத்தை எடுத்துச் செல்வது, வாகன உரிமையாளரை கடும் நெருக்கடிக்கு உள்ளாக்குகிறது.",

chapter9Subheading6: "குறிப்பு",

chapter9Paragraph14:
"லீசிங் மூலம் வாகனம் வாங்கும் போது, லீசிங் நிறுவனம் வாகனத்தின் பதிவுச் சான்றிதழ் (Certificate of Registration) அல்லது 'வாகன புத்தகம்', காப்பீட்டு பத்திரம் (Insurance Policy) மற்றும் வாகனத்துடன் வழங்கப்படும் கூடுதல் சாவியை தங்களிடம் வைத்திருக்கும். வாடிக்கையாளருக்கு வருமான அனுமதி பத்திரம் அல்லது காப்பீட்டு சான்றிதழ் பெற வேண்டிய தேவை ஏற்பட்டால், அதற்காக லீசிங் நிறுவனத்தால் சான்றளிக்கப்பட்ட கடிதம் வழங்கப்படும்.",






chapter10Title: "10. வேக நெடுஞ்சாலையில் முக்கியமான அம்சங்கள்",

chapter10List11: 
"வேக நெடுஞ்சாலையில் செல்ல அனுமதி இல்லாத வாகனங்கள்: மூச்சங்க வாகனங்கள், மோட்டார் சைக்கிள்கள், பைக்குகள், டிராக்டர்கள் மற்றும் தேவையான தகுதியை பூர்த்தி செய்யாத ஏதேனும் வாகனங்கள்.",
chapter10List12:
"வேக நெடுஞ்சாலையில் அல்லது இரண்டு பக்கங்களிலும் பயணிகள் நடக்க தடைசெய்யப்பட்டுள்ளது.",

chapter10Subheading1: "வேக நெடுஞ்சாலையில் செல்ல வாகனத்தின் தகுதி",
chapter10List21: 
"நாட்கோடி 100 கிமீ வேகத்தில் பயணிக்கக்கூடும் திறன்.",
chapter10List22:
"அதிக சுமை ஏற்றப்படாதது மற்றும் இயக்கத்தின் போது கருப்பு புகை வெளியிடாதது.",
chapter10List23:
"மோட்டார் வாகன சட்டத்திற்கு ஏற்ப தரநிலைப்படுத்தப்பட்ட வாகனம் (உயரம், எடை போன்றவை).",
chapter10List24:
"கருவிகள் சரியாக செயல்படுவதை உறுதி செய்தல் (ஒளிச்சார், டாஷ்போர்ட் சென்சார், சீட்டுகள், பாதுகாப்பு பட்டைகள் போன்றவை).",
chapter10List25:
"டயர் மற்றும் இயந்திரம் சரியான நிலையில் இருப்பது.",
chapter10List26:
"டயர்களில் சரியான காற்று அழுத்தம் இருப்பது.",

chapter10Subheading2: "வேக நெடுஞ்சாலையை பாதுகாப்பாக பயன்படுத்தும் வழிகாட்டுதல்கள்",
chapter10List31: 
"கிடைக்கக்கூடிய அதிகபட்ச வேகம்: 100 கிமீ/மணி.",
chapter10List32:
"எப்போதும் முன்னேறும் வாகனத்துடன் பாதுகாப்பான தூரத்தை வைத்திருங்கள். (வேக நெடுஞ்சாலையில் உங்கள் வாகனத்தின் இயக்கம் பொதுவான சாலைக்குக் காட்டிலும் மிகவும் வேறுபடும்)",
chapter10List33:
"எப்போதும் பாதுகாப்பு பட்டை அணியுங்கள். விபத்தில் உங்கள் உயிரைக் காப்பாற்றுவதில் மிக முக்கிய உதவி இது.",
chapter10List34:
"எப்போதும் வலது அல்லது இடது வரிசையில் பயணிக்கவும். உள்ளே செல்லும் பாதை, பிற வாகனங்களை கடக்க மட்டுமே பயன்படுகிறது.",
chapter10List35:
"வாகனத்தை இயக்குவதற்கு முன் பக்கக் கண்ணாடிகளை சரிபார்த்து, பாதுகாப்பானதாயின் சிக்னல்களை வெளியிட்டு, மீண்டும் பின்புற வாகனத்திற்கு இடையூறு இல்லாமல் தூரம் வைத்துப் இடது வழியில் சென்று முன்னே செல்லவும்.",
chapter10List36:
"வேக நெடுஞ்சாலைக்கு நுழையும் மற்றும் வெளியேறும் சாலைகளில் அதிகபட்ச வேகம்: 60 கிமீ/மணி.",
chapter10List37:
"அதிரடியான நிறுத்த சிக்னல் அவசர நிலைகளில் மட்டுமே பயன்படுத்தப்படும்.",
chapter10List38:
"சுற்றுப்புறம் பார்க்க, உடல் தேவைகளுக்காக ஓய்வெடுக்க அல்லது வேக நெடுஞ்சாலையில் உங்கள் வாகனத்தை நிறுத்த அல்லது இறங்குவதは禁止.",
chapter10List39:
"உங்கள் அனைத்து தேவைகளை ஓய்வெடுக்கும் இடங்களில் பூர்த்தி செய்ய வேண்டும் என்பது உங்கள் பொறுப்பாகும்.",
chapter10List40:
"பயணத்தின் போது சாலைக்கு கழிவு அல்லது குப்பை அகற்றாதீர்கள்.",
chapter10List41:
"கெட்ட வானிலை வேளைகளில், வேகத்தை குறைத்து, மிகவும் கவனமாக ஓட்டுங்கள்.",
chapter10List42:
"அவசர நிலை ஏற்பட்டால் உங்கள் வாகனத்தை அவசர வழிச்சாலைவில் நிறுத்துங்கள். இந்த வழிச்சாலை 175 மீட்டர் அகலம் மட்டுமே இருப்பதால், நிறுத்தும் மற்றும் வெளியேறும் போது மிகவும் கவனமாக இருங்கள்.",
chapter10List43:
"அவசர நிலை அல்லது பேரிடர் நிலை ஏற்பட்டால் 1969 அவசர தொடர்பு எண்ணிற்கு தெரிவித்து, அவசர உதவி வரும் வரை வாகனத்தில் இருக்க வேண்டும்.",
chapter10List44:
"வேக நெடுஞ்சாலையில் எப்போதும் பின்புற ஓட்டம் தடையாகும். உங்கள் வெளியேறும் இடம் தவறியால் அடுத்த பரிவர்த்தனை வரை செல்லவும்.",
chapter10List45:
"வேக நெடுஞ்சாலையில் வழங்கப்படும் அவசர சேவைகள் மற்றும் உங்கள் காரணமாக சாலை அல்லது சொத்து சேதங்களுக்கு உயர் கட்டணங்கள் விதிக்கப்படும். எனவே உங்கள் வாகனத்தை ஏற்றும் போது கவனமாக இருக்கவும்.",
chapter10List46:
"வாகனம் வேக நெடுஞ்சாலைக்கு பொருத்தமற்றிருந்தால், அதில் நுழைவதை தவிர்க்கவும். எப்போதும் அதிகபட்ச பாதுகாப்புடன் ஓட்டவும்.",
chapter10List47:
"வேக நெடுஞ்சாலையில் தொடர்புடைய சட்ட விதிகளை பின்பற்றி, வேகமான, பாதுகாப்பான மற்றும் வசதியான பயணத்தை அனுபவிக்கவும்.",





chapter11Title: "11. நடப்போர்க்கான பாதை விதிகள்",

chapter11Paragraph1: "முகநெடுஞ்சாலையில் பயணிக்கும் போது எப்போதும் பாதையை வலது பக்கம் பயன்படுத்துங்கள். அப்பொழுது எதிரிலிருந்து வரும் வாகனங்களை நீங்கள் பார்க்க முடியும், பின்னிலிருந்து வரும் வாகனங்கள் உங்கள் இடப்பக்கத்திலிருந்து செல்கின்றன.",
chapter11Paragraph2: "நடப்போர்க்கான பாதையோ அல்லது நடப்போர்க்கான குறிப்பிட்ட பக்க வழியோ இருந்தால், எப்போதும் அதை பயன்படுத்தவும்.",
chapter11Paragraph3: "பாதையில் பயணம் செய்யும் போது தனித்து அல்லது அதிகபட்சம் இரண்டு பேர் வரிசையில் செல்ல வேண்டும். எப்போதும் இரண்டு பேர்களை விட ஒரே வரிசையில் செல்வதைத் தவிர்க்க வேண்டும்.",
chapter11Paragraph4: "சிறுவர்களை முன்னிறுத்தி செல்லும்போது எப்போதும் அவர்களின் பாதுகாப்பைப் பற்றி கவனமாக இருக்கவும். குழந்தைகள் பாதையில் இல்லாமல் பாதையின் வெளியே இருக்க வேண்டும், மூத்தவர்கள் பாதையை பயன்படுத்தி நடந்து செல்ல வேண்டும்.",
chapter11Paragraph5: "முக்கோணங்களில் அல்லது சந்திப்புகளில், பாதையை இரு பக்கங்களும் பாவனை செய்ய வாய்ப்பு இருப்பதால் அதிக கவனமாக பயணம் செய்ய வேண்டும்.",
chapter11Paragraph6: "இரவின்போது பயணம் செய்யும்போது சாத்தியமானால் வெள்ளை அல்லது வெளிர் நிற உடை அணிந்து பயணம் செய்தல் சிறந்தது. அப்பொழுது ஓட்டுநர்கள் உங்களை தெளிவாக காணலாம்.",
chapter11Paragraph7: "பாதை கடக்க வேண்டியதாயின், அருகில் நடப்போர்க்கான இடம், பாதையின் கீழ் செல்லும் குவாய் அல்லது நடப்போர்க்கான பாலம் இருப்பதை கவனமாக பார்த்து பயணம் செய்யவும். உங்கள் இடத்திலிருந்து 50 மீட்டர் அளவில் அந்த இடம் இருந்தால் அவசியமாக பயன்படுத்த வேண்டும்.",
chapter11Paragraph8: "நடப்போர்க்கான இடத்தில் செல்லும் முன் எதிரிலிருந்து வரும் வாகனங்களை கவனிக்கவும். ஓட்டுநர்கள் தங்கள் வேகத்தை குறைத்து வாகனத்தை நிறுத்தும் நேரம் கிடைக்கும், பாதுகாப்பாக கடக்கவும். கடக்கும் போது நீங்கள் செல்வது மெல்லிய மஞ்சள் வரி பகுதி மட்டுமே, சீப்பிரா வரி/தண்டு வரி பகுதி அல்ல.",
chapter11Paragraph9: "நடப்போர்க்கான இடத்திற்கருகில் போலீஸ் அதிகாரி இருந்தால், அவருடைய உத்தரவின்படி நடந்து செல்லவும்.",
chapter11Paragraph10: "நடப்போர்க்கான இடம் இல்லையெனில், சாலை வாகன குறைவாக இருக்கும் வரை வலது பக்கம், இடது பக்கம் மற்றும் மீண்டும் வலது பக்கம் கவனமாக பார்க்கவும், பிறகு பாதுகாப்பாக கடக்கவும்.",
chapter11Paragraph11: "நிறுத்தப்பட்ட வாகனங்களுக்குள் நேரடியாக சென்று ஒரே நேரத்தில் பாதையை கடக்க வேண்டாம்.",
chapter11Paragraph12: "நடப்போர்க்கான இடத்தில் உள்நோக்கி விளக்க சிக்னல் இருந்தால், அந்த விளக்க சிக்னலை பின்பற்றி பாதையை கடக்கவும். இந்த விளக்க சிக்னல் தானியங்கி அல்லது இயந்திரமாக இருக்கலாம். கைமுறை செயல்படுத்த வேண்டியதாக இருந்தால், அதற்கான சுவிட்ச் கீழே நிறுவப்பட்டிருக்கும்.",
chapter11Paragraph13: "விளக்க சிக்னலில் ‘சிவப்பு மனிதன்’ காட்டில் இருந்தால் பாதையை கடக்க கூடாது. தானியங்கி கம்பம் செல்லும் வரை காத்திருங்கள் அல்லது கைமுறையாக ‘பச்சை மனிதன்’ காட்டி பாதையை கடக்கவும்.",
chapter11Paragraph14: "ஆனால் இப்போது எதிரிலிருந்து வரும் வாகனங்களை கவனமாக பார்த்து செல்லவும். ஏனெனில் ஓட்டுநர்களுக்கு விளக்க சிக்னல் மாற்ற நேரம் கிடைக்க வேண்டும்.",
chapter11Paragraph15: "குறுகிய காலத்தில் (பெரும்பாலும் ஒரு நிமிடம் போன்ற) பச்சை மனிதன் விளக்கத் தோன்றும் போது விரைவில் சிவப்பு மனிதன் விளக்க தோன்றும். ஆகையால் அப்போது பாதையை கடக்கத் தொடங்கக்கூடாது. மேலும் நீங்கள் பாதையில் பயணித்து வந்தால் விரைவில் பாதையின் மற்ற பக்கத்திற்குப் பிற்கொண்டு செல்ல வேண்டும்.",

chapter11Image1: PDFViewerImage5,





chapter12Title: "12. காலடி சைக்கிள் பயணிகளுக்கான முக்கிய விதிகள்",
chapter12Paragraph1: "சாலைக்கு செல்லும் முன் உங்கள் கால்கள் பாதுகாப்பான நிலையில் உள்ளதா என சரிபார்க்கவும்.",
chapter12Paragraph2: "ஆண்டாண்டு அனுமதி சின்னத்தை தெளிவாக பார்க்கக்கூடிய வகையில் நிறுவவும்.",
chapter12Paragraph3: "சாலையின் இடப்பக்கத்தில் சைக்கிள் ஓட்டவும்.",
chapter12Paragraph4: "சைக்கிள் ஓட்ட பாதை இருந்தால் எப்போதும் அதைப் பயன்படுத்தவும்.",
chapter12Image1: PDFViewerImage6,
chapter12Image2: PDFViewerImage7,
chapter12Paragraph5: "வாகனங்களை மிஞ்சும் போது மிகுந்த கவனமாக இருங்கள்.",
chapter12Paragraph6: "எப்போதும் இருவிரல்கள் சைக்கிள் ஹேண்டிலில் மட்டுமே இருக்கவும்.",
chapter12Paragraph7: "கை சிக்னல்கள் சரியாக, திறம்பட மற்றும் தெளிவாக வழங்கப்பட வேண்டும்.",
chapter12Paragraph8: "இரவின்போது ஓட்டினால் காலடியில் விளக்கு (அல்லது ஏதேனும் பொருத்தமான ஒளி மூலமும்) பொருத்தவும்.",
chapter12Paragraph9: "முன்பக்கத்தில் தெளிவான ஒளியை வெளியிடும் விளக்கு மற்றும் பின்பக்கத்தில் சிவப்பு ஒளி பிரதிபலிப்பான் பொருத்தப்பட்டிருக்க வேண்டும்.",
chapter12Paragraph10: "அந்த பிரதிபலிப்பான் அகலம் 03.75 செ.மீ. இருக்க வேண்டும். பின்புற சக்கரத்தின் மண் ஆவணத்தின் கீழ் முனையில் இருந்து 23.00 செ.மீ. உயரத்திற்கு வெள்ளை வண்ணம் பூசப்பட்ட பகுதியின் மீது பிரதிபலிப்பான் பொருத்தப்பட வேண்டும்.",
chapter12Image3: PDFViewerImage8,
chapter12Image4: PDFViewerImage9,
chapter12Image5: PDFViewerImage10,
chapter12Image6: PDFViewerImage11,






chapter13Title: "13. மோட்டார் வாகன ஓட்டுநர்களுக்கான முக்கிய குறிப்புகள்",

chapter13Paragraph1: "நீங்கள் ஓட்ட தேவையான நிலைமையில் இருக்கும்போது மட்டுமே பயணம் தொடங்குங்கள். நீங்கள் போதை மருந்துகள் (அல்லது போதை விளைவிக்கும் மருந்துகள்) பயன்படுத்தி மது சாக் கொண்டு கோபமாக இருந்தால், ஓட்ட வேண்டாம்.",
chapter13Paragraph2: "வாகனம் ஓட்டும் போது தொலைபேசி பயன்படுத்துவது, உணவு சாப்பிடுவது தவிர்க்கவும். கையுறை அணிந்து ஓட்ட வேண்டாம்.",
chapter13Paragraph3: "வாகனத்தின் இயந்திர நிலை நல்லதாக இருப்பதை உறுதிசெய்க. கைக்குச்சூழல், ஸ்டீயரிங், டயர்கள், விளக்குகள், குழாய்கள், ஒளிச் சிக்னல்கள், வைப்பர் ஆகியவற்றில் கவனம் செலுத்தவும்.",
chapter13Subheading1: "நீங்கள் முக்கிய நெடுஞ்சாலையில் ஓட்டும் போது பின்வரும் தேவைகள் பூர்த்தியாக இருக்க வேண்டும்.",

chapter13List11: "1. ஓட்டுநர் சரியான உடல் மற்றும் மனநிலை உடையவர் ஆக வேண்டும்.",
chapter13List12: "2. வாகனம் சாலை ஓட்டத்திற்கு தகுதியான நிலையில் இருக்க வேண்டும்.",
chapter13List13: "3. வாகனத்திற்கு செல்லுபடியாகும் காப்பீட்டு சான்றிதழ் இருக்க வேண்டும்.",
chapter13List14: "4. வாகனத்திற்கு செல்லுபடியாகும் வருமான அனுமதி அட்டையை பெற்றிருப்பது.",
chapter13List15: "5. ஓட்டுநர் சார்ந்த வாகன வகைக்கான செல்லுபடியாகும் ஓட்டுநர் அனுமதி அட்டை கொண்டிருக்க வேண்டும்.",
chapter13List16: "6. வாகனத்திற்கு செல்லுபடியாகும் வாயு வெளியீட்டு சான்றிதழ் இருக்க வேண்டும்.",

chapter13Paragraph4: "ஓட்டும் போது ஓட்டுநர் அனுமதி அட்டை, வாகன வருமான அட்டை, காப்பீட்டு சான்றிதழ் மற்றும் வாயு வெளியீட்டு சான்றிதழ் வாகனத்தில் எப்போதும் இருக்க வேண்டும்.",
chapter13Paragraph5: "நீங்கள் ஓட்டத்தை பயிற்சி பெற்றிருப்பது என்றால், அந்த வாகன வகைக்கான செல்லுபடியாகும் ஓட்டுநர் அனுமதி அட்டை கொண்ட, வயது 21க்கு மேற்பட்ட ஒருவர் உங்கள் பக்கத்தில் அமர்ந்து இருக்க வேண்டும். (இந்த விதி மோட்டார் சைக்கிள்கள் மற்றும் டிராக்டருக்கு பொருந்தாது)",

chapter13Paragraph6: "வாகனத்தின் எண் அட்டையில், எண் அளவுக்கு இரட்டை அளவில் சிவப்பு நிற L சின்னம், எண் அட்டையின் மேல் தெளிவாக காணப்படும் வகையில் பொருத்தப்பட்டிருக்க வேண்டும்.",
chapter13Paragraph7: "ஓட்டுநர் இருக்கையில் அமர்ந்து அதை உங்களுக்கு பொருந்துமாறு அமைக்கவும். பக்க கண்ணாடி உங்களுக்கு பொருந்துமாறு அமைக்கவும். இருக்கை படுக்கை இருந்தால் சரியாக நிலைநிறுத்தவும்.",
chapter13Paragraph8: "சிறிய பிள்ளையை எடுத்துச் செல்கிறீர்களானால் எப்போதும் பின்புற இருக்கையில் அமர வைக்கவும். பிள்ளைகளுக்காக உருவாக்கப்பட்ட பாதுகாப்பு இருக்கையை பயன்படுத்தினால் அது சிறந்தது.",
chapter13Paragraph9: "பக்க கண்ணாடியால் பின்புறத்தை கவனிக்கவும். தேவையானால் வலது புற மேலே பின்புற பார்த்து சாலை பாதுகாப்பானதா என உறுதிசெய்க. பின்னர் சிக்னல் கொடுத்து பின்புற வாகனங்களுக்கு தடையாக இல்லாமல் பயணம் தொடங்கவும்.",
chapter13Image1: PDFViewerImage12,

chapter13Paragraph10: "எப்போதும் வேகம் வரம்புகளுக்கு உட்பட்டு ஓட்டவும். ஓட்டும் போது உங்கள் கை எப்போதும் கைக்குச்சூழலில் இருக்க வேண்டும். கியர் மாற்றம் போன்ற அவசியமான செயல்கள் செய்யும் போது ஒரு கை எப்போதும் கைக்குச்சூழலில் இருக்க வேண்டும்.",
chapter13Paragraph11: "கை சிக்னல்கள் மற்றும் ஒளி சிக்னல்கள் தெளிவாக வழங்கப்பட வேண்டும். முக்கியமாக கை சிக்னல்கள் தெளிவாக வழங்கப்பட வேண்டும். அந்த செயல்களை செய்த பிறகு ஒளி சிக்னலை அணைத்து விட வேண்டும்.",
chapter13Paragraph12: "குழாய் சத்தமூட்டும் வலிமையால் வாகனம் ஓட்ட வேண்டாம்.",

chapter13Subheading2: "வாகனங்களுக்கு இடைவெளி மற்றும் வேகம்",
chapter13Paragraph13: "எப்போதும் முன்னே செல்லும் வாகனத்துடன் பாதுகாப்பான இடைவெளியை பராமரிக்கவும். முன்னே செல்லும் வாகனம் திடீர் நிறுத்தப்பட்டால், மோதல் இல்லாமல் உங்கள் வாகனத்தை நிறுத்த முடியும்.",

chapter13Paragraph14: "வேகம் அதிகமாக இருந்தால் ஒரே நேரத்தில் பயணம் செய்யும் தூரம் அதிகரிக்கும், ஆகையால் வாகனம் நிறுத்தும் நேரமும் அதிகரிக்கும்.",

chapter13Subheading3: "நிறுத்தும் தூரம் - எண்ணும் தூரம் + ஸ்டீயரிங் பயன்பாட்டு தூரம்",
chapter13Paragraph15: "நடக்கிற வாகனத்தை ஸ்டீயரிங் பயன்படுத்தி நிறுத்தும்போது, முழுமையாக நிலைத்திடுவதற்கு முன் பயண தூரம் கீழ்காணும் அட்டவணையால் புரிந்துகொள்ளலாம்.",
chapter13Image2: PDFViewerImage13,

chapter13Subheading4: "ஒளி சிக்னல்கள்",
chapter13Paragraph16: "வேகமாக செல்லும் வாகனங்களுக்கு இடம் கொடுங்கள். மெதுவாக செல்லும் கனமான வாகனங்கள், வேகமாக செல்லும் வாகனங்களுக்கு சாலை இடம் கொடுக்க வேண்டும். வாகனம் இடம் பெறும் சரியான நேரம் கிடைத்தால் வாகனத்தை பக்கமாக கொண்டு செல்ல அல்லது நிறுத்தி வேகமாக செல்லும் மற்ற வாகனங்களுக்கு இடம் கொடுக்குவது கனமான வாகன ஓட்டுநர்களின் பொறுப்பாகும்.",

chapter13Paragraph17: "ஒளி சிக்னல்களின் நோக்கம் மற்றவர்களுக்கு நீங்கள் செய்யவிருக்கும் இயக்கத்தை அறிவிப்பதாகும். அபாயம் குறிக்கும் சிக்னல் (Park Lights) வாகனம் அபாயகரமான நிலையில் இருக்கும்போது அல்லது ஆபத்தான நிலையில் இருப்பதை தெரிவிக்க பயன்படுத்த வேண்டும். இது வாகனம் ஓட்டப்படும் போது அல்லது நிறுத்தப்பட்ட போது மட்டுமே பயன்படுத்தப்பட வேண்டும்.",

chapter13Paragraph18: "ஒளி பிரகாசமான முக்கிய விளக்குகளால் முன்னுரிமை கிடையாது; இது முன்னே வருவதை மட்டுமே தெரிவிக்கிறது.",

chapter13Paragraph19: "நீங்கள் பின்புறம் செல்ல நினைக்காத போது முன்னே செல்லும் வாகனத்தைச் சாமர்த்தியமாக அணுகும்போது உங்கள் முக்கிய விளக்குகளை மங்கலாக்கவும் (dim). வெளிச்சம் போதுமான போது முக்கிய விளக்குகளை தேவையில்லாமல் பயன்படுத்த வேண்டாம். பின்புறம் செல்ல திட்டமிடாத வாகனத்துடன் இணைந்து செல்லும்போது முக்கிய விளக்குகளை மங்கலாக்கவும்.",

chapter13Paragraph20: "(உங்கள் முக்கிய விளக்குகள் இயங்கும் போது முன்னே செல்லும் வாகனத்தின் பக்க கண்ணாடி வழியாக வெளிச்சம் நேரடியாக ஓட்டுநரின் கண்களுக்கு செல்வதை குறைத்தால் அல்லது அணைத்தால், மிகவும் கவனமாக ஓட்டவும்.)",






chapter14Title: "14. ஓட்டுநர் பாதைகள் தொடர்பான விதிகள்",

chapter14Paragraph1: "ஓட்டுநர் பாதைகளுக்கான விதிமுறைகளை எப்போதும் பின்பற்றுங்கள். இதனால் தேவையில்லாத வாகன நெரிசலை தடுக்கும், பொருளாதார மற்றும் மனித கால நஷ்டத்தை குறைக்கும் மற்றும் ஓட்டுநர் அபாயங்களைத் தவிர்க்க உதவும்.",

chapter14Paragraph2: "சாலையின் நடுவில் வரையப்பட்ட ஒற்றை வெள்ளை கோடு வழியாக ஓட்ட அனுமதி, வலமாக திரும்புவதற்கும் அவசர அவசர நிலையைத் தவிர்க்கவும் மட்டுமே.",

chapter14Subheading1: "இரட்டைய வெள்ளை கோடு",
chapter14Image1: PDFViewerImage14,

chapter14Subheading2: "ஒற்றை வெள்ளை கோடு",
chapter14Paragraph30: "சாலையின் நடுவில் வரையப்பட்ட ஒற்றை வெள்ளை கோடு வழியாக ஓட்ட அனுமதி, வலமாக திரும்புவதற்கும் அவசர நிலையைத் தவிர்க்கவும் மட்டுமே.",
chapter14Image2: PDFViewerImage15,

chapter14Subheading3: "சாலையின் நடுவண் கோடு",
chapter14Paragraph3: "சமமான இடைவெளியுடைய வெள்ளை குறுக்குக் கோடு அல்லது விளக்குகளை கொண்ட வெள்ளை குறுக்குக் கோடு வழியாக சாலையின் நடுவண் கோடு வகைப்படுத்தப்படுவதால் எதிரெதிர் போக்கில் செல்கின்ற வாகனங்கள் தனித்தனி ஓட்டுநர் பாதைகள் பிரிக்கப்பட்டுள்ளன.",
chapter14Paragraph4: "முன்னே வரும் வாகனங்களுக்கு இடையூறு இல்லாத அளவுக்கே, இந்த கோடுகளை கடக்க அனுமதி உள்ளது.",
chapter14Image3: PDFViewerImage16,

chapter14Subheading4: "ஓட்டுநர் பாதை குறிகள்",
chapter14Paragraph5: "நீண்ட இடைவெளியுள்ள சிறிய மஞ்சள் கோடு மூலம் சாலையில் ஓட்டுநர் பாதைகள் பிரிக்கப்பட்டுள்ளன. இப்படி பிரிக்கப்பட்ட பாதைகளில் எப்போதும் அந்த ஓட்டுநர் பாதையைப் பயன்படுத்த வேண்டும்.",
chapter14Paragraph6: "பாதைகளை இடையூறு செய்யாமல் மாறாமல் இருக்க வேண்டும். இருப்பினும், மற்ற வாகனங்களுக்கு இடையூறு இல்லாமல் தேவையான ஓட்டுநர் பாதைக்கு மாற அல்லது முன்னே செல்க அனுமதி உள்ளது. ஒளி சிக்னல்களை சரியாக பயன்படுத்தி பாதுகாப்பாக மாற்றவும்.",
chapter14Image4: PDFViewerImage17,

chapter14Subheading5: "மூன்று ஓட்டுநர் பாதைகள் கொண்ட சாலையில்",
chapter14Paragraph7: "சாலையின் இடது பக்க ஓட்டுநர் பாதை மெதுவாக செல்லும் வாகனங்களுக்கும் இடது திரும்பும் வாகனங்களுக்கும் பிரிக்கப்பட்டுள்ளது. [படம் 1 ஓட்டுநர் பாதை]",
chapter14Paragraph8: "நடுநிலை ஓட்டுநர் பாதை நேராக செல்லும் வாகனங்களுக்கு பிரிக்கப்பட்டுள்ளது. [படம் 2 ஓட்டுநர் பாதை]",
chapter14Paragraph9: "சாலையின் நடுவண் கோடு அருகேயுள்ள ஓட்டுநர் பாதை [படம் 3 பாதை] வலமாக திரும்ப எதிர்பார்க்கும் வாகனங்கள் மற்றும் பின்புறம் செல்லும் வாகனங்களுக்கு பிரிக்கப்பட்டுள்ளது.",
chapter14Image5: PDFViewerImage18,

chapter14Paragraph10: "சாலையிலிருந்து வெளியேறுவதற்கு முன்பு ஒளி சிக்னல் கொடுங்கள். பின்னர் பின்புற கண்ணாடியால் பாதையை கவனித்து இடது அல்லது வலது ஓட்டுநர் பாதைக்கு பாதுகாப்பாக செல்லுங்கள். பின்னர் முன்னே குறிப்பிட்ட வகையில் பாதுகாப்பாக வெளியேறுங்கள்.",
chapter14Paragraph11: "சாலையில் நெரிசல் இருக்கும்போது எப்போதும் உங்கள் ஓட்டுநர் பாதையில் வாகனம் வைக்கவும். இது தேவையில்லாத நெரிசலை குறைக்கும். குறுகிய இடைவெளியுள்ள நீண்ட வெள்ளை கோடு சாலையில் ஆபத்தான பகுதியைக் குறிக்கிறது. இதில் மிகவும் கவனமாக ஓட்ட வேண்டும்.",
chapter14Image6: PDFViewerImage19,
chapter14Image7: PDFViewerImage20,
chapter14Image8: PDFViewerImage21,

chapter14Subheading6: "பின்வரும் சிக்னல்கள் இருப்பின் பாதுகாப்பாகவும் கவனமாகவும் வேகத்தை குறைத்து ஓட்டவும்.",
chapter14List11: "பாதை ஓட்டும் இடங்களில் நாயகர்கள் இருக்கின்றனர்.",
chapter14List12: "மாடு அல்லது பிற மிருகங்கள் சாலையில் கடக்கக்கூடிய இடங்கள் முன்னதாக இருக்கின்றன.",
chapter14List13: "நடப்போர் கடக்கும் இடம் முன்னதாக இருக்கின்றது.",
chapter14List14: "குழந்தைகள் சாலையில் செல்லும் இடம் முன்னதாக இருக்கிறது.",
chapter14List15: "பள்ளி முன்பு உள்ளது.",
chapter14List16: "மனிதர்கள் வேலை செய்யும் இடங்களும் முன்னதாக உள்ளன.",

chapter14Paragraph25: "நடப்போர் கடக்கும் இடத்தில் (மஞ்சள் கோடு) நடப்போர் இருப்பின், ஒளி சிக்னல் முன் அல்லது பாதையில் வாகனம் நிறுத்த வேண்டும். வாகனம் நிறுத்தும் இடம் பாதை கோடு அல்லது அதற்கு பிறகு இருக்கக் கூடாது. அந்த கோடு முன்னதாக உள்ளது.",
chapter14Image9: PDFViewerImage22,

chapter14Paragraph13: "நடப்போர் கடக்கும் இடத்தில் (ஜீப்ரா கோடு மூலம் கட்டுப்படுத்தப்பட்ட பகுதியில்) வாகனங்களை நிறுத்த, முன்னிலை வாகனங்களை முன்னிலை சென்று அனுமதி அளிக்கவும், கம்பியை ஊதவும் தடை செய்யப்படுகிறது.",

chapter14Subheading7: "வாகனங்களை பின்புறம் கடக்க.",
chapter14Paragraph14: "பின்புறம் செல்லும் வாகனம் பாதுகாப்பாக முன்னே செல்லும் வாகனத்தை கடக்க முடியும் என்பதும், பின்புற செல்லும் வாகனத்திற்கு இடையூறு இல்லாததும் உறுதிசெய்யப்பட்டால் மட்டுமே வாகனத்தை பின்புறம் கடக்கவும். இல்லையெனில், பரிசோதனை இல்லாத முன்னே செல்லும் செயல்கள் சாலையில் உயிருக்கு ஆபத்தானதாகும்.",
chapter14Paragraph15: "இரவு நேரம், முக்கருவால் கண்ணிழைவு, மழையுடன் நனைந்த சாலை மற்றும் பழைய, அறிமுகமில்லாத சாலையில் பின்புறம் கடக்கும் போது பாதுகாப்பாக இருக்க வேண்டும்.",
chapter14Paragraph16: "மற்ற வாகனத்தை கடக்கவேண்டுமானால், முதலில் முன்னே பாதை தெளிவாக இருப்பதை உறுதிசெய்க, அந்த பகுதியில் பின்புறம் கடக்க முடியும் என்பதும் உறுதிசெய்க. பின்னர் பின்புற பாதையை கவனித்து வலமாக திரும்பும் ஒளி சிக்னல் கொடுக்கவும்.",
chapter14Paragraph17: "பின்னர் வாகனத்திற்கு அதிக வேகம் கொடுத்து (3, 4வது கியரில்) பின்புறம் செல்லவும்.",
chapter14Paragraph18: "வாகனம் பின்புறம் சென்ற பிறகு, மீண்டும் ஒரே ஓட்டுநர் பாதையில் இணைந்து முன்னே செல்லும் போது பின்புற சென்ற வாகனத்திற்கு இடையூறு ஏற்படும். எனவே, சிறிது தூரம் வலது ஓட்டுநர் பாதையில் பாதுகாப்பான இடைவெளியுடன், ஒளி சிக்னல்களைப் பயன்படுத்தி முதன்மை ஓட்டுநர் பாதையில் செல்லவும்.",
chapter14Paragraph19: "முன்னே செல்லும் வாகனம் வலமாக திரும்பச் செய்யும் சிக்னல் கொடுக்கப்பட்டு இடது பக்கமிருந்து முன்னிலை வாகனங்கள் பாதுகாப்பாக முன்னிலை சென்றால் மட்டுமே இடது பக்கமிருந்து முன்னிலை செல்ல அனுமதி உள்ளது. ஆனால் மற்ற எல்லா நேரங்களிலும் முன்னிலை செல்ல வேண்டும். அணைக்கப்படும் பிரதான விளக்குகள் உங்கள் முன்னே வருவதை மட்டுமே தெரிவிக்கின்றன; முன்னுரிமை கிடையாது.",
chapter14Paragraph20: "மற்ற வாகனம் உங்களை பின்புறம் கடக்கும்போது, உங்கள் வாகனத்தின் வேகத்தை குறைத்து இடது பக்கமாக செல்ல இடம் கொடுக்கவும். பின்புறம் செல்ல அனுமதி இல்லாமல் வேகப்போட்டி ஓட்டுவது உங்கள் அநாகரிக நடவடிக்கையாகும்.",
chapter14Paragraph21: "மெதுவாக செல்லும் வாகனங்கள் வேகமாக செல்லும் மற்ற வாகனங்களுக்கு பின்புறம் கடக்க இடம் கொடுக்க வேண்டும்.",

chapter14Subheading8: "பின்புறம் கடக்க கூடாத இடங்கள்.",
chapter14List21: "1. நடப்போர் கடக்கும் இடம்",
chapter14List22: "2. வளைவு",
chapter14List23: "3. சந்திப்பு",
chapter14List24: "4. மலைச்சிகரம் அல்லது வளைந்த பாலம்",
chapter14List25: "5. ஒற்றை அல்லது இரட்டை வெள்ளை கோடுகள் கட்டுப்படுத்தும் பகுதி",
chapter14List26: "6. முன்னிலை செல்ல தடை விதிக்கப்பட்ட பகுதி",

chapter14Subheading9: "பின்புறம் ஓட்டுதல்",
chapter14Paragraph22: "பின்புறம் ஓட்டும்போது மிகவும் கவனமாக இருக்க வேண்டும்.",
chapter14Paragraph23: "புற்சாலையில் இருந்து முக்கிய சாலைக்கு பின்புறம் ஓட்டுவது தவிர்க்கவும். பின்புறம் ஓட்டும்போது மெதுவாக செல்லவும்.",
chapter14Paragraph24: "தேவையில்லாமல் பின்புறம் ஓட்டுவது தவிர்க்கவும்.",





chapter15Title: "15. சந்திப்புக்கூட்டில் ஓட்டுதல்",

chapter15Paragraph1: "சந்திப்பில் மற்ற சாலைகளில் இருந்து அல்லது பல திசைகளில் வாகனங்கள் சேருவதால், மற்ற சாலைகளுக்கு வாகனங்கள் வெளியே செல்லுவதால் மிகவும் கவனமாக ஓட்ட வேண்டும்.",

chapter15Paragraph2: "ஓட்டுநர் பாதைகள் ஒரே நேரத்தில் கடக்கும்போது வாகனங்கள் ஓட்டப்படும் காரணமாக, இவ்விடத்தில் வாகனங்கள் 충돌ம் ஏற்படும் வாய்ப்பு அதிகமாகும். சந்திப்புக்கு அருகே செல்லும் முன் நீங்கள் செல்ல வேண்டிய பாதையை தீர்மானிக்கவும்.",

chapter15Paragraph3: "சந்திப்பில் வாகனம் நிறுத்தி, செல்ல வேண்டிய பாதையை ஆராய்வது, பின்புறம் திரும்ப ஓட்டுவது அல்லது U-மாற்றம் செய்வது தவிர்க்கப்பட வேண்டும். இதனால் மற்ற வாகனங்களின் ஓட்ட பாதைகள் தடையடையாது. சந்திப்புக்கு வந்து பின்புற கண்ணாடியை கவனித்து, தேவையான ஒளி சிக்னல்களை பயன்படுத்தி சரியான ஓட்டுநர் பாதையில் வாகனத்தை வைக்கவும்.",
chapter15Image1: PDFViewerImage23,

chapter15Paragraph4: "இடதுபுறம் திரும்பவோ அல்லது நேராக முன்னே செல்கவோ இருந்தால், இடது ஓட்டுநர் பாதையில் இருக்கவும். வலப்புறம் திரும்ப வேண்டியிருந்தால் மட்டுமே வலது ஓட்டுநர் பாதையில் செல்லவும்.",
chapter15Subheading1: "மூன்று ஓட்டுநர் பாதைகள் கொண்ட சாலையில்,",
chapter15List11: "இடதுபுறம் திரும்ப வேண்டுமானால் இடது ஓட்டுநர் பாதையில் ஓட்டவும்.",
chapter15List12: "வலப்புறம் திரும்ப வேண்டுமானால் வலது ஓட்டுநர் பாதையில் செல்லவும்.",
chapter15List13: "நேராக முன்னே செல்ல வேண்டுமானால் நடுநிலை ஓட்டுநர் பாதையில் செல்லவும்.",

chapter15Paragraph5: "சந்திப்பில் இடதுபுறம் அல்லது வலப்புறம் திரும்பும் வாகனங்கள் நேராக செல்லும் வாகனங்களுக்கு இடம் கொடுக்க வேண்டும்.",
chapter15Image2: PDFViewerImage24,

chapter15Subheading2: "மூன்று பாதைகள் கொண்ட நான்கு வழி சந்திப்பு",
chapter15List21: "1 - பின்புற கண்ணாடியை கவனிக்கவும்.",
chapter15List22: "2 - ஒளி சிக்னல் கொடுக்கவும்.",
chapter15List23: "3 - பொருத்தமான ஓட்டுநர் பாதையில் செல்வது.",

chapter15Image3: PDFViewerImage25,





chapter16Title: "16. விளக்கு சிக்னல்கள்",
chapter16Paragraph1: "இந்த சிக்னல் மூலம் விளக்கு சிக்னல்களால் வாகனங்கள் இயக்கப்படுகின்ற குறுக்குவழி செங்குத்தில் நீங்கள் அணுகி வருகின்றீர்கள் என்று உணரலாம்.",
chapter16Image1: PDFViewerImage26,
chapter16Paragraph2: "விளக்கு சிக்னல்களுக்கு அனைத்து வாகன ஓட்டிகளும் முறையாக சென்ஸாரி செய்யப்பட வேண்டும். விளக்கு சிக்னல் மூலம் வாகன இயக்கம் நிறுத்தப்பட்டிருந்தால் (சிவப்பு நிறம்), சாலையில் அமைக்கப்பட்ட நிறுத்த வரிக்கு இங்கே வாகனத்தை நிறுத்த வேண்டும்.",
chapter16Image2: PDFViewerImage27,
chapter16Paragraph3: "அந்த நிறுத்த வரி இல்லையெனில், விளக்கு சிக்னல் முன் அல்லது சாலை பிரிவுக்கு செல்லும் முன் வாகனத்தை நிறுத்த வேண்டும்.",
chapter16Image3: PDFViewerImage28,
chapter16Image4: PDFViewerImage29,
chapter16Image5: PDFViewerImage30,
chapter16Image6: PDFViewerImage31,
chapter16Paragraph4: "இந்த சிக்னல்கள் எவ்வளவு சரியாகவும் கவனமாகவும் அமைக்கப்பட்டிருந்தாலும், சில நேரங்களில் தவறாக செயல்படும் வாய்ப்பு இருக்கலாம். மேலும், விளக்கு சிக்னல்களை புறக்கணித்து ஓட்டுவது சட்டவிரோதமாக இருக்கக்கூடும். எனவே, விளக்கு சிக்னல்கள் இருந்தபோதும் சாலைக்கு உங்கள் பழக்கப்பட்ட கவனத்தை பராமரிக்க வேண்டும்.",
chapter16Paragraph5: "சில சந்தர்ப்பங்களில் விளக்கு சிக்னல்கள் தற்காலிகமாக செயலிழக்கப்பட்டு போலீஸ் அதிகாரியால் வாகனங்கள் இயக்கப்படக்கூடும். அப்படியானால், போலீஸ் கைகள் மூலம் வழங்கப்படும் சிக்னல்களை முறையாக பின்பற்ற வேண்டும்.",






chapter17Title: "17. போலீஸ் கை சிக்னல்கள்",
chapter17Paragraph1: "போலீஸ் அதிகாரி வாகனங்களை கட்டுப்படுத்தும் போது கையால் வழங்கப்படும் சிக்னல்களை முறையாக பின்பற்ற வேண்டும்.",
chapter17Image1: PDFViewerImage32,
chapter17Paragraph2: "இந்த நிலையில், சாலையில் அமைக்கப்பட்ட நிறுத்த வரியில் இங்கே வாகனத்தை நிறுத்த வேண்டும். அந்த வரி அமைக்கப்படவில்லை என்றால், சாலை பிரிவில் செல்லும் முன் வாகனத்தை நிறுத்த வேண்டும்.",




chapter18Title: "18. வட்டச்சாலையில் இயக்கம்",
chapter18Paragraph1: "பின்வரும் சிக்னல் மூலம் முன்னிலையில் ஒரு வட்டச்சாலை உள்ளதென அறிவிக்கப்படுகிறது.",
chapter18Image1: PDFViewerImage33,
chapter18Paragraph2: "அந்த வட்டச்சாலை கட்டாயமானதாக இருந்தால், நீங்கள் அதில் செல்ல வேண்டும்.",
chapter18Image2: PDFViewerImage34,
chapter18Subheading1: "வட்டச்சாலையின் விதி [வலது விதி]",
chapter18Paragraph3: "வட்டச்சாலையில் வலது பக்கத்திலிருந்து வரும் வாகனங்களுக்கு வழியளித்து இயக்க வேண்டும். வலது பக்கத்திலிருந்து வரும் வாகனங்களுக்கு வழி கொடுக்க, வட்டச்சாலையின் சாலையில் அமைக்கப்பட்ட \"வழியளிக்கும்\" கோடுகளின் அருகே உங்கள் வாகனத்தை நிறுத்த வேண்டும்.",
chapter18Image3: PDFViewerImage35,




chapter19Title: "19. சந்திப்புக் குறுக்கே",
chapter19Image1: PDFViewerImage36,
chapter19Paragraph1: "சந்திப்பில் சாலையில் மஞ்சள் நிற சந்திப்பு குறிகள் இருக்கலாம். உங்கள் வெளியேறும் வழி தெளிவாக இருந்தால் அக்குறிப்பின் மேல் செல்லக்கூடாது.",
chapter19Paragraph2: "எந்த சமயத்தில் வேண்டுமானாலும், நீங்கள் சந்திப்பு குறிக்கில் இருக்க அனுமதிக்கப்படுவது, வலது திருப்பம் செய்ய திட்டமிட்டால் முன்னிலுள்ள வாகனங்களின் மற்றும் வலது திருப்பத்திற்கு உள்ள மற்ற வாகனங்களின் காரணமாக உங்கள் இயக்கத்திற்கு தடையுண்டானால் மட்டுமே.",
chapter19Paragraph3: "மற்ற எந்த நேரத்திலும் சந்திப்பு குறிக்கில் இருப்பது தடை செய்யப்பட்டுள்ளது.",





chapter20Title: "20. வாகனங்களை நிறுத்துதல்",
chapter20Paragraph1: "மிகவும் அவசியமாகும் போது, வாகன நிறுத்துமிடம் பயன்படுத்தவும். சாலையின் மையத்தில் நிறுத்தப்படும் போது, அந்த சாலை வாகனங்கள் செல்லும் திசைக்கு முகம்திட்டு இடது பக்கமாக சாலைக்கு சீராக நிறுத்தப்பட வேண்டும்.",
chapter20Image1: PDFViewerImage37,
chapter20Paragraph2: "இஞ்சின் நிறுத்தி, சரியான முறையில் நிறுத்தும் கைபிரேக் (Hand Break) பயன்படுத்தவும். குறிப்பாக சாலையின் பக்கத்தில் கதவு திறக்கும் போது பின்னால் வரும் வாகனங்களை கவனமாக பார்க்கவும்.",
chapter20Paragraph3: "வாகன நிறுத்துமிடங்களில், கோணாகோ அல்லது வேறு வகையில் வாகனங்களை நிறுத்த உத்தரவிடப்பட்டிருந்தால் அதை பின்பற்றவும். சரியான திட்டமிடல் இல்லாமல் இடத்தில் இடம் வாகனங்களை நிறுத்துவது மற்றோரவர்களின் நேரத்தையும், உங்கள் நேரத்தையும் வீணாக்கும். மேலும் சாலை தடையாக நிறுத்தப்படுவதால் ஏற்படும் பண நஷ்டமும், சாலைப் பிசியாக இருப்பதும் குறைபாடு அல்ல. எனவே வாகன நிறுத்துமிடங்களில் அல்லது சாலையில் சரியான முறையில் வாகனங்களை நிறுத்துவது மிக முக்கியம்.",
chapter20Subheading1: "வாகனங்களை நிறுத்தும் இரண்டு பிரதான முறைகள் உள்ளன.",
chapter20List11: 
  "1) சீரான முறை - Parallel parking",
chapter20List12: "2) கோண முறை - Angle parking",

chapter20Subheading2: "சீரான முறை",
chapter20Paragraph4: "முதலில் உங்கள் வாகனத்தை நிறுத்துவதற்கான போதுமான இடத்தை கண்டறியவும். பாதுகாப்பாக வாகனம் நிறுத்த, குறைந்தது வாகனத்தின் நீளத்துக்கு மேல் 2 மீட்டர் இடம் இருக்க வேண்டும். பிறகு சரியான முறையில் சிக்னல் காட்டி வாகனத்தை இயக்கவும்.",
chapter20Paragraph5: "இதற்கான நியமிக்கப்பட்ட விதி இல்லை என்றாலும், பெரும்பாலான வாகன ஓட்டிகள் பின்பற்றும் முறை கீழே கொடுக்கப்பட்டுள்ளது. இது எளிதானதும், பாதுகாப்பானதும் ஆகும். இருப்பினும் உங்கள் வசதிக்கும் திறமைக்கும் ஏற்ப எந்த விதமான முறையையும் பின்பற்றலாம். முக்கியமாக, மற்ற வாகனங்களுக்கு மற்றும் சாலை தடையாக இல்லாமல் வாகனம் நிறுத்தப்பட வேண்டும்.",
chapter20Paragraph6: "வாகனத்தை நிறுத்தும் இடத்திற்கு முன் உள்ள வாகனத்துடன் சீராக வைத்து, 5 மீட்டர் இடைவெளியை பராமரித்து உங்கள் வாகனத்தை முன்னுக்கு வையுங்கள்.",

chapter20Image2: PDFViewerImage38,
chapter20Paragraph7: "மெல்ல மறுபக்கம் பின்வாங்க ஆரம்பித்து, ஸ்டியரிங் அடிப்படையிலான திருப்பம் செய்யவும். 45 டிகிரி வரை ஸ்டியரிங் திருப்பும் வரை பின்வாங்கவும்.",
chapter20Image3: PDFViewerImage39,
chapter20Paragraph8: "பிறகு சக்கரத்தை நேராக வைத்து மேலும் பின்வாங்கவும்.",
chapter20Image4: PDFViewerImage40,
chapter20Paragraph9: "பிறகு மீண்டும் மற்றொரு பக்கத்திற்கு ஸ்டியரிங் திருப்பி பின்வாங்கவும்.",
chapter20Image5: PDFViewerImage41,
chapter20Paragraph10: "பிறகு சரியான இடைவெளியுடன் நிறுத்தவும்.",
chapter20Image6: PDFViewerImage42,

chapter20Subheading3: "கோண முறை",
chapter20Paragraph11: "பலமாக வாகனங்களை நிறுத்த இந்த முறை பயன்படுத்தப்படுகிறது. இதிலும் வாகனத்தின் இரண்டு பக்கங்களிலும் மற்ற இரண்டு வாகனங்கள் இருக்கும்.",
chapter20Paragraph12: "இது முன்னிலை சீருடன் 90 டிகிரி கோணம் உருவாக்கும்.",
chapter20Image7: PDFViewerImage43,

chapter20Paragraph13: "60 டிகிரி கோணத்தில் வாகனங்களை நிறுத்துதல்",
chapter20Paragraph14: "இந்த முறையில் வாகனங்களை நிறுத்துவது தனித்தேறான வழியுள்ள சாலைகளில் நடைபெறும். குறைந்த இடம் உள்ள நிறுத்துமிடங்களிலும் இதே முறை பின்பற்றப்படுகிறது.",
chapter20Image8: PDFViewerImage44,

chapter20Paragraph15: "வாகன நிறுத்துமிடத்தில் வாகனத்தில் யாரும் இல்லாத அல்லது வாகனத்திற்கு பொறுப்புடைய ஒருவர் இல்லையெனில், வாகனத்தை பூட்டி வைக்க வேண்டும்.",
chapter20Paragraph16: "இரவு நேரத்தில் வாகனங்கள் செல்லும் சாலையில் நிறுத்தும் போது நிறுத்தும் விளக்குகளை அணைக்கவும்.",

chapter20List2: [
  "வாகனம் நிறுத்தும் போது, கியர் நியூட்டரில் வைத்து, முன்னோக்கி சக்கரங்களை இயக்கம் செய்ய, ஸ்டியரிங் முழுமையாக திருப்பி, கை பிரேக் இழுக்கவும்."
],
chapter20Image9: PDFViewerImage45,

chapter20List3: [
  "பின்வாங்கும் இடத்தில் (மலை போன்ற இடம்) நிறுத்தும்போது முதல் கியரில் கை பிரேக் இழுத்து நிறுத்தவும். மேலும் சாலை வளைவு உள்ள இடங்களில் சக்கரை சாலையின் பக்கத்துக்கு சீராக வைத்தே நிறுத்தவும். வளைவு இல்லாத இடங்களில் சக்கரை சாலையின் நடுவாக வைத்தே நிறுத்தவும்."
],
chapter20Image10: PDFViewerImage46,




chapter21Title: "21. வாகனங்களை நிறுத்தத் தடை செய்யப்பட்ட இடங்கள்",
chapter21List11: 
  "மல்கோணத்திலிருந்து 25 மீட்டர் அளவில் உள்ள இடம்.",
chapter21List12: "பஸ் நிறுத்துமிடத்திலிருந்து 30 மீட்டர் அளவில் உள்ள இடம்.",
chapter21List13: "பாதசாலை மாறும் இடத்திலிருந்து 15 மீட்டர் பகுதி உள்ள இடம்.",
chapter21List14: "அக்னி அணைக்கும் நீர் குழாயின் அருகே 15 மீட்டர் உள்ள இடம்.",
chapter21List15: "பாதசாலை நடுத்தரத்தில்.",
chapter21List16: "பாலத்தில்.",
chapter21List17: "மலை உச்சியில்.",
chapter21List18: "சாலையில் வளைவு உள்ள இடத்தில்.",
chapter21List19: "சாலை குறுகிய இடத்தில்.",
chapter21List20: "தனித்தோ அல்லது இரட்டை வெள்ளை கோடு கொண்ட சாலை பகுதியில்.",
chapter21List21: "பஸ் அல்லது பைசிக்கிள் ஓட்டும் பாதையில்.",
chapter21List22: "வேகமான ஓட்டும் பாதையில்.",
chapter21List23: "கூலி வாகன நிறுத்துமிடத்தில்.",
chapter21List24: "கட்டுப்பாட்டு சின்னங்கள் மூலம் நிறுத்தத் தடை செய்யப்பட்ட இடத்தில்.",
chapter21List25: "ஏதேனும் இடத்தில் கதவை தடை செய்யும் வகையில்.",




chapter22Title: "22. சாலை சின்னங்கள்",
chapter22Paragraph1: "சாலை சின்னங்கள் பிரதானமாக இரண்டு வகைகளாக பிரிக்கப்படும்.",
chapter22List11: 
  "1) பலகை சின்னங்கள்",
chapter22List12: "2) சாலையில் அமைக்கப்பட்ட சின்னங்கள்",

chapter22Subheading1: "பலகை வகை சின்னங்களில் சில வகைகள் உள்ளன",
chapter22List21: 
  "ஆபத்துக்களை அறிவிக்கும் சின்னங்கள்",
chapter22List22: "கட்டுப்பாட்டு சின்னங்கள்",
chapter22List23: "தகவல் சின்னங்கள்",
chapter22List231: "a வழிகாட்டும் முன்னோட்ட சின்னங்கள்",
chapter22List232: "b வழிகாட்டும் சின்னங்கள்",
chapter22List233: "c இடங்களை குறிக்கும் சின்னங்கள்",

chapter22List24: "மற்ற சின்னங்கள்",

chapter22Subheading2: "கட்டுப்பாட்டு சின்ன வகைகள்",
chapter22List31: 
  "a) தடை சின்னங்கள்",
chapter22List32: "b) வரையறை சின்னங்கள்",
chapter22List33: "c) கட்டளைக் கொடுக்கும் சின்னங்கள்",
chapter22List34: "d) முன்னுரிமை சின்னங்கள்",

chapter22Subheading21: "2) கட்டுப்பாட்டு சின்னங்கள்",
chapter22Subheading3: "ஆபத்துக்களை அறிவிக்கும் சின்னங்கள்",
chapter22Image1: PDFViewerImage47,
chapter22Image2: PDFViewerImage48,
chapter22Image3: PDFViewerImage49,
chapter22Image4: PDFViewerImage50,
chapter22Image5: PDFViewerImage51,
chapter22Image6: PDFViewerImage52,

chapter22Subheading4: "தடை சின்னங்கள்",
chapter22Image7: PDFViewerImage53,
chapter22Image8: PDFViewerImage54,
chapter22Image9: PDFViewerImage55,
chapter22Paragraph2: "இந்த சாலையில் நுழைவு மற்றும் (மறுபுற நுழைவும்) தடை செய்யப்பட்டுள்ளது.",
chapter22Image10: PDFViewerImage56,
chapter22Paragraph3: "இந்த சாலையில் நுழைவு தடை செய்யப்பட்டாலும், சாலையின் மறுபுறத்திலிருந்து வாகனங்கள் வெளியே வர அனுமதி உள்ளது.",
chapter22Paragraph4: "இந்த சின்னத்தால் கட்டுப்படுத்தப்படும் வரம்பில் 'வாகனங்களை நிறுத்துதல்' தடைப்பட்டாலும் அவசர சந்தர்ப்பங்களில் என்ஜின் நிறுத்த அனுமதி உள்ளது.",
chapter22Paragraph5: "எந்த விதமான வாகன நிறுத்தலும் மற்றும் நிறுத்தப்பட்ட வாகனங்களை இயக்குதல் தடை செய்யப்பட்டுள்ளது.",
chapter22Image11: PDFViewerImage57,
chapter22Image12: PDFViewerImage58,

chapter22Subheading5: "மேலும் பலகைகள்",
chapter22Paragraph6: "இந்த பலகை கட்டுப்பாட்டு சின்னங்களின் செயல்படும் திசை மற்றும் தூரத்தை காட்டுகிறது. அந்த கட்டுப்பாட்டு சின்னத்தின் கீழ் இந்த மேலதிக பலகை நிறுவப்பட்டுள்ளது. பெரும்பாலும் வாகன நிறுத்தம் தொடர்பான கட்டுப்பாட்டு சின்னங்களில் இந்த மேலதிக பலகை பயன்படுத்தப்படுகிறது.",
chapter22Image13: PDFViewerImage59,

chapter22Subheading6: "வரையறை சின்னங்கள்",
chapter22Image14: PDFViewerImage60,

chapter22Subheading7: "கட்டளைக் கொடுக்கும் சின்னங்கள்",
chapter22Image15: PDFViewerImage61,

chapter22Subheading8: "முன்னுரிமை சின்னங்கள்",
chapter22Paragraph7: "பக்கசாலையில் செல்லும் வாகனங்கள் பிரதான சாலையில் செல்லும் வாகனங்களுக்கு இடம்கொடுக்க வேண்டும் என்பதை தெரிவிக்க பயன்படுகிறது.",
chapter22Image16: PDFViewerImage62,
chapter22Paragraph8: "பக்கசாலையில் இருந்து பிரதான சாலைக்கு நுழையும் வாகனங்கள் கட்டாயமாக நிறுத்தி பிரதான சாலையில் செல்லும் வாகனங்களுக்கு இடம்கொடுக்க வேண்டும் என்பதை இந்த சின்னம் காட்டுகிறது.",
chapter22Image17: PDFViewerImage63,
chapter22Paragraph9: "பக்கசாலையில் இருந்து பிரதான சாலைக்கு நுழையும் வாகனங்கள் பிரதான சாலையில் செல்லும் வாகனங்களுக்கு முன்னுரிமை அளிக்கும் என்பதை, பிரதான சாலையின் வாகனங்களுக்கு அறிவிப்பு இந்த சின்னத்தால் செய்யப்படுகிறது.",
chapter22Image18: PDFViewerImage64,
chapter22Paragraph10: "பக்கசாலையில் இருந்து பிரதான சாலைக்கு நுழையும் வாகனங்கள் பிரதான சாலையில் செல்லும் வாகனங்களுக்கு அளிக்கும் முன்னுரிமை முடிவடைந்தது என்பதை, பிரதான சாலையின் வாகனங்களுக்கு அறிவிப்பு இந்த சின்னத்தால் செய்யப்படுகிறது.",
chapter22Image19: PDFViewerImage65,
chapter22Image20: PDFViewerImage66,

chapter22Subheading9: "தகவல் சின்னங்கள்",
chapter22List41: 
  "a) வழிகாட்டும் முன்னோட்ட சின்னங்கள்",
chapter22List43: "c) இடங்களை குறிக்கும் சின்னங்கள்",
chapter22Image21: PDFViewerImage67,

chapter22Subheading12:"சாலை மாற்றப்பட்டால் அந்த திசையை தெரிவிக்க பயன்படுகிறது.",
chapter22Image22: PDFViewerImage68,

chapter22Subheading11:"சாலையில் உள்ள தடையை காட்ட பயன்படுகிறது.",
chapter22Image23: PDFViewerImage69,
chapter22Image24: PDFViewerImage70,

chapter22List42: "b) வழிகாட்டும் சின்னங்கள்",
chapter22Image25: PDFViewerImage71,

chapter22Subheading10: "மற்ற சின்னங்கள்",
chapter22Image26: PDFViewerImage72,
chapter22Image27: PDFViewerImage73,





chapter23Title: "23. சாலையில் அமைக்கப்படும் சின்னங்கள்",
chapter23Subheading1: "காலடிய மாற்றத்தில் சாலையில் அமைக்கப்படும் குறியீடுகள்",
chapter23Image1: PDFViewerImage74,
chapter23Image2: PDFViewerImage75,
chapter23Paragraph1: "நிறுத்து சின்னத்தின் போது சாலையில் அமைக்கப்படும் நிறுத்தம் பக்கசாலையில் இருந்து பிரதான சாலைக்கு நுழையும் இடத்தில் இந்த கோடு அமைக்கப்பட்டால், வாகனத்தை நிறுத்தி இருபக்கத்திலிருந்து வரும் வாகனங்களுக்கு முன்னுரிமை வழங்கப்பட வேண்டும்.",
chapter23List11:
  '"சாலையில் இடம்கொடுக்கும் கோடு" பிரதான சாலைக்கு நுழையும்போது பக்கசாலையிலிருந்து வரும் வாகனங்களுக்கு இந்த சின்னம் அமைக்கப்படுவதைக் காணலாம்',
chapter23Image3: PDFViewerImage76,

chapter23List12:"சங்கமம் அல்லது சாலையை பிரிக்கும் இடத்தில் அமைக்கப்படும் நிறுத்த கோடு",
chapter23Image4: PDFViewerImage77,

chapter23List13:"வட்டச்சாலையில் அமைக்கப்படும் சாலையில் இடம்கொடுக்கும் கோடு",
chapter23Image5: PDFViewerImage78,

chapter23List14: "சாலையின் நெடுவரிசையை காட்டும் கோடு",
chapter23Image6: PDFViewerImage79,

chapter23List15: "வாகன நிறுத்தம் தடை செய்யப்பட்டுள்ள அல்லது கட்டுப்படுத்தப்பட்டுள்ளதை காட்டும் சாலையின் நெடுவரிசையில் அமைக்கப்படும் கோடு",
chapter23Image7: PDFViewerImage80,
chapter23Image8: PDFViewerImage81,
chapter23Image9: PDFViewerImage82,

chapter23List16: "ஒற்றை வெள்ளை கோடு கொண்ட கட்டுப்பாடு: கோடு பக்கமாக வலமாக திரும்ப அனுமதிக்கப்பட்டால், கோட்டை கடந்து ஓட்டுவது மற்றும் இருபக்க வாகனங்களை நிறுத்தி வைப்பது தடை.",
chapter23Image10: PDFViewerImage83,

chapter23List17:"இரட்டை வெள்ளை கோடு கொண்ட கட்டுப்பாடு: கோட்டை கடந்து ஓட்டுவது தடை, இருபக்க வாகனங்களை நிறுத்தி வைப்பது தடை. வலமாக திரும்பும் நடவடிக்கையும் தடை.",
chapter23Image11: PDFViewerImage84,

chapter23List18:"அபாயப் பிரதேசம்: இந்த சின்னம் இருபக்கத்திலும், எதிர்மறை திசையில் செல்கின்ற வாகனங்கள் பாதுகாப்பாக செல்லக்கூடியதாக உறுதியாக இல்லை என்றால், இங்கு வலமாக திரும்ப முடியாது.",
chapter23Image12: PDFViewerImage85,

chapter23List19:"அபாயப் பிரதேசம்: இந்த குறுக்க கோடுகள் இருபுறமும் ஒரே திசையில் செல்லும் போது பாதுகாப்பாக ஓட்ட வேண்டிய பிரதேசத்தை காட்டுகின்றன.",
chapter23Image13: PDFViewerImage86,

chapter23List20: "ஓட்டுநரை பிரித்துக் காட்ட பயன்படும் கோடுகள்",
chapter23Image14: PDFViewerImage87,

chapter23List21b: "முந்தையதாக வலமாக திரும்ப வேண்டும் என்று காட்டும் சின்னம்",
chapter23Image15: PDFViewerImage88,

chapter23List22b: "முந்தையதாக வலமாக திரும்ப வேண்டும் என்று காட்டும் சின்னம்",
chapter23Image16: PDFViewerImage89,

chapter23List23b: "முந்தையதாக நேராக செல்ல வேண்டும் என்று காட்டும் சின்னம்",
chapter23Image17: PDFViewerImage90,

chapter23List24b: "'நிறுத்து' சின்னம் உள்ள இடத்தில் சாலையில் அமைக்கப்படும் குறியீடு",
chapter23Image18: PDFViewerImage91,

chapter23List25: "முன்னிலையில் அபாயம் இருப்பதை எச்சரிக்கும் குறியீடு",
chapter23Image19: PDFViewerImage92,

chapter23List26:"பஸ்சு ஓட்டுநர் பாதை",
chapter23Image20: PDFViewerImage93,

chapter23List27: "சைக்கிள் ஓட்டுநர் பாதை",
chapter23Image21: PDFViewerImage94,

chapter23List28: "சாலையில் அபாயம் இருப்பதை எச்சரிக்கும் கோடு",
chapter23Image22: PDFViewerImage95,

chapter23List29: "பஸ் அல்லது காலடி பாதை பிரிக்கப்பட்ட கோடு",
chapter23Image23: PDFViewerImage96,

chapter23Subheading2: "கூடுதல் அறிவு",
chapter23Image24: PDFViewerImage97,

chapter23Paragraph2: "படத்தில் காட்டப்பட்ட சங்கமத்தில்,",
chapter23List21: 
  "மோட்டார் வாகனங்கள் அவசியமாக நேராக செல்ல வேண்டும். ✓",
chapter23List22: "மூன்று சக்கர வாகனங்கள் நேராக செல்லலாம். X",
chapter23List23: "மூன்று சக்கர வாகனங்கள் வலமாக திரும்பலாம் அல்லது நேராக செல்லலாம். X",
chapter23List24: "மோட்டார் வாகனங்கள் நேராக செல்லலாம் அல்லது வலமாக திரும்பலாம். X",

chapter23List31: "சாலை சின்னம் என்ன? சாலையை கடந்து செல்ல தவிர்க்கப்படவேண்டிய கோடு.",
chapter23Image25: PDFViewerImage98,

chapter23List32: "இந்த சாலை சின்னம் என்ன? வட்டச்சாலையில் அமைக்கப்படும் சாலையில் இடம்கொடுக்கும் கோடு",
chapter23Image26: PDFViewerImage99,

chapter23List33:"இந்த சாலை சின்னம் என்ன? நிறுத்து சின்னத்தில் அமைக்கப்படும் நிறுத்த கோடு.",
chapter23Image27: PDFViewerImage100,

chapter23List41: "T வடிவ சங்கமத்தில் நுழையும் போது, வாகனத்தை நின்று இருபக்கத்திலும் அருகிலிருந்து வரும் வாகனங்களுக்கு இடம்கொடுத்து ஓட்ட வேண்டும்.",
chapter23List42: "சாலை விதிகள் தொகுப்பில் 'ஆபத்துக்களை அறிவிக்கும் சின்னம்' காட்டுவது? மஞ்சள் பின்னணி கருப்பு நிறம்.",
chapter23List43: "வட்டச்சாலையின் அடிப்படை விதி என்ன? வலதுபக்கம் வரும் வாகனங்களுக்கு இடம்கொடுத்து ஓட்ட வேண்டும்.",
chapter23List44: "மூன்று பாதைகள் கொண்ட சாலையில் நேராக செல்லும்போது, நடுவண் பாதையை பயன்படுத்த வேண்டும்.",
chapter23List45: "'ஆபத்துக் காட்டு விளக்கு (Hazard Lamps)' பயன்படுத்தப்பட வேண்டியது, வாகனம் நின்று நிலையான நிலையில் இருக்கும் போது மட்டுமே.",
chapter23List46: "இரவு நேரத்தில் வாகனத்தை நிறுத்தும்போது, வாகனம் போக்குவரத்து நிலைக்கு எதிர்நீச்சல் செய்யப்பட வேண்டும்.",
chapter23List47: "வாகனத்தை நிறுத்தும் போது 'நிறுத்தும் தூரம்' என்ன? சிந்திக்கும் தூரம் மற்றும் கையை சக்கரத்தில் வைக்கும் தூரம் இரண்டும் சேர்க்கப்படுகிறது.",
chapter23List48: "முன்னிலையில் காலடி மாற்றம் இருப்பதைப் பார்த்தால், வாகனத்தை நிறுத்த தயாராக இருப்பது வேகத்தை கட்டுப்படுத்து.",
chapter23List49: "முன்னிலையில் வலமாக திரும்பவேண்டுமானால், வாகனத்தை சாலையின் வலப்பக்க ஓட்ட பாதையில் ஓட்ட வேண்டும்.",
chapter23List50: "பக்கசாலையில் இருந்து பிரதான சாலைக்கு நுழையும் போது, இருபுறத்தையும் கவனமாக பார்த்து நுழைய வேண்டும்.",
chapter23List51: "குறைந்த வேகமான கியரில் (மிகப்பெரிய கியர்) ஓட்டும்போது.",
chapter23List52: "மோட்டார் வாகனத்தில் எரிபொருள் ஊற்றும்போது, என்ஜின் நிறுத்த வேண்டும்.",
chapter23List53: "புதிய பதிவு இலத்திரனியல் நம்பிக்கை (VIC) எப்போதும் வாகனத்தில் வைத்திருக்க வேண்டும்.",
chapter23List54: "வாகனத்தை தொடங்கும் போது 3,4 கியர் பயன்படுத்தி வேகத்தை அதிகரித்து ஓட்ட வேண்டும்.",
chapter23List55: "மோட்டார் வாகனத்தில் போர்பர் மீது உலோக பாதுகாப்பு வலை பொருத்துவது சட்டபூர்வமில்லை.",
chapter23List56: "சாலை விதிகள் பின்பற்றும் போது முன்னுரிமை வரிசை: போலீஸ் சின்னங்கள், விளக்க சின்னங்கள், சாலை சின்னங்கள், சாலையில் அமைக்கப்படும் சின்னங்கள்.",
chapter23List57: "சாலையில் உள்ள சின்னங்கள் இரண்டு முக்கிய வகைகள்: பலகை சின்னங்கள் மற்றும் சாலையில் அமைக்கப்படும் சின்னங்கள்.",
chapter23List58: "வாகன ஓட்டுனர் சின்னம் வைக்கும் நோக்கம் தன் செயலை மற்றவர்களுக்கு அறிவிப்பது.",
chapter23List59: "வாகன முன்ன்சாளியை இருட்டாக்க முடியாது. இருபக்க சாளரங்களில் 1/5 பகுதியை மட்டும் இருட்டாக்கலாம்.",
chapter23List60: "காணாத விரைவு வளைவில், குழாயை சத்தம் செய்து குறைந்த வேகத்தில் ஓட்ட வேண்டும்.",
chapter23List61: "முக்கிய விளக்கின் இரண்டு வகைகள் உள்ளன: ஹெட் லைட் மற்றும் டிம்/அளவுகோல் விளக்கு.",
chapter23List62: "பெரிய கியரில் ஓட்டும்போது குறைந்த/பெரிய வேக கியர் பயன்படுத்த வேண்டும்.",
chapter23List63: "ஸ்லிப்பிங் செய்யும் போது கையேடு பயன்படுத்த வேண்டாம். Accelerator விடும் போது ஸ்டீயரிங் திருப்பவும்.",
chapter23List64: "பெரும்பாலான போக்குவரத்து நிலையில், இடது காலடி கிளட்ச் பேடல், வலது காலடி பிரேக் பேடல் மீது இயந்திரமாக இருக்க வேண்டும்.",
chapter23List65: "காலியான சாலை ஓட்டும்போது இடது காலடி விடுவிட, வலது காலடி Accelerator பேடல் மீது இருக்க வேண்டும்.",
chapter23List66: "இருக்கும் இறங்கும் பாதையில் ஓட்டும்போது, இடது காலடி கிளட்ச் பேடல், வலது காலடி பிரேக் பேடல் மீது இருக்க வேண்டும்.",
chapter23List67: "காலடி மாற்றம் இல்லாமல் சாலையை கடக்குமிடம் நடந்துகொள்வதால் ரூ.1000.00 முதல் 2000.00 வரை அபராதம் விதிக்கப்படும்.",
chapter23List68: "மரணாகிய விபத்து என்பது, விபத்து நடந்த 30 நாட்களுக்குள் ஒருவருக்கோ அல்லது பலருக்கோ மரணம் ஏற்பட்ட விபத்து.",
chapter23List69: "கவனமாக ஓட்ட வேண்டிய இடங்கள்: பள்ளிகளின் அருகே, ரயில் கடந்து செல்லும் இடம், காலடி மாற்றங்கள், சங்கமங்கள், மக்கள் நெரிசலான சாலைகள் போன்றவை.",
chapter23List70: "பக்கசாலையிலிருந்து பிரதான சாலைக்கு நுழையும் போது, பிரதான சாலையின் வாகனங்களுக்கு இடம் கொடுத்து ஓட்ட வேண்டும்.",

chapter23Paragraph3: "T வடிவ சங்கமத்தில், உங்கள் வாகனத்தை சாலையில் இடம்கொடுக்கும் கோடுக்கு முன்னால் நிறுத்தி, பிரதான சாலையின் இருபக்கத்திலும் அருகிலிருந்து வரும் வாகனங்களுக்கு இடம் கொடுத்து ஓட்ட வேண்டும்.",





chapter24Title: "24. விபத்து அல்லது அவசர நிலை காலங்களில் மேற்கொள்ள வேண்டிய படிகள்",
chapter24Paragraph1: "வாகனம் திடீர் விபத்து அல்லது அவசர நிலைக்கு ஆளானால், அதனை சாலையிலிருந்து விரைவில் வெளியேற்றி, சாலையின் போக்குவரத்திற்கு ஏற்படும் இடையூறுகளை அகற்ற வேண்டும். இருப்பினும், திடீர் விபத்துக்கு முன் வாகனத்தின் நிலையை மாற்றுவதற்கு முன் காவல்துறை, காப்பீட்டு பிரதிநிதி மற்றும் விபத்தில் சம்பந்தப்பட்ட மற்றவர்/பிரிவு ஒருவருடன் ஆலோசனை செய்து முடிவு எடுக்க வேண்டும்.",
chapter24Paragraph2: "அதேபோல், விபத்து நேரத்தில், வாகனத்தின் நிலையை மாற்றுவதற்கு முன், அதனை இடத்தில் பாறை அல்லது அடையாளங்களால் சாலை மீது குறி செய்யுதல், புகைப்படம் எடுப்பது போன்றவை மிகவும் பொருத்தமானது.",
chapter24Paragraph3: "விபத்தில் சிக்கிய வாகனத்தை சாலையிலிருந்து வெளியேற்ற முடியாவிட்டால், வாகனத்தின் அபாயம் எச்சரிக்கும் விளக்கை ஏற்றி வைக்கவும். வாகனம் இருக்கும் இடத்திலிருந்து சுமார் 50 மீட்டர் தொலைவில், வாகனத்தை நோக்கி வரும் மற்ற வாகனங்களுக்கு எதிராக சிவப்பு பிரதிபலிக்கும் முக்கோணத்தை வைக்கவும். குறுகிய சாலையில் இருப்பின் வாகனத்திற்கு முன்புறம் சுமார் 50 மீட்டர் தொலைவில் இதேபோல் அபாய எச்சரிக்கை சாதனத்தை வைக்கவும்.",
chapter24Paragraph4: "உங்கள் வாகனம் திடீர் விபத்துக்கு முகங்கொண்டால்,",
chapter24List11: "வாகனத்தை நிறுத்தவும்.",
chapter24List12: "காயமடைந்தவர்கள் போக்குவரத்தில் ஏற்படக்கூடிய தாமதங்களை தவிர்த்து விரைவில் காவல்துறைக்கு விபத்து பற்றி அறிவிக்கவும். (வாகன விபத்து ஏற்பட்டால் 24 மணித்தியாலத்திற்கு உள்ளாக காவல்துறைக்கு தகவல் தெரிவிக்கப்பட வேண்டும்.)",
chapter24List13: "காவல்துறையினர், கிராம நிர்வாக அதிகாரி, காயமடைந்த நபர் அல்லது அந்த நபரை கவனிக்கும் ஒருவர் கேட்டால் கீழ்க்காணும் தகவல்களை வழங்க வேண்டும்.",
chapter24SubList11: "ஓட்டுனரின் பெயர்",
chapter24SubList12: "முகவரி",
chapter24SubList13: "வாகனத்தின் உரிமையாளரின் பெயர்",
chapter24SubList14: "வாகனத்தின் எண்ணிக்கை",
chapter24Paragraph5: "மேலும், நீங்கள் விபத்து நேரத்தில் வாகனத்தில் பயணித்தவராக இருந்தாலும், மேலே குறிப்பிடப்பட்ட தகவல்களை வழங்கவும், உங்கள் பெயர், முகவரி மற்றும் சம்பந்தப்பட்ட நேரத்தில் வாகனத்தில் பயணித்ததாக காவல்துறைக்கு தெரிவிக்கவும்.",
chapter24Paragraph6: "காயமடைந்தவர்கள் இருப்பின் அல்லது காயமடைந்த நபர் சொந்தமாக இருக்காதபோது அல்லது அந்த காயத்தால் யாரோ ஒருவர் உயிருக்கு அபாயம் ஏற்படும் என உணரப்பட்டால், உடனே அந்த காயமடைந்தவர்களை அருகிலுள்ள மருத்துவமனைக்கு அழைத்துச் செல்லவும்.",
chapter24Paragraph7: "காவல்துறை அதிகாரி அல்லது கிராம நிர்வாக அதிகாரி அல்லது காயமடைந்த நபர் அல்லது அவர behalf செயல்படும் நபர் கேட்டால் காப்பீட்டு சான்றிதழை வழங்கவும். அந்த நேரத்தில் வழங்க முடியாவிட்டால், விரைவில் சம்பந்தப்பட்ட காவல்துறை நிலையத்திற்கு சமர்ப்பிக்கவும்.",
chapter24Paragraph8: "விபத்தைத் தடுப்பதற்கோ அல்லது வாகனத்தை கட்டுப்படுத்த முடியாத நேரங்களில் மட்டுமே சாலை விதிகளை மீறுவது தவறாகக் கருதப்படாது.",





chapter25Title: "25. ஓட்டுநர்களுக்கான முக்கிய பொதுவான தொழில்நுட்ப அறிவு",

chapter25Paragraph1: "எஞ்சின் என்பது எந்தவொரு மோட்டார் வாகனத்தின் இதயமான மிகவும் மதிப்புள்ள பகுதி ஆகும். எரிபொருளைப் பயன்படுத்தி சக்தி உற்பத்தி செய்யப்படுவது எஞ்சின் மூலம் தான். இவை பொதுவாக உள் எரிப்பு எஞ்சின் (Internal Combustion Engine) என அழைக்கப்படுகின்றன. நான்கு ஸ்ட்ரோக் எஞ்சின் (4 Stroke Engine) மற்றும் இரண்டு ஸ்ட்ரோக் எஞ்சின் (2 Stroke Engine) என இரண்டு வகையாக இருந்தாலும், தற்போது அனைத்து டீசல் மற்றும் பெட்ரோல் வாகனங்களுக்கும் நான்கு ஸ்ட்ரோக் எஞ்சின் பயன்படுத்தப்படுகிறது.",

chapter25Paragraph2: "நான்கு ஸ்ட்ரோக் உள் எரிப்பு எஞ்சின் செயல்படும் போது நடைபெறும் செயல்முறை வரிசை பின்வருமாறு விளக்கப்படலாம்.",

chapter25List11: "காற்றுடன் கலந்த எரிபொருள் சிலிண்டரில் சேர்ந்து வருதல்.",
chapter25List12: "எரிபொருள் + காற்று கலவை குருட்டப்படுதல்.",
chapter25List13: "மின் ஸ்பார்க் மூலம் குருட்டப்பட்ட எரிபொருள் காற்று கலவை எரிதல்.",
chapter25List14: "அப்போது உண்டாகும் வெப்பம் காரணமாக சிலிண்டர் உள்ள காற்று விரிவடைந்து பிஸ்டன் கீழே தள்ளப்படுதல்.",
chapter25List15: "அந்த இயக்கம் க்ராங்க்ஷாஃப்ட் (Crankshaft) மூலம் சுழற்சி இயக்கமாக மாற்றப்பட்டு சக்கரத்திற்கு பரிமாறப்படுதல்.",

chapter25Paragraph3: "நான்கு ஸ்ட்ரோக் எஞ்சின் எனப்படும் போது, அந்த எஞ்சின் ஒரே சுற்றில் நான்கு படிகள் முடியும்.",

chapter25List21: "சுய்சிதை படி - Intake",
chapter25List22: "குறுக்கல் படி - Compression Stroke",
chapter25List23: "சக்தி படி - Power Stroke",
chapter25List24: "வெளியீட்டு படி - Exhaust Stroke",

chapter25Image1: PDFViewerImage101,
chapter25Image2: PDFViewerImage102,

chapter25Subheading1: "சுய்சிதை படி",
chapter25Paragraph4: "பிஸ்டன் மேலிருந்து கீழே செல்லும் போது சிலிண்டரில் உருவாகும் வெற்றிடம் காரணமாக, உள்ளே வரும் வால்வ் வழியாக காற்றுடன் கலந்த எரிபொருள் சிலிண்டரில் அடைந்து வெற்றிடத்தை நிரப்புகிறது.",

chapter25Subheading2: "குறுக்கல் படி",
chapter25Paragraph5: "கீழே சென்ற பிஸ்டன் மேலே செல்லும் போது சிலிண்டர் மேல்தட்டு மூடப்பட்டு, எரிபொருள் காற்று கலவை அதிகமாக குருட்டப்படுகிறது. சுய்சிதை படியில் பிஸ்டன் கீழே வந்த போது சிலிண்டரில் உள்ள வெற்றிடம் மற்றும் குறுக்கல் படியில் பிஸ்டன் மேலே சென்ற போது உள்ள வெற்றிடம் இடையிலான விகிதம் 'குறுக்கல் விகிதம்' (Compression Rate) என அழைக்கப்படுகிறது.",

chapter25Subheading3: "சக்தி படி",
chapter25Paragraph6: "குறுக்கல் முடிவில் சிலிண்டரில் உள்ள ஸ்பார்க் பிளக் மூலம் மின்சாரம் வெளியேறும் மற்றும் குருட்டப்பட்ட எரிபொருள் + காற்று கலவை எரிதல் ஏற்படும். இதனால் மிகப்பெரிய வெப்ப சக்தி உருவாகி, காற்று விரிவடைந்து பிஸ்டன் கீழே தள்ளப்படும். இதனால் க்ராங்க்ஷாஃப்டுக்கு இயக்கம் கிடைக்கும்.",

chapter25Subheading4: "வெளியீட்டு படி",
chapter25Paragraph7: "சக்தி படியில் க்ராங்க்ஷாஃப்ட் மூலம் பிஸ்டன் மீண்டும் மேலே தள்ளப்படும், அதே சமயம் வெளியீட்டு வால்வ் திறந்து எரிந்த காற்று வெளியே செல்கிறது. வெளியீட்டு படி முடிந்தவுடன் மீண்டும் சுய்சிதை படி நிகழும். இந்த செயல்முறை தொடர்ச்சியாக நடந்து சக்கர இயக்கத்திற்கு தேவையான சக்தியை வழங்குகிறது. பிஸ்டன் மேலோ அல்லது கீழே செல்லும் ஒரு தூரம் 'படி' (Stroke) எனப்படும். சக்கர இயக்கத்திற்கு தேவையான சக்தி வழங்க இந்த நான்கு படிகள் நடக்கும்போது, இதன் பெயர் நான்கு ஸ்ட்ரோக் எஞ்சின் ஆகும்.",

chapter25Paragraph8b: "வெளியீட்டு படி முடிந்தவுடன் மீண்டும் சுய்சிதை படி நிகழும். இந்த செயல்முறை தொடர்ச்சியாக நடந்து சக்கர இயக்கத்திற்கு தேவையான சக்தி வழங்குகிறது.",
chapter25Paragraph9b: "பிஸ்டன் மேலோ அல்லது கீழே செல்லும் ஒரு தூரம்-படி (Stroke)- எனப்படுவதை அடிப்படையாகக் கொண்டு, சக்கர இயக்கத்திற்கு தேவையான சக்தி வழங்க இந்த நான்கு படிகள் நடக்கும்போது, இதன் பெயர் நான்கு ஸ்ட்ரோக் எஞ்சின்.",

chapter25List31: "எஞ்சினுக்கு எஞ்சின் எண்ணெய் சேர்க்கப்படுகிறது - எஞ்சின் பகுதிகளுக்கு இடையிலான உருக்கம் குறைத்து, பகுதிகளை காயமடையாமல் பாதுகாப்பதற்காக",
chapter25List32: "எஞ்சின் எண்ணெய் நிலையை சரிபார்க்கப்படுகிறது - எண்ணெய் அளவை அளக்கும் கரும்பி (Dipstick)",
chapter25List33: "எஞ்சின் ஸ்டார்ட் செய்ய முடியாமல் இருப்பது - பேட்டரி குறைவாக இருப்பது",
chapter25List34: "ஸ்டார்டர் மோட்டார் செயலிழப்பு - எஞ்சின் இடைநிறுத்தம்",
chapter25List35: "ஸ்டார்ட் செய்யும்போது எஞ்சின் மெதுவாக இயக்கப்படுகிறது - பேட்டரி குறைவாக இருப்பது, ஸ்டார்டர் மோட்டார் குறைபாடு",
chapter25List36: "எஞ்சின் அதிகமாக வெப்பமடைவது - ரேடியேட்டர் பாஞ் பெல்ட் சுருண்டல், ரேடியேட்டர் பாஞ் குறைபாடு, ரேடியேட்டரில் நீர் குறைவு, காக்ன்டு அல்லது வாட்டர் பம்ப் குறைபாடு",
chapter25List37: "எஞ்சின் எண்ணெய் குறைவதற்கான காரணம் - எண்ணெய் அதிகம் உருக்கம் அல்லது காக்ன்டு",
chapter25List38: "எஞ்சின் சக்தி குறைவு (Under compression) - எண்ணெய் வெளியேறுதல், சிலிண்டர் நீல புகை வெளியேறும், பிளீடர் மூலம் புகை வெளியேறும்",

chapter25Subheading5: "அடிக்கலற்ற எரிப்பு (Ignition Failure)",
chapter25Paragraph8: "நான்கு ஸ்ட்ரோக் எஞ்சின் எரிபொருள் காற்று கலவை தேவையில்லாமல் அதிகமாக குருட்டப்பட்டால், சிலிண்டரில் வெடிப்பு ஏற்படும். இதனால் எஞ்சின் துடிப்பு மற்றும் இரட்டை குலுங்கும் சத்தம் உண்டாகும். இதை 'அடிக்கலற்ற எரிப்பு' என அழைக்கப்படுகிறது.",

chapter25List41: "அடிக்கலற்ற எரிப்புக்கு காரணம் - சிலிண்டரில் காற்று அதிகம் செல்லுதல்",
chapter25List42: "அடிக்கலற்ற எரிப்பு நிகழும் சூழ்நிலைகள் - அதிக சக்தியுள்ள கியர் (1,2,3 போன்ற) அதிக வேகத்தில் செல்லும்போது, பாரம் ஏந்தி மலைப்பாதையில் செல்லும்போது",
chapter25List43: "அடிக்கலற்ற எரிப்பு தவிர்க்கும் வழி - கியர் மாற்றி அதிக வேக கியரில் இயக்குதல்",

chapter25Subheading6: "எஞ்சின் எண்ணெய் நிலை பரிசோதனை",
chapter25Paragraph9: "வாகனத்தை சமமாக உள்ள மேற்பரப்பில் நிறுத்தவும்.",
chapter25Paragraph10: "எஞ்சினை நிறுத்தி குளிர வைக்கவும். குறைந்தது 1/2 மணி நேரம் குளிர்ந்து கொள்ள வேண்டும். இரவு நேரத்தில் நிறுத்திய வாகனம் என்றால் காலை எண்ணெய் நிலை பரிசோதனை சிறந்தது.",
chapter25Paragraph11: "முதலில் எண்ணெய் அளவை அளக்கும் கரும்பியை (dipstick) வெளியே எடுத்து நன்கு துடைக்கவும். மீண்டும் செய்க.",
chapter25Paragraph12: "பிறகு எண்ணெய் நிலையை பரிசோதிக்கவும்.",





chapter26Title: "26. குளிர்படுத்தும் அமைப்பு",
chapter26Image1: PDFViewerImage103,
chapter26Paragraph1: "வாகனம் ஓட்டும் போது ஓட்டுனரின் கண் எப்போதும் கவனிக்கும் டாஷ்போர்டில் இருக்கும் சுட்டி 'எஞ்சின் வெப்பநிலை’ காட்டும் சென்சர் ஆகும்.",
chapter26Paragraph2: "மோட்டார் வாகன எஞ்சினில் நடைபெறும் செயல்முறை மிக அதிக வெப்பத்தை உருவாக்கும். உருவாகும் வெப்பத்தை வேகமாக நீக்காதால் அது எஞ்சினுக்கு சேதத்தை ஏற்படுத்தும், அதனால் எஞ்சினில் குளிர்படுத்தும் அமைப்பு இணைக்கப்பட்டுள்ளது.",

chapter26Paragraph3: "எஞ்சினால் உண்டாகும் அதிக வெப்பத்தின் சுமார் 45% வெளியீட்டு வாயுவுடன் சைலென்சரில் வெளியேறுகிறது. மீதமுள்ள வாயு முன்னமே கூறிய குளிர்ப்புப் பொருளில் வெளியேறுகிறது. எஞ்சின் அதிக வெப்பமடைந்தால்",

chapter26List11: "எஞ்சின் பகுதிகள் தேவையற்றவாறு விரிவடைந்து எஞ்சின் அடைவு ஏற்படுதல்",
chapter26List12: "சிலிண்டர் ஹெడ్, கேஸ்கெட் போன்றவை சேதப்படுதல்",
chapter26List13: "எஞ்சின் எண்ணெய் தேவையற்றவாறு வெளியேறுதல் போன்ற நிலைகள் ஏற்படலாம்",

chapter26Paragraph4: "மோட்டார் வாகன் எஞ்சினை குளிர்ப்பது முக்கியமான 03 வகைகளில் நடக்கிறது.",

chapter26List21: "காற்றால் குளிர்ப்பது",
chapter26List22: "தண்ணீரால் குளிர்ப்பது",
chapter26List23: "எண்ணெய் மூலம் குளிர்ப்பது",

chapter26Paragraph5: "காற்றைப் பயன்படுத்தி எஞ்சினை குளிர்ப்பதில், ப்ளோவர் மூலம் பெரிய காற்றழுத்தம் எஞ்சின் சுற்றி செல்ல அனுமதிக்கப்படுகிறது. தண்ணீரால் குளிர்ப்பதில், ரேடியேட்டர் வழியாக எஞ்சின் சிலிண்டர் சுற்றி தண்ணீர் ஓடும். எஞ்சின் வழியாக செல்லும் எண்ணெய் வெப்பத்தை உறிஞ்சி எஞ்சினை குளிர்ப்பது எண்ணெய் குளிர்ப்புப் பணி மூலம் நடைபெறுகிறது.",

chapter26List31: "எஞ்சின் குளிர்ப்புப் பொருளில் தண்ணீர் சுழற்சி செய்யப்படுவது வாட்டர் பம்ப் மூலம்",
chapter26List32: "எஞ்சின் தேவையற்ற குளிர்ப்பால் ஏற்படும் நன்மைகள் - எஞ்சின் சக்தி குறைவு, எரிபொருள் செலவு அதிகரிப்பு, வெளியேறும் சுடாத வாயுவின் அளவு அதிகரிப்பு, ஓட்ட வேகம் குறைவு",
chapter26List33: "எஞ்சின் தேவையற்ற வெப்பமடைய காரணங்கள் - ரேடியேட்டர் பான் சுருண்டல், ரேடியேட்டரில் தேவையான அளவு தண்ணீர் இல்லாமை",
chapter26List34: "எஞ்சின் அதிக வெப்பம் ஏற்பட்டதைக் கண்டறிதல் - அதிக வெப்பம் என்று காட்டும் சென்சர், ரேடியேட்டரில் தண்ணீர் குறைவாக இருப்பது",

chapter26Subheading1: "அதிக வெப்ப சென்சர்/சுட்டி (Overheat Indicator)",

chapter26Image2: PDFViewerImage104,

chapter26Paragraph6: "எஞ்சின் அதிக வெப்பம் அடைந்தால் இது ஒளிர்கிறது. ஆரம்பத்தில் இனிஷன் விசை இயக்கும்போதும் இது ஒருமுறை ஒளிரி அணைந்து விடும்.",

chapter26Subheading2: "அதிக வெப்பம் ஏற்பட்ட போது",

chapter26Paragraph7: "அதிக வெப்ப சுட்டி ஒளிரும்போது வாகனத்தின் ஏர் கண்டிஷனிங் இயங்கினால் அதனை முடிக்கவும். உடனே வாகனத்தை நிறுத்தவும். வாகனம் நிறுத்தப்பட்டவுடன் ரேடியேட்டர் நீர் நிலையை உடனே பரிசோதிக்கக் கூடாது.",

chapter26Paragraph8: "விரைவில் ரேடியேட்டர் மூடியை திறந்தால் நீர் வளிமண்டலத்திற்கு எதிராக மிதக்கும் மற்றும் நடக்கும் நீர் ஓட்டத்திற்கு எதிர்கொள்ள வேண்டி வரும்.",

chapter26Paragraph9: "எனவே ரேடியேட்டர் நீர் குறைவில் இருக்கும் வரை சிறிது நேரம் காத்திருங்கள், பின்னர் பிளாஸ்டிக் போலியான மூடியைக் கொண்டு ரேடியேட்டர் திறப்பது பாதுகாப்பானது. பொதுவாக ரேடியேட்டர் மூடியை இரண்டு கட்டங்களுக்கு திறக்கலாம். இது பாதுகாப்பு நடவடிக்கை. முதல் கட்டம் திறந்தால் வாகனத்தில் உள்ள வாயு வெளியேறும். அதனால் எப்போதும் ரேடியேட்டர் மூடியை இரண்டு கட்டங்களுக்கு திறக்கவும்.",

chapter26Subheading3: "அதிக வெப்பமடைந்த வாகனத்திற்கு நீர் ஊட்டுதல்",

chapter26Paragraph10: "அதிக வெப்பத்திற்காக சிறிது நேரம் நீர் ஊற்ற வேண்டும். நீர் ஊற்றும் போது வாகன எஞ்சின் ஓட்டப்படும்.",

chapter26Subheading4: "ரேடியேட்டருக்கு 'கூலன்ட்' (Coolant) பயன்படுத்துதல்",

chapter26Paragraph11: "ரேடியேட்டர் கூலன்ட் மூலம் நீர் வெப்பநிலை குறையும் மற்றும் வெப்பநிலை உயரும். இதோடு ரேடியேட்டர் குழாய்களில் கறி தடை ஏற்படுதல் தடுக்கும். இதனால் எந்தவொரு காலநிலைத்திலும் வாகனத்திற்கு சரியான அளவிலான கூலன்ட் பயன்படுத்துவது அவசியமும் முக்கியமும் ஆகும்.",

chapter26List41: "கிளாட்ச் பயன்பாடு - எஞ்சினையும் கியர் பாக்சையும் தேவையான போது இணைத்தல் மற்றும் பிரித்தல்",
chapter26List42: "சிறந்த நிலை கிளாட்சின் பண்பு - எஞ்சின் மற்றும் கியர் பாக்சை இணைக்கும் மற்றும் பிரிக்கும் போது ஒலி, சலிப்பு இல்லாமை, சமநிலை மற்றும் எளிதாக செயல்படுதல்",
chapter26List43: "கிளாட்ச் ஸ்லிப் அறிகுறிகள் - கியர் விடும் போது கிளாட்ச் அதிக ரேஸ் ஆகி வாகனம் இயக்க முடியாமை, எஞ்சின் ஒலி அதிகமாகும்",
chapter26List44: "கிளாட்ச் ஸ்லிப் காரணங்கள் - பிளேட் கழிவாகுதல், கிளாட்சில் எண்ணெய் ஒட்டுதல், கிளாட்ச் பீஸில் அழுத்தம் குறைவு",
chapter26List45: "கிளாட்ச் ஸ்லிப் சோதனை - கைச்சிபுடன் வாகனத்தை ஓட்டவும், முதல் கியரில் வைத்து கிளாட்சை முறையாக விடவும். இதில் எஞ்சின் நிறுத்தப்பட்டால் கிளாட்சில் ஸ்லிப் இல்லை",




chapter27Title: "27. கியர் பெட்டி",
chapter27Paragraph1: "வாகனம் எப்போதும் சமமில்லா பாதையில் ஓடாது. ஆகவே பாதையில் உள்ள சரிவுகள் மற்றும் உயர்வுகளின் படி எஞ்சின் சக்தி குறையவோ அதிகரிக்கவோ செய்து சக்கரங்களுக்கு வழங்கப்பட வேண்டும்.",
chapter27Paragraph2: "நிறுத்தப்பட்ட வாகனத்தை இயக்குதல், மலை ஏறுதல் போன்ற சூழ்நிலைகளில் அதிக சக்தி தேவைப்படும், சமமான பாதையில் ஓடும் போது அல்லது பாலத்தில் செல்லும் போது தேவையானது குறைந்த எஞ்சின் சக்தி.",
chapter27Paragraph3: "இந்த முறையில் எஞ்சின் சக்தியை குறைக்கவும் அல்லது அதிகரிக்கவும் பயன்படுத்தப்படும் இயந்திர சாதனம் 'கியர் பெட்டி' எனப்படும்.",
chapter27Image1: PDFViewerImage105,
chapter27Paragraph4: "சாதாரணமாக வாகனத்தில் முன்னர் 4 அல்லது 5 கியர்கள் இருக்கும். 1,2,3 கியர்கள் அதிக வலிமை (எஞ்சின் சக்தி) கொண்டவை; இவற்றில் வாகனத்திற்கு சக்கரங்களை இயக்கும் சக்தி அதிகமாக இருந்தாலும் வேகம் குறைவாக இருக்கும். 4 மற்றும் 5 கியர்கள் குறைந்த வலிமை கொண்டவை; ஆனால் வேகம் அதிகமாக இருக்கும். 5வது கியர் Top gear எனப்படும். நவீன வாகனங்களில் Top gearக்குப் பின்பு Over drive எனப்படும் கியர் கூட காணப்படும்.",
chapter27Paragraph5: "மேலும், Reverse gear என்பது அதிக வலிமை மற்றும் குறைந்த வேகம் கொண்ட கியர் ஆகும்.",
chapter27Paragraph6: "வாகனம் ஓடத் தொடங்கும்போது எப்போதும் முதலில் 1வது கியர் மூலம் இயக்க வேண்டும். இதுபோல் பயணத்தின் போது அல்லது பறிமானம் ஏற்றும் போது மேல்நிலை கியர்களைப் பயன்படுத்தக் கூடாது; கீழ்நிலை கியர்களின் நீண்ட பயணம் எஞ்சினுக்கு மிகுந்த சேதத்தை ஏற்படுத்தும்.",

chapter27List11: "Sliding mesh",
chapter27List12: "Constant mesh",
chapter27List13: "Syncromesh",
chapter27List14: "Epycyclic, எனப்படும் கியர் பெட்டியின் முக்கிய மாதிரிகள் 04 காணப்படுகின்றன",

chapter27Paragraph7: "Sliding mesh கியர் பெட்டி பழைய மாதிரிகளில் இருக்கும்; இதில் கியர் மாற்றும்போது இருமுறை கிளட்ச் அழுத்த வேண்டும். Constant mesh கியர் பெட்டி பாரம் அதிகமான வாகனங்களுக்கு பயன்படுத்தப்படும், Syncromesh மற்றும் Epycyclic மாதிரிகள் பயணிகள் வாகனங்களில் பெரிதும் பயன்படுத்தப்படுகின்றன.",

chapter27List2: [
  "கியர் பெட்டியின் தேவையுணர்வு",
],

chapter27List31: "வாகன வேகத்தை மாற்ற",
chapter27List32: "வாகனத்தை முன்னோக்கி மற்றும் பின்செலுத்த",

chapter27List4: [
  "கியர் அடைக்கும் போது சிரமம் ஏற்படும்",
],

chapter27List51: "கிளாட்ச் தடை",
chapter27List52: "கியர் பெட்டி அடைவு",
chapter27List53: "கிளாட்ச் எண்ணெய் இல்லாமை",






chapter28Title: "28. தடுப்பு அல்லது கிளட்ச்",
chapter28Paragraph1: "ஓடும் வாகனத்தை தற்காலிகமாக நிறுத்தவும், வேகத்தை கட்டுப்படுத்தவும் கிளட்ச் பயனுள்ளது.",
chapter28Paragraph2: "கிளட்ச் அமைப்புகளின் வகைகள்.",
chapter28List11: "இயந்திர தடுப்பு அமைப்புகள்.",
chapter28List12: "திரவ தடுப்பு அமைப்புகள்.",
chapter28List13: "காற்று தடுப்பு அமைப்புகள்.",
chapter28Subheading1: "நல்ல கிளட்ச் அமைப்பின் பண்புகள்.",
chapter28Paragraph3: "குறுகிய நேரத்தில் குறுகிய தூரத்தில் வாகனத்தை நிறுத்த முடியும்.",
chapter28Paragraph4: "எளிதாக மற்றும் தற்காலிகமாக செயல்பட வேண்டும். எந்தவொரு பாதை நிலை மற்றும் எந்தவொரு காலநிலை உள்ள போதும் செயல்பட வேண்டும்.",
chapter28List2: [
  "கிளட்ச் படுகையின் சுதந்திர இயக்கம், செ.மீ. 01 இருக்க வேண்டும்."
],

chapter28Subheading2: "கிளட்ச் செயல்படாமல் இருப்பதற்கான காரணங்கள்",

chapter28List31: "கிளட்ச் தட்டின் ஆடை சேதம்.",
chapter28List32: "கிளட்ச் அடைவு.",
chapter28List33: "திரவ கிளட்ச் அமைப்பில் ப்ரேக் எண்ணெய் இல்லாமை.",
chapter28List34: "கிளட்ச் எண்ணெய் தடிப்பு.",

chapter28Paragraph5: "கிளட்ச் எண்ணெய் தடிக்கப்பட்டால், கிளட்ச் பயன்படுத்தும் போது தடுப்பு எதிர்பார்த்தவெளி நோக்கி வாகனம் நகரும்.",

chapter28Subheading3: "கிளட்ச் எண்ணெய் குறைவதற்கான காரணங்கள்",

chapter28List41: "தடிப்பு.",
chapter28List42: "ப்ரேக் வாஷர் சேதம்.",
chapter28List43: "சிலிண்டர் சேதம்.",

chapter28Subheading4: "கிளட்ச் பயன்படுத்தும் போது வாகனம் பக்கமாக நகருவதற்கான காரணங்கள்.",

chapter28List51: "சக்கரத்தில் கிளட்ச் எண்ணெய் தடிப்பு உள்ளது.",
chapter28List52: "கிளட்ச் சரியாக சுழற்சி செய்யப்படவில்லை.",
chapter28List53: "ஒரு டயர் அதிகமாக பழுதடைந்துள்ளது.",
chapter28List54: "ஒரு டயர் அழுத்தம் குறைவு அல்லது அதிகம்.",
chapter28List55: "சக்கரத்தில் கிளட்ச் அடைவு.",

chapter28Paragraph6: "ஓடும் போது ஒரே நேரத்தில் கிளட்ச் செயலிழந்தாலும், கிளட்ச் படுகையை பலமுறை குதித்து விடவும். 1, 2 போன்ற குஞ்சு கியர் மாற்றவும். கை கிளட்ச் அழுத்தவும்.",

chapter28Paragraph7: "வாகனத்தை விரைவாக நிறுத்த, ப்ரேக் படுகையை வேகமாக பலமுறை குதித்து விடவும்.",

chapter28Subheading5: "ABS ப்ரேக் என்பது என்ன?",

chapter28Paragraph8: "Anti-Locking Brake System. ABS கிளட்ச் அமைப்பில் கிளட்ச் பயன்படுத்தும் போது சக்கரம் அடைவு செய்யப்படாது.",

chapter28Paragraph9: "வாகனம் ஸ்லிப் ஆகும்போது, கிளட்ச் விடவும், ஸ்லிப் நடைபெறும் பக்கம் மட்டுமே வெட்டவும்.",





chapter29Title: "29. சும்மாக வைத்தல்",
chapter29Subheading1: "சும்மாக வைத்தலை இயக்குதல்.",
chapter29Paragraph1: "கியர் மாற்றும் போது தவிர அனைத்து நிலைகளிலும் கைகளைக் கைகளில் வைத்திருப்பது சும்மாக வைத்தல் மீது இருக்க வேண்டும்.",
chapter29Paragraph2: "எப்போதும் இழுக்கும் மற்றும் தள்ளும் முறைக்கு சும்மாக வைத்தலை பயன்படுத்த வேண்டும். எந்த நேரத்திலும் விரல்களை ஒருவருக்கொருவர் கடந்து போகும் வகையில் வைக்கக்கூடாது.",
chapter29Paragraph3: "பெரிய வாகனம் ஓட்டும் போது, சும்மாக வைத்தலில் கைகள் இருக்க வேண்டியது கடிகாரத்தில் 9.15 இடம் போலவே இருக்க வேண்டும்.",
chapter29Paragraph4: "சிறிய வாகனம் ஓட்டும் போது, 10.10 இடம் போலவே கைகள் இருக்க வேண்டும்.",
chapter29Paragraph5: "ஆனால் நீங்கள் ஓட்டும் வாகனத்தில் அவசர நிகழ்ச்சியில் செயல்படும் ஏர் பேக்கள் (Air Bags) உள்ளதெனில், கட்டாயமாக நீங்கள் சும்மாக வைத்தலில் கைகளை 8.20 இடம் போலவே வைக்க வேண்டும். இல்லையெனில் அவசர நிகழ்ச்சியில் ஏர் பேக் செயல்பட்டால் முதலில் பாதிக்கப்படுவது உங்கள் இரு கைகளாகும்.",




chapter30Title: "30. பேட்டரி",
chapter30List1Title: "பேட்டரி வைத்திருப்பது முக்கியத்துவம்.",
chapter30List1: [
  "என்ஜின் இயக்க மற்றும் விளக்குகள் மற்றும் குழாய்களை செயல்படுத்த."
],

chapter30List2Title: "பேட்டரி ஓவர் சார்ஜ் ஆகும் போது,",
chapter30List2: [
  "பேட்டரிக்கு அதிக மின்சாரம் கிடைப்பதால்."
],

chapter30List3Title: "பேட்டரி நிறுவப்படாத போது,",
chapter30List31: "பேட்டரி இணைப்புக் கம்பியை பரிசோதிக்கவும்.",
chapter30List32: "பேட்டரி தண்ணீர் நிலையை பரிசோதிக்கவும்.",
chapter30List33: "ஆல்டர்னேட்டரை பரிசோதிக்கவும்.",
chapter30List34: "பேன் பெல்ட் பரிசோதிக்கவும்.",

chapter30List4Title:
  "முக்கிய விளக்குகள், குழாய், சிக்னல்கள் போன்ற அனைத்தும் செயல்படவில்லை என்றால்,",
chapter30List4: [
  "பேட்டரி சரிவடைதல் அல்லது இணைப்புக் கம்பி குன்றியது."
],

chapter30List5Title: "மேலே கூறிய ஒரு கருவி மட்டுமே செயல்படவில்லை என்றால்,",
chapter30List5: [
  "அந்த கருவி எரிந்து போனது அல்லது அதற்கு தொடர்பான ஃபியூஸ் எரிந்து போனது."
],

chapter30List6Title:
  "வாகனத்தில் மின்சார குறைவு (ஷார்ட்) ஏற்பட்டதை உடனே அறிந்தால்,",
chapter30List6: [
  "உடனடியாக வாகனத்தை நிறுத்தி என்ஜினை அணைத்து, பேட்டரியின் இணைப்புக் கம்பியை (டெர்மினல் கம்பி) அகற்றவும்."
],

chapter30List7Title: "பேட்டரியின் நிறுவப்பட்ட நிலை,",
chapter30List7: [
  "இக்னிஷன் சாவியை வைக்கும்போது காடும் மற்றும் மறையும் சிவப்பு விளக்கு மூலம் பேட்டரி சரியான நிறுவப்பட்ட நிலையில் உள்ளது என்பதை தெரிந்துகொள்ளலாம்."
],




chapter31Title: "31. ஓட்டுநர் இயக்க முறை",
chapter31Paragraph1:
  "காரணமாக வாகனம் இயக்கும்போது அனைத்து நான்கு சக்கல்களும் என்ஜின் சக்தியால் இயக்கப்படும் போல் தெரிகிறதென்றால், அது \"நான்கு சக்கல் இயக்கம்\" (Fourwheel Drive - 4x4) கொண்ட வாகனங்களில் மட்டுமே நடக்கும்.",
chapter31Paragraph2:
  "மற்ற அனைத்து வாகனங்களிலும் என்ஜின் சக்தியால் இயக்கப்படும் சக்கல்கள் இரண்டு சக்கல்கள் மட்டுமே. என்ஜின் சக்தி முன்னோக்கோ அல்லது பின்புறமாகோ செல்கின்ற சக்கல்களை \"இயக்கும் சக்கல்\" என்று கூறுவர். மற்ற இரண்டு சக்கல்கள் \"இயங்காத சக்கல்\" என்று அழைக்கப்படுகின்றன.",
chapter31Paragraph3:
  "இந்த வகையில் என்ஜின் சக்தியால் இயக்கப்படும் சக்கல்களின் அமைப்பின்படி முக்கியமாக மூன்று வகை வாகனங்கள் உள்ளன.",
chapter31ListTitle: "வாகன ஓட்டுநர் இயக்க முறை வகைகள்",
chapter31List1: 
  "முன்னணி இயக்கம் – Front wheel drive",
chapter31List2:"பின்புற இயக்கம் – Rear wheel drive",
chapter31List3:"நான்கு சக்கல் இயக்கம் – Four wheel drive (4×4)"
,






chapter32Title: "32. டயர்",
chapter32Paragraph1:
  "டயர் வாங்கும்போது கவனிக்க வேண்டிய அம்சங்கள்.",

chapter32ListTitle1: "டயர் வாங்கும்போது கவனிக்க வேண்டிய அம்சங்கள்",
chapter32List11: 
  "டயரின் பிராண்ட் (Brand).",
chapter32List12:"டயரின் தரம்."
,

chapter32Paragraph2:
  "டயரின் துடை வடிவம் சமமாகப் பரவியிருந்தால் அது 'சமமிதிக' (Symmetric) துடை வடிவம் கொண்ட டயர். துடை வடிவம் இருபுறமும் வேறுபட்டு இருந்தால், அது 'அசமமிதிக' (Asymmetric) துடை வடிவம் கொண்ட டயர். இப்படியான அசமமிதிக டயர் நிறுவும் போது Inside எனக் குறிப்பிடப்பட்ட பக்கம் உள்ளே, Outside எனக் குறிப்பிடப்பட்ட பக்கம் வெளியே இருக்குமாறு நிறுவ வேண்டும்.",

chapter32Title2: "3). ஈர்ப்பு மதிப்பு – Traction Rate",
chapter32Paragraph3:
  " ஈரமான மடிமை மேற்பரப்பில் நிறுத்தும் திறனை இதன் மூலம் காணலாம். Traction மதிப்பு அதிகமாயின் குறுகிய தூரத்தில் வாகனத்தை நிறுத்த முடியும். Traction மதிப்புகள் AA, A, B, C என வகைப்படுத்தப்படுகின்றன. AA என்பது மிக உயர்ந்த மதிப்பாகும், C என்பது மிக குறைந்த மதிப்பு. இலங்கையின் சாலைகளுக்கு AA அல்லது A மதிப்பின் டயர்கள் ஏற்றதாகும்.",

chapter32ThreadWearTitle: "4). Thread Wear Rate",
chapter32ThreadWearParagraph:
  " துடைகளின் நீடித்த தன்மையை இது குறிப்பிடுகிறது. மதிப்பு அதிகமானால், துடைகளின் நீடித்த தன்மை அதிகமாக இருக்கும்.",

chapter32TemperatureTitle: "5). வெப்ப எதிர்ப்பு மதிப்பு",
chapter32TemperatureParagraph:
  " இந்த மதிப்புகள் A, B, C என வகைப்படுத்தப்பட்டுள்ளன.",
chapter32TemperatureList11: "A – வெப்பம் அதிகமான பகுதிகளுக்கு",
chapter32TemperatureList12:"B – சாதாரண குளிர்மழை பகுதிகளுக்கு",
chapter32TemperatureList13:"C – குளிர் பகுதிகளுக்கு",

chapter32TemperatureNote:
  "எங்களுடைய நாட்டிற்கு B மதிப்புடைய டயர்கள் மிகவும் பொருத்தமானவை.",

chapter32LoadSpeedTitle: "6). அதிகபட்ச சரக்கு சுமை மற்றும் வேகம் குறியீடு",
chapter32LoadSpeedList1: 
  "Max Load Capacity – டயர் தாங்கக்கூடிய அதிகபட்ச சுமை.",
chapter32LoadSpeedList2:"Speed Index – அந்த அதிகபட்ச சுமையுடன் செல்லக்கூடிய அதிகபட்ச வேகம்."
,

chapter32LoadParagraph:
  "Max Load Capacity மதிப்புகள் டயரில் உள்ள குறியீடுகள் மற்றும் அவற்றிற்கு தொடர்புடைய சுமை கீழ்க்காணும் அட்டவணைகளில் குறிப்பிடப்பட்டுள்ளன.",

chapter32LoadImages: [
  PDFViewerImage106,
  PDFViewerImage107,
  PDFViewerImage108,
  PDFViewerImage109,
],

chapter32SpeedParagraph:
  "Load Index மதிப்புகள் டயரில் குறியீடுகளுடன் சேர்த்து, அதற்குரிய வேகம் கீழ்க்காணும் அட்டவணைகளில் குறிப்பிடப்பட்டுள்ளன.",

chapter32SpeedImages: [
  PDFViewerImage110,
  PDFViewerImage111,
  PDFViewerImage112,
],

chapter32ManufactureTitle: "7). உற்பத்தி தேதி",
chapter32ManufactureParagraph1:
  "பொதுவாக, டயர் உற்பத்தி செய்யப்பட்ட நாளிலிருந்து 04 ஆண்டுகள் கழிந்தால் பழையதாகக் கருதப்படும்.",
chapter32ManufactureParagraph2:
  "சமீபத்திய சந்தையில் 'கழிந்த துடை கொண்ட டயர்கள்' மற்றும் 'மீண்டும் நிரப்பப்பட்ட டயர்கள்' அதிகம் உள்ளன. மீண்டும் நிரப்பப்பட்ட டயர்கள் பயன்படுத்தலாம், ஆனால் மிகவும் குறைந்த விலையுடைய பழைய துடை கொண்ட டயர்கள் எந்தவொரு சூழலிலும் பயன்படுத்தக் கூடாது.",
chapter32ManufactureParagraph3:
  "டயரின் அனைத்து தரவுகளும் அழியாமல் பதிவுசெய்யப்பட்டுள்ளன. உற்பத்தியாளர் மற்றும் நாட்டின் படி அந்தத் தகவல்கள் மாறக்கூடும் என்பதால், அவற்றை சரியாகப் படித்து புரிந்து கொள்ள வேண்டும்.",

chapter32DateCodeParagraph:
  "உற்பத்தி தேதி 4 இலக்கங்களைக் கொண்ட எண்ணாகக் குறிப்பிடப்பட்டுள்ளது. உதாரணமாக 3705 என்பது 2005 ஆண்டின் 37வது வாரத்தில் உற்பத்தி செய்யப்பட்ட டயர் என்பதை குறிக்கிறது.",

chapter32DateImages: [
  PDFViewerImage113
],

chapter32DateCodeParagraph2:
  "3705 – 2005 ஆண்டின் 37வது வாரத்தில் உற்பத்தி செய்யப்பட்ட டயர்.",
chapter32DateCodeParagraph3:
  "பின்வரும் நீளமான எண்ணும் டயரின் மேல் பதிவு செய்யப்பட்டுள்ளது.",

chapter32DateImages2:[
  PDFViewerImage114
],

chapter32DateCodeParagraph4:
  "பின்வரும் நீளமான எண்ணும் டயரின் மேல் பதிவு செய்யப்பட்டுள்ளது.",
chapter32DateImages3:[
  PDFViewerImage115
],

chapter32AirPressureTitle: "காற்றழுத்தம் பரிசோதனை",
chapter32AirPressureParagraph:
  "பொதுவாக, இரண்டாம் வாரத்திற்கு ஒருமுறை சக்கல்களின் காற்றழுத்தம் பரிசோதிக்கப்பட வேண்டும்.",
chapter32AirPressureList1: 
  "காற்றழுத்தம் அதிகமாக இருந்தால்",
chapter32AirPressureList2:"காற்றழுத்தம் குறைவாக இருந்தால்",
chapter32AirPressureList3:"சக்கல் அலைய்ன்மெண்ட் மாற்றம்",
chapter32AirPressureList4:"ஷாக் அப்சார்பர், அமோர்டிசர், ஸ்பிரிங் தாழ்வு",
chapter32AirPressureList5:"குறைந்த காற்றழுத்தத்தில் இயக்குதல்",
chapter32AirPressureList6:"சக்கல் அலைய்ன்மெண்ட் இல்லாததால் டயர் வேகமாக கழித்து செல்லும்",
chapter32AirPressureList7:"அவசரம் இல்லாதபட்சத்தில் இரண்டாம் வாரத்திற்கு ஒருமுறை குறைந்தது டயர் பரிசோதனை செய்யவேண்டும்",

chapter32RotationTitle: "டயர்களின் இடம் மாற்றம்",
chapter32RotationParagraph:
  "பொதுவாக, ஒவ்வொரு 8000 கிலோமீட்டர் பயணத்திற்கு டயர்களின் இடம் மாற்றப்பட வேண்டும். இதற்கு அனைத்து டயர்களும் ஒரே அளவில் பயன்படுத்தப்பட்டிருக்க வேண்டும்.",
chapter32RotationImage: PDFViewerImage116,





chapter33Title: "33. டாஷ்போர்டு சின்னங்கள்",
chapter33Paragraph1:
  "டாஷ்போர்டில் காணப்படும் முக்கிய சின்னங்கள் சில கீழே கொடுக்கப்பட்டுள்ளன.",
chapter33Image: PDFViewerImage117,
chapter33ListTitle: "டாஷ்போர்டும் வாகன தொடர்புடைய முக்கிய அம்சங்களும்",
chapter33List11: 
  "4×4 வாகனங்கள் என்பது ? என்ஜின் சக்தி நான்கு சக்கல்களுக்கும் செலுத்தப்படும் வாகனங்கள்.",
chapter33List12: "டீசல் வாகனத்தில் டீசல் முடிந்ததும் பம்பிற்கு காற்று எறிந்தால் ? டீசலை நிரப்பி, பம்பில் உள்ள காற்றை நீக்கி இயக்க வேண்டும்.",
chapter33List13: "டிபரன்சியலின் பணிகள் ? திருப்பும்போது இரு சக்கல்களின் வேகங்களை சமமாக பராமரிப்பது.",
chapter33List14: "இரு பக்கக் கண்ணாடிகள் மற்றும் உள்ளே உள்ள கண்ணாடியை சரியாக அமைத்தால், முன்னணி கண்ணாடியிலிருந்து காணப்படும் பரப்பளவும் 360 டிகிரி பரப்பளவில் ஓட்டுனருக்கு தெரியும்.",
chapter33List15: "அனர்த்தத்தில் செயல்படும் ஏர் பேக்குகள் உள்ள வாகனத்தில் பயணம் செய்யும்போதும், கட்டாயமாக இருக்கை பட்டை அணிய வேண்டும்.",
chapter33List16: "ஏர் பேக்குகளில் உள்ளது நைட்ரஜன் (N2) வாயு.",
chapter33List17: "வாகனம் தீண்டிவிடும் அபாயம் ஏற்பட்டால் உடனடியாக.",
chapter33List18: "வாகனத்தின் பின்புற ஜன்னல்களை ஸ்டிக்கர், திரை துணியால் மூடுவது சட்டவிரோதம்.",
chapter33List19: "வாகனத்தின் முன்னணியில் பாதுகாப்பு கம்பிகள் நிறுவுவது சட்டவிரோதம்.",
chapter33List10: "அந்தர்முக பார்வையற்ற நபரை கண்டறிதல், வெள்ளை சேலை பயன்படுத்துதல் அல்லது வழிகாட்டும் நாயுடன் பயணம் செய்தல்.",
chapter33List111: "சுற்றுச்சூழல் அடிப்படைக் சட்டம் ? வலது விதி – வலதுபுற நெருக்கமான வாகனங்களுக்கு இடம் கொடுத்து இயக்க வேண்டும்.",
chapter33List121: "சேர்ச் செய்வது போது மீட்டர் / டாஷ்போர்டில் சிவப்பு விளக்கு ஒளிரினால், வாகனத்தை நிறுத்தி பிழை என்ன என்பதை உறுதி செய்ய வேண்டும்.",
chapter33List1311: "வாகனத்தில் எரிபொருள் நிரப்பும் போது, என்ஜினை நிறுத்த வேண்டும்.",
chapter33List141: "வாகன மின்சார சுற்றிலும் பிழை ஏற்பட்டால், கெட்டியான வயர் கண்டறிந்தால், பேட்டரி இணைப்புப் வயரை சரிசெய்ய வேண்டும்.",
chapter33List151: "வாயு வெளியீட்டு அறிக்கை அல்லது புகை சான்றிதழ், எப்போதும் வாகனத்தில் இருக்க வேண்டும்.",
chapter33List161: "கயிறு வாகனத்தில், தீ அணைக்கும் வாகனத்தில், போலீஸ் அல்லது இராணுவ வாகனத்தைத் தவிர வேறு எந்த வாகனத்திலும் விதிமுறை விதிகள் இல்லாமல், தீவிர, கடுமையான, பயமுறுத்தும் சத்தங்கள் வெளியிடும் கருவிகள் நிறுவ முடியாது.",
chapter33List171: "புகை, நுழைவுத் தூள், மரச் சுண்ணாம்பு, தீச்சுண்ணி, கூழ், கிரீஸ் அல்லது எண்ணெய் உள்ள பொருட்களை வெளியேற்றும் வாகன ஓட்டுதல் தடை செய்யப்படுகிறது.",
chapter33List181: "வாகனத்தில் உள்ள ஒலிப்பிரசார கருவிகள் (ரேடியோ) ஒலியை வாகனத்திற்கு வெளியே செல்லாமல் இருக்க வேண்டும்.",





chapter34Title: "34. ஓட்டுனரை நிறுத்துதல்",
chapter34ListTitle: "போலீஸ் அதிகாரி ஓட்டுனரை நிறுத்துவதற்கான சூழல்கள்",
chapter34List11: 
  "தன்னுடைய பெயர் மற்றும் முகவரி கேட்டபோது தராதது அல்லது கொடுக்கப்பட்ட தகவல் பொய் என போலீஸ் அதிகாரி நியாயமான சந்தேகத்தை ஏற்படுத்தும்.",
chapter34List12: "காற்று அழுத்தம் அதிகமாக இருக்கும் போது.",
chapter34List13: "மரணம் அல்லது காயம் ஏற்படும் பயங்கர விபத்துடன் தொடர்புடையது.",
chapter34List14: "மதுபானம் அல்லது போதைப்பொருள் எடுத்திருப்பதாக அல்லது அப்படியாக போலீஸ் அதிகாரி நியாயமான சந்தேகத்தை ஏற்படுத்தும் சூழல்.",
chapter34List15: "போலீஸ் அதிகாரியின் கருத்தில் போலியான அல்லது முறை மீறிய ஆவணங்கள் அல்லது போலி எண்ணிக்கை தகடுகள் தன்னிடம் இருக்கிறது என்று சந்தேகம்.",
chapter34List16: "போலீஸ் அதிகாரியின் கருத்தில் மாற்றப்பட்ட அல்லது சிறிது மாற்றப்பட்ட சசீ எண், என்ஜின் எண் கொண்ட மோட்டார் வாகனம் தன்னிடம் உள்ளது என்று சந்தேகம்.",
chapter34List17: "கொடுக்கப்பட்ட வாகனம் திருடப்பட்டதாக போலீஸ் அதிகாரி நியாயமான சந்தேகத்தை ஏற்படுத்தும் சூழல்.",

chapter34Paragraph1:
  "மோட்டார் வாகன ஓட்டுனரை சரிபார்ப்பு அல்லது விசாரணைக்காக குறிப்பிட்ட நேரம் போலீஸ் நிலையத்தில் நிறுத்த போலீஸ் அதிகாரிக்கு அதிகாரம் உள்ளது."
,




chapter35Title: "35. வாகன பராமரிப்பு",
chapter35Paragraph1: 
  "வாகனத்தை ஓட்டும் நபர் எப்போதும் மோட்டார் நிபுணர் அல்லாததால், அவர் தனது வாகனத்தைப் பற்றிப் 100% க்கு அறிவை கொண்டிருக்க வேண்டியதில்லை. அவசர சிக்கலின் போது எப்படி செயல்பட வேண்டும் மற்றும் வாகனத்தைச் சரியாக பராமரிப்பது பற்றிய அறிவு போதுமானது.",

chapter35Paragraph2: 
  "வாகனத்துடன் கையேடு (Manual) கிடைத்திருந்தால், அதை வாசித்து புரிந்து கொள்ளவும்.",

chapter35Paragraph3: 
  "குறைந்தது வாரத்திற்கு ஒரு முறை பின்வரும் பரிசோதனைகளைச் செய்யவும்.",

chapter35SubTitle1: "வாரத்திற்கு ஒரு முறை செய்ய வேண்டிய அடிப்படை பரிசோதனைகள் (P O W E R)",
chapter35List11: "P – Fuel (எரிபொருள்)",
chapter35List12: "O – Oil (எண்ணெய்)",
chapter35List13: "W – Water (நீர்)",
chapter35List14: "E – Electricity (மின்சாரம் – பேட்டரி)",
chapter35List15: "R – Rubber (டைர்)",

chapter35Paragraph41: 
  "வாகனத்தை சேவை செய்ய அல்லது பழுதுபார்க்கும் போது, அதற்கான தகவல்களை வாகனத்திற்கு அர்ப்பணிக்கப்பட்ட பதிவு புத்தகத்தில் பதிவு செய்யவும்.",

chapter35Paragraph42: 
  "சேவை செய்யும் போது எப்போதும் வாகன உற்பத்தியாளர் பரிந்துரைத்த எண்ணெய் வகைகள் மற்றும் கூடுதல் பகுதிகளை பயன்படுத்தவும்.",

chapter35Paragraph43: 
  "நவீன வாகனங்களில் எஞ்சின் நீர் செல்லும் போது சேதமடையக்கூடிய பகுதிகள் உள்ளன. சேவை செய்யும் போது கவனமாக இருங்கள். வாகனத்தை சேவை அல்லது பழுதுபார்க்க செல்லும்போது, அதனைச் செய்ய அதிகாரபூர்வமான நிறுவனம் நோக்கி எடுத்துச் செல்லவும். தேவையான அளவு வரை அந்த நிறுவனம் சேவையை நிறைவேற்றும் வரை வாகனத்துடன் இருங்கள்.",

chapter35Paragraph5: 
  "இதில் காட்டப்பட்டுள்ள அளவுகள் சுமார் மதிப்புகள் மட்டுமே. வாகனத்தின் மாதிரி படி மாற்றம் இருக்கலாம்.",

chapter35List51: "Engine oil – ஒவ்வொரு Km 5,000 க்கும் ஒரு முறை",
chapter35List52: "Engine oil filter – ஒவ்வொரு Km 10,000 க்கும் ஒரு முறை",
chapter35List53: "Fuel filter – வாகன மாதிரி படி",
chapter35List54: "Air cleaner – ஒவ்வொரு Km 40,000 க்கும் ஒரு முறை",
chapter35List55: "Gear box oil – ஒவ்வொரு Km 40,000 க்கும் ஒரு முறை",
chapter35List56: "Brake oil – ஒவ்வொரு Km 40,000 க்கும் ஒரு முறை",

chapter35Paragraph6: 
  "சரியாக பராமரிக்கப்பட்ட வாகனம் உங்கள் நேரத்தையும் பணத்தையும் சேமித்து தரும்.",



}
]; 